import {
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toList3jhuyej2anx2q as toList,
  VOID7hggqo3abtya as VOID,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  createThis2j2avj17cvnv2 as createThis,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ArrayList3it5z8td81qkl as ArrayList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isInterface3d6p8outrmvmk as isInterface,
  lazy2hsh8ze7j6ikd as lazy,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  copyOf3rutauicler23 as copyOf,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  split2bvyvnrlcifjv as split,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  startsWith26w8qjqapeeq6 as startsWith,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt,
  printStackTrace18lnx7a39cni as printStackTrace,
  contains3u8qpdzrl9an as contains,
  Collection1k04j3hzsbod0 as Collection,
  indexOff2hgzjbxdcp4 as indexOf,
  KtList3hktaavzmj137 as KtList,
  roundToInt1ue8x8yshtznx as roundToInt,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  numberToDouble210hrknaofnhf as numberToDouble,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  sum2ku6kbgxq0lee as sum,
  first58ocm7j58k3q as first,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  protoOf180f3jzyo7rfj as protoOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  HashMap1a0ld5kgwhmhv as HashMap,
  startsWith1bgirhbedtv2y as startsWith_0,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  first28gmhyvs4kf06 as first_0,
  toMap1vec9topfei08 as toMap,
  lines3g90sq0zeq43v as lines,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  listOf1jh22dvmctj1r as listOf,
  plus310ted5e4i90h as plus,
  numberToChar93r9buh19yek as numberToChar,
  toString14fd7g605f91p as toString_1,
  toInt2q8uldh7sc951 as toInt_0,
  toDouble1kn912gjoizjp as toDouble,
  Char__rangeTo_impl_tkncvp1xeq9dxokim1v as Char__rangeTo_impl_tkncvp,
  joinToString1cxrrlmo0chqs as joinToString,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toIntArray2d4xwvtjb01mq as toIntArray,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  listOfvhqybd2zx248 as listOf_0,
  println2shhhgwwt4c61 as println,
  emptyList1g2z5xcrvp2zy as emptyList,
  until1jbpn0z3f8lbg as until,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  firstOrNull1982767dljvdy as firstOrNull_0,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  last1vo29oleiqj36 as last,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  step18s9qzr5xwxat as step,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  toIntArray27j90pvfixv10 as toIntArray_0,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  toLongw1zpgk99d84b as toLong,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  addAll1k27qatfgp3k5 as addAll,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  first1vi3grnpj1175 as first_2,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_0,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap_0,
  _UByte___init__impl__g9hnc43i8t7wecfr79w as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  copyOfwy6h3t5vzqpl as copyOf_0,
  abs1kdzbjes1idip as abs,
  getOrNull1go7ef9ldk0df as getOrNull_1,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  KProperty02ce7r476m8633 as KProperty0,
  ValueTimeMark__minus_impl_f87sko6qoir9myg4l1 as ValueTimeMark__minus_impl_f87sko,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instanceeeaudfwfrq87 as Companion_instance_0,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3 as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89 as _SliceOrientation___get_rotation__impl__m65r0o,
  Companion_getInstance2kfoysd3on6as as Companion_getInstance_0,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41 as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  plus1r33v70e4ipd7 as plus_1,
  get_immutablepxpdoj6e54ll as get_immutable,
  arc$default4sjbw0e0mkug as arc$default,
  polyline$default15ixww87ep7hu as polyline$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  Winding_EVEN_ODD_getInstancemyc10vdu2m52 as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_1,
  LineScaleMode_NORMAL_getInstance1wxue9rdh6hry as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstancetv7srcehoz43 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance35lw9h64apo2h as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance38kh1ikwl48ly as Winding_NON_ZERO_getInstance,
  moveTo1v59p8psmu2yv as moveTo,
  cubicTo2zrtior3nyf69 as cubicTo,
  line3u2mk0n2uhnlh as line,
  arcTo1g4ivunekrrtg as arcTo,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  roundRect2sqmspzw5002d as roundRect,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  polygonadxvu38ofi9j as polygon,
  polylineq7ufb9w9mvhi as polyline,
  polyline3q11230zq86y as polyline_0,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance3d17rumlj92i7 as Companion_getInstance_2,
  write11msa0gyjblqp as write,
  get_isConvex3nm4n5empqw0n as get_isConvex,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  MarginInt3jiec8xsxkfd as MarginInt,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_1,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_3,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_4,
  Vector2D378fe5rov8fgw as Vector2D,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_5,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_6,
  Companion_getInstance2yu48324co92b as Companion_getInstance_7,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y as BoundsBuilder__plus_impl_cz7f7x,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_8,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btd19ndx9mxcgcss as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndtx0rhatnvuhb1 as Angle__hashCode_impl_szcndt,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x_1,
  get_radians391vbqqjsolq6 as get_radians,
  _Angle___get_degrees__impl__qg56vw2n539uvc01e1n as _Angle___get_degrees__impl__qg56vw,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423 as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstance26n3n49ggvwm4 as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  Ratio__toFloat_impl_1ftup533krasllqk7v1 as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  interpolatexm8yaf0iv9q9 as interpolate,
  clamp012a0sd8pj80ati as clamp01_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  get_nextPowerOfTwoselx3fye7kjp as get_nextPowerOfTwo,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  convertRangeClamped3njqr0qabe371 as convertRangeClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn2mn8x7j48jyfs as _Ratio___init__impl__9mwvn2,
  clamp1qclpmpfxm7xb as clamp_1,
  toRatio1hooqit5gulhr as toRatio_0,
  interpolate35pbs3ac913y4 as interpolate_0,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_9,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  umodgae5ifx362au as umod,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instancelqpzd9anuk16 as Companion_instance_2,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  Companion_instance3ldriv9x4zcjm as Companion_instance_3,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  doubleArrayListOfkj3z9zq4pobs as doubleArrayListOf,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgt2kqnbzr6sil9y as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t21dxxdiycat5m as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa01c9hqlgdxaps5 as TGenStack__pop_impl_qisxa0,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  NativeImageRefqizti6jm75 as NativeImageRef,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstance3qe1a0k2pp7jd as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil as Endian_LITTLE_ENDIAN_getInstance,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_10,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb8124zcs6bgqfxc as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc2wqa90g1ifa1l as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k3q1wtux9fkamc as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  UByteArrayInt__fill$default_impl_mdydxi1wz00ttbtxw3z as UByteArrayInt__fill$default_impl_mdydxi,
  _UByteArrayInt___get_size__impl__bcjnte1riayqw17gpkp as _UByteArrayInt___get_size__impl__bcjnte,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  UByteArrayInt__getOrElse_impl_f0pf7216mblxgilcglu as UByteArrayInt__getOrElse_impl_f0pf72,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  _UByteArrayInt___get_data__impl__l2b9131ldqmcpexnjin as _UByteArrayInt___get_data__impl__l2b913,
  set81874nlu4rwumg as set8,
  arraycopy3n78tfzvkl4kg as arraycopy_1,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstance6aal8l6ipt6u as Companion_getInstance_11,
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  ASCII_getInstancey3nspn0nzsaa as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  toByteArraybbc3ng3wgt1d as toByteArray,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwu2vjc0ffpg6ich as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get,
  Companion_getInstance345a0ojzj45ct as Companion_getInstance_12,
} from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  Dyn__get_impl_6l2p802ap79h85reiiq as Dyn__get_impl_6l2p80,
  Dyn__toDoubleDefault_impl_fspogf1rn8v9q6wbx2 as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy1b2jkpzd6lmvg as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgreuo7vfsc7aqn as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s3bs6vkriyagvh as Dyn__toString_impl_9l0v3s,
  _Dyn___get_int__impl__sh8lhmx5zxcvkgp62x as _Dyn___get_int__impl__sh8lhm,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstance3mocpl8hga9iq as Companion_getInstance_13,
  uncompress3ofkd276wd0zn as uncompress,
  CompressionContext8cgnuxsl0ava as CompressionContext,
  compress1visp4hlh2b1n as compress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  sliceHere162e6oimkowhf as sliceHere,
  readString3h14fm47a2tde as readString,
  readU162q6ft3yjssyvs as readU16,
  readS325wl7ebgpu38s as readS32,
  readBytesExact305h8zdeltghk as readBytesExact,
  sliceStart186j1d4dpd1wx as sliceStart,
  readStringzzxx8hll1ncys as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  MemorySyncStream1uv927me2xl9s as MemorySyncStream,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_0,
  readBytes3l26albs0coyl as readBytes,
  readAll1pkrq4jwoqns4 as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof,
  write32BE32zetfyrv09xq as write32BE,
  writeBytes3aje3m4oawkwy as writeBytes,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream,
  readU82o15i0epsnmc5 as readU8,
  readAll3m5rixujsbctr as readAll_0,
  write81fg3kayjaelgo as write8,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_14,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream2ficq0l6vek7d as readAsSyncStream,
  _PathInfo___init__impl__vpw96aee5jvc40cw94 as _PathInfo___init__impl__vpw96a,
  get_extensionLCr5nk7cwvpg7s as get_extensionLC,
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Companion_instance3mhfp4g0i6mgz as Companion_instance_4,
  decodeBytes3q5q9i2zh0cy6 as decodeBytes,
} from './korlibs-image-core-root-korlibs-image-core.mjs';
import { CRC32_getInstance38eqfkdpicymh as CRC32_getInstance } from './korlibs-checksum-root-korlibs-checksum.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class GrowMethod extends Enum {}
class Entry {
  constructor(slice, data) {
    this.h42_1 = slice;
    this.i42_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.h42_1.toString() + ', data=' + toString(this.i42_1) + ')';
  }
  hashCode() {
    var result = this.h42_1.hashCode();
    result = imul(result, 31) + (this.i42_1 == null ? 0 : hashCode(this.i42_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!this.h42_1.equals(tmp0_other_with_cast.h42_1))
      return false;
    if (!equals(this.i42_1, tmp0_other_with_cast.i42_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  static m43(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.j42_1 = binPacker;
    $this.k42_1 = border;
    $this.l42_1 = premultiplied;
    $this.m42_1 = allowToGrow;
    $this.n42_1 = growMethod;
    $this.o42_1 = MarginInt.o2g($this.k42_1);
    $this.p42_1 = Bitmap32.k43($this.x2p(), $this.y2p(), VOID, $this.l42_1);
    $this.q42_1 = arrayListOf([$this.p42_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r42_1 = ArrayList.i1();
    $this.s42_1 = LinkedHashMap.rc();
    $this.t42_1 = null;
    return $this;
  }
  static n43(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.m43(Companion_instance_0.n3m(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  x2p() {
    return numberToInt(this.j42_1.x2p());
  }
  y2p() {
    return numberToInt(this.j42_1.y2p());
  }
  e1() {
    return this.r42_1.e1();
  }
  o43(bmp, data, name) {
    return this.l43(slice(bmp, VOID, name), data, name);
  }
  p43(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.e1() : name;
    return $super === VOID ? this.o43(bmp, data, name) : $super.o43.call(this, bmp, data, name);
  }
  l43(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.o43(extract_0(bmp).d44(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.e1() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.t42_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.t42_1).h42_1;
        if (bigEmptySlice.j3o_1 >= bmp.j3o_1 && bigEmptySlice.k3o_1 >= bmp.k3o_1) {
          entry = new Entry(bigEmptySlice.t3p(RectangleInt.n2m(0, 0, bmp.j3o_1, bmp.k3o_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.j42_1.p2z(bmp.j3o_1 + imul(this.k42_1, 2), bmp.k3o_1 + imul(this.k42_1, 2));
        var slice = sliceWithSize(this.p42_1, numberToInt(rect.y2d() + this.k42_1), numberToInt(rect.a2e() + this.k42_1), bmp.j3o_1, bmp.k3o_1, rname);
        var dstX = slice.y2d();
        var dstY = slice.a2e();
        var boundsWithBorder = get_bounds_0(slice).o2m(this.o42_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.p42_1;
        if (true) {
          this_0.e44();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.p42_1.f44(bmp, dstX, dstY);
          expandBorder(this.p42_1, slice.b3o_1, this.k42_1);
        }finally {
          result = true ? this_0.g44(boundsWithBorder) : 0;
        }
        entry = new Entry(slice, data);
        if (this.t42_1 == null || bmp.b2n() > ensureNotNull(this.t42_1).h42_1.b2n()) {
          this.t42_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.r42_1;
      var element = entry;
      this_1.h(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.s42_1;
      var value = entry;
      this_2.j3(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.m42_1)
          throw e;
        growAtlas(this, bmp);
        return this.l43(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  h44(bmp, data, name, $super) {
    name = name === VOID ? bmp.e3o_1 : name;
    return $super === VOID ? this.l43(bmp, data, name) : $super.l43.call(this, bmp, data, name);
  }
}
class Bitmap {
  static i44(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.q43_1 = new Mixin();
    $this.r43_1 = width;
    $this.s43_1 = height;
    $this.t43_1 = bpp;
    $this.u43_1 = backingArray;
    $this.v43_1 = RectangleInt.n2m(0, 0, $this.r43_1, $this.s43_1);
    $this.w43_1 = null;
    $this.x43_1 = premultiplied;
    $this.y43_1 = false;
    var tmp = $this;
    tmp.z43_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.a44_1 = 0;
    $this.b44_1 = null;
    $this.c44_1 = false;
    return $this;
  }
  r10(_set____db54di) {
    this.q43_1.r10(_set____db54di);
  }
  s10() {
    return this.q43_1.s10();
  }
  e1() {
    return SizeInt.d2o(this.r43_1, this.s43_1);
  }
  j44() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z43_1;
    tempInts$factory();
    return this_0.u1();
  }
  k44() {
    return _RgbaArray___init__impl__oib4y4(this.j44());
  }
  l44() {
    return imul(this.r43_1, this.t43_1) / 8 | 0;
  }
  b2n() {
    return imul(this.r43_1, this.s43_1);
  }
  m44(x, y) {
    return imul(y, this.r43_1) + x | 0;
  }
  n44() {
    if (!(this.b44_1 == null)) {
      this.b44_1 = null;
    }
  }
  e44() {
    return Unit_instance;
  }
  g44(rect) {
    if (this.b44_1 == null)
      this.b44_1 = rect;
    else
      this.b44_1 = Companion_instance_1.u2m(ensureNotNull(this.b44_1), rect);
    this.a44_1 = this.a44_1 + 1 | 0;
    return this.a44_1;
  }
  o44(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.p44(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  q44(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.r44(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  s44(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.q44(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.q44.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  t44(x, y, v) {
    if (this.x43_1) {
      this.r44(x, y, asNonPremultiplied(_RGBA___get_premultiplied__impl__3bulqc(v)));
    } else {
      this.r44(x, y, v);
    }
  }
  u44(x, y) {
    var tmp;
    if (this.x43_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = asPremultiplied(this.p44(x, y));
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = this.p44(x, y);
    }
    return tmp;
  }
  v44(x, y, color) {
    this.r44(x, y, _RGBA___init__impl__lqpay5(color));
  }
  w44(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.p44(x, y));
  }
  x44(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.r43_1 || y0 >= this.s43_1)
      return Colors_getInstance().d45_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.r43_1 - 1 | 0);
    var y1Inside = y1 < (this.s43_1 - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.p44(x0, y0);
    var c10 = x1Inside ? this.p44(x1, y0) : c00;
    var c01 = y1Inside ? this.p44(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.p44(x1, y1) : c01;
    return Companion_getInstance_22().v4a(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  w4a(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.x4a(srcX);
    var srcX1 = src.x4a(srcX + width | 0);
    var srcY0 = src.y4a(srcY);
    var srcY1 = src.y4a(srcY + height | 0);
    var dstX0 = dst.x4a(dstX);
    var dstX1 = dst.x4a(dstX + width | 0);
    var dstY0 = dst.y4a(dstY);
    var dstY1 = dst.y4a(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.z4a(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  z4a(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.o44(srcX, srcY + y | 0, width, 1, this.j44(), 0);
        dst.q44(dstX, dstY + y | 0, width, 1, this.j44(), 0);
      }
       while (inductionVariable < height);
  }
  a4b(x) {
    return x >= 0 && x < this.r43_1;
  }
  b4b(y) {
    return y >= 0 && y < this.s43_1;
  }
  c4b(x, y) {
    return this.a4b(x) && this.b4b(y);
  }
  d4b(x) {
    return clamp(x, 0, this.r43_1 - 1 | 0);
  }
  e4b(y) {
    return clamp(y, 0, this.s43_1 - 1 | 0);
  }
  x4a(x) {
    return clamp(x, 0, this.r43_1);
  }
  y4a(y) {
    return clamp(y, 0, this.s43_1);
  }
  f4b() {
    var inductionVariable = 0;
    var last = this.s43_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.g4b(y, (this.s43_1 - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  h4b() {
    var inductionVariable = 0;
    var last = this.r43_1 / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.i4b(x, (this.r43_1 - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  j4b(rotation) {
    var tmp;
    switch (rotation.t3_1) {
      case 0:
        tmp = this.o10();
        break;
      case 1:
        tmp = this.k4b().h4b();
        break;
      case 2:
        tmp = this.k4b().h4b().k4b().h4b();
        break;
      case 3:
        tmp = this.k4b().f4b();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  l4b(orientation) {
    var out = this.o10();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.h4b();
    }
    return out.j4b(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  k4b() {
    var temp = new IntArray2(this.r43_1, this.s43_1, readPixelsUnsafe(this, 0, 0, this.r43_1, this.s43_1));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.s43_1;
    var height = this.r43_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.s43_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.r43_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.d2q(y, x, temp.s2f(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.m4b(this.s43_1, this.r43_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.s44(0, 0, this.s43_1, this.r43_1, out.w2p_1);
    return this_0;
  }
  g4b(y0, y1) {
    var inductionVariable = 0;
    var last = this.r43_1;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.w44(x, y0);
        var c1 = this.w44(x, y1);
        this.v44(x, y0, c1);
        this.v44(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  i4b(x0, x1) {
    var inductionVariable = 0;
    var last = this.s43_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.w44(x0, y);
        var c1 = this.w44(x1, y);
        this.v44(x0, y, c1);
        this.v44(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  n4b(antialiasing) {
    throw UnsupportedOperationException.qa('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  m4b(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString_0(this) + ')');
  }
  d44() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.k43(this.r43_1, this.s43_1, VOID, this.x43_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.o44(0, 0, this.r43_1, this.s43_1, this_0.h43_1, 0);
    return this_0;
  }
  o4b() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.d44();
    }
    return tmp;
  }
  o10() {
    var out = this.m4b(this.r43_1, this.s43_1);
    this.z4a(0, 0, out, 0, 0, this.r43_1, this.s43_1);
    return out;
  }
}
class Companion {
  constructor() {
    Companion_instance_5 = this;
    this.y4b_1 = Bitmap32.k43(0, 0, VOID, true);
  }
  z4b(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.k43(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.h43_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  a4c(width, height, premultiplied) {
    return Bitmap32.k43(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  b4c(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.f4c_1;
    var dstShift = dstChannel.f4c_1;
    var dstClear = dstChannel.h4c_1;
    var dstData = dst.h43_1;
    var srcData = src.h43_1;
    var inductionVariable = 0;
    var last = dst.b2n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  i4c(src, dst, dstChannel) {
    var destShift = imul(dstChannel.e4c_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.b2n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.d4d()[n] & 255;
        dst.h43_1[n] = dst.h43_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  e4d(src, srcChannel, dst) {
    var shift = srcChannel.f4c_1;
    var inductionVariable = 0;
    var last = src.b2n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.d4d()[n] = toByte((src.h43_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.w4b_1 = this$0;
  }
  f4d($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$iterator), $completion);
  }
  ge(p1, $completion) {
    return this.f4d(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static k43(width, height, ints, premultiplied) {
    Companion_getInstance_15();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.i44(width, height, 32, premultiplied, ints);
    $this.h43_1 = ints;
    if ($this.h43_1.length < imul(width, height))
      throw RuntimeException.za('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.h43_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.i43_1 = new Int32Array(tmp$ret$0);
    $this.j43_1 = RectangleInt.n2m(0, 0, width, height);
    return $this;
  }
  static g4d(width, height, value) {
    Companion_getInstance_15();
    return this.k43(width, height, _RgbaArray___get_ints__impl__u2kps1(value), false);
  }
  m4b(width, height) {
    return Bitmap32.k43(width, height, VOID, this.x43_1);
  }
  z4a(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.z4a(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.h43_1;
    var dstArray = dst.h43_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.m44(srcX, srcY + y | 0), dstArray, dst.m44(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  h4d(x, y, color) {
    this.t44(x, y, color);
  }
  i4d(x, y) {
    return this.u44(x, y);
  }
  v44(x, y, color) {
    this.h43_1[this.m44(x, y)] = color;
  }
  w44(x, y) {
    return this.h43_1[this.m44(x, y)];
  }
  p44(x, y) {
    return _RGBA___init__impl__lqpay5(this.w44(x, y));
  }
  r44(x, y, v) {
    return this.v44(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  j4d(n, color) {
    this.h43_1[n] = this.x43_1 ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  k4d(n, color) {
    var tmp;
    if (this.x43_1) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.h43_1[n] = tmp;
  }
  x4b(n) {
    var tmp;
    if (this.x43_1) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.h43_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.h43_1[n]);
    }
    return tmp;
  }
  l4d(n) {
    return this.x43_1 ? _RGBAPremultiplied___init__impl__uos02x(this.h43_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.h43_1[n]));
  }
  m4d(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.m44(dx, dy + y | 0);
        var srcOffset = src.m44(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.k4d(dstOffset + x | 0, mix(dst.l4d(dstOffset + x | 0), src.l4d(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.x43_1 === src.x43_1) {
            arraycopy(src.h43_1, srcOffset, dst.h43_1, dstOffset, width);
          } else if (!dst.x43_1) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.j4d(dstOffset + x_0 | 0, src.x4b(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.k4d(dstOffset + x_1 | 0, src.l4d(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  n4d(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.r43_1 - dx_0 | 0;
    var availableHeight = this.s43_1 - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.m4d(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  o4d(mix, other, _dx, _dy) {
    this.n4d(other, _dx, _dy, 0, 0, other.r43_1, other.s43_1, mix);
  }
  p4d(color, x, y, width, height) {
    var x1 = this.d4b(x);
    var x2 = this.d4b((x + width | 0) - 1 | 0);
    var y1 = this.e4b(y);
    var y2 = this.e4b((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.x43_1);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.h43_1, colorInt, this.m44(x1, cy), this.m44(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  q4d(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.r43_1 - x | 0 : width;
    height = height === VOID ? this.s43_1 - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.p4d(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.p4d.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  r4d(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.n4d(get_bmp(src), dx, dy, b.y2d(), b.a2e(), b.z2d(), b.b2e(), mix);
  }
  s4d(src, dx, dy) {
    return this.o4d(false, src, dx, dy);
  }
  t4d(src, dx, dy) {
    return this.o4d(true, src, dx, dy);
  }
  f44(src, dx, dy) {
    return this.r4d(src, dx, dy, true);
  }
  u4d(destination, input, source) {
    return Companion_getInstance_15().b4c(input, source, this, destination);
  }
  v4d(destination, input) {
    return Companion_getInstance_15().i4c(input, this, destination);
  }
  w4d(channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_15().e4d(this, channel, out);
    return out;
  }
  x4d(channel, out, $super) {
    out = out === VOID ? Bitmap8.s4e(this.r43_1, this.s43_1) : out;
    return $super === VOID ? this.w4d(channel, out) : $super.w4d.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.ec('Bitmap32(');
    this_0.gh(this.r43_1);
    this_0.ec(', ');
    this_0.gh(this.s43_1);
    if (!(this.w43_1 == null)) {
      this_0.ec(', name=');
      this_0.ec(this.w43_1);
    }
    this_0.ec(')');
    return this_0.toString();
  }
  g4b(y0, y1) {
    var s0 = this.m44(0, y0);
    var s1 = this.m44(0, y1);
    arraycopy(this.h43_1, s0, this.i43_1, 0, this.r43_1);
    arraycopy(this.h43_1, s1, this.h43_1, s0, this.r43_1);
    arraycopy(this.i43_1, 0, this.h43_1, s1, this.r43_1);
  }
  o10() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.h43_1.slice();
    return Bitmap32.k43(this.r43_1, this.s43_1, tmp$ret$1, this.x43_1);
  }
  n4b(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  t4e() {
    return this.x43_1 ? this : this.copyPremultiplied();
  }
  u4e() {
    return !this.x43_1 ? this : this.v4e();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.o10();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.w4e();
    return this_0;
  }
  v4e() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.o10();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.x4e();
    return this_0;
  }
  w4e() {
    if (this.x43_1)
      return Unit_instance;
    this.x43_1 = true;
    var inductionVariable = 0;
    var last = this.b2n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.h43_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.h43_1[n])));
      }
       while (inductionVariable < last);
  }
  x4e() {
    if (!this.x43_1)
      return Unit_instance;
    this.x43_1 = false;
    var inductionVariable = 0;
    var last = this.b2n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.h43_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.h43_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  a1() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  y4e(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.h43_1, this.m44(x, y), width);
    } else {
      var m = this.m44(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.h43_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  d44() {
    return this;
  }
}
class Companion_0 {
  z4e(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.w4a(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static b4f(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_11.a4f(1 << bpp) : palette;
    var $this = this.i44(width, height, bpp, false, bytes);
    $this.w4c_1 = bytes;
    $this.x4c_1 = palette;
    if ($this.w4c_1.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.za('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.d4d().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.y4c_1 = new Int8Array(tmp$ret$0);
    $this.z4c_1 = _UByteArrayInt___init__impl__xif7bu($this.d4d());
    $this.a4d_1 = 8 / bpp | 0;
    $this.b4d_1 = ilog2($this.a4d_1);
    $this.c4d_1 = $this.a4d_1 - 1 | 0;
    return $this;
  }
  d4d() {
    return this.w4c_1;
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.t43_1 + ', width=' + this.r43_1 + ', height=' + this.s43_1 + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.x4c_1) + ')';
  }
  w44(x, y) {
    return this.d4f(this.m44(x, y));
  }
  v44(x, y, color) {
    return this.c4f(this.m44(x, y), color);
  }
  d4f(n) {
    var iD = this.f4f(n);
    var iM = this.g4f(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.z4c_1, iD), imul(this.t43_1, iM), this.t43_1);
  }
  c4f(n, color) {
    var iD = this.f4f(n);
    var iM = this.g4f(n);
    UByteArrayInt__set_impl_gn4532(this.z4c_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.z4c_1, iD), color, imul(this.t43_1, iM), this.t43_1));
  }
  p44(x, y) {
    var tmp = this.x4c_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.w44(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  r44(x, y, v) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw NotImplementedError.ee('An operation is not implemented: ' + reason);
  }
  e4f(x, y) {
    return this.f4f(this.m44(x, y));
  }
  f4f(n) {
    return n >>> this.b4d_1 | 0;
  }
  g4f(n) {
    return n & this.c4d_1;
  }
  g4b(y0, y1) {
    var s0 = this.e4f(0, y0);
    var s1 = this.e4f(0, y1);
    arraycopy_0(this.d4d(), s0, this.y4c_1, 0, this.l44());
    arraycopy_0(this.d4d(), s1, this.d4d(), s0, this.l44());
    arraycopy_0(this.y4c_1, 0, this.d4d(), s1, this.l44());
  }
  h4f(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.d4d(), this.m44(x, y), width / this.a4d_1 | 0);
    } else {
      var m = this.m44(x, y);
      var inductionVariable = 0;
      var last = width / this.a4d_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.d4d()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  i4f() {
    var maxRefColor = -1;
    var inductionVariable = 0;
    var last = this.b2n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.math.max' call
        var a = maxRefColor;
        var b = this.d4f(n);
        maxRefColor = Math.max(a, b);
      }
       while (inductionVariable < last);
    return maxRefColor + 1 | 0;
  }
  d44() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.k43(this.r43_1, this.s43_1, VOID, this.x43_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.h43_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.x4c_1);
    var inductionVariable = 0;
    var last = this.b2n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.d4f(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static s4e(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_11.a4f(256) : palette;
    return this.b4f(8, width, height, data, palette);
  }
  m4b(width, height) {
    return Bitmap8.s4e(width, height, VOID, this.x4c_1);
  }
  v44(x, y, color) {
    return this.c4f(this.m44(x, y), color);
  }
  w44(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.z4c_1, this.m44(x, y));
  }
  p44(x, y) {
    var tmp = this.x4c_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.w44(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  d4f(n) {
    return UByteArrayInt__get_impl_px6q8a(this.z4c_1, n);
  }
  c4f(n, color) {
    UByteArrayInt__set_impl_gn4532(this.z4c_1, n, color);
  }
  z4a(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.z4a(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.d4d();
        var tmp_0 = this.m44(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).d4d(), dst.m44(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  o10() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this.d4d().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.x4c_1).slice();
    return Bitmap8.s4e(this.r43_1, this.s43_1, tmp, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.r43_1 + ', ' + this.s43_1 + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.x4c_1) + ')';
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_7 = this;
    this.n4f_1 = values();
  }
  d1(index) {
    return this.n4f_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.e4c_1 = index;
    this.f4c_1 = imul(this.e4c_1, 8);
    this.g4c_1 = 255 << this.f4c_1;
    this.h4c_1 = ~this.g4c_1;
  }
}
class Bitmaps {}
class Companion_2 {
  constructor() {
    this.o4f_1 = 1.0;
    this.p4f_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.q4f_1 = width;
    this.r4f_1 = height;
    this.s4f_1 = d;
    this.t4f_1 = px;
    this.u4f_1 = py;
    this.v4f_1 = imul(this.q4f_1, this.r4f_1);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.s4f_1.length >= this.v4f_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.l5(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.t4f_1.length >= this.v4f_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.l5(toString_0(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.u4f_1.length >= this.v4f_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_1 = 'Check failed.';
      throw IllegalStateException.l5(toString_0(message_1));
    }
  }
  a4b(x) {
    return x >= 0 && x < this.q4f_1;
  }
  b4b(y) {
    return y >= 0 && y < this.r4f_1;
  }
  c4b(x, y) {
    return this.a4b(x) && this.b4b(y);
  }
  m44(x, y) {
    return imul(y, this.q4f_1) + x | 0;
  }
  a4g(x, y) {
    return this.c4b(x, y) ? this.s4f_1[this.m44(x, y)] : Infinity;
  }
  x4f(x, y) {
    return this.c4b(x, y) ? this.t4f_1[this.m44(x, y)] : -1;
  }
  y4f(x, y) {
    return this.c4b(x, y) ? this.u4f_1[this.m44(x, y)] : -1;
  }
  z4f(x, y, d) {
    if (!this.c4b(x, y))
      return Unit_instance;
    this.s4f_1[this.m44(x, y)] = d;
  }
  b4g(x, y, px, py) {
    if (!this.c4b(x, y))
      return Unit_instance;
    var index = this.m44(x, y);
    this.t4f_1[index] = px;
    this.u4f_1[index] = py;
  }
  w4f(x, y, px, py) {
    return this.b4g(x, y, this.x4f(px, py), this.y4f(px, py));
  }
  c4g(bmp, thresold) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.q4f_1 === bmp.r43_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.l5(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.r4f_1 === bmp.s43_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.l5(toString_0(message_0));
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.r4f_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.q4f_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.z4f(x, y, Infinity);
            this.b4g(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.r4f_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.q4f_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.z4f(x_0, y_0, 0.0);
              this.b4g(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.r4f_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.q4f_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.r4f_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.q4f_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.r4f_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.q4f_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.z4f(x_3, y_3, -this.a4g(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  static r4g(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.i44(width, height, 32, premultiplied, data);
    $this.q4g_1 = data;
    return $this;
  }
  r44(x, y, v) {
    var rindex = index4(this, x, y);
    this.q4g_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.q4g_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.q4g_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.q4g_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  p44(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_22().s4g(this.q4g_1[rindex + 0 | 0], this.q4g_1[rindex + 1 | 0], this.q4g_1[rindex + 2 | 0], this.q4g_1[rindex + 3 | 0]);
  }
  t4g(x, y) {
    return this.q4g_1[index4(this, x, y) + 0 | 0];
  }
  u4g(x, y) {
    return this.q4g_1[index4(this, x, y) + 1 | 0];
  }
  v4g(x, y) {
    return this.q4g_1[index4(this, x, y) + 2 | 0];
  }
  w4g(x, y) {
    return this.q4g_1[index4(this, x, y) + 3 | 0];
  }
  x4g(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.q4g_1[rindex + 0 | 0] = r;
    this.q4g_1[rindex + 1 | 0] = g;
    this.q4g_1[rindex + 2 | 0] = b;
    this.q4g_1[rindex + 3 | 0] = a;
  }
  y4g(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.q4g_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.q4g_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.q4g_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.q4g_1[rindex + 3 | 0]);
    return out;
  }
  z4g(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.r43_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.s43_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.m44(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.y4g(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  a4h(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.z4g(out) : $super.z4g.call(this, out);
  }
  b4h(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.r43_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.s43_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.m44(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.y4g(x, y, out);
            this.x4g(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  c4h(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.b4h(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.b4h.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  d4h() {
    var _destruct__k2r9zo = this.a4h();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.c4h(-range, +range);
  }
  e4h(scale) {
    return this.f4h(scale, scale, scale, scale);
  }
  f4h(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.r43_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.s43_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.m44(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.x4g(x, y, this.t4g(x, y) * scaleRed, this.u4g(x, y) * scaleGreen, this.v4g(x, y) * scaleBlue, this.w4g(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  g4h(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.r43_1 - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.s43_1 - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.m44(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.t4g(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.u4g(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.v4g(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.w4g(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.x4g(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static v4h(width, height, data, premultiplied) {
    var $this = this.i44(width, height, 32, premultiplied, null);
    $this.u4h_1 = data;
    return $this;
  }
  d44() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_15().a4c(this.r43_1, this.s43_1, this.x43_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.o44(0, 0, this.r43_1, this.s43_1, this_0.h43_1, 0);
    return this_0;
  }
  r44(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.k44(), 0, v);
    this.q44(x, y, 1, 1, this.j44(), 0);
  }
  p44(x, y) {
    this.o44(x, y, 1, 1, this.j44(), 0);
    return RgbaArray__get_impl_nzyo1o(this.k44(), 0);
  }
  v44(x, y, color) {
    return this.r44(x, y, _RGBA___init__impl__lqpay5(color));
  }
  w44(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.p44(x, y));
  }
  f4b() {
    var tmp = this.d44().f4b();
    this.s44(0, 0, this.r43_1, this.s43_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).h43_1);
    return this;
  }
  h4b() {
    var tmp = this.d44().h4b();
    this.s44(0, 0, this.r43_1, this.s43_1, (tmp instanceof Bitmap32 ? tmp : THROW_CCE()).h43_1);
    return this;
  }
  g4b(y0, y1) {
    this.o44(0, y0, this.r43_1, 1, this.j44(), 0);
    this.o44(0, y1, this.r43_1, 1, this.j44(), this.r43_1);
    this.q44(0, y1, this.r43_1, 1, this.j44(), 0);
    this.q44(0, y0, this.r43_1, 1, this.j44(), this.r43_1);
  }
  i4b(x0, x1) {
    this.o44(x0, 0, 1, this.s43_1, this.j44(), 0);
    this.o44(x1, 0, 1, this.s43_1, this.j44(), this.r43_1);
    this.q44(x1, 0, 1, this.s43_1, this.j44(), 0);
    this.q44(x0, 0, 1, this.s43_1, this.j44(), this.r43_1);
  }
  m4b(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.u3() + '(' + this.r43_1 + ', ' + this.s43_1 + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class NullBitmap extends Bitmap {
  static a4j(width, height, premultiplied) {
    Companion_getInstance_19();
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.i44(width, height, 32, premultiplied, null);
  }
  r44(x, y, v) {
    return Unit_instance;
  }
  p44(x, y) {
    return _RGBA___init__impl__lqpay5(0);
  }
}
class Companion_3 extends NullBitmap {
  static m4i() {
    Companion_instance_9 = null;
    var $this = this.a4j(1, 1);
    Companion_instance_9 = $this;
    return $this;
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.j4f_1 = colors;
    this.k4f_1 = names;
    this.l4f_1 = changeStart;
    this.m4f_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.ec('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.j4f_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.j4f_1, n);
        var tmp22_safe_receiver = this.k4f_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.ec(', ');
        }
        if (!(name == null)) {
          this_0.ec(name);
          this_0.ec(': ');
        }
        this_0.ec(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.ec(')');
    return this_0.toString();
  }
}
class Result {
  constructor(bmp, buffer, radius, cutoff) {
    this.l4j_1 = bmp;
    this.m4j_1 = buffer;
    this.n4j_1 = radius;
    this.o4j_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.l4j_1.toString() + ', buffer=' + this.m4j_1 + ', radius=' + this.n4j_1 + ', cutoff=' + this.o4j_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.l4j_1);
    result = imul(result, 31) + this.m4j_1 | 0;
    result = imul(result, 31) + this.n4j_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.l4j_1, tmp0_other_with_cast.l4j_1))
      return false;
    if (!(this.m4j_1 === tmp0_other_with_cast.m4j_1))
      return false;
    if (!(this.n4j_1 === tmp0_other_with_cast.n4j_1))
      return false;
    if (!equals(this.o4j_1, tmp0_other_with_cast.o4j_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.p4j_1 = 1.0E10;
  }
  q4j(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.k43(bmp.r43_1 + imul(buffer, 2) | 0, bmp.s43_1 + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.r43_1;
    var height = out.s43_1;
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.r43_1;
    var height_0 = out.s43_1;
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.s43_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.r43_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.i4d(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.k2q(x0, y0, 1.0E10);
                gridInner.k2q(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.k2q(x0, y0, 0.0);
                gridInner.k2q(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.k2q(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.k2q(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.r4j(gridOuter.i2q_1, 0, 0, out.r43_1, out.s43_1, gridOuter.x2p(), f, v, z);
    this.r4j(gridInner.i2q_1, buffer, buffer, bmp.r43_1, bmp.s43_1, gridInner.x2p(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.s43_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.r43_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.s2f(x_0, y_0);
            var gin = gridInner.s2f(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.h4d(x_0, y_0, Companion_getInstance_22().k4j(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  }
  s4j(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.r43_1;
      var b = bmp.s43_1;
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.q4j(bmp, maxSide, buffer, radius, cutoff) : $super.q4j.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  r4j(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.t4j(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.t4j(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  t4j(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class ColorFormat32 {
  constructor() {
    this.z4j_1 = 32;
  }
  u4j() {
    return this.z4j_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.a4k_1 = 24;
  }
  u4j() {
    return this.a4k_1;
  }
}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.b4k_1 = _r;
    this.c4k_1 = _g;
    this.d4k_1 = _b;
    this.e4k_1 = _a;
    this.f4k_1 = true;
    this.g4k_1 = Colors_getInstance().y44_1;
  }
  h4k() {
    return this.b4k_1;
  }
  i4k() {
    return this.c4k_1;
  }
  j4k() {
    return this.d4k_1;
  }
  k4k(value) {
    this.e4k_1 = value;
    this.f4k_1 = true;
  }
  l4k() {
    return this.e4k_1;
  }
  m4k(v) {
    this.n4k(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.g4k_1 = v;
    this.f4k_1 = false;
  }
  o4k() {
    if (this.f4k_1) {
      this.f4k_1 = false;
      this.g4k_1 = Companion_getInstance_22().s4g(this.b4k_1, this.c4k_1, this.d4k_1, this.e4k_1);
    }
    return this.g4k_1;
  }
  n4k(r, g, b, a) {
    this.b4k_1 = r;
    this.c4k_1 = g;
    this.d4k_1 = b;
    this.e4k_1 = a;
    this.f4k_1 = true;
  }
  p4k(other) {
    return this.n4k(other.b4k_1, other.c4k_1, other.d4k_1, other.e4k_1);
  }
  q4k(a, b) {
    return this.n4k(a.h4k() * b.h4k(), a.i4k() * b.i4k(), a.j4k() * b.j4k(), a.l4k() * b.l4k());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.b4k_1 + ', _g=' + this.c4k_1 + ', _b=' + this.d4k_1 + ', _a=' + this.e4k_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b4k_1);
    result = imul(result, 31) + getNumberHashCode(this.c4k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d4k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e4k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.b4k_1, tmp0_other_with_cast.b4k_1))
      return false;
    if (!equals(this.c4k_1, tmp0_other_with_cast.c4k_1))
      return false;
    if (!equals(this.d4k_1, tmp0_other_with_cast.d4k_1))
      return false;
    if (!equals(this.e4k_1, tmp0_other_with_cast.e4k_1))
      return false;
    return true;
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.y44_1 = Companion_getInstance_22().k4j(255, 255, 255, 255);
    this.z44_1 = Companion_getInstance_22().k4j(0, 0, 0, 255);
    this.a45_1 = Companion_getInstance_22().k4j(255, 0, 0, 255);
    this.b45_1 = Companion_getInstance_22().k4j(0, 255, 0, 255);
    this.c45_1 = Companion_getInstance_22().k4j(0, 0, 255, 255);
    this.d45_1 = Companion_getInstance_22().k4j(0, 0, 0, 0);
    this.e45_1 = Companion_getInstance_22().k4j(255, 255, 255, 0);
    this.f45_1 = Companion_getInstance_22().r4k(240, 248, 255);
    this.g45_1 = Companion_getInstance_22().r4k(250, 235, 215);
    this.h45_1 = Companion_getInstance_22().r4k(0, 255, 255);
    this.i45_1 = Companion_getInstance_22().r4k(127, 255, 212);
    this.j45_1 = Companion_getInstance_22().r4k(240, 255, 255);
    this.k45_1 = Companion_getInstance_22().r4k(245, 245, 220);
    this.l45_1 = Companion_getInstance_22().r4k(255, 228, 196);
    this.m45_1 = Companion_getInstance_22().r4k(255, 235, 205);
    this.n45_1 = Companion_getInstance_22().r4k(138, 43, 226);
    this.o45_1 = Companion_getInstance_22().r4k(165, 42, 42);
    this.p45_1 = Companion_getInstance_22().r4k(222, 184, 135);
    this.q45_1 = Companion_getInstance_22().r4k(95, 158, 160);
    this.r45_1 = Companion_getInstance_22().r4k(127, 255, 0);
    this.s45_1 = Companion_getInstance_22().r4k(210, 105, 30);
    this.t45_1 = Companion_getInstance_22().r4k(255, 127, 80);
    this.u45_1 = Companion_getInstance_22().r4k(100, 149, 237);
    this.v45_1 = Companion_getInstance_22().r4k(255, 248, 220);
    this.w45_1 = Companion_getInstance_22().r4k(220, 20, 60);
    this.x45_1 = Companion_getInstance_22().r4k(0, 0, 139);
    this.y45_1 = Companion_getInstance_22().r4k(0, 255, 255);
    this.z45_1 = Companion_getInstance_22().r4k(0, 139, 139);
    this.a46_1 = Companion_getInstance_22().r4k(184, 134, 11);
    this.b46_1 = Companion_getInstance_22().r4k(169, 169, 169);
    this.c46_1 = Companion_getInstance_22().r4k(0, 100, 0);
    this.d46_1 = Companion_getInstance_22().r4k(169, 169, 169);
    this.e46_1 = Companion_getInstance_22().r4k(189, 183, 107);
    this.f46_1 = Companion_getInstance_22().r4k(255, 0, 255);
    this.g46_1 = Companion_getInstance_22().r4k(139, 0, 139);
    this.h46_1 = Companion_getInstance_22().r4k(85, 107, 47);
    this.i46_1 = Companion_getInstance_22().r4k(255, 140, 0);
    this.j46_1 = Companion_getInstance_22().r4k(153, 50, 204);
    this.k46_1 = Companion_getInstance_22().r4k(139, 0, 0);
    this.l46_1 = Companion_getInstance_22().r4k(233, 150, 122);
    this.m46_1 = Companion_getInstance_22().r4k(143, 188, 143);
    this.n46_1 = Companion_getInstance_22().r4k(72, 61, 139);
    this.o46_1 = Companion_getInstance_22().r4k(47, 79, 79);
    this.p46_1 = Companion_getInstance_22().r4k(47, 79, 79);
    this.q46_1 = Companion_getInstance_22().r4k(0, 206, 209);
    this.r46_1 = Companion_getInstance_22().r4k(148, 0, 211);
    this.s46_1 = Companion_getInstance_22().r4k(255, 20, 147);
    this.t46_1 = Companion_getInstance_22().r4k(0, 191, 255);
    this.u46_1 = Companion_getInstance_22().r4k(105, 105, 105);
    this.v46_1 = Companion_getInstance_22().r4k(105, 105, 105);
    this.w46_1 = Companion_getInstance_22().r4k(30, 144, 255);
    this.x46_1 = Companion_getInstance_22().r4k(178, 34, 34);
    this.y46_1 = Companion_getInstance_22().r4k(255, 250, 240);
    this.z46_1 = Companion_getInstance_22().r4k(34, 139, 34);
    this.a47_1 = Companion_getInstance_22().r4k(255, 0, 255);
    this.b47_1 = Companion_getInstance_22().r4k(220, 220, 220);
    this.c47_1 = Companion_getInstance_22().r4k(248, 248, 255);
    this.d47_1 = Companion_getInstance_22().r4k(255, 215, 0);
    this.e47_1 = Companion_getInstance_22().r4k(218, 165, 32);
    this.f47_1 = Companion_getInstance_22().r4k(173, 255, 47);
    this.g47_1 = Companion_getInstance_22().r4k(240, 255, 240);
    this.h47_1 = Companion_getInstance_22().r4k(255, 105, 180);
    this.i47_1 = Companion_getInstance_22().r4k(205, 92, 92);
    this.j47_1 = Companion_getInstance_22().r4k(75, 0, 130);
    this.k47_1 = Companion_getInstance_22().r4k(255, 255, 240);
    this.l47_1 = Companion_getInstance_22().r4k(240, 230, 140);
    this.m47_1 = Companion_getInstance_22().r4k(230, 230, 250);
    this.n47_1 = Companion_getInstance_22().r4k(255, 240, 245);
    this.o47_1 = Companion_getInstance_22().r4k(124, 252, 0);
    this.p47_1 = Companion_getInstance_22().r4k(255, 250, 205);
    this.q47_1 = Companion_getInstance_22().r4k(173, 216, 230);
    this.r47_1 = Companion_getInstance_22().r4k(240, 128, 128);
    this.s47_1 = Companion_getInstance_22().r4k(224, 255, 255);
    this.t47_1 = Companion_getInstance_22().r4k(250, 250, 210);
    this.u47_1 = Companion_getInstance_22().r4k(211, 211, 211);
    this.v47_1 = Companion_getInstance_22().r4k(144, 238, 144);
    this.w47_1 = Companion_getInstance_22().r4k(211, 211, 211);
    this.x47_1 = Companion_getInstance_22().r4k(255, 182, 193);
    this.y47_1 = Companion_getInstance_22().r4k(255, 160, 122);
    this.z47_1 = Companion_getInstance_22().r4k(32, 178, 170);
    this.a48_1 = Companion_getInstance_22().r4k(135, 206, 250);
    this.b48_1 = Companion_getInstance_22().r4k(119, 136, 153);
    this.c48_1 = Companion_getInstance_22().r4k(119, 136, 153);
    this.d48_1 = Companion_getInstance_22().r4k(176, 196, 222);
    this.e48_1 = Companion_getInstance_22().r4k(255, 255, 224);
    this.f48_1 = Companion_getInstance_22().r4k(0, 255, 0);
    this.g48_1 = Companion_getInstance_22().r4k(50, 205, 50);
    this.h48_1 = Companion_getInstance_22().r4k(250, 240, 230);
    this.i48_1 = Companion_getInstance_22().r4k(128, 0, 0);
    this.j48_1 = Companion_getInstance_22().r4k(102, 205, 170);
    this.k48_1 = Companion_getInstance_22().r4k(0, 0, 205);
    this.l48_1 = Companion_getInstance_22().r4k(186, 85, 211);
    this.m48_1 = Companion_getInstance_22().r4k(147, 112, 219);
    this.n48_1 = Companion_getInstance_22().r4k(60, 179, 113);
    this.o48_1 = Companion_getInstance_22().r4k(123, 104, 238);
    this.p48_1 = Companion_getInstance_22().r4k(0, 250, 154);
    this.q48_1 = Companion_getInstance_22().r4k(72, 209, 204);
    this.r48_1 = Companion_getInstance_22().r4k(199, 21, 133);
    this.s48_1 = Companion_getInstance_22().r4k(25, 25, 112);
    this.t48_1 = Companion_getInstance_22().r4k(245, 255, 250);
    this.u48_1 = Companion_getInstance_22().r4k(255, 228, 225);
    this.v48_1 = Companion_getInstance_22().r4k(255, 228, 181);
    this.w48_1 = Companion_getInstance_22().r4k(255, 222, 173);
    this.x48_1 = Companion_getInstance_22().r4k(0, 0, 128);
    this.y48_1 = Companion_getInstance_22().r4k(253, 245, 230);
    this.z48_1 = Companion_getInstance_22().r4k(128, 128, 0);
    this.a49_1 = Companion_getInstance_22().r4k(107, 142, 35);
    this.b49_1 = Companion_getInstance_22().r4k(255, 165, 0);
    this.c49_1 = Companion_getInstance_22().r4k(255, 69, 0);
    this.d49_1 = Companion_getInstance_22().r4k(218, 112, 214);
    this.e49_1 = Companion_getInstance_22().r4k(238, 232, 170);
    this.f49_1 = Companion_getInstance_22().r4k(152, 251, 152);
    this.g49_1 = Companion_getInstance_22().r4k(175, 238, 238);
    this.h49_1 = Companion_getInstance_22().r4k(219, 112, 147);
    this.i49_1 = Companion_getInstance_22().r4k(255, 239, 213);
    this.j49_1 = Companion_getInstance_22().r4k(255, 218, 185);
    this.k49_1 = Companion_getInstance_22().r4k(205, 133, 63);
    this.l49_1 = Companion_getInstance_22().r4k(255, 192, 203);
    this.m49_1 = Companion_getInstance_22().r4k(221, 160, 221);
    this.n49_1 = Companion_getInstance_22().r4k(176, 224, 230);
    this.o49_1 = Companion_getInstance_22().r4k(128, 0, 128);
    this.p49_1 = Companion_getInstance_22().r4k(188, 143, 143);
    this.q49_1 = Companion_getInstance_22().r4k(65, 105, 225);
    this.r49_1 = Companion_getInstance_22().r4k(139, 69, 19);
    this.s49_1 = Companion_getInstance_22().r4k(250, 128, 114);
    this.t49_1 = Companion_getInstance_22().r4k(244, 164, 96);
    this.u49_1 = Companion_getInstance_22().r4k(46, 139, 87);
    this.v49_1 = Companion_getInstance_22().r4k(255, 245, 238);
    this.w49_1 = Companion_getInstance_22().r4k(160, 82, 45);
    this.x49_1 = Companion_getInstance_22().r4k(192, 192, 192);
    this.y49_1 = Companion_getInstance_22().r4k(135, 206, 235);
    this.z49_1 = Companion_getInstance_22().r4k(106, 90, 205);
    this.a4a_1 = Companion_getInstance_22().r4k(112, 128, 144);
    this.b4a_1 = Companion_getInstance_22().r4k(112, 128, 144);
    this.c4a_1 = Companion_getInstance_22().r4k(255, 250, 250);
    this.d4a_1 = Companion_getInstance_22().r4k(0, 255, 127);
    this.e4a_1 = Companion_getInstance_22().r4k(70, 130, 180);
    this.f4a_1 = Companion_getInstance_22().r4k(210, 180, 140);
    this.g4a_1 = Companion_getInstance_22().r4k(0, 128, 128);
    this.h4a_1 = Companion_getInstance_22().r4k(216, 191, 216);
    this.i4a_1 = Companion_getInstance_22().r4k(255, 99, 71);
    this.j4a_1 = Companion_getInstance_22().r4k(64, 224, 208);
    this.k4a_1 = Companion_getInstance_22().r4k(238, 130, 238);
    this.l4a_1 = Companion_getInstance_22().r4k(245, 222, 179);
    this.m4a_1 = Companion_getInstance_22().r4k(245, 245, 245);
    this.n4a_1 = Companion_getInstance_22().r4k(154, 205, 50);
    this.o4a_1 = Companion_getInstance_22().r4k(255, 255, 0);
    this.p4a_1 = mapOf([to('black', new RGBA(this.z44_1)), to('white', new RGBA(this.y44_1)), to('red', new RGBA(this.a45_1)), to('green', new RGBA(this.b45_1)), to('blue', new RGBA(this.c45_1)), to('aliceblue', new RGBA(this.f45_1)), to('antiquewhite', new RGBA(this.g45_1)), to('aqua', new RGBA(this.h45_1)), to('aquamarine', new RGBA(this.i45_1)), to('azure', new RGBA(this.j45_1)), to('beige', new RGBA(this.k45_1)), to('bisque', new RGBA(this.l45_1)), to('blanchedalmond', new RGBA(this.m45_1)), to('blueviolet', new RGBA(this.n45_1)), to('brown', new RGBA(this.o45_1)), to('burlywood', new RGBA(this.p45_1)), to('cadetblue', new RGBA(this.q45_1)), to('chartreuse', new RGBA(this.r45_1)), to('chocolate', new RGBA(this.s45_1)), to('coral', new RGBA(this.t45_1)), to('cornflowerblue', new RGBA(this.u45_1)), to('cornsilk', new RGBA(this.v45_1)), to('crimson', new RGBA(this.w45_1)), to('cyan', new RGBA(this.y45_1)), to('darkblue', new RGBA(this.x45_1)), to('darkcyan', new RGBA(this.z45_1)), to('darkgoldenrod', new RGBA(this.a46_1)), to('darkgray', new RGBA(this.b46_1)), to('darkgreen', new RGBA(this.c46_1)), to('darkgrey', new RGBA(this.d46_1)), to('darkkhaki', new RGBA(this.e46_1)), to('darkmagenta', new RGBA(this.g46_1)), to('darkolivegreen', new RGBA(this.h46_1)), to('darkorange', new RGBA(this.i46_1)), to('darkorchid', new RGBA(this.j46_1)), to('darkred', new RGBA(this.k46_1)), to('darksalmon', new RGBA(this.l46_1)), to('darkseagreen', new RGBA(this.m46_1)), to('darkslateblue', new RGBA(this.n46_1)), to('darkslategray', new RGBA(this.o46_1)), to('darkslategrey', new RGBA(this.p46_1)), to('darkturquoise', new RGBA(this.q46_1)), to('darkviolet', new RGBA(this.r46_1)), to('deeppink', new RGBA(this.s46_1)), to('deepskyblue', new RGBA(this.t46_1)), to('dimgray', new RGBA(this.u46_1)), to('dimgrey', new RGBA(this.v46_1)), to('dodgerblue', new RGBA(this.w46_1)), to('firebrick', new RGBA(this.x46_1)), to('floralwhite', new RGBA(this.y46_1)), to('forestgreen', new RGBA(this.z46_1)), to('fuchsia', new RGBA(this.a47_1)), to('gainsboro', new RGBA(this.b47_1)), to('ghostwhite', new RGBA(this.c47_1)), to('gold', new RGBA(this.d47_1)), to('goldenrod', new RGBA(this.e47_1)), to('greenyellow', new RGBA(this.f47_1)), to('honeydew', new RGBA(this.g47_1)), to('hotpink', new RGBA(this.h47_1)), to('indianred', new RGBA(this.i47_1)), to('indigo', new RGBA(this.j47_1)), to('ivory', new RGBA(this.k47_1)), to('khaki', new RGBA(this.l47_1)), to('lavender', new RGBA(this.m47_1)), to('lavenderblush', new RGBA(this.n47_1)), to('lawngreen', new RGBA(this.o47_1)), to('lemonchiffon', new RGBA(this.p47_1)), to('lightblue', new RGBA(this.q47_1)), to('lightcoral', new RGBA(this.r47_1)), to('lightcyan', new RGBA(this.s47_1)), to('lightgoldenrodyellow', new RGBA(this.t47_1)), to('lightgray', new RGBA(this.u47_1)), to('lightgreen', new RGBA(this.v47_1)), to('lightgrey', new RGBA(this.w47_1)), to('lightpink', new RGBA(this.x47_1)), to('lightsalmon', new RGBA(this.y47_1)), to('lightseagreen', new RGBA(this.z47_1)), to('lightskyblue', new RGBA(this.a48_1)), to('lightslategray', new RGBA(this.b48_1)), to('lightslategrey', new RGBA(this.c48_1)), to('lightsteelblue', new RGBA(this.d48_1)), to('lightyellow', new RGBA(this.e48_1)), to('lime', new RGBA(this.f48_1)), to('limegreen', new RGBA(this.g48_1)), to('linen', new RGBA(this.h48_1)), to('magenta', new RGBA(this.f46_1)), to('maroon', new RGBA(this.i48_1)), to('mediumaquamarine', new RGBA(this.j48_1)), to('mediumblue', new RGBA(this.k48_1)), to('mediumorchid', new RGBA(this.l48_1)), to('mediumpurple', new RGBA(this.m48_1)), to('mediumseagreen', new RGBA(this.n48_1)), to('mediumslateblue', new RGBA(this.o48_1)), to('mediumspringgreen', new RGBA(this.p48_1)), to('mediumturquoise', new RGBA(this.q48_1)), to('mediumvioletred', new RGBA(this.r48_1)), to('midnightblue', new RGBA(this.s48_1)), to('mintcream', new RGBA(this.t48_1)), to('mistyrose', new RGBA(this.u48_1)), to('moccasin', new RGBA(this.v48_1)), to('navajowhite', new RGBA(this.w48_1)), to('navy', new RGBA(this.x48_1)), to('oldlace', new RGBA(this.y48_1)), to('olive', new RGBA(this.z48_1)), to('olivedrab', new RGBA(this.a49_1)), to('orange', new RGBA(this.b49_1)), to('orangered', new RGBA(this.c49_1)), to('orchid', new RGBA(this.d49_1)), to('palegoldenrod', new RGBA(this.e49_1)), to('palegreen', new RGBA(this.f49_1)), to('paleturquoise', new RGBA(this.g49_1)), to('palevioletred', new RGBA(this.h49_1)), to('papayawhip', new RGBA(this.i49_1)), to('peachpuff', new RGBA(this.j49_1)), to('peru', new RGBA(this.k49_1)), to('pink', new RGBA(this.l49_1)), to('plum', new RGBA(this.m49_1)), to('powderblue', new RGBA(this.n49_1)), to('purple', new RGBA(this.o49_1)), to('rosybrown', new RGBA(this.p49_1)), to('royalblue', new RGBA(this.q49_1)), to('saddlebrown', new RGBA(this.r49_1)), to('salmon', new RGBA(this.s49_1)), to('sandybrown', new RGBA(this.t49_1)), to('seagreen', new RGBA(this.u49_1)), to('seashell', new RGBA(this.v49_1)), to('sienna', new RGBA(this.w49_1)), to('silver', new RGBA(this.x49_1)), to('skyblue', new RGBA(this.y49_1)), to('slateblue', new RGBA(this.z49_1)), to('slategray', new RGBA(this.a4a_1)), to('slategrey', new RGBA(this.b4a_1)), to('snow', new RGBA(this.c4a_1)), to('springgreen', new RGBA(this.d4a_1)), to('steelblue', new RGBA(this.e4a_1)), to('tan', new RGBA(this.f4a_1)), to('teal', new RGBA(this.g4a_1)), to('thistle', new RGBA(this.h4a_1)), to('tomato', new RGBA(this.i4a_1)), to('turquoise', new RGBA(this.j4a_1)), to('violet', new RGBA(this.k4a_1)), to('wheat', new RGBA(this.l4a_1)), to('whitesmoke', new RGBA(this.m4a_1)), to('yellowgreen', new RGBA(this.n4a_1)), to('yellow', new RGBA(this.o4a_1))]);
  }
  s4k(str) {
    return this.t4k(str, this.d45_1, true);
  }
  t4k(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).z2(hex.length))
          return this.z44_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_22().k4j(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.e1() : false) {
          tmp = parts.d1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.e1() : false) {
          tmp_0 = parts.d1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.e1() : false) {
          tmp_1 = parts.d1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.e1() : false) {
          tmp_2 = parts.d1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_22().k4j(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.p4a_1.h3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.u4k_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.v4k('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().a45_1;
      } else {
        throw $p;
      }
    }
  }
  v4k(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.t4k(str, default_0, errorOnDefault) : $super.t4k.call(this, str, new RGBA(default_0), errorOnDefault).u4k_1;
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_20();
    super();
    this.x4k_1 = rOffset;
    this.y4k_1 = gOffset;
    this.z4k_1 = bOffset;
  }
  v4j(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.x4k_1 | 0) & 255;
  }
  w4j(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.y4k_1 | 0) & 255;
  }
  x4j(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.z4k_1 | 0) & 255;
  }
  y4j(v) {
    return 255;
  }
}
class Companion_4 extends RGB {
  constructor() {
    Companion_instance_10 = null;
    super(0, 8, 16);
    Companion_instance_10 = this;
  }
}
class Companion_5 {
  a4f(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.a4l_1 = ints;
  }
  e3(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.a4l_1, fromIndex, toIndex);
  }
  b4l(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.a4l_1, elements);
  }
  a3(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  c4l(element) {
    return RgbaArray__indexOf_impl_d6b5pl(this.a4l_1, element);
  }
  b3(element) {
    return RgbaArray__indexOf_impl_d6b5pl_0(this, element);
  }
  g1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.a4l_1);
  }
  a1() {
    return RgbaArray__iterator_impl_5wfwsm(this.a4l_1);
  }
  c3() {
    return RgbaArray__listIterator_impl_m4kjt0(this.a4l_1);
  }
  d3(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.a4l_1, index);
  }
  e1() {
    return _RgbaArray___get_size__impl__imxef8(this.a4l_1);
  }
  d4l(index) {
    return RgbaArray__get_impl_nzyo1o(this.a4l_1, index);
  }
  d1(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.a4l_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.a4l_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.a4l_1, other);
  }
}
class Companion_6 extends ColorFormat32 {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
    this.r4a_1 = 0;
    this.s4a_1 = 8;
    this.t4a_1 = 16;
    this.u4a_1 = 24;
  }
  s4g(r, g, b, a) {
    return this.e4l(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  e4l(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  k4j(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  r4k(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  f4l(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  g4l(rgba) {
    return rgba;
  }
  v4j(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  w4j(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  x4j(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  y4j(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  h4l(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.i4l(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  i4l(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  j4l(c1, c2, factor) {
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = Ratio__toFloat_impl_1ftup5(factor) * 256;
    var tmp$ret$0 = roundToInt(this_0);
    return this.h4l(c1, c2, tmp$ret$0);
  }
  k4l(c1, c2, factor) {
    return Companion_getInstance_22().f4l(_RGBA___get_rgb__impl__tijaqt(this.j4l(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  v4a(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.k4l(c00, c10, factorX);
    var c2 = this.k4l(c01, c11, factorX);
    return this.k4l(c1, c2, factorY);
  }
  j4j(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_22().f4l(_RGBA___get_rgb__impl__tijaqt(this.h4l(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  l4l(src, dst, ratio) {
    return Companion_getInstance_22().k4j(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_22();
    this.u4k_1 = value;
  }
  o10() {
    return RGBA__clone_impl_w007z0(this.u4k_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.u4k_1);
  }
  m4l(other) {
    return RGBA__compareTo_impl_lrfjc1(this.u4k_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.u4k_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.u4k_1, other);
  }
}
class Companion_7 {
  constructor() {
    this.n4l_1 = 16711935;
    this.o4l_1 = -16711936;
  }
  p4l(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
}
class Companion_8 {
  q4l(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.r4l_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.r4l_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.r4l_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.r4l_1, other);
  }
}
class Companion_9 {
  s4l(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_10 {
  b4m(font, fontSize, chars, fontName, paint, mipmaps_0, effect) {
    var fontSizeD = numberToDouble(fontSize);
    var fmetrics = font.c4m(fontSizeD);
    // Inline function 'kotlin.collections.map' call
    var this_0 = chars.d4m_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = font.e4m(fontSizeD, item, VOID, null);
      destination.h(tmp$ret$0);
    }
    var glyphMetrics = destination;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(glyphMetrics, 10));
    var tmp0_iterator = glyphMetrics.a1();
    while (tmp0_iterator.b1()) {
      var item_0 = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.Companion.invoke.<anonymous>' call
      var tmp$ret$3 = (item_0.x2p() + 4) * (fmetrics.t4m() + 4);
      destination_0.h(tmp$ret$3);
    }
    var requiredArea = toIntCeil_0(sum(destination_0));
    // Inline function 'kotlin.math.sqrt' call
    var tmp$ret$6 = Math.sqrt(requiredArea);
    var requiredAreaSide = toIntCeil(tmp$ret$6);
    var matlas = MutableAtlas.n43(get_nextPowerOfTwo(requiredAreaSide), get_nextPowerOfTwo(requiredAreaSide));
    var border = 2;
    var indexedObject = chars.d4m_1;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable_0 < last_0) {
      var codePoint = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var result = renderGlyphToBitmap(font, fontSizeD, codePoint, paint, true, effect, 1);
      matlas.p43(result.u4m_1.d44().t4e(), result);
    }
    var fm = first(matlas.r42_1).i42_1.v4m_1;
    var atlas = mipmaps(matlas.p42_1, mipmaps_0);
    // Inline function 'korlibs.image.font.Companion.invoke' call
    var lineHeight = fmetrics.t4m();
    var base = fmetrics.l4m_1;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = matlas.r42_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_1 = LinkedHashMap.sc(capacity);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.image.font.Companion.invoke.<anonymous>' call
      var slice = element.h42_1;
      var g = first(element.i42_1.x4m_1);
      var m = g.c4n_1;
      var pair = to(g.a4n_1, new Glyph(fontSizeD, g.a4n_1, slice, -border | 0, numberToInt(border - m.y2p() - m.a2e()) + numberToInt(fm.m4m_1) | 0, toIntCeil_0(m.j4m_1)));
      destination_1.j3(pair.sl_1, pair.tl_1);
    }
    var glyphs = toIntMap(destination_1);
    var kernings = IntMap.p2w();
    return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs, kernings, fontName, null);
  }
}
class Kerning {
  constructor(first, second, amount) {
    this.l4n_1 = first;
    this.m4n_1 = second;
    this.n4n_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.t4l_1 = fontSize;
    this.u4l_1 = id;
    this.v4l_1 = texture;
    this.w4l_1 = xoffset;
    this.x4l_1 = yoffset;
    this.y4l_1 = xadvance;
    var tmp = this;
    tmp.z4l_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.a4m_1 = new GlyphMetrics(this.t4l_1, true, -1, Companion_getInstance_4().o2l(this.w4l_1, this.x4l_1, this.v4l_1.j3o_1, this.v4l_1.k3o_1), this.y4l_1);
  }
  o4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z4l_1;
    bmp$factory();
    return this_0.u1();
  }
  toString() {
    return 'Glyph(fontSize=' + this.t4l_1 + ', id=' + this.u4l_1 + ', texture=' + this.v4l_1.toString() + ', xoffset=' + this.w4l_1 + ', yoffset=' + this.x4l_1 + ', xadvance=' + this.y4l_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.t4l_1);
    result = imul(result, 31) + this.u4l_1 | 0;
    result = imul(result, 31) + this.v4l_1.hashCode() | 0;
    result = imul(result, 31) + this.w4l_1 | 0;
    result = imul(result, 31) + this.x4l_1 | 0;
    result = imul(result, 31) + this.y4l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.t4l_1, tmp0_other_with_cast.t4l_1))
      return false;
    if (!(this.u4l_1 === tmp0_other_with_cast.u4l_1))
      return false;
    if (!this.v4l_1.equals(tmp0_other_with_cast.v4l_1))
      return false;
    if (!(this.w4l_1 === tmp0_other_with_cast.w4l_1))
      return false;
    if (!(this.x4l_1 === tmp0_other_with_cast.x4l_1))
      return false;
    if (!(this.y4l_1 === tmp0_other_with_cast.y4l_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_2() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.x4n(size, metrics) : $super.x4n.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.z4n(size, codePoint, metrics, reader) : $super.z4n.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.e4o(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.e4o.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function get_baseBmp() {
  return get_bmp(this.u4n().v4l_1);
}
function getFontMetrics(size, metrics) {
  return metrics.y4n(this.v4n(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.a4o(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.a4m_1;
  return metrics.b4o(tmp0_elvis_lhs == null ? this.w4n() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.p4n();
}
function get_0(charCode) {
  var tmp0_elvis_lhs = this.a4o(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.a4o(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.u4n() : tmp1_elvis_lhs;
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.d4o(size);
  var tmp0_elvis_lhs = this.r4n().d1(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.z4n(size, codePoint, metrics, reader);
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
  if (this_0.g4m_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.x2p() === 0.0 && metrics.y2p() === 0.0)
    return false;
  var texX = pos.h2d_1 + metrics.y2d();
  var texY = pos.i2d_1 + metrics.a2e();
  var swidth = metrics.x2p();
  var sheight = metrics.y2p();
  var tmp_1;
  if (equals(ctx.b4p(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.o4n();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.k43(g.o4n().r43_1, g.o4n().s43_1, VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.v43_1;
    if (true) {
      this_1.e44();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx_0 = this_1.n4b(true);
      try {
        // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.s4b_1.f4o_1;
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
          ctx_0.a4p(1.0 / scale);
          ctx_0.c4p(ctx.b4p());
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var width = ctx_0.x2p() * scale;
          var height = ctx_0.y2p() * scale;
          ctx_0.d4p(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
        }finally {
          ctx_0.s4b_1.f4o_1 = t;
        }
      }finally {
        ctx_0.d1b();
      }
    }finally {
      result = true ? this_1.g44(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.u4d(BitmapChannel_ALPHA_getInstance(), g.o4n(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.e4p(bmp, Vector2D.q2f(texX, texY - metrics.b2e()), Size2D.u2l(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.d4o(size);
  var tmp40_safe_receiver = this.c4o(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.n4n_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.h4p_1 = new Mixin();
    this.i4p_1 = fontSize;
    this.j4p_1 = lineHeight;
    this.k4p_1 = base;
    this.l4p_1 = glyphs;
    this.m4p_1 = kernings;
    this.n4p_1 = name;
    this.o4p_1 = distanceField;
    this.p4p_1 = this.j4p_1 - this.k4p_1;
    var tmp = this;
    tmp.q4p_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.r4p_1 = new GlyphMetrics(this.i4p_1, false, 0, Companion_getInstance_4().v2g(), 0.0);
    var tmp_0 = this;
    tmp_0.s4p_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.t4p_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  r10(_set____db54di) {
    this.h4p_1.r10(_set____db54di);
  }
  s10() {
    return this.h4p_1.s10();
  }
  p4n() {
    return this.i4p_1;
  }
  t4m() {
    return this.j4p_1;
  }
  j3p() {
    return this.k4p_1;
  }
  r4n() {
    return this.l4p_1;
  }
  s4n() {
    return this.m4p_1;
  }
  u3() {
    return this.n4p_1;
  }
  q4n() {
    return this.o4p_1;
  }
  v11() {
    return this;
  }
  v4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q4p_1;
    naturalFontMetrics$factory();
    return this_0.u1();
  }
  w4n() {
    return this.r4p_1;
  }
  c4o(first, second) {
    return this.m4p_1.d1(Companion_instance_15.s4l(first, second));
  }
  a4o(codePoint) {
    return this.l4p_1.d1(codePoint);
  }
  u4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s4p_1;
    anyGlyph$factory();
    return this_0.u1();
  }
  u4p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t4p_1;
    invalidGlyph$factory();
    return this_0.u1();
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_17 = this;
    this.y4p_1 = CharacterSet.g4q(' ');
    this.z4p_1 = CharacterSet.g4q(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)), ''));
    this.a4q_1 = CharacterSet.g4q(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), ''));
    this.b4q_1 = CharacterSet.g4q(joinToString(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)), ''));
    this.c4q_1 = CharacterSet.g4q('!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}');
    this.d4q_1 = CharacterSet.g4q('\xE7\xC7 \xF1\xD1 \xE5\xC5 \xE6\xC6 \xFF \xA2\xA3\xA5P\xAA\xB0\xBF\xAC\xBD\xBC\xA1\xAB\xBB\xDF\xB5\xF8\xB1\xF7\xB0\xB7.\xB2 \xE1\xE9\xED\xF3\xFA\xE4\xEB\xEF\xF6\xFC\xE0\xE8\xEC\xF2\xF9\xE2\xEA\xEE\xF4\xFB \xC1\xC9\xCD\xD3\xDA\xC4\xCB\xCF\xD6\xDC\xC0\xC8\xCC\xD2\xD9\xC2\xCA\xCE\xD4\xDB');
    this.e4q_1 = CharacterSet.g4q('\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F');
    this.f4q_1 = this.y4p_1.h4q(this.z4p_1).h4q(this.a4q_1).h4q(this.b4q_1).h4q(this.c4q_1).h4q(this.d4q_1);
  }
}
class CharacterSet {
  static i4q(codePoints) {
    Companion_getInstance_27();
    var $this = createThis(this);
    $this.d4m_1 = codePoints;
    return $this;
  }
  static g4q(chars) {
    Companion_getInstance_27();
    // Inline function 'kotlin.text.map' call
    // Inline function 'kotlin.text.mapTo' call
    var destination = ArrayList.w(charSequenceLength(chars));
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(chars)) {
      var item = charSequenceGet(chars, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.CharacterSet.<init>.<anonymous>' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(item);
      destination.h(tmp$ret$0);
    }
    return this.i4q(toIntArray(destination));
  }
  h4q(other) {
    // Inline function 'kotlin.collections.plus' call
    var this_0 = this.d4m_1;
    var elements = other.d4m_1;
    var tmp$ret$0 = primitiveArrayConcat([this_0, elements]);
    return CharacterSet.i4q(tmp$ret$0);
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.u4m_1 = bmp;
    this.v4m_1 = fmetrics;
    this.w4m_1 = metrics;
    this.x4m_1 = glyphs;
    this.y4m_1 = glyphsPerLine;
    this.z4m_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString_0(this.u4m_1) + ', fmetrics=' + this.v4m_1.toString() + ', metrics=' + this.w4m_1.toString() + ', glyphs=' + toString_0(this.x4m_1) + ', glyphsPerLine=' + toString_0(this.y4m_1) + ', shape=' + toString(this.z4m_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.u4m_1);
    result = imul(result, 31) + this.v4m_1.hashCode() | 0;
    result = imul(result, 31) + this.w4m_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.x4m_1) | 0;
    result = imul(result, 31) + hashCode(this.y4m_1) | 0;
    result = imul(result, 31) + (this.z4m_1 == null ? 0 : hashCode(this.z4m_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.u4m_1, tmp0_other_with_cast.u4m_1))
      return false;
    if (!this.v4m_1.equals(tmp0_other_with_cast.v4m_1))
      return false;
    if (!this.w4m_1.equals(tmp0_other_with_cast.w4m_1))
      return false;
    if (!equals(this.x4m_1, tmp0_other_with_cast.x4m_1))
      return false;
    if (!equals(this.y4m_1, tmp0_other_with_cast.y4m_1))
      return false;
    if (!equals(this.z4m_1, tmp0_other_with_cast.z4m_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.a4n_1 = codePoint;
    this.b4n_1 = pos;
    this.c4n_1 = metrics;
    this.d4n_1 = fontMetrics;
    this.e4n_1 = transform;
    this.f4n_1 = index;
    this.g4n_1 = nline;
    var tmp = this;
    tmp.h4n_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.i4n_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.j4n_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.k4n_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  g4t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h4n_1;
    boundsPath$factory();
    return this_0.u1();
  }
  h4t() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i4n_1;
    boundsPathCurves$factory();
    return this_0.u1();
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.a4n_1 + ', pos=' + this.b4n_1.toString() + ', metrics=' + this.c4n_1.toString() + ', fontMetrics=' + this.d4n_1.toString() + ', transform=' + this.e4n_1.toString() + ', index=' + this.f4n_1 + ', nline=' + this.g4n_1 + ')';
  }
  hashCode() {
    var result = this.a4n_1;
    result = imul(result, 31) + this.b4n_1.hashCode() | 0;
    result = imul(result, 31) + this.c4n_1.hashCode() | 0;
    result = imul(result, 31) + this.d4n_1.hashCode() | 0;
    result = imul(result, 31) + this.e4n_1.hashCode() | 0;
    result = imul(result, 31) + this.f4n_1 | 0;
    result = imul(result, 31) + this.g4n_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.a4n_1 === tmp0_other_with_cast.a4n_1))
      return false;
    if (!this.b4n_1.equals(tmp0_other_with_cast.b4n_1))
      return false;
    if (!this.c4n_1.equals(tmp0_other_with_cast.c4n_1))
      return false;
    if (!this.d4n_1.equals(tmp0_other_with_cast.d4n_1))
      return false;
    if (!this.e4n_1.equals(tmp0_other_with_cast.e4n_1))
      return false;
    if (!(this.f4n_1 === tmp0_other_with_cast.f4n_1))
      return false;
    if (!(this.g4n_1 === tmp0_other_with_cast.g4n_1))
      return false;
    return true;
  }
}
class TextMetricsResult {
  constructor(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.i4t_1 = fmetrics;
    this.j4t_1 = metrics;
    this.k4t_1 = glyphs;
    this.l4t_1 = glyphsPerLine;
  }
  toString() {
    return 'TextMetricsResult(fmetrics=' + this.i4t_1.toString() + ', metrics=' + this.j4t_1.toString() + ', glyphs=' + toString_0(this.k4t_1) + ', glyphsPerLine=' + toString_0(this.l4t_1) + ')';
  }
  hashCode() {
    var result = this.i4t_1.hashCode();
    result = imul(result, 31) + this.j4t_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.k4t_1) | 0;
    result = imul(result, 31) + hashCode(this.l4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.i4t_1.equals(tmp0_other_with_cast.i4t_1))
      return false;
    if (!this.j4t_1.equals(tmp0_other_with_cast.j4t_1))
      return false;
    if (!equals(this.k4t_1, tmp0_other_with_cast.k4t_1))
      return false;
    if (!equals(this.l4t_1, tmp0_other_with_cast.l4t_1))
      return false;
    return true;
  }
}
class MultiplePlacedGlyphMetrics {
  constructor() {
    this.n4u_1 = FastArrayList.j11();
    this.o4u_1 = FastArrayList.j11();
  }
  e1() {
    return this.n4u_1.e1();
  }
  t4v(glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.n4u_1.h(glyph);
    while (this.o4u_1.e1() <= glyph.g4n_1) {
      this.o4u_1.h(FastArrayList.j11());
    }
    this.o4u_1.d1(glyph.g4n_1).h(glyph);
  }
}
class ITextRendererActions {}
function reset() {
  this.d4y(Companion_getInstance_6().j2d_1);
}
function advance(x) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.pz();
  var that = Vector2D.q2f(x, 0.0);
  var tmp$ret$0 = Vector2D.q2f(this_0.h2d_1 + that.h2d_1, this_0.i2d_1 + that.i2d_1);
  this.d4y(tmp$ret$0);
}
function newLine(y, end) {
  this.d4y(Vector2D.q2f(0.0, this.pz().i2d_1 + y));
  var _unary__edvuaz = this.v4x();
  this.b4y(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor($box) {
    boxApply(this, $box);
    this.l4x_1 = new GlyphPath();
    this.m4x_1 = new GlyphMetrics();
    this.n4x_1 = new FontMetrics();
    this.o4x_1 = 0;
    this.q4x_1 = 0.0;
    this.r4x_1 = Companion_getInstance_6().j2d_1;
    this.s4x_1 = Companion_getInstance_5().s2g_1;
    this.t4x_1 = null;
    this.u4x_1 = Colors_getInstance().y44_1;
  }
  t4m() {
    return this.n4x_1.t4m();
  }
  b4y(_set____db54di) {
    this.o4x_1 = _set____db54di;
  }
  v4x() {
    return this.o4x_1;
  }
  a4y() {
    var tmp = this.p4x_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  c4y(font, size) {
    this.p4x_1 = font;
    this.q4x_1 = size;
    font.x4n(size, this.n4x_1);
  }
  d4y(_set____db54di) {
    this.r4x_1 = _set____db54di;
  }
  pz() {
    return this.r4x_1;
  }
  e4y(reader, codePoint) {
    return this.a4y().z4n(this.q4x_1, codePoint, this.m4x_1, reader);
  }
  f4y(_set____db54di) {
    this.s4x_1 = _set____db54di;
  }
  y4x() {
    return this.s4x_1;
  }
  c4o(leftCodePoint, rightCodePoint) {
    return this.a4y().g4p(this.q4x_1, leftCodePoint, rightCodePoint);
  }
}
class drawText$actions$1 extends TextRendererActions {
  constructor($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed, $box) {
    if ($box === VOID)
      $box = {};
    $box.a4x_1 = $size;
    $box.b4x_1 = $align;
    $box.c4x_1 = $pos;
    $box.d4x_1 = $ctx;
    $box.e4x_1 = $paint;
    $box.f4x_1 = $textRangeStart;
    $box.g4x_1 = $textRangeEnd;
    $box.h4x_1 = $doRender;
    $box.i4x_1 = $glyphs;
    $box.j4x_1 = $placed;
    super($box);
    this.y4w_1 = measure($renderer, $text, $size, $fnt);
    this.z4w_1 = 0;
  }
  k4x(reader, codePoint) {
    var nline = this.v4x();
    var dx = this.y4w_1.w4x(this.b4x_1.k4v_1, nline);
    var dy = this.y4w_1.n4v(this.b4x_1.l4v_1, this.n4x_1);
    var px = this.pz().h2d_1 + this.c4x_1.h2d_1 - dx;
    var py = this.pz().i2d_1 + this.c4x_1.i2d_1 + dy;
    var tmp71_safe_receiver = this.d4x_1;
    if (tmp71_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp71_safe_receiver.s4b_1.f4o_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        this.d4x_1.x4x(px, py);
        this.d4x_1.z4x(get_immutable(this.y4x()));
        var tmp0_elvis_lhs = this.t4x_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.e4x_1 : tmp0_elvis_lhs;
        this.d4x_1.c4p(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.f4x_1;
        var containsUpper = this.g4x_1;
        var containsArg = this.z4w_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.a4y().e4o(this.d4x_1, this.a4x_1, codePoint, Companion_getInstance_6().j2d_1, null, this.m4x_1, reader, this.h4x_1);
        }
        this.z4w_1 = this.z4w_1 + 1 | 0;
      }finally {
        tmp71_safe_receiver.s4b_1.f4o_1 = t;
      }
    }
    if (!(this.i4x_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.q2f(px, py), this.m4x_1.o10(), this.n4x_1.o10(), this.y4x(), this.i4x_1.e1(), nline);
      this.i4x_1.t4v(glyph);
    }
    var tmp72_safe_receiver = this.j4x_1;
    if (tmp72_safe_receiver == null)
      null;
    else
      tmp72_safe_receiver(this, codePoint, Vector2D.q2f(px, py), this.a4x_1, this.m4x_1, this.n4x_1, this.y4x());
    return this.m4x_1;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.d2g(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.l2n(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_5().v2g() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.i4y_1 = path;
    this.j4y_1 = colorShape;
    this.k4y_1 = bitmap;
    this.l4y_1 = bitmapOffset;
    this.m4y_1 = bitmapScale;
    this.n4y_1 = transform;
    this.o4y_1 = scale;
  }
  p4y() {
    return this.k4y_1 == null && this.j4y_1 == null;
  }
  q4y(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.s4b_1.f4o_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.z4x(this.n4y_1);
      if (!(this.k4y_1 == null)) {
        c.e4p(ensureNotNull(this.k4y_1), this.l4y_1, toFloat(ensureNotNull(this.k4y_1).e1()).z2n(this.m4y_1));
      } else if (!(this.j4y_1 == null)) {
        c.r4y(ensureNotNull(this.j4y_1));
        c.m4u();
      } else {
        draw_1(c, this.i4y_1);
      }
    }finally {
      c.s4b_1.f4o_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.i4y_1.toString() + ', colorShape=' + toString(this.j4y_1) + ', bitmap=' + toString(this.k4y_1) + ', bitmapOffset=' + this.l4y_1.toString() + ', bitmapScale=' + this.m4y_1.toString() + ', transform=' + this.n4y_1.toString() + ', scale=' + this.o4y_1 + ')';
  }
  hashCode() {
    var result = this.i4y_1.hashCode();
    result = imul(result, 31) + (this.j4y_1 == null ? 0 : hashCode(this.j4y_1)) | 0;
    result = imul(result, 31) + (this.k4y_1 == null ? 0 : hashCode(this.k4y_1)) | 0;
    result = imul(result, 31) + this.l4y_1.hashCode() | 0;
    result = imul(result, 31) + this.m4y_1.hashCode() | 0;
    result = imul(result, 31) + this.n4y_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.i4y_1.equals(tmp0_other_with_cast.i4y_1))
      return false;
    if (!equals(this.j4y_1, tmp0_other_with_cast.j4y_1))
      return false;
    if (!equals(this.k4y_1, tmp0_other_with_cast.k4y_1))
      return false;
    if (!this.l4y_1.equals(tmp0_other_with_cast.l4y_1))
      return false;
    if (!this.m4y_1.equals(tmp0_other_with_cast.m4y_1))
      return false;
    if (!this.n4y_1.equals(tmp0_other_with_cast.n4y_1))
      return false;
    if (!equals(this.o4y_1, tmp0_other_with_cast.o4y_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.s4y_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_28();
    distanceField = distanceField === VOID ? null : distanceField;
    this.t4y_1 = new Mixin();
    this.u4y_1 = font;
    this.v4y_1 = fontSize;
    this.w4y_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.n43(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.w4y_1 == null))
      this_0.p42_1;
    else
      mipmaps(this_0.p42_1);
    tmp.x4y_1 = this_0;
    this.y4y_1 = this.u4y_1.c4m(this.v4y_1);
    this.z4y_1 = this.y4y_1.t4m();
    this.a4z_1 = this.y4y_1.n4m_1;
    this.b4z_1 = IntMap.p2w();
    this.c4z_1 = IntMap.p2w();
    var tmp_0 = this;
    tmp_0.d4z_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.e4z_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.f4z_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.g4z_1 = new GlyphMetrics(this.v4y_1, false, 0, Companion_getInstance_4().v2g(), 0.0);
  }
  r10(_set____db54di) {
    this.t4y_1.r10(_set____db54di);
  }
  s10() {
    return this.t4y_1.s10();
  }
  p4n() {
    return this.v4y_1;
  }
  q4n() {
    return this.w4y_1;
  }
  t4m() {
    return this.z4y_1;
  }
  j3p() {
    return this.a4z_1;
  }
  r4n() {
    return this.b4z_1;
  }
  s4n() {
    return this.c4z_1;
  }
  u4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d4z_1;
    anyGlyph$factory_0();
    return this_0.u1();
  }
  u4p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e4z_1;
    invalidGlyph$factory_0();
    return this_0.u1();
  }
  u3() {
    return this.u4y_1.u3();
  }
  v4n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f4z_1;
    naturalFontMetrics$factory_0();
    return this_0.u1();
  }
  w4n() {
    return this.g4z_1;
  }
  c4o(first, second) {
    var kerning = this.u4y_1.g4p(this.v4y_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.c4z_1;
      var key = Companion_instance_15.s4l(first, second);
      var res = this_0.d1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.j2w(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.d1(key));
    }
    return tmp;
  }
  a4o(codePoint) {
    if (this.b4z_1.d1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.h4z(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.h4z(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.h4z(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.i4z(tmp$ret$6);
    }
    return this.b4z_1.d1(codePoint);
  }
  h4z(codePoint, range) {
    var containsLower = range.d2_1;
    if (codePoint <= range.e2_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.g2s(coerceAtLeast(range.h2() - range.i2() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.i2();
      var last = range.h2();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.m2s(v);
        }
         while (!(v === last));
      this.i4z(this_0.x2s());
    }
  }
  i4z(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.x4y_1.p42_1;
    var rect = this_0.v43_1;
    if (true) {
      this_0.e44();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.b4z_1;
        var res = this_1.d1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.w4y_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.v4y_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.u4y_1;
          var tmp84_size = this.v4y_1;
          var tmp85_paint = Colors_getInstance().y44_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.u4m_1.d44();
          var rbmp;
          switch (this.w4y_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.z4m_1).j4z(), bmp.r43_1, bmp.s43_1);
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.z4m_1).j4z(), bmp.r43_1, bmp.s43_1);
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.x4y_1.p43(rbmp, Unit_instance);
          var slice = entry.h42_1.p3p(border, border, entry.h42_1.j3o_1 - border | 0, entry.h42_1.k3o_1 - border | 0);
          var g = first(result_0.x4m_1);
          var m = g.c4n_1;
          var xadvance = m.j4m_1;
          var tmp$ret$1 = new Glyph(this.v4y_1, codePoint, slice, -toIntRound(g.b4n_1.h2d_1) | 0, -toIntRound(g.b4n_1.i2d_1) | 0, toIntRound(xadvance));
          this_1.j2w(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.d1(codePoint));
      }
    }finally {
      result = true ? this_0.g44(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.k4m_1 = size;
    this.l4m_1 = top;
    this.m4m_1 = ascent;
    this.n4m_1 = baseline;
    this.o4m_1 = descent;
    this.p4m_1 = bottom;
    this.q4m_1 = lineGap;
    this.r4m_1 = maxWidth;
    this.s4m_1 = unitsPerEm;
  }
  k4z() {
    // Inline function 'kotlin.math.max' call
    var a = this.m4m_1;
    var b = this.l4m_1;
    return Math.max(a, b);
  }
  l4z() {
    // Inline function 'kotlin.math.min' call
    var a = this.o4m_1;
    var b = this.p4m_1;
    return Math.min(a, b);
  }
  m4z() {
    return this.k4z() - this.l4z();
  }
  t4m() {
    return this.m4z() + this.q4m_1;
  }
  t4u(other) {
    return this.n4z(other, 1.0);
  }
  y4n(other, size) {
    return this.n4z(other, size / other.k4m_1);
  }
  n4z(other, scale) {
    this.k4m_1 = other.k4m_1 * scale;
    this.l4m_1 = other.l4m_1 * scale;
    this.m4m_1 = other.m4m_1 * scale;
    this.n4m_1 = other.n4m_1 * scale;
    this.o4m_1 = other.o4m_1 * scale;
    this.p4m_1 = other.p4m_1 * scale;
    this.q4m_1 = other.q4m_1 * scale;
    this.s4m_1 = other.s4m_1 * scale;
    this.r4m_1 = other.r4m_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.ec('FontMetrics(');
    this_0.ec('size=' + niceStr(this.k4m_1, 1) + ', ');
    this_0.ec('top=' + niceStr(this.l4m_1, 1) + ', ');
    this_0.ec('ascent=' + niceStr(this.m4m_1, 1) + ', ');
    this_0.ec('baseline=' + niceStr(this.n4m_1, 1) + ', ');
    this_0.ec('descent=' + niceStr(this.o4m_1, 1) + ', ');
    this_0.ec('bottom=' + niceStr(this.p4m_1, 1) + ', ');
    this_0.ec('lineGap=' + niceStr(this.q4m_1, 1) + ', ');
    this_0.ec('unitsPerEm=' + niceStr(this.s4m_1, 1) + ', ');
    this_0.ec('maxWidth=' + niceStr(this.r4m_1, 1) + ', ');
    this_0.ec('lineHeight=' + niceStr(this.t4m(), 1));
    this_0.ec(')');
    return this_0.toString();
  }
  o10() {
    return this.o4z();
  }
  p4z(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  o4z(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.k4m_1 : size;
    top = top === VOID ? this.l4m_1 : top;
    ascent = ascent === VOID ? this.m4m_1 : ascent;
    baseline = baseline === VOID ? this.n4m_1 : baseline;
    descent = descent === VOID ? this.o4m_1 : descent;
    bottom = bottom === VOID ? this.p4m_1 : bottom;
    lineGap = lineGap === VOID ? this.q4m_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.r4m_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.s4m_1 : unitsPerEm;
    return $super === VOID ? this.p4z(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.p4z.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  hashCode() {
    var result = getNumberHashCode(this.k4m_1);
    result = imul(result, 31) + getNumberHashCode(this.l4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r4m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s4m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.k4m_1, tmp0_other_with_cast.k4m_1))
      return false;
    if (!equals(this.l4m_1, tmp0_other_with_cast.l4m_1))
      return false;
    if (!equals(this.m4m_1, tmp0_other_with_cast.m4m_1))
      return false;
    if (!equals(this.n4m_1, tmp0_other_with_cast.n4m_1))
      return false;
    if (!equals(this.o4m_1, tmp0_other_with_cast.o4m_1))
      return false;
    if (!equals(this.p4m_1, tmp0_other_with_cast.p4m_1))
      return false;
    if (!equals(this.q4m_1, tmp0_other_with_cast.q4m_1))
      return false;
    if (!equals(this.r4m_1, tmp0_other_with_cast.r4m_1))
      return false;
    if (!equals(this.s4m_1, tmp0_other_with_cast.s4m_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_4().v2g() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.f4m_1 = size;
    this.g4m_1 = existing;
    this.h4m_1 = codePoint;
    this.i4m_1 = bounds;
    this.j4m_1 = xadvance;
  }
  b2e() {
    return this.i4m_1.b2e();
  }
  y2d() {
    return this.i4m_1.y2d();
  }
  a2e() {
    return this.i4m_1.a2e();
  }
  x2p() {
    return this.i4m_1.t2d_1;
  }
  y2p() {
    return this.i4m_1.u2d_1;
  }
  o10() {
    return this.q4z(VOID, VOID, VOID, this.i4m_1.o10());
  }
  b4o(other, size, codePoint) {
    return this.r4z(other, size / other.f4m_1, codePoint);
  }
  r4z(other, scale, codePoint) {
    this.f4m_1 = other.f4m_1;
    this.g4m_1 = other.g4m_1;
    this.h4m_1 = codePoint;
    this.i4m_1 = other.i4m_1.x2l(scale);
    this.j4m_1 = other.j4m_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.ec('GlyphMetrics(');
    this_0.ec('codePoint=' + this.h4m_1 + " ('" + toString_1(numberToChar(this.h4m_1)) + "'), ");
    this_0.ec('existing=' + this.g4m_1 + ', ');
    this_0.ec('xadvance=' + roundToInt(this.j4m_1) + ', ');
    this_0.ec('bounds=' + this.i4m_1.l2().toString());
    this_0.ec(')');
    return this_0.toString();
  }
  s4z(size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  }
  q4z(size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.f4m_1 : size;
    existing = existing === VOID ? this.g4m_1 : existing;
    codePoint = codePoint === VOID ? this.h4m_1 : codePoint;
    bounds = bounds === VOID ? this.i4m_1 : bounds;
    xadvance = xadvance === VOID ? this.j4m_1 : xadvance;
    return $super === VOID ? this.s4z(size, existing, codePoint, bounds, xadvance) : $super.s4z.call(this, size, existing, codePoint, bounds, xadvance);
  }
  hashCode() {
    var result = getNumberHashCode(this.f4m_1);
    result = imul(result, 31) + getBooleanHashCode(this.g4m_1) | 0;
    result = imul(result, 31) + this.h4m_1 | 0;
    result = imul(result, 31) + this.i4m_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.j4m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.f4m_1, tmp0_other_with_cast.f4m_1))
      return false;
    if (!(this.g4m_1 === tmp0_other_with_cast.g4m_1))
      return false;
    if (!(this.h4m_1 === tmp0_other_with_cast.h4m_1))
      return false;
    if (!this.i4m_1.equals(tmp0_other_with_cast.i4m_1))
      return false;
    if (!equals(this.j4m_1, tmp0_other_with_cast.j4m_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_4().v2g() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.p4u_1 = bounds;
    this.q4u_1 = lineBounds;
    this.r4u_1 = fontMetrics;
    this.s4u_1 = nlines;
  }
  t4z() {
    var tmp0_elvis_lhs = firstOrNull_0(this.q4u_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().d2e_1 : tmp0_elvis_lhs;
  }
  y2d() {
    return this.p4u_1.y2d();
  }
  a2e() {
    return this.p4u_1.a2e();
  }
  x2p() {
    return this.p4u_1.t2d_1;
  }
  y2p() {
    return this.p4u_1.u2d_1;
  }
  u4z() {
    return -this.y2d();
  }
  v4z() {
    return this.t4z().u2d_1 + this.t4z().a2e();
  }
  s4v() {
    return this.r4u_1.m4m_1;
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.y2d()) + ', ' + get_niceStr_0(this.a2e()) + ', ' + get_niceStr_0(this.x2p()) + ', ' + get_niceStr_0(this.y2p()) + '][' + get_niceStr_0(this.u4z()) + ', ' + get_niceStr_0(this.v4z()) + ']';
  }
  hashCode() {
    var result = this.p4u_1.hashCode();
    result = imul(result, 31) + hashCode(this.q4u_1) | 0;
    result = imul(result, 31) + this.r4u_1.hashCode() | 0;
    result = imul(result, 31) + this.s4u_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.p4u_1.equals(tmp0_other_with_cast.p4u_1))
      return false;
    if (!equals(this.q4u_1, tmp0_other_with_cast.q4u_1))
      return false;
    if (!this.r4u_1.equals(tmp0_other_with_cast.r4u_1))
      return false;
    if (!(this.s4u_1 === tmp0_other_with_cast.s4u_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.sc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.y4z_1;
      destination.j3(tmp$ret$0, element);
    }
    tmp.z4z_1 = toIntMap(destination);
  }
  d1(id) {
    return this.z4z_1.d1(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.a50_1 = path;
    this.b50_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.a50_1.toString() + ', advanceWidth=' + this.b50_1 + ')';
  }
  hashCode() {
    var result = this.a50_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.b50_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.a50_1.equals(tmp0_other_with_cast.a50_1))
      return false;
    if (!equals(this.b50_1, tmp0_other_with_cast.b50_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.c50_1 = charstringsIndex;
    this.d50_1 = globalSubrIndex;
    this.e50_1 = localSubrsIndex;
    this.f50_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.f50_1.h3(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_0(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.g50_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.f50_1.h3(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_0(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.h50_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  i50(index, flipY) {
    var evalCtx = new EvalContext(this.d50_1, this.e50_1, this.g50_1, this.h50_1, index);
    var vp = new VectorPath();
    var bytes = this.c50_1.d1(index);
    CharStringType2_instance.l50(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.c3w(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.v50_1);
  }
  x50(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.i50(index, flipY) : $super.i50.call(this, index, flipY);
  }
}
class DataIndex {
  static y50(offsets, bytes) {
    var $this = createThis(this);
    $this.j50_1 = offsets;
    $this.k50_1 = bytes;
    return $this;
  }
  static z50() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.y50(tmp, tmp$ret$1);
  }
  e1() {
    return this.j50_1.length - 1 | 0;
  }
  a51(index) {
    return this.j50_1[index + 1 | 0] - this.j50_1[index] | 0;
  }
  d1(index) {
    return copyOfRange(this.k50_1, this.j50_1[index], this.j50_1[index + 1 | 0]);
  }
  b51() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.d1(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return destination;
  }
  a1() {
    return this.b51().a1();
  }
  toString() {
    var tmp = this.e1();
    var tmp_0 = toString_0(toList_0(this.j50_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.e1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
        var it = item;
        var tmp$ret$0 = this.a51(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString_0(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.y4z_1 = id;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_20 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.sc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.e51_1;
      destination.j3(tmp$ret$0, element);
    }
    tmp.f51_1 = toIntMap(destination);
  }
  d1(id) {
    var tmp0_elvis_lhs = this.f51_1.d1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.l5(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.z50() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.z50() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.m50_1 = globalSubrIndex;
    this.n50_1 = localSubrsIndex;
    this.o50_1 = defaultWidthX;
    this.p50_1 = nominalWidthX;
    this.q50_1 = index;
    this.r50_1 = heap;
    this.s50_1 = computeSubrBias(CharStringType2_instance, this.m50_1.e1());
    this.t50_1 = computeSubrBias(CharStringType2_instance, this.n50_1.e1());
    this.u50_1 = 0;
    this.v50_1 = this.o50_1;
    this.w50_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.e51_1 = id;
  }
}
class CFF {
  g51(_this__u8e3s4) {
    this.h51(_this__u8e3s4);
    var nameIndex = this.i51(_this__u8e3s4);
    var topDictIndex = this.i51(_this__u8e3s4);
    var topDictByte = topDictIndex.d1(0)[1];
    var topDict = this.j51(openFastStream(topDictIndex.d1(0)));
    var stringIndex = this.i51(_this__u8e3s4);
    var globalSubrIndex = this.i51(_this__u8e3s4);
    var privateSizeOffset = topDict.h3(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.z50();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.h(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.d1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.d1(1);
      privateDict = this.j51(_this__u8e3s4.b1t(privateOffset, privateSize));
      var localSubrs = privateDict.h3(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.i51(_this__u8e3s4.c1t(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.h3(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.i51(_this__u8e3s4.c1t(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  h51(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.h1t();
    var versionMinor = _this__u8e3s4.h1t();
    var headerSize = _this__u8e3s4.h1t();
    var offsetSize = _this__u8e3s4.h1t();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.l5(toString_0(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().k51_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  l51(_this__u8e3s4) {
    return _this__u8e3s4.h1t();
  }
  m51(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.l51(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.h1t();
        break;
      case 2:
        tmp = _this__u8e3s4.j1t();
        break;
      case 3:
        tmp = _this__u8e3s4.k1t();
        break;
      case 4:
        tmp = _this__u8e3s4.l1t();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  i51(_this__u8e3s4) {
    var count = _this__u8e3s4.j1t();
    if (count === 0)
      return DataIndex.z50();
    var offSize = this.l51(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.g2s((coerceAtLeast(this_0.h2() - this_0.i2() | 0, 0) / this_0.f2_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.i2();
    var nestedLast = this_0.h2();
    var stepArg = this_0.f2_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.m51(_this__u8e3s4, offSize) - 1 | 0;
        this_1.m2s(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.f1t(offsets.t2s());
    return DataIndex.y50(offsets.x2s(), bytes);
  }
  j51(_this__u8e3s4) {
    var map = LinkedHashMap.rc();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.i1();
    while (_this__u8e3s4.yy()) {
      var item = this.n51(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.j3(item, value);
        values.m3();
      } else {
        if (isNumber(item)) {
          values.h(item);
        }
      }
    }
    return map;
  }
  n51(_this__u8e3s4) {
    var b0 = _this__u8e3s4.h1t();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_29();
      tmp = tmp_0.d1(b0 === 12 ? b0 << 8 | _this__u8e3s4.h1t() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.h1t() << 8 | _this__u8e3s4.h1t());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.h1t() << 24 | _this__u8e3s4.h1t() << 16 | _this__u8e3s4.h1t() << 8 | _this__u8e3s4.h1t();
    } else if (b0 === 30) {
      tmp = this.o51(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.h1t() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.h1t() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  p51(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.h1t() === 30)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.l5(toString_0(message));
      }
    }
    var str = StringBuilder.f();
    end: while (true) {
      var byte = _this__u8e3s4.h1t();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.ec('E-');
              break;
            default:
              str.fc((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  o51(_this__u8e3s4, readHeader) {
    return toDouble(this.p51(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  q51(_this__u8e3s4, value) {
    _this__u8e3s4.m2t(_this__u8e3s4.e1() - 1 | 0, value);
  }
  r51(_this__u8e3s4) {
    return _this__u8e3s4.d1(_this__u8e3s4.e1() - 1 | 0);
  }
  s51(_this__u8e3s4) {
    return _this__u8e3s4.r3(_this__u8e3s4.e1() - 1 | 0);
  }
  t51(_this__u8e3s4, value) {
    _this__u8e3s4.j12(value);
  }
  u51(_this__u8e3s4, value) {
    _this__u8e3s4.j12(value);
  }
  v51(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.u3l();
    _this__u8e3s4.t6();
    _this__u8e3s4.t3l(lastPoint);
  }
  w51(_this__u8e3s4, x, y) {
    _this__u8e3s4.q3v(Vector2D.q2f(x, y));
  }
  x51(_this__u8e3s4, x, y) {
    _this__u8e3s4.r3v(Vector2D.q2f(x, y));
  }
  y51(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.y3l(Vector2D.q2f(fcx1, fcy1), Vector2D.q2f(fcx2, fcy2), Vector2D.q2f(fax, fay));
  }
  z51(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.u3l().h2d_1 + cx1;
    var fcy1 = _this__u8e3s4.u3l().i2d_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.y51(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  a52(_this__u8e3s4, v, horizontal) {
    return this.w51(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  b52(_this__u8e3s4, v, horizontal) {
    return this.x51(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  c52(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.h1t();
  }
  d52(ctx, s, evalCtx, stack, stackLevel) {
    while (s.yy()) {
      var v0 = this.c52(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_30();
        var op = tmp.d1(v0 === 12 ? v0 << 8 | this.c52(s) : v0);
        switch (op.t3_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.g1()) {
              tmp_0 = !evalCtx.w50_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.v50_1 = stack.d1(0) + evalCtx.p50_1;
              evalCtx.w50_1 = true;
            }

            if (!(ctx.d3v() === 0)) {
              this.v51(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.s51(stack));
            var bytes = global ? evalCtx.m50_1.d1(evalCtx.s50_1 + funcOffset | 0) : evalCtx.n50_1.d1(evalCtx.t50_1 + funcOffset | 0);
            this.d52(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.s51(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.s51(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.f2t(this_0, this_0);
            break;
          case 39:
            stack.v2s(stack.e1() - 2 | 0, stack.e1() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.ee();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.ee();
          case 25:
            var index = this.s51(stack);
            var value = this.s51(stack);
            evalCtx.r50_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.r51(stack);
            var tmp$ret$3 = evalCtx.r50_1[numberToInt(it)];
            this.q51(stack, tmp$ret$3);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.s51(stack);
            var l = this.s51(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$5 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.t51(stack, tmp$ret$5);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.s51(stack);
            var l_0 = this.s51(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$7 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.t51(stack, tmp$ret$7);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = this.r51(stack) === 0.0 ? 1 : 0;
            this.q51(stack, tmp$ret$9);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.s51(stack);
            var l_1 = this.s51(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$11 = l_1 === r_1 ? 1 : 0;
            this.t51(stack, tmp$ret$11);
            break;
          case 29:
            var v2 = this.s51(stack);
            var v1 = this.s51(stack);
            var s2 = this.s51(stack);
            var s1 = this.s51(stack);
            this.t51(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.j12(Default_getInstance().hp());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.r51(stack);
            var tmp$ret$13 = Math.sqrt(x);
            this.q51(stack, tmp$ret$13);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.r51(stack);
            var tmp$ret$15 = Math.abs(x_0);
            this.q51(stack, tmp$ret$15);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = -this.r51(stack);
            this.q51(stack, tmp$ret$16);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.s51(stack);
            var l_2 = this.s51(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_2 + r_2;
            this.t51(stack, tmp$ret$17);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.s51(stack);
            var l_3 = this.s51(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_3 - r_3;
            this.t51(stack, tmp$ret$18);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.s51(stack);
            var l_4 = this.s51(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_4 / r_4;
            this.t51(stack, tmp$ret$19);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.s51(stack);
            var l_5 = this.s51(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$20 = l_5 * r_5;
            this.t51(stack, tmp$ret$20);
            break;
          case 26:
            if (stack.e1() > 2) {
              evalCtx.v50_1 = stack.d1(0) + evalCtx.p50_1;
              evalCtx.w50_1 = true;
            }

            if (!(ctx.d3v() === 0)) {
              this.v51(ctx);
            }

            this.w51(ctx, stack.d1(stack.e1() - 2 | 0), stack.d1(stack.e1() - 1 | 0));
            stack.m3();
            break;
          case 3:
          case 28:
            if (stack.e1() > 1) {
              evalCtx.v50_1 = stack.d1(0) + evalCtx.p50_1;
              evalCtx.w50_1 = true;
            }

            this.a52(ctx, this.s51(stack), op.equals(Op_hmoveto_getInstance()));
            stack.m3();
            break;
          case 5:
            var progression = step(until(0, stack.e1()), 2);
            var inductionVariable = progression.d2_1;
            var last = progression.e2_1;
            var step_0 = progression.f2_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.x51(ctx, stack.d1(n), stack.d1(n + 1 | 0));
              }
               while (!(n === last));
            stack.m3();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.e1();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.b52(ctx, stack.d1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.m3();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.e1() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.d1(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.x51(ctx, tmp_1, stack.d1(_unary__edvuaz_0));
              }
            }

            while ((stack.e1() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.d1(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.d1(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.d1(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.d1(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.d1(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.z51(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.d1(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.e1()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.d1(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.x51(ctx, tmp_7, stack.d1(_unary__edvuaz_8));
              }
            }

            stack.m3();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.e1() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.d1(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.e1() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.l5(toString_0(message));
            }

            while (n_2 < stack.e1()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.d1(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.d1(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.d1(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.d1(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.z51(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.m3();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.g1()) {
                break $l$loop;
              }
              var vv_0 = this.s51(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.s51(stack);
              var y2_0 = this.s51(stack);
              var v1_1 = this.s51(stack);
              var v2_0 = stack.e1() === 1 ? this.s51(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.z51(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.m3();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.ee();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.e1() % 2 | 0) === 0) && !evalCtx.w50_1) {
              var value_0 = stack.d1(0);
              evalCtx.v50_1 = value_0 + evalCtx.p50_1;
            }

            evalCtx.u50_1 = evalCtx.u50_1 + (stack.e1() >>> 1 | 0) | 0;
            evalCtx.w50_1 = true;
            stack.m3();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.u50_1 + 7 | 0) >>> 3 | 0;
              s.dz(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.ee();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.ee();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.c52(s) << 8 | this.c52(s);
        var fractionPart = this.c52(s) << 8 | this.c52(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.t51(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.c52(s) << 8 | this.c52(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.c52(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.c52(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.u51(stack, value_2);
      }
    }
  }
  l50(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.a2t(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.d52(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.d52.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.k51_1 = Companion_getInstance_14().iz('TtfCIDFont');
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_21 = this;
    this.e52_1 = Companion_getInstance_14().iz('TTF');
  }
}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.u54(size, codePoint, path, reader) : $super.u54.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.ry_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      this.z4n(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.ry_1 = old;
      }
    }
  }
  var g = this.v54(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.m4u();
    }
    if (!g.p4y()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.s4b_1.f4o_1;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.x4x(pos.h2d_1, pos.i2d_1);
      g.q4y(ctx);
    }finally {
      ctx.s4b_1.f4o_1 = t;
    }
    switch (fill) {
      case true:
        ctx.v4v();
        break;
      case false:
        ctx.u4v();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.p4y();
  }
  return false;
}
class BaseTtfFont {
  static q5e(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.f52_1 = new Mixin();
    $this.g52_1 = s;
    $this.h52_1 = extName;
    $this.i52_1 = onlyReadMetadata;
    $this.j52_1 = enableLigatures;
    $this.k52_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.l52_1 = tmp_1;
    $this.m52_1 = 0;
    $this.n52_1 = 0;
    $this.o52_1 = 0;
    $this.p52_1 = 0;
    $this.q52_1 = 0;
    $this.r52_1 = 0;
    $this.s52_1 = 0;
    $this.t52_1 = 0;
    $this.u52_1 = 0;
    $this.v52_1 = 0;
    $this.w52_1 = 0;
    $this.x52_1 = 0;
    $this.y52_1 = 0;
    $this.z52_1 = 0;
    $this.a53_1 = Companion_instance_25.r5e(0, 0);
    $this.b53_1 = 0;
    $this.c53_1 = 0;
    $this.d53_1 = 0;
    $this.e53_1 = 0;
    $this.f53_1 = 0;
    $this.g53_1 = 0;
    $this.h53_1 = 0;
    $this.i53_1 = 0;
    $this.j53_1 = 0;
    $this.k53_1 = 0;
    $this.l53_1 = 0;
    $this.m53_1 = 0;
    $this.n53_1 = new Int32Array(0);
    $this.o53_1 = Companion_instance_25.r5e(0, 0);
    $this.p53_1 = 128;
    $this.q53_1 = 0;
    $this.r53_1 = 0;
    $this.s53_1 = 0;
    $this.t53_1 = 0;
    $this.u53_1 = 0;
    $this.v53_1 = 0;
    $this.w53_1 = 0;
    $this.x53_1 = 0;
    $this.y53_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.z53_1 = emptyList();
    $this.a54_1 = LinkedHashMap.rc();
    $this.b54_1 = LinkedHashMap.rc();
    $this.c54_1 = IntMap.p2w(512);
    $this.d54_1 = LinkedHashMap.rc();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.e54_1 = [];
    $this.f54_1 = IntMap.p2w();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.g54_1 = emptyList();
    $this.h54_1 = new COLRv1();
    $this.i54_1 = false;
    $this.j54_1 = IntIntMap.h2x();
    $this.k54_1 = IntMap.p2w();
    $this.m54_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_4().v2g(), 0.0);
    $this.n54_1 = false;
    $this.o54_1 = null;
    return $this;
  }
  r10(_set____db54di) {
    this.f52_1.r10(_set____db54di);
  }
  s10() {
    return this.f52_1.s10();
  }
  static p54(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.q5e(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  x4n(size, metrics) {
    return metrics.y4n(this.z54(), size);
  }
  z4n(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.k56(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.w5b_1;
    return metrics.b4o(tmp0_elvis_lhs == null ? this.m54_1 : tmp0_elvis_lhs, size, codePoint);
  }
  g4p(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  u54(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.ry_1;
    var codePointPeek = reader == null ? null : reader.zy(0);
    var tmp0_elvis_lhs = this.j56(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.d4o(size);
    path.i4y_1 = g.c29().z5b_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.j5c();
    tmp_0.j4y_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.b5c();
    var bitmapEntry = g.l5c();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.l59();
    path.k4y_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.p53_1 / bitmapEntry.u58_1.a58_1;
      var scaleY = this.p53_1 / bitmapEntry.u58_1.b58_1;
      path.l4y_1 = Vector2D.q2f(0.0, ((-bitmapEntry.v58_1 | 0) - bitmapEntry.f59() | 0) * scaleY);
      path.m4y_1 = Scale.b2l(scaleX, scaleY);
    }
    path.n4y_1 = Companion_getInstance_5().s2g_1.s2h(scale, scale);
    path.o4y_1 = scale;
    return path;
  }
  d4o(size) {
    return size / this.p53_1;
  }
  w54(key) {
    return this.a54_1.h3(key);
  }
  x54(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.a54_1.j3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.b54_1.j3(glyphID, codePoint);
  }
  y54(codePoint, glyphID) {
  }
  z54() {
    var tmp = this.l54_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  a55() {
    return this.k52_1.a55();
  }
  u3() {
    var tmp0_elvis_lhs = this.h52_1;
    return tmp0_elvis_lhs == null ? this.a55() : tmp0_elvis_lhs;
  }
  q54() {
    this.r54();
    this.g55();
    this.h55();
    this.i55();
    this.e55();
    if (!this.i52_1) {
      if (!(this.t54('CFF ') == null) && this.t54('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.d55('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.o54_1 = CFF_instance.g51(tmp111_safe_receiver);
        }
      }
      this.f55();
      this.g56();
      this.j55();
      this.k55();
      this.f56();
      this.e56();
      this.m55();
      this.n55();
      this.o55();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.d4o(1.0);
    this_0.k4m_1 = 1.0;
    this_0.l4m_1 = this.t53_1 * scale;
    this_0.m4m_1 = this.b53_1 * scale;
    this_0.n4m_1 = 0.0 * scale;
    this_0.o4m_1 = this.c53_1 * scale;
    this_0.p4m_1 = this.r53_1 * scale;
    this_0.q4m_1 = this.d53_1 * scale;
    this_0.r4m_1 = this.e53_1 * scale;
    this_0.s4m_1 = this.p53_1 * scale;
    tmp.l54_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.u3() + ')';
  }
  b55(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.j1t());
  }
  c55(_this__u8e3s4) {
    return Companion_instance_25.r5e(_this__u8e3s4.i1t(), _this__u8e3s4.i1t());
  }
  d55(name) {
    var tmp109_safe_receiver = this.t54(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.o57();
  }
  e55() {
    var tmp111_safe_receiver = this.d55('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_24.r57(tmp111_safe_receiver, this.k52_1);
    }
    return Unit_instance;
  }
  f55() {
    var tmp111_safe_receiver = this.d55('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.x53_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.f1t(imul(bytesPerEntry, this.m52_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.x53_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.p1t(this.m52_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.r1t(this.m52_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.n53_1 = tmp_1;
    }
    return Unit_instance;
  }
  g55() {
    var tmp111_safe_receiver = this.d55('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.j1t() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.j1t() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.o53_1 = this.c55(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.l1t();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.l1t();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.j1t();
      this.p53_1 = tmp111_safe_receiver.j1t();
      var created = tmp111_safe_receiver.m1t().b4(new Long(1000, 0));
      var modified = tmp111_safe_receiver.m1t().b4(new Long(1000, 0));
      this.q53_1 = tmp111_safe_receiver.i1t();
      this.r53_1 = tmp111_safe_receiver.i1t();
      this.s53_1 = tmp111_safe_receiver.i1t();
      this.t53_1 = tmp111_safe_receiver.i1t();
      this.u53_1 = tmp111_safe_receiver.j1t();
      this.v53_1 = tmp111_safe_receiver.j1t();
      this.w53_1 = tmp111_safe_receiver.i1t();
      this.x53_1 = tmp111_safe_receiver.i1t();
      this.y53_1 = tmp111_safe_receiver.i1t();
    }
    return Unit_instance;
  }
  h55() {
    var tmp111_safe_receiver = this.d55('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.c55(tmp111_safe_receiver);
      this.m52_1 = tmp111_safe_receiver.j1t();
      this.n52_1 = tmp111_safe_receiver.j1t();
      this.o52_1 = tmp111_safe_receiver.j1t();
      this.p52_1 = tmp111_safe_receiver.j1t();
      this.q52_1 = tmp111_safe_receiver.j1t();
      this.r52_1 = tmp111_safe_receiver.j1t();
      this.s52_1 = tmp111_safe_receiver.j1t();
      this.t52_1 = tmp111_safe_receiver.j1t();
      this.u52_1 = tmp111_safe_receiver.j1t();
      this.v52_1 = tmp111_safe_receiver.j1t();
      this.w52_1 = tmp111_safe_receiver.j1t();
      this.x52_1 = tmp111_safe_receiver.j1t();
      this.y52_1 = tmp111_safe_receiver.j1t();
      this.z52_1 = tmp111_safe_receiver.j1t();
    }
    return Unit_instance;
  }
  i55() {
    var tmp111_safe_receiver = this.d55('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.a53_1 = this.c55(tmp111_safe_receiver);
      this.b53_1 = tmp111_safe_receiver.i1t();
      this.c53_1 = tmp111_safe_receiver.i1t();
      this.d53_1 = tmp111_safe_receiver.i1t();
      this.e53_1 = tmp111_safe_receiver.j1t();
      this.f53_1 = tmp111_safe_receiver.i1t();
      this.g53_1 = tmp111_safe_receiver.i1t();
      this.h53_1 = tmp111_safe_receiver.i1t();
      this.i53_1 = tmp111_safe_receiver.i1t();
      this.j53_1 = tmp111_safe_receiver.i1t();
      this.k53_1 = tmp111_safe_receiver.i1t();
      tmp111_safe_receiver.i1t();
      tmp111_safe_receiver.i1t();
      tmp111_safe_receiver.i1t();
      tmp111_safe_receiver.i1t();
      this.l53_1 = tmp111_safe_receiver.i1t();
      this.m53_1 = tmp111_safe_receiver.j1t();
    }
    return Unit_instance;
  }
  j55() {
    var tmp111_safe_receiver = this.d55('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.m53_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.d2_1;
      var last_0 = this_0.e2_1;
      if (inductionVariable <= last_0)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new HorMetric(tmp111_safe_receiver.j1t(), tmp111_safe_receiver.i1t());
          destination.h(tmp$ret$0);
        }
         while (!(item === last_0));
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).p57_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.m52_1 - this.m53_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var inductionVariable_0 = this_1.d2_1;
      var last_1 = this_1.e2_1;
      if (inductionVariable_0 <= last_1)
        do {
          var item_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
          var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.i1t());
          destination_0.h(tmp$ret$3);
        }
         while (!(item_0 === last_1));
      var compressedMetrics = destination_0;
      this.z53_1 = plus(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  k55() {
    var tmp111_safe_receiver = this.d55('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp111_safe_receiver.j1t();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.j1t();
          var numPalettes = tmp111_safe_receiver.j1t();
          var numColorRecords = tmp111_safe_receiver.j1t();
          var colorRecordsArrayOffset = tmp111_safe_receiver.l1t();
          var colorRecordIndices = tmp111_safe_receiver.o1t(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.l1t() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.l1t() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.l1t() : -1;
          tmp111_safe_receiver.x1s(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.q1t(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_22().k4j(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.w(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.h(tmp$ret$0);
          }

          tmp.g54_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  l55(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.g1t(), _this__u8e3s4.g1t(), _this__u8e3s4.h1t(), _this__u8e3s4.g1t(), _this__u8e3s4.g1t(), _this__u8e3s4.g1t(), _this__u8e3s4.g1t(), _this__u8e3s4.g1t(), _this__u8e3s4.g1t(), _this__u8e3s4.g1t(), _this__u8e3s4.g1t(), _this__u8e3s4.g1t());
  }
  m55() {
    var tmp111_safe_receiver = this.d55('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.j1t();
      var minorVersion = tmp111_safe_receiver.j1t();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.l1t();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.l1t(), tmp111_safe_receiver.l1t(), tmp111_safe_receiver.l1t(), tmp111_safe_receiver.l1t(), this.l55(tmp111_safe_receiver), this.l55(tmp111_safe_receiver), tmp111_safe_receiver.j1t(), tmp111_safe_receiver.j1t(), tmp111_safe_receiver.h1t(), tmp111_safe_receiver.h1t(), tmp111_safe_receiver.h1t(), tmp111_safe_receiver.g1t());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.a1();
        while (_iterator__ex2g4s.b1()) {
          var cbi = _iterator__ex2g4s.c1();
          var glyphCount = cbi.z57_1 - cbi.y57_1 | 0;
          tmp111_safe_receiver.x1s(cbi.s57_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.u57_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$Subtable(tmp111_safe_receiver.j1t(), tmp111_safe_receiver.j1t(), tmp111_safe_receiver.l1t());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.x1s(cbi.s57_1 + subtable.d5e_1 | 0);
            var indexFormat = tmp111_safe_receiver.j1t();
            var imageFormat = tmp111_safe_receiver.j1t();
            var imageDataOffset = tmp111_safe_receiver.l1t();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.e5e() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.l1t() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.b5e_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.d54_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.j3(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  n55() {
    var tmp111_safe_receiver = this.d55('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.j1t();
      var minorVersion = tmp111_safe_receiver.j1t();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.d54_1.n3().a1();
        while (_iterator__ex2g4s.b1()) {
          var i = _iterator__ex2g4s.c1();
          var format = i.r58_1;
          if (format === 17 || format === 18) {
            i.v58_1 = tmp111_safe_receiver.h1t();
            i.w58_1 = tmp111_safe_receiver.h1t();
            i.x58_1 = tmp111_safe_receiver.g1t();
            i.y58_1 = tmp111_safe_receiver.g1t();
            i.z58_1 = tmp111_safe_receiver.h1t();
            i.a59_1 = format === 18 ? tmp111_safe_receiver.g1t() : i.x58_1;
            i.b59_1 = format === 18 ? tmp111_safe_receiver.g1t() : i.y58_1;
            i.c59_1 = format === 18 ? tmp111_safe_receiver.g1t() : i.z58_1;
          }
          var dataLen = tmp111_safe_receiver.l1t();
          i.d59_1 = tmp111_safe_receiver.a1t(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  o55() {
    var tmp111_safe_receiver = this.d55('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp111_safe_receiver.j1t();
      var flags = tmp111_safe_receiver.j1t();
      var numStrikes = tmp111_safe_receiver.l1t();
      var strikeOffsets = tmp111_safe_receiver.r1t(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp111_safe_receiver.x1s(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$StrikeInfo(tmp111_safe_receiver.j1t(), tmp111_safe_receiver.j1t(), item, toIntArrayList(tmp111_safe_receiver.r1t(this.m52_1 + 1 | 0)));
        destination.h(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.a1();
        if (!iterator.b1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.c1();
        if (!iterator.b1()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.f5e_1;
        do {
          var e = iterator.c1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.f5e_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.b1());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.m52_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.i5e_1.d1(n);
          var len = strike.i5e_1.d1(n + 1 | 0) - offset | 0;
          var start = strike.h5e_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.x1s(start);
          var originOffsetX = tmp111_safe_receiver.i1t();
          var originOffsetY = tmp111_safe_receiver.i1t();
          var graphicType = tmp111_safe_receiver.u1t(4);
          var bytes = tmp111_safe_receiver.a1t(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.d54_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.f5e_1, strike.f5e_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.d59_1 = bytes;
          this_0.j3(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  p55(_this__u8e3s4) {
    return _this__u8e3s4.l1t();
  }
  q55(_this__u8e3s4) {
    return _this__u8e3s4.j1t();
  }
  r55(_this__u8e3s4) {
    return _this__u8e3s4.i1t();
  }
  s55(_this__u8e3s4) {
    return _this__u8e3s4.j1t();
  }
  t55(_this__u8e3s4) {
    return _this__u8e3s4.k1t();
  }
  u55(_this__u8e3s4) {
    return _this__u8e3s4.l1t();
  }
  v55(_this__u8e3s4, isVar) {
    var xx = this.q56(_this__u8e3s4);
    var yx = this.q56(_this__u8e3s4);
    var xy = this.q56(_this__u8e3s4);
    var yy = this.q56(_this__u8e3s4);
    var dx = this.q56(_this__u8e3s4);
    var dy = this.q56(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  w55(_this__u8e3s4, out) {
    out.p59_1 = this.p56(_this__u8e3s4);
    out.q59_1 = _this__u8e3s4.j1t();
    out.r59_1 = this.p56(_this__u8e3s4);
    return out;
  }
  x55(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.w55(_this__u8e3s4, out) : $super.w55.call(this, _this__u8e3s4, out);
  }
  y55(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.h1t();
    var xMin = this.r55(_this__u8e3s4);
    var yMin = this.r55(_this__u8e3s4);
    var xMax = this.r55(_this__u8e3s4);
    var yMax = this.r55(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.p55(_this__u8e3s4);
    }
    return Companion_getInstance_4().s2l(xMin, yMin, xMax, yMax);
  }
  z55(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.y55(_this__u8e3s4, doVar) : $super.y55.call(this, _this__u8e3s4, doVar);
  }
  a56(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.h1t()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.j1t();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.x55(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  b56(glyphID, s, c, pal, level) {
    var nodeFormat = s.h1t();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString(getOrNull(Companion_getInstance_33().a57_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.h1t();
        var firstLayerIndex = s.l1t();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.h54_1.u5a_1[firstLayerIndex + n | 0];
            this.b56(glyphID, this.h54_1.x5a_1.c1t(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.j1t();
        var alpha = this.p56(s);
        if (isVar) {
          var varIndexBase = this.p55(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.ee();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.g54_1.d1(pal).j4f_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.y4v(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.t55(s);
        var x0 = this.r55(s);
        var y0 = this.r55(s);
        var x1 = this.r55(s);
        var y1 = this.r55(s);
        var x2 = this.r55(s);
        var y2 = this.r55(s);
        var colorLine = this.a56(s.c1t(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.p55(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.m59_1;
        var transform = Companion_getInstance_5().s2g_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.o59(paint_0, this.g54_1.d1(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.y4v(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.t55(s);
        var x0_0 = this.r55(s);
        var y0_1 = this.r55(s);
        var radius0 = this.q55(s);
        var x1_0 = this.r55(s);
        var y1_1 = this.r55(s);
        var radius1 = this.q55(s);
        var colorLine_0 = this.a56(s.c1t(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.p55(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.m59_1;
        var transform_0 = Companion_getInstance_5().s2g_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.o59(paint_1, this.g54_1.d1(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.y4v(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.t55(s);
        var centerX = this.r55(s);
        var centerY = this.r55(s);
        var startAngle = this.p56(s);
        var endAngle = this.p56(s);
        if (isVar) {
          var varIndexBase_2 = this.p55(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.ee();
      case 10:
        var paint_2 = this.t55(s);
        var glyphID_0 = s.j1t();
        var colr = this.f54_1.d1(glyphID_0);
        var glyph = this.o56(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f4w();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.c29().z5b_1), '\n'));
            }
            c.s5e(glyph.c29().z5b_1);
            this.b56(glyphID_0, s.c1t(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.n4w();
        }

        break;
      case 11:
        var glyphID_1 = s.j1t();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.ee();
      case 12:
      case 13:
        var paint_3 = this.t55(s);
        var transform_1 = this.t55(s);
        var affine = this.v55(s.c1t(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f4w();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.z4x(affine);
          this.b56(glyphID, s.c1t(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.n4w();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.t55(s);
        var dx = FWord__toDouble_impl_53j5qp(this.b55(s));
        var dy = FWord__toDouble_impl_53j5qp(this.b55(s));
        if (isVar) {
          var varIndexBase_3 = this.p55(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f4w();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.x4x(dx, -dy);
          this.b56(glyphID, s.c1t(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.n4w();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.t55(s);
        var scaleX = this.p56(s);
        var scaleY = this.p56(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.r55(s);
          var centerY_0 = this.r55(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.ee();
        }

        if (isVar) {
          var varIndexBase_4 = this.p55(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.f4w();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.t5e(numberToDouble(scaleX), numberToDouble(scaleY));
          this.b56(glyphID, s.c1t(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.n4w();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.t55(s);
        var scale = this.p56(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.r55(s);
          var centerY_1 = this.r55(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.p55(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.ee();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.t55(s);
        var angle = this.p56(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.r55(s);
          var centerY_2 = this.r55(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.p55(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.ee();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.t55(s);
        var xSkewAngle = this.p56(s);
        var ySkewAngle = this.p56(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.r55(s);
          var centerY_3 = this.r55(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.p55(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.ee();
      case 32:
        var sourcePaint = this.t55(s);
        var compositeMode = s.h1t();
        var backdropPaint = this.t55(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.ee();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.ee('An operation is not implemented: ' + reason);
    }
  }
  c56(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.j1t();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.j1t();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.p1t(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.j1t();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
        var inductionVariable_0 = this_3.d2_1;
        var last_0 = this_3.e2_1;
        if (inductionVariable_0 <= last_0)
          do {
            var item = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.j1t(), _this__u8e3s4.j1t(), _this__u8e3s4.j1t());
            destination.h(tmp$ret$4);
          }
           while (!(item === last_0));
        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.a1();
        if (!iterator.b1())
          throw NoSuchElementException.b7();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.c1();
        var maxValue = it.l5e_1 + it.m5e_1 | 0;
        while (iterator.b1()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.c1();
          var v = it_0.l5e_1 + it_0.m5e_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.a1();
        while (_iterator__ex2g4s.b1()) {
          var range = _iterator__ex2g4s.c1();
          var inductionVariable_1 = range.j5e_1;
          var last_1 = range.k5e_1;
          if (inductionVariable_1 <= last_1)
            do {
              var glyphID = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var offset = glyphID - range.j5e_1 | 0;
              glyphArray[range.l5e_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_1));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.ee('An operation is not implemented: ' + reason);
    }
  }
  d56(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.c56(_this__u8e3s4, hintedCount) : $super.c56.call(this, _this__u8e3s4, hintedCount);
  }
  e56() {
    var tmp111_safe_receiver = this.d55('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.j1t();
      var minorVersion = tmp111_safe_receiver.j1t();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.l5(toString_0(message));
      }
      var scriptListOffset = this.s55(tmp111_safe_receiver);
      var featureListOffset = this.s55(tmp111_safe_receiver);
      var lookupListOffset = this.s55(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.u55(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.c1t(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.j1t();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.u1t(4);
          var scriptOffset = this.s55(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.c1t(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.j1t();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.u1t(4);
          var featureOffset = this.s55(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.c1t(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.j1t();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.g2s((coerceAtLeast(this_3.h2() - this_3.i2() | 0, 0) / this_3.f2_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.i2();
      var nestedLast = this_3.h2();
      var stepArg = this_3.f2_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.s55(this_2);
          this_4.m2s(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.a1();
      while (_iterator__ex2g4s.b1()) {
        var lookupOffset = _iterator__ex2g4s.c1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.c1t(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.j1t();
        var lookupFlag = this_5.j1t();
        var subTableCount = this_5.j1t();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.o1t(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.j1t();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.c1t(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.j1t();
              var coverageOffset = this.s55(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.i1t();
                  var coverageTable = this.d56(this_8.c1t(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.j54_1.g2x(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.j1t();
                  var coverageTable_0 = this.d56(this_8.c1t(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.p1t(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.j54_1.g2x(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.l5(toString_0(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.j1t();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.l5(toString_0(message_1));
              }

              var coverageOffset_0 = this.s55(this_8);
              var ligatureSetCount = this_8.j1t();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.p1t(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.c56(this_8.c1t(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.rc();
                  var codePoint = this.i56(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.c1t(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.j1t();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.p1t(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.c1t(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.j1t();
                    var componentCount = this_19.j1t();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.p1t(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.i56(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_11();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.gz(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.j3(ligature, value);
                  }
                  this.k54_1.j2w(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_31().e52_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.q31(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.r31(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  f56() {
    var tmp111_safe_receiver = this.d55('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp111_safe_receiver.j1t();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.j1t();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.l1t();
          var layerRecordsOffset = tmp111_safe_receiver.l1t();
          var numLayerRecords = tmp111_safe_receiver.j1t();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.c1t(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.j1t(), this_0.j1t());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.e54_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.c1t(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.j1t(), this_1.j1t(), this_1.j1t());
              this.f54_1.j2w(info.f5c_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.u55(tmp111_safe_receiver);
            var layerListOffset = this.u55(tmp111_safe_receiver);
            var clipListOffset = this.u55(tmp111_safe_receiver);
            var varIdxMapOffset = this.u55(tmp111_safe_receiver);
            var varStoreOffset = this.u55(tmp111_safe_receiver);
            this.h54_1.z5a_1.m3();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.c1t(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.c1t(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.l1t();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.u55(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray_0(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.c1t(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.c1t(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp111_safe_receiver.c1t(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.h54_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp111_safe_receiver.c1t(clipListOffset);
              var format = s.h1t();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.l1t();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.j1t();
                var endGlyphID = s.j1t();
                var clipBoxOffset = this.t55(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.h54_1.z5a_1.g2x(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.c1t(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.l1t();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.j1t();
              var paint = this.u55(this_3);
              this.f54_1.j2w(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  g56() {
    var tmp111_safe_receiver = this.d55('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp111_safe_receiver.j1t();
      var numTables = tmp111_safe_receiver.j1t();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.d2_1;
      var last = this_0.e2_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new BaseTtfFont$readCmap$EncodingRecord(tmp111_safe_receiver.j1t(), tmp111_safe_receiver.j1t(), tmp111_safe_receiver.l1t());
          destination.h(tmp$ret$0);
        }
         while (!(item === last));
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.a1();
      while (_iterator__ex2g4s.b1()) {
        var table = _iterator__ex2g4s.c1();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp111_safe_receiver.c1t(table.p5e_1);
        var format = $this$run.j1t();
        try {
          switch (format) {
            case 0:
              var length = $this$run.j1t();
              var language = $this$run.j1t();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.f1t(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_0 = 0;
              var last_0 = this_1.length;
              if (inductionVariable_0 < last_0)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable_0 < last_0);
              var glyphIdArray = this_2;
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < 256)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  this.y54(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_1 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.j1t();
              var language_0 = $this$run.j1t();
              var segCount = $this$run.j1t() / 2 | 0;
              var searchRangeS = $this$run.j1t();
              var entrySelector = $this$run.j1t();
              var rangeShift = $this$run.j1t();
              var endCount = $this$run.p1t(segCount);
              $this$run.j1t();
              var startCount = $this$run.p1t(segCount);
              var idDelta = $this$run.o1t(segCount);
              var rangeOffsetPos = $this$run.y1s();
              var idRangeOffset = $this$run.p1t(segCount);
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < segCount)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_3 = sc;
                  if (inductionVariable_3 <= ec)
                    do {
                      var c = inductionVariable_3;
                      inductionVariable_3 = inductionVariable_3 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.c1t(glyphIndexOffset).j1t();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.x54(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_2 < segCount);
              break;
            case 6:
              var length_1 = $this$run.j1t();
              var language_1 = $this$run.j1t();
              var firstCode = $this$run.j1t();
              var entryCount = $this$run.j1t();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < entryCount)
                do {
                  var n_2 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.x54(codePoint, $this$run.j1t());
                }
                 while (inductionVariable_4 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.j1t();
              var length_2 = $this$run.l1t();
              var language_2 = $this$run.l1t();
              var numGroups = $this$run.l1t();
              var inductionVariable_5 = 0;
              if (inductionVariable_5 < numGroups)
                do {
                  var n_3 = inductionVariable_5;
                  inductionVariable_5 = inductionVariable_5 + 1 | 0;
                  var startCharCode = $this$run.l1t();
                  var endCharCode = $this$run.l1t();
                  var startGlyphId = $this$run.l1t();
                  var inductionVariable_6 = startCharCode;
                  if (inductionVariable_6 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.x54(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_5 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  h56(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_elvis_lhs = this.b54_1.h3(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  i56(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.h56(charIndex, default_0) : $super.h56.call(this, charIndex, default_0);
  }
  j56(reader, codePoint, cache) {
    var g = this.m56(codePoint);
    var skipCount = 1;
    if (this.j52_1 && !(g == null)) {
      var subs = this.k54_1.d1(codePoint);
      if (!(reader == null) && !(subs == null)) {
        // Inline function 'kotlin.math.min' call
        var a = reader.sy();
        var b = subs.m57_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.ez(0, count);
            var replacement = subs.n57_1.h3(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.o56(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.dz(skipCount);
    }
    return g;
  }
  k56(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.j56(reader, codePoint, cache) : $super.j56.call(this, reader, codePoint, cache);
  }
  l56(codePoint, cache) {
    var tmp134_safe_receiver = this.w54(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.n56(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  m56(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.l56(codePoint, cache) : $super.l56.call(this, codePoint, cache);
  }
  n56(index, cache, codePoint) {
    var cff = this.o54_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.c54_1;
      var res = this_0.d1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.x50(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.b50_1), new GlyphGraphicsPath(index, gvector.a50_1));
        this_0.j2w(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.d1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.n53_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.n53_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.c54_1.d1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.t54('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.o57();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.s56($this$runTable.c1t(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.z53_1.d1(index).p57_1, true);
    }
    var glyph = tmp;
    if (cache && !this.i54_1) {
      this.c54_1.j2w(index, glyph);
    }
    return glyph;
  }
  o56(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.n56(index, cache, codePoint) : $super.n56.call(this, index, cache, codePoint);
  }
  p56(_this__u8e3s4) {
    var v = _this__u8e3s4.i1t();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  q56(_this__u8e3s4) {
    var v = _this__u8e3s4.l1t();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  r56(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.g1t();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.h1t();
    } else if (word && signed) {
      tmp = _this__u8e3s4.i1t();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.j1t();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  s56(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.i1t();
    var xMin = _this__u8e3s4.i1t();
    var yMin = _this__u8e3s4.i1t();
    var xMax = _this__u8e3s4.i1t();
    var yMax = _this__u8e3s4.i1t();
    var advanceWidth = this.z53_1.d1(index).p57_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.i1();
      do {
        var flags = _this__u8e3s4.j1t();
        var glyphIndex = _this__u8e3s4.j1t();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.r56(_this__u8e3s4, signed, words);
        var y = this.r56(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.p56(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.p56(_this__u8e3s4);
          scaleY = this.p56(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.p56(_this__u8e3s4);
          scale01 = this.p56(_this__u8e3s4);
          scale10 = this.p56(_this__u8e3s4);
          scaleY = this.p56(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.o56(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.h(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.j1t();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.j1t();
      var instructions = _this__u8e3s4.f1t(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.g2s();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.h1t();
        flags_0.m2s(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.h1t();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.m2s(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.m10(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.h1t();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.i1t() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.x2s(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  static u4s(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_31();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.p54(d, extName, onlyReadMetadata, enableLigatures);
    $this.t4s_1 = LinkedHashMap.rc();
    $this.q54();
    return $this;
  }
  r54() {
    this.t4s_1.l3(Companion_instance_24.s54(this.g52_1.d1t()));
  }
  t54(name) {
    return this.t4s_1.h3(name);
  }
}
class Companion_16 {
  constructor() {
    this.z56_1 = 26;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_23 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a57_1 = this_0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.b57_1 = fillArrayVal(Array(26), null);
    this.c57_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.d57_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.e57_1 = tmp_5;
    this.f57_1 = null;
  }
  a55() {
    var tmp0_elvis_lhs = this.g57(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.g57(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  h57(nameId) {
    if (this.b57_1[nameId] == null) {
      var nameLength = this.d57_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.f57_1).s1t(this.c57_1[nameId], nameLength, this.e57_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.f();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.fc(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.b57_1[nameId] = tmp;
    }
    return this.b57_1[nameId];
  }
  g57(nameId) {
    return this.h57(nameId.k57_1);
  }
  l57() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.sc(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.g57(element);
      result.j3(element, tmp$ret$0);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString_0(this.l57()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.m57_1 = maxSequence;
    this.n57_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.t56_1 = id;
    this.u56_1 = checksum;
    this.v56_1 = offset;
    this.w56_1 = length;
    this.x56_1 = null;
    var tmp = this;
    tmp.y56_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  o57() {
    return _get_ss__ndcawb(this).o10();
  }
  toString() {
    return 'Table(id=' + this.t56_1 + ', checksum=' + this.u56_1 + ', offset=' + this.v56_1 + ', length=' + this.w56_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.t56_1);
    result = imul(result, 31) + this.u56_1 | 0;
    result = imul(result, 31) + this.v56_1 | 0;
    result = imul(result, 31) + this.w56_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.t56_1 === tmp0_other_with_cast.t56_1))
      return false;
    if (!(this.u56_1 === tmp0_other_with_cast.u56_1))
      return false;
    if (!(this.v56_1 === tmp0_other_with_cast.v56_1))
      return false;
    if (!(this.w56_1 === tmp0_other_with_cast.w56_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.p57_1 = advanceWidth;
    this.q57_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.p57_1 + ', lsb=' + this.q57_1 + ')';
  }
  hashCode() {
    var result = this.p57_1;
    result = imul(result, 31) + this.q57_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.p57_1 === tmp0_other_with_cast.p57_1))
      return false;
    if (!(this.q57_1 === tmp0_other_with_cast.q57_1))
      return false;
    return true;
  }
}
class Companion_18 {
  r57(s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.j1t();
    var count = s.j1t();
    var stringOffset = s.j1t();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.j1t();
        var encodingId = s.j1t();
        var languageId = s.j1t();
        var nameId = s.j1t();
        var length = s.j1t();
        var offset = s.j1t();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.d57_1[nameId] === -1) {
          info.c57_1[nameId] = stringOffset + offset | 0;
          info.d57_1[nameId] = length;
          info.e57_1[nameId] = charset;
          info.f57_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  s54(s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.l1t() === 1953784678) {
      var majorVersion = s.j1t();
      var minorVersion = s.j1t();
      var numFonts = s.l1t();
      var tableDirectoryOffsets = s.r1t(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.l1t();
        var dsigLength = s.l1t();
        var dsigOffset = s.l1t();
      }
      s.x1s(tableDirectoryOffsets[0]);
    } else {
      s.e1t(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.j1t();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.j1t();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.j1t();
    var searchRange = s.j1t();
    var entrySelector = s.j1t();
    var rangeShift = s.j1t();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var inductionVariable = this_2.d2_1;
    var last = this_2.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
        var tmp$ret$2 = new Table(s.u1t(4), s.l1t(), s.l1t(), s.l1t());
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    var tables = destination;
    var tablesByName = LinkedHashMap.rc();
    var _iterator__ex2g4s = tables.a1();
    while (_iterator__ex2g4s.b1()) {
      var table = _iterator__ex2g4s.c1();
      var tmp = table;
      tmp.x56_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.t56_1;
      tablesByName.j3(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.k57_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.s57_1 = indexSubTableArrayOffset;
    this.t57_1 = indexTablesSize;
    this.u57_1 = numberofIndexSubTables;
    this.v57_1 = colorRef;
    this.w57_1 = hori;
    this.x57_1 = vert;
    this.y57_1 = startGlyphIndex;
    this.z57_1 = endGlyphIndex;
    this.a58_1 = ppemX;
    this.b58_1 = ppemY;
    this.c58_1 = bitDepth;
    this.d58_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.s57_1 + ', indexTablesSize=' + this.t57_1 + ', numberofIndexSubTables=' + this.u57_1 + ', colorRef=' + this.v57_1 + ', hori=' + this.w57_1.toString() + ', vert=' + this.x57_1.toString() + ', startGlyphIndex=' + this.y57_1 + ', endGlyphIndex=' + this.z57_1 + ', ppemX=' + this.a58_1 + ', ppemY=' + this.b58_1 + ', bitDepth=' + this.c58_1 + ', flags=' + this.d58_1 + ')';
  }
  hashCode() {
    var result = this.s57_1;
    result = imul(result, 31) + this.t57_1 | 0;
    result = imul(result, 31) + this.u57_1 | 0;
    result = imul(result, 31) + this.v57_1 | 0;
    result = imul(result, 31) + this.w57_1.hashCode() | 0;
    result = imul(result, 31) + this.x57_1.hashCode() | 0;
    result = imul(result, 31) + this.y57_1 | 0;
    result = imul(result, 31) + this.z57_1 | 0;
    result = imul(result, 31) + this.a58_1 | 0;
    result = imul(result, 31) + this.b58_1 | 0;
    result = imul(result, 31) + this.c58_1 | 0;
    result = imul(result, 31) + this.d58_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.s57_1 === tmp0_other_with_cast.s57_1))
      return false;
    if (!(this.t57_1 === tmp0_other_with_cast.t57_1))
      return false;
    if (!(this.u57_1 === tmp0_other_with_cast.u57_1))
      return false;
    if (!(this.v57_1 === tmp0_other_with_cast.v57_1))
      return false;
    if (!this.w57_1.equals(tmp0_other_with_cast.w57_1))
      return false;
    if (!this.x57_1.equals(tmp0_other_with_cast.x57_1))
      return false;
    if (!(this.y57_1 === tmp0_other_with_cast.y57_1))
      return false;
    if (!(this.z57_1 === tmp0_other_with_cast.z57_1))
      return false;
    if (!(this.a58_1 === tmp0_other_with_cast.a58_1))
      return false;
    if (!(this.b58_1 === tmp0_other_with_cast.b58_1))
      return false;
    if (!(this.c58_1 === tmp0_other_with_cast.c58_1))
      return false;
    if (!(this.d58_1 === tmp0_other_with_cast.d58_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.e58_1 = ascender;
    this.f58_1 = descender;
    this.g58_1 = widthMax;
    this.h58_1 = caretSlopeNumerator;
    this.i58_1 = caretSlopeDenominator;
    this.j58_1 = caretOffset;
    this.k58_1 = minOriginSB;
    this.l58_1 = minAdvanceSB;
    this.m58_1 = maxBeforeBL;
    this.n58_1 = minAfterBL;
    this.o58_1 = pad1;
    this.p58_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.e58_1 + ', descender=' + this.f58_1 + ', widthMax=' + this.g58_1 + ', caretSlopeNumerator=' + this.h58_1 + ', caretSlopeDenominator=' + this.i58_1 + ', caretOffset=' + this.j58_1 + ', minOriginSB=' + this.k58_1 + ', minAdvanceSB=' + this.l58_1 + ', maxBeforeBL=' + this.m58_1 + ', minAfterBL=' + this.n58_1 + ', pad1=' + this.o58_1 + ', pad2=' + this.p58_1 + ')';
  }
  hashCode() {
    var result = this.e58_1;
    result = imul(result, 31) + this.f58_1 | 0;
    result = imul(result, 31) + this.g58_1 | 0;
    result = imul(result, 31) + this.h58_1 | 0;
    result = imul(result, 31) + this.i58_1 | 0;
    result = imul(result, 31) + this.j58_1 | 0;
    result = imul(result, 31) + this.k58_1 | 0;
    result = imul(result, 31) + this.l58_1 | 0;
    result = imul(result, 31) + this.m58_1 | 0;
    result = imul(result, 31) + this.n58_1 | 0;
    result = imul(result, 31) + this.o58_1 | 0;
    result = imul(result, 31) + this.p58_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.e58_1 === tmp0_other_with_cast.e58_1))
      return false;
    if (!(this.f58_1 === tmp0_other_with_cast.f58_1))
      return false;
    if (!(this.g58_1 === tmp0_other_with_cast.g58_1))
      return false;
    if (!(this.h58_1 === tmp0_other_with_cast.h58_1))
      return false;
    if (!(this.i58_1 === tmp0_other_with_cast.i58_1))
      return false;
    if (!(this.j58_1 === tmp0_other_with_cast.j58_1))
      return false;
    if (!(this.k58_1 === tmp0_other_with_cast.k58_1))
      return false;
    if (!(this.l58_1 === tmp0_other_with_cast.l58_1))
      return false;
    if (!(this.m58_1 === tmp0_other_with_cast.m58_1))
      return false;
    if (!(this.n58_1 === tmp0_other_with_cast.n58_1))
      return false;
    if (!(this.o58_1 === tmp0_other_with_cast.o58_1))
      return false;
    if (!(this.p58_1 === tmp0_other_with_cast.p58_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.q58_1 = glyphID;
    this.r58_1 = imageFormat;
    this.s58_1 = offset;
    this.t58_1 = size;
    this.u58_1 = info;
    this.v58_1 = height;
    this.w58_1 = width;
    this.x58_1 = horiBearingX;
    this.y58_1 = horiBearingY;
    this.z58_1 = horiAdvance;
    this.a59_1 = vertBearingX;
    this.b59_1 = vertBearingY;
    this.c59_1 = vertAdvance;
    this.d59_1 = null;
    this.e59_1 = null;
  }
  f59() {
    return this.u58_1.w57_1.f58_1;
  }
  g59(cache) {
    var tmp0_elvis_lhs = this.e59_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().k59(toSyncStream(ensureNotNull(this.d59_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.e59_1 = bmp;
    return bmp;
  }
  l59(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.g59(cache) : $super.g59.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.q58_1 + ', imageFormat=' + this.r58_1 + ', offset=' + this.s58_1 + ', size=' + this.t58_1 + ', info=' + this.u58_1.toString() + ', height=' + this.v58_1 + ', width=' + this.w58_1 + ', horiBearingX=' + this.x58_1 + ', horiBearingY=' + this.y58_1 + ', horiAdvance=' + this.z58_1 + ', vertBearingX=' + this.a59_1 + ', vertBearingY=' + this.b59_1 + ', vertAdvance=' + this.c59_1 + ')';
  }
  hashCode() {
    var result = this.q58_1;
    result = imul(result, 31) + this.r58_1 | 0;
    result = imul(result, 31) + this.s58_1 | 0;
    result = imul(result, 31) + this.t58_1 | 0;
    result = imul(result, 31) + this.u58_1.hashCode() | 0;
    result = imul(result, 31) + this.v58_1 | 0;
    result = imul(result, 31) + this.w58_1 | 0;
    result = imul(result, 31) + this.x58_1 | 0;
    result = imul(result, 31) + this.y58_1 | 0;
    result = imul(result, 31) + this.z58_1 | 0;
    result = imul(result, 31) + this.a59_1 | 0;
    result = imul(result, 31) + this.b59_1 | 0;
    result = imul(result, 31) + this.c59_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.q58_1 === tmp0_other_with_cast.q58_1))
      return false;
    if (!(this.r58_1 === tmp0_other_with_cast.r58_1))
      return false;
    if (!(this.s58_1 === tmp0_other_with_cast.s58_1))
      return false;
    if (!(this.t58_1 === tmp0_other_with_cast.t58_1))
      return false;
    if (!this.u58_1.equals(tmp0_other_with_cast.u58_1))
      return false;
    if (!(this.v58_1 === tmp0_other_with_cast.v58_1))
      return false;
    if (!(this.w58_1 === tmp0_other_with_cast.w58_1))
      return false;
    if (!(this.x58_1 === tmp0_other_with_cast.x58_1))
      return false;
    if (!(this.y58_1 === tmp0_other_with_cast.y58_1))
      return false;
    if (!(this.z58_1 === tmp0_other_with_cast.z58_1))
      return false;
    if (!(this.a59_1 === tmp0_other_with_cast.a59_1))
      return false;
    if (!(this.b59_1 === tmp0_other_with_cast.b59_1))
      return false;
    if (!(this.c59_1 === tmp0_other_with_cast.c59_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.m59_1 = cycle;
    this.n59_1 = stops;
  }
  o59(paint, palette) {
    var _iterator__ex2g4s = this.n59_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stop = _iterator__ex2g4s.c1();
      paint.q5a(stop.p59_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.j4f_1, stop.q59_1), stop.r59_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.m59_1.toString() + ', stops=' + toString_0(this.n59_1) + ')';
  }
  hashCode() {
    var result = this.m59_1.hashCode();
    result = imul(result, 31) + hashCode(this.n59_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.m59_1.equals(tmp0_other_with_cast.m59_1))
      return false;
    if (!equals(this.n59_1, tmp0_other_with_cast.n59_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.p59_1 = stopOffset;
    this.q59_1 = paletteIndex;
    this.r59_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.t5a_1 = this.t3_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.u5a_1 = layerList;
    this.v5a_1 = s;
    this.w5a_1 = sBaseOffset;
    this.x5a_1 = sLayerOffset;
    this.y5a_1 = sClipOffset;
    this.z5a_1 = IntIntMap.h2x();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.a5b_1 = x;
    this.b5b_1 = y;
    this.c5b_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.a5b_1 + ', y=' + this.b5b_1 + ', onCurve=' + this.c5b_1 + ')';
  }
  hashCode() {
    var result = this.a5b_1;
    result = imul(result, 31) + this.b5b_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c5b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.a5b_1 === tmp0_other_with_cast.a5b_1))
      return false;
    if (!(this.b5b_1 === tmp0_other_with_cast.b5b_1))
      return false;
    if (!(this.c5b_1 === tmp0_other_with_cast.c5b_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.d5b_1 = glyph;
    this.e5b_1 = x;
    this.f5b_1 = y;
    this.g5b_1 = scaleX;
    this.h5b_1 = scale01;
    this.i5b_1 = scale10;
    this.j5b_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString_0(this.d5b_1) + ', x=' + this.e5b_1 + ', y=' + this.f5b_1 + ', scaleX=' + this.g5b_1 + ', scale01=' + this.h5b_1 + ', scale10=' + this.i5b_1 + ', scaleY=' + this.j5b_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.d5b_1);
    result = imul(result, 31) + this.e5b_1 | 0;
    result = imul(result, 31) + this.f5b_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.g5b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h5b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i5b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j5b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.d5b_1, tmp0_other_with_cast.d5b_1))
      return false;
    if (!(this.e5b_1 === tmp0_other_with_cast.e5b_1))
      return false;
    if (!(this.f5b_1 === tmp0_other_with_cast.f5b_1))
      return false;
    if (!equals(this.g5b_1, tmp0_other_with_cast.g5b_1))
      return false;
    if (!equals(this.h5b_1, tmp0_other_with_cast.h5b_1))
      return false;
    if (!equals(this.i5b_1, tmp0_other_with_cast.i5b_1))
      return false;
    if (!equals(this.j5b_1, tmp0_other_with_cast.j5b_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.m5b_1 = $outer;
    this.k5b_1 = glyphID;
    this.l5b_1 = paletteIndex;
  }
  n5b(pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.m5b_1.g54_1, pal).j4f_1);
    var index = this.l5b_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index < this_0.e1() : false) {
      tmp = this_0.d1(index);
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = new RGBA(Colors_getInstance().a47_1);
    }
    return tmp.u4k_1;
  }
  o5b() {
    return this.n5b(0);
  }
  p5b(pal) {
    var tmp135_safe_receiver = this.m5b_1.o56(this.k5b_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.c29();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp136_safe_receiver.z5b_1, null, new RGBA(this.n5b(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.k5b_1 + ', ' + this.l5b_1 + ', ' + RGBA__toString_impl_4lw6dp(this.o5b()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.a5c(pal) : $super.a5c.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.e5c_1 = $outer;
    this.c5c_1 = glyphID;
    this.d5c_1 = paint;
  }
  a5c(pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.e5c_1.h54_1.w5a_1.c1t(this.d5c_1);
    try {
      this.e5c_1.b56(this.c5c_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.f4t();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.c5c_1 + '][' + this.d5c_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.i5c_1 = $outer;
    this.f5c_1 = glyphID;
    this.g5c_1 = firstLayerIndex;
    this.h5c_1 = numLayers;
  }
  d1(index) {
    return this.i5c_1.e54_1[this.g5c_1 + index | 0];
  }
  b51() {
    var tmp = 0;
    var tmp_0 = this.h5c_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.d1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  a5c(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.b51();
    var destination = ArrayList.i1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.p5b(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.h(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.f5c_1 + '][' + this.h5c_1 + '](' + toString_0(this.b51()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.y5b_1 = glpyhIndex;
    this.z5b_1 = path;
  }
  t3l(p) {
    this.z5b_1.t3l(p);
  }
  v3l(p) {
    this.z5b_1.v3l(p);
  }
  w3l(c, a) {
    this.z5b_1.w3l(c, a);
  }
  y3l(c1, c2, a) {
    this.z5b_1.y3l(c1, c2, a);
  }
  t6() {
    this.z5b_1.t6();
  }
  e3v(p0, p1) {
    this.z5b_1.e3v(p0, p1);
  }
  f3v(a, c, r) {
    this.z5b_1.f3v(a, c, r);
  }
  g1() {
    return this.z5b_1.g1();
  }
  g3v(rect) {
    this.z5b_1.g3v(rect);
  }
  h3v(pos, size) {
    this.z5b_1.h3v(pos, size);
  }
  i3v(x, y, width, height) {
    this.z5b_1.i3v(x, y, width, height);
  }
  j3v(x, y, w, h, rtl, rtr, rbr, rbl) {
    this.z5b_1.j3v(x, y, w, h, rtl, rtr, rbr, rbl);
  }
  k3v(center, r, start, end, counterclockwise) {
    this.z5b_1.k3v(center, r, start, end, counterclockwise);
  }
  b3g(center, radius) {
    this.z5b_1.b3g(center, radius);
  }
  m3v(path, close) {
    this.z5b_1.m3v(path, close);
  }
  n3v(points, close) {
    this.z5b_1.n3v(points, close);
  }
  o3v(points, close) {
    this.z5b_1.o3v(points, close);
  }
  q3v(delta) {
    this.z5b_1.q3v(delta);
  }
  r3v(delta) {
    this.z5b_1.r3v(delta);
  }
  q2m(m) {
    return this.z5b_1.q2m(m);
  }
  d3v() {
    return this.z5b_1.d3v();
  }
  u3l() {
    return this.z5b_1.g3m_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.y5b_1 + ', "' + toSvgPathString(this.z5b_1) + '")';
  }
  hashCode() {
    var result = this.y5b_1;
    result = imul(result, 31) + this.z5b_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.y5b_1 === tmp0_other_with_cast.y5b_1))
      return false;
    if (!this.z5b_1.equals(tmp0_other_with_cast.z5b_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.x5b_1 = $outer;
    this.q5b_1 = index;
    this.r5b_1 = xMin;
    this.s5b_1 = yMin;
    this.t5b_1 = xMax;
    this.u5b_1 = yMax;
    this.v5b_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.r5b_1;
    var yMin_0 = this.s5b_1;
    var xMax_0 = this.t5b_1;
    var yMax_0 = this.u5b_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.x5b_1.h54_1.y5a_1;
      var glyphIDToClipOffset = this.x5b_1.h54_1.z5a_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.rp(this.q5b_1)) {
        var clipOffset = glyphIDToClipOffset.d1(this.q5b_1);
        tmp_0 = this.x5b_1.z55(sClipOffset.c1t(clipOffset));
      } else {
        var tmp137_safe_receiver = this.j5c();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.b5c();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.k5c();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.y2d());
        xMax_0 = numberToInt(bounds.z2d());
        yMin_0 = numberToInt(bounds.a2e());
        yMax_0 = numberToInt(bounds.b2e());
      }
    }
    var size = this.x5b_1.p53_1;
    var scale = this.x5b_1.d4o(size);
    tmp.w5b_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_4().r2l(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.v5b_1 * scale);
  }
  j5c() {
    return this.x5b_1.f54_1.d1(this.q5b_1);
  }
  l5c() {
    return this.x5b_1.d54_1.h3(this.q5b_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.x5c_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.u5c_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.u5c_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.d5b_1.c29().z5b_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.d5b_1.q5b_1, new VectorPath(IntArrayList.g2s(gpath.a3m_1.e1()), DoubleArrayList.a2t(gpath.b3m_1.e1())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_5().v2g().r2h(item.g5b_1, item.j5b_1).x2h(item.e5b_1, -item.f5b_1 | 0);
      this_1.z5b_1.z3v(item.d5b_1.c29().z5b_1, m);
      destination.h(this_1);
    }
    tmp.v5c_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.v5c_1;
    var n = 0;
    while (n < this_2.e1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.d1(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.z5b_1.a3m_1.e1() | 0;
      dataSize = dataSize + gpath_0.z5b_1.b3m_1.e1() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.g2s(commandsSize), DoubleArrayList.a2t(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.v5c_1;
    var n_0 = 0;
    while (n_0 < this_4.e1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.d1(_unary__edvuaz_0);
      this_3.z5b_1.a3w(it.z5b_1);
    }
    tmp_0.w5c_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.v5b_1 + '](' + toString_0(this.u5c_1) + ')';
  }
  c29() {
    return this.w5c_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.i5d_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.g5d_1 = path;
    this.h5d_1 = listOf_0(this.g5d_1);
  }
  c29() {
    return this.g5d_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.y5d_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.r5d_1 = contoursIndices;
    this.s5d_1 = flags;
    this.t5d_1 = xPos;
    this.u5d_1 = yPos;
    this.v5d_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.y5d_1;
    var inductionVariable = 0;
    var last = this.r5d_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.r5d_1[n] + 1 | 0;
        var cend = this.r5d_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.g2s(commandSize), DoubleArrayList.a2t(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.y5d_1;
    var inductionVariable_0 = 0;
    var last_0 = this.r5d_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.r5d_1[n_0] + 1 | 0;
        var cend_0 = this.r5d_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.z5d(cend_0, this_1.l52_1[0]);
        var next = this.z5d(cstart_0, this_1.l52_1[1]);
        if (curr.c5b_1) {
          this_0.t3l(Vector2D.d2g(curr.a5b_1, -curr.b5b_1 | 0));
        } else if (next.c5b_1) {
          this_0.t3l(Vector2D.d2g(next.a5b_1, -next.b5b_1 | 0));
        } else {
          this_0.t3l(Vector2D.d2g(imul(curr.a5b_1 + next.a5b_1 | 0, numberToInt(0.5)), -numberToInt((curr.b5b_1 + next.b5b_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.z5d(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.l52_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.c5b_1) {
              this_0.v3l(Vector2D.d2g(curr.a5b_1, -curr.b5b_1 | 0));
            } else {
              var prev2X = prev.a5b_1;
              var prev2Y = prev.b5b_1;
              var next2X = next.a5b_1;
              var next2Y = next.b5b_1;
              if (!prev.c5b_1) {
                prev2X = numberToInt((curr.a5b_1 + prev.a5b_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.b5b_1 + prev.b5b_1 | 0) * 0.5);
                this_0.v3l(Vector2D.d2g(prev2X, -prev2Y | 0));
              }
              if (!next.c5b_1) {
                next2X = numberToInt((curr.a5b_1 + next.a5b_1 | 0) * 0.5);
                next2Y = numberToInt((curr.b5b_1 + next.b5b_1 | 0) * 0.5);
              }
              this_0.v3l(Vector2D.d2g(prev2X, -prev2Y | 0));
              this_0.w3l(Vector2D.d2g(curr.a5b_1, -curr.b5b_1 | 0), Vector2D.d2g(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.t6();
      }
       while (inductionVariable_0 < last_0);
    tmp.w5d_1 = this_0;
    this.x5d_1 = listOf_0(this.w5d_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.v5d_1 ? 'Dummy' : '') + '[' + this.q5b_1 + '](advance=' + this.v5b_1 + ') : ' + this.w5d_1.toString();
  }
  a5e(n) {
    return !((this.s5d_1[n] & 1) === 0);
  }
  z5d(n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.a5b_1 = this.t5d_1[n];
    out.b5b_1 = this.u5d_1[n];
    out.c5b_1 = this.a5e(n);
    return out;
  }
  c29() {
    return this.w5d_1;
  }
}
class BaseTtfFont$readCblc$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.b5e_1 = firstGlyphIndex;
    this.c5e_1 = lastGlyphIndex;
    this.d5e_1 = additionalOffsetToIndexSubtable;
  }
  e5e() {
    return this.c5e_1 - this.b5e_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.b5e_1 + ', lastGlyphIndex=' + this.c5e_1 + ', additionalOffsetToIndexSubtable=' + this.d5e_1 + ')';
  }
  hashCode() {
    var result = this.b5e_1;
    result = imul(result, 31) + this.c5e_1 | 0;
    result = imul(result, 31) + this.d5e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$Subtable ? other : THROW_CCE();
    if (!(this.b5e_1 === tmp0_other_with_cast.b5e_1))
      return false;
    if (!(this.c5e_1 === tmp0_other_with_cast.c5e_1))
      return false;
    if (!(this.d5e_1 === tmp0_other_with_cast.d5e_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.f5e_1 = ppem;
    this.g5e_1 = ppi;
    this.h5e_1 = strikeOffset;
    this.i5e_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.f5e_1 + ', ppi=' + this.g5e_1 + ', strikeOffset=' + this.h5e_1 + ', offsets=' + this.i5e_1.toString() + ')';
  }
  hashCode() {
    var result = this.f5e_1;
    result = imul(result, 31) + this.g5e_1 | 0;
    result = imul(result, 31) + this.h5e_1 | 0;
    result = imul(result, 31) + this.i5e_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$StrikeInfo ? other : THROW_CCE();
    if (!(this.f5e_1 === tmp0_other_with_cast.f5e_1))
      return false;
    if (!(this.g5e_1 === tmp0_other_with_cast.g5e_1))
      return false;
    if (!(this.h5e_1 === tmp0_other_with_cast.h5e_1))
      return false;
    if (!this.i5e_1.equals(tmp0_other_with_cast.i5e_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.j5e_1 = start;
    this.k5e_1 = endInclusive;
    this.l5e_1 = index;
    this.m5e_1 = (this.k5e_1 - this.j5e_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.j5e_1 + ', endInclusive=' + this.k5e_1 + ', index=' + this.l5e_1 + ')';
  }
  hashCode() {
    var result = this.j5e_1;
    result = imul(result, 31) + this.k5e_1 | 0;
    result = imul(result, 31) + this.l5e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.j5e_1 === tmp0_other_with_cast.j5e_1))
      return false;
    if (!(this.k5e_1 === tmp0_other_with_cast.k5e_1))
      return false;
    if (!(this.l5e_1 === tmp0_other_with_cast.l5e_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.n5e_1 = platformId;
    this.o5e_1 = encodingId;
    this.p5e_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.n5e_1 + ', encodingId=' + this.o5e_1 + ', offset=' + this.p5e_1 + ')';
  }
  hashCode() {
    var result = this.n5e_1;
    result = imul(result, 31) + this.o5e_1 | 0;
    result = imul(result, 31) + this.p5e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$EncodingRecord ? other : THROW_CCE();
    if (!(this.n5e_1 === tmp0_other_with_cast.n5e_1))
      return false;
    if (!(this.o5e_1 === tmp0_other_with_cast.o5e_1))
      return false;
    if (!(this.p5e_1 === tmp0_other_with_cast.p5e_1))
      return false;
    return true;
  }
}
class Companion_19 {
  r5e(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.sc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.w5e_1;
      destination.j3(tmp$ret$0, element);
    }
    tmp.y5e_1 = destination;
  }
  d1(index) {
    var tmp0_elvis_lhs = this.y5e_1.h3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.w5e_1 = id;
    this.x5e_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.z5e_1 = Companion_getInstance_14().iz('EXIF');
  }
  a5f(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx.bind(VOID, this, ss, info, debug), $completion);
  }
  b5f(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.a5f(ss, info, debug, $completion) : $super.a5f.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.c5f_1 = function_0;
  }
  hj(a, b) {
    return this.c5f_1(a, b);
  }
  compare(a, b) {
    return this.hj(a, b);
  }
  s4() {
    return this.c5f_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.s4(), other.s4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s4());
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.i1();
      var tmp0_iterator = frames.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.j5f_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.a1();
      while (tmp0_iterator_0.b1()) {
        var item = tmp0_iterator_0.c1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.l5f_1;
        destination_0.h(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.v5f_1 = frames;
    this.w5f_1 = direction;
    this.x5f_1 = name;
    this.y5f_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_0(this.v5f_1);
    tmp_1.z5f_1 = tmp0_elvis_lhs == null ? ImageFrame.a5g(0) : tmp0_elvis_lhs;
  }
}
class Companion_21 {
  b5g(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(bitmaps.length);
    var inductionVariable = 0;
    var last = bitmaps.length;
    while (inductionVariable < last) {
      var item = bitmaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_30.c5g(item);
      destination.h(tmp$ret$0);
    }
    return new ImageData(destination);
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.d5g_1 = function_0;
  }
  hj(a, b) {
    return this.d5g_1(a, b);
  }
  compare(a, b) {
    return this.hj(a, b);
  }
  s4() {
    return this.d5g_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.s4(), other.s4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s4());
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp171_safe_receiver = firstOrNull_0(frames);
      var tmp0_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.x2p();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp172_safe_receiver = firstOrNull_0(frames);
      var tmp1_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.y2p();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.g5g_1 = new Mixin();
    this.h5g_1 = frames;
    this.i5g_1 = loopCount;
    this.j5g_1 = width;
    this.k5g_1 = height;
    this.l5g_1 = layers;
    this.m5g_1 = animations;
    this.n5g_1 = name;
    this.o5g_1 = new ImageAnimation(this.h5g_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.m5g_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.sc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.x5f_1;
      destination.j3(tmp$ret$0, element);
    }
    tmp_1.p5g_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.h5g_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.sc(capacity_0);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.u3();
      destination_0.j3(tmp$ret$3, element_0);
    }
    tmp_2.q5g_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.h5g_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_4);
    tmp_3.r5g_1 = sortedWith(this_2, tmp$ret$6);
  }
  r10(_set____db54di) {
    this.g5g_1.r10(_set____db54di);
  }
  s10() {
    return this.g5g_1.s10();
  }
  b2n() {
    return get_area(this.h5g_1);
  }
  s5g() {
    var tmp173_safe_receiver = firstOrNull_0(this.r5g_1);
    var tmp0_elvis_lhs = tmp173_safe_receiver == null ? null : tmp173_safe_receiver.e5g();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString_0(this.h5g_1) + ')';
  }
}
class Companion_22 {
  t5g(bitmaps) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(bitmaps, 10));
    var tmp0_iterator = bitmaps.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.Companion.invoke.<anonymous>' call
      var tmp$ret$0 = Companion_instance_27.b5g([item]);
      destination.h(tmp$ret$0);
    }
    return ImageDataContainer.x5g(destination);
  }
  b5g(bitmaps) {
    return Companion_instance_28.t5g(toList_1(bitmaps));
  }
}
class ImageDataContainer {
  static x5g(imageDatas) {
    var $this = createThis(this);
    $this.u5g_1 = imageDatas;
    var tmp = $this;
    tmp.v5g_1 = lazy(ImageDataContainer$imageDatasByName$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.w5g_1 = lazy(ImageDataContainer$default$delegate$lambda($this));
    return $this;
  }
  static z5g(imageDatas) {
    return this.x5g(toList_1(imageDatas));
  }
  y5g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5g_1;
    imageDatasByName$factory();
    return this_0.u1();
  }
  a5h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w5g_1;
    default$factory();
    return this_0.u1();
  }
  s5g() {
    return this.a5h().s5g();
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_29 = this;
    this.v4p_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.w4p_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.x4p_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_39();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.b5h_1 = filename;
    this.c5h_1 = width;
    this.d5h_1 = height;
    this.e5h_1 = premultiplied;
    this.f5h_1 = asumePremultiplied;
    this.g5h_1 = requestedMaxSize;
    this.h5h_1 = debug;
    this.i5h_1 = preferKotlinDecoder;
    this.j5h_1 = tryNativeDecode;
    this.k5h_1 = format;
    this.l5h_1 = out;
    this.m5h_1 = extra;
  }
  r10(_set____db54di) {
    this.m5h_1 = _set____db54di;
  }
  s10() {
    return this.m5h_1;
  }
  n5h() {
    return this;
  }
  o5h() {
    var tmp0_elvis_lhs = this.e5h_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  p5h(filename) {
    return this.q5h(filename);
  }
  r5h(file) {
    return this.p5h(get_baseName(file));
  }
  s5h(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  q5h(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.b5h_1 : filename;
    width = width === VOID ? this.c5h_1 : width;
    height = height === VOID ? this.d5h_1 : height;
    premultiplied = premultiplied === VOID ? this.e5h_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.f5h_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.g5h_1 : requestedMaxSize;
    debug = debug === VOID ? this.h5h_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.i5h_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.j5h_1 : tryNativeDecode;
    format = format === VOID ? this.k5h_1 : format;
    out = out === VOID ? this.l5h_1 : out;
    extra = extra === VOID ? this.m5h_1 : extra;
    return $super === VOID ? this.s5h(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.s5h.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.b5h_1 + ', width=' + this.c5h_1 + ', height=' + this.d5h_1 + ', premultiplied=' + this.e5h_1 + ', asumePremultiplied=' + this.f5h_1 + ', requestedMaxSize=' + this.g5h_1 + ', debug=' + this.h5h_1 + ', preferKotlinDecoder=' + this.i5h_1 + ', tryNativeDecode=' + this.j5h_1 + ', format=' + toString(this.k5h_1) + ', out=' + toString(this.l5h_1) + ', extra=' + toString(this.m5h_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.b5h_1);
    result = imul(result, 31) + (this.c5h_1 == null ? 0 : this.c5h_1) | 0;
    result = imul(result, 31) + (this.d5h_1 == null ? 0 : this.d5h_1) | 0;
    result = imul(result, 31) + (this.e5h_1 == null ? 0 : getBooleanHashCode(this.e5h_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f5h_1) | 0;
    result = imul(result, 31) + (this.g5h_1 == null ? 0 : this.g5h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h5h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i5h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j5h_1) | 0;
    result = imul(result, 31) + (this.k5h_1 == null ? 0 : hashCode(this.k5h_1)) | 0;
    result = imul(result, 31) + (this.l5h_1 == null ? 0 : hashCode(this.l5h_1)) | 0;
    result = imul(result, 31) + (this.m5h_1 == null ? 0 : hashCode(this.m5h_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.b5h_1 === tmp0_other_with_cast.b5h_1))
      return false;
    if (!(this.c5h_1 == tmp0_other_with_cast.c5h_1))
      return false;
    if (!(this.d5h_1 == tmp0_other_with_cast.d5h_1))
      return false;
    if (!(this.e5h_1 == tmp0_other_with_cast.e5h_1))
      return false;
    if (!(this.f5h_1 === tmp0_other_with_cast.f5h_1))
      return false;
    if (!(this.g5h_1 == tmp0_other_with_cast.g5h_1))
      return false;
    if (!(this.h5h_1 === tmp0_other_with_cast.h5h_1))
      return false;
    if (!(this.i5h_1 === tmp0_other_with_cast.i5h_1))
      return false;
    if (!(this.j5h_1 === tmp0_other_with_cast.j5h_1))
      return false;
    if (!equals(this.k5h_1, tmp0_other_with_cast.k5h_1))
      return false;
    if (!equals(this.l5h_1, tmp0_other_with_cast.l5h_1))
      return false;
    if (!equals(this.m5h_1, tmp0_other_with_cast.m5h_1))
      return false;
    return true;
  }
}
class ImageFormat {
  static u5h(exts, mimeType) {
    mimeType = mimeType === VOID ? 'image/' + first_2(exts) : mimeType;
    var $this = createThis(this);
    $this.h59_1 = mimeType;
    var tmp = $this;
    tmp.i59_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp_0.j59_1 = toSet(destination);
    return $this;
  }
  n5h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i59_1;
    decodingProps$factory();
    return this_0.u1();
  }
  w5h(image, s, props) {
    throw UnsupportedOperationException.q8();
  }
  x5h(s, props) {
    return this.v5h(s, props).a5h();
  }
  y5h(image, s, props) {
    return this.w5h(ImageDataContainer.z5g([image]), s, props);
  }
  z5h(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.t5h(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.b5i_1 = bmp.r43_1;
      this_0.c5i_1 = bmp.s43_1;
      this_0.d5i_1 = bmp.t43_1;
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  t5h(s, props) {
    return this.x5h(s, props).s5g();
  }
  e5i(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.z5h(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  f5i(s, props) {
    return this.t5h(s, props);
  }
  k59(s, props, $super) {
    props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
    return $super === VOID ? this.f5i(s, props) : $super.f5i.call(this, s, props);
  }
  g5i(data, props) {
    return this.t5h(openSync(data), props);
  }
  h5i(data, props, $completion) {
    return this.g5i(data, props);
  }
  i5i(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq.bind(VOID, this, file, props), $completion);
  }
  j5i(image, props) {
    // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
    var initialCapacity = imul(image.b2n(), 4);
    var buffer = ByteArrayBuilder.sv(initialCapacity);
    var s = MemorySyncStream(buffer);
    // Inline function 'korlibs.image.format.ImageFormat.encode.<anonymous>' call
    this.y5h(image, s, props);
    return buffer.xv();
  }
  k5i(bitmap, props) {
    return this.j5i(Companion_instance_27.b5g([bitmap]), props);
  }
  toString() {
    return 'ImageFormat(' + toString_0(this.j59_1) + ')';
  }
}
class ImageEncodingProps {
  constructor(filename, quality, extra, depremultiplyIfRequired, init) {
    filename = filename === VOID ? '' : filename;
    quality = quality === VOID ? 0.81 : quality;
    extra = extra === VOID ? null : extra;
    depremultiplyIfRequired = depremultiplyIfRequired === VOID ? true : depremultiplyIfRequired;
    init = init === VOID ? null : init;
    this.l5i_1 = filename;
    this.m5i_1 = quality;
    this.n5i_1 = extra;
    this.o5i_1 = depremultiplyIfRequired;
    this.p5i_1 = init;
    var tmp175_safe_receiver = this.p5i_1;
    if (tmp175_safe_receiver == null)
      null;
    else
      tmp175_safe_receiver(this);
  }
  r10(_set____db54di) {
    this.n5i_1 = _set____db54di;
  }
  s10() {
    return this.n5i_1;
  }
  r5h(file) {
    return this.q5i(get_baseName(file));
  }
  r5i(filename, quality, extra, depremultiplyIfRequired, init) {
    return new ImageEncodingProps(filename, quality, extra, depremultiplyIfRequired, init);
  }
  q5i(filename, quality, extra, depremultiplyIfRequired, init, $super) {
    filename = filename === VOID ? this.l5i_1 : filename;
    quality = quality === VOID ? this.m5i_1 : quality;
    extra = extra === VOID ? this.n5i_1 : extra;
    depremultiplyIfRequired = depremultiplyIfRequired === VOID ? this.o5i_1 : depremultiplyIfRequired;
    init = init === VOID ? this.p5i_1 : init;
    return $super === VOID ? this.r5i(filename, quality, extra, depremultiplyIfRequired, init) : $super.r5i.call(this, filename, quality, extra, depremultiplyIfRequired, init);
  }
  toString() {
    return 'ImageEncodingProps(filename=' + this.l5i_1 + ', quality=' + this.m5i_1 + ', extra=' + toString(this.n5i_1) + ', depremultiplyIfRequired=' + this.o5i_1 + ', init=' + toString(this.p5i_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.l5i_1);
    result = imul(result, 31) + getNumberHashCode(this.m5i_1) | 0;
    result = imul(result, 31) + (this.n5i_1 == null ? 0 : hashCode(this.n5i_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o5i_1) | 0;
    result = imul(result, 31) + (this.p5i_1 == null ? 0 : hashCode(this.p5i_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageEncodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageEncodingProps ? other : THROW_CCE();
    if (!(this.l5i_1 === tmp0_other_with_cast.l5i_1))
      return false;
    if (!equals(this.m5i_1, tmp0_other_with_cast.m5i_1))
      return false;
    if (!equals(this.n5i_1, tmp0_other_with_cast.n5i_1))
      return false;
    if (!(this.o5i_1 === tmp0_other_with_cast.o5i_1))
      return false;
    if (!equals(this.p5i_1, tmp0_other_with_cast.p5i_1))
      return false;
    return true;
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static w5i(formats) {
    var $this = this.u5h(['']);
    $this.v5i_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static x5i(formats) {
    return this.w5i(toList_1(formats));
  }
  y5i(_set____db54di) {
    var this_0 = this.v5i_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  z5i() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.v5i_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  a5j() {
    return this.z5i();
  }
  b5j(ext) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.a5j().a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExtOrNull.<anonymous>' call
        if (element.j59_1.z2(ext)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  c5j(ext) {
    var tmp0_elvis_lhs = this.b5j(ext);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.a5j();
      var destination = ArrayList.i1();
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExt.<anonymous>' call
        var list = element.j59_1;
        addAll(destination, list);
      }
      throw UnsupportedOperationException.qa("Don't know how to generate file for extension '" + ext + "' (supported extensions " + toString_0(destination) + ')');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageFormats(' + this.a5j().e1() + ')' + toString_0(this.a5j());
  }
  z5h(s, props) {
    if (this.a5j().g1())
      return null;
    var _iterator__ex2g4s = this.a5j().a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var format = _iterator__ex2g4s.c1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.z5h(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  v5h(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.a5j().a1();
      while (_iterator__ex2g4s.b1()) {
        var format = _iterator__ex2g4s.c1();
        if (format.e5i(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImageContainer.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.v5h(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.qa('No suitable image format : MAGIC:' + readString_0(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
  w5h(image, s, props) {
    this.c5j(get_extensionLC(_PathInfo___init__impl__vpw96a(props.l5i_1))).w5h(image, s, props);
  }
}
class ImageFormatsMutable extends ImageFormats {
  static i5j() {
    var $this = this.x5i([]);
    $this.h5j_1 = new NonRecursiveLock();
    return $this;
  }
  static j5j(formats) {
    var $this = this.i5j();
    $this.k5j(formats.slice());
    return $this;
  }
  k5j(formats) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.h5j_1.w1z_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.y5i(minus(plus_0(this.z5i(), formats), this));
    return this;
  }
}
class Companion_24 {
  l5j(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.m5j(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  c5g(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.l5j(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.l5j.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static a5g(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.g5f_1 = new Mixin();
    $this.h5f_1 = index;
    $this.i5f_1 = fastTime;
    $this.j5f_1 = layerData;
    $this.k5f_1 = firstOrNull_0($this.j5f_1);
    return $this;
  }
  r10(_set____db54di) {
    this.g5f_1.r10(_set____db54di);
  }
  s10() {
    return this.g5f_1.s10();
  }
  n5j() {
    return toDuration_0(this.i5f_1);
  }
  static m5j(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.a5g(index, get_fast(time), layerData);
  }
  o5j() {
    var tmp177_safe_receiver = this.k5f_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.u5f_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  p5j() {
    var tmp178_safe_receiver = this.k5f_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.m5f_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  q5j() {
    var tmp179_safe_receiver = this.k5f_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.n5f_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  f5g() {
    var tmp180_safe_receiver = this.k5f_1;
    var tmp0_elvis_lhs = tmp180_safe_receiver == null ? null : tmp180_safe_receiver.o5f_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  x2p() {
    return this.o5j().j3o_1;
  }
  y2p() {
    return this.o5j().k3o_1;
  }
  b2n() {
    return this.o5j().b2n();
  }
  e5g() {
    var tmp182_safe_receiver = this.k5f_1;
    var tmp0_elvis_lhs = tmp182_safe_receiver == null ? null : tmp182_safe_receiver.e5g();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  u3() {
    return this.o5j().e3o_1;
  }
  toString() {
    return 'ImageFrame(' + this.o5j().toString() + ', time=' + Duration__toString_impl_8d916b(this.n5j()) + ', targetX=' + this.p5j() + ', targetY=' + this.q5j() + ', main=' + this.f5g() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.l5f_1 = layer;
    this.m5f_1 = targetX;
    this.n5f_1 = targetY;
    this.o5f_1 = main;
    this.p5f_1 = includeInAtlas;
    this.q5f_1 = tilemap;
    this.r5f_1 = ninePatchSlice;
    this.s5f_1 = null;
    this.t5f_1 = null;
    this.u5f_1 = slice;
  }
  x2p() {
    return this.u5f_1.j3o_1;
  }
  y2p() {
    return this.u5f_1.k3o_1;
  }
  e5g() {
    if (get_bmp(this.u5f_1).r43_1 === this.x2p() && get_bmp(this.u5f_1).s43_1 === this.y2p())
      return get_bmp(this.u5f_1);
    if (this.s5f_1 == null)
      this.s5f_1 = extract_0(this.u5f_1);
    return ensureNotNull(this.s5f_1);
  }
}
class ImageInfo {
  constructor() {
    this.a5i_1 = new Mixin();
    this.b5i_1 = 0;
    this.c5i_1 = 0;
    this.d5i_1 = 8;
  }
  r10(_set____db54di) {
    this.a5i_1.r10(_set____db54di);
  }
  s10() {
    return this.a5i_1.s10();
  }
  toString() {
    var tmp = this.b5i_1;
    var tmp_0 = this.c5i_1;
    var tmp_1 = this.d5i_1;
    var tmp183_safe_receiver = this.s10();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString(tmp183_safe_receiver == null ? null : toMap_0(tmp183_safe_receiver)) + ')';
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r5j_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.d5f_1 = index;
    this.e5f_1 = name;
    this.f5f_1 = type;
  }
}
class NativeImageFormatProvider {
  u5j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0.bind(VOID, this, data, props), $completion);
  }
  o5k(_this__u8e3s4, props) {
    return this.q5k(_this__u8e3s4, props);
  }
  q5k(image, props) {
    return this.p5k(toBitmap_0(image.s41()), props);
  }
  n5k(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1.bind(VOID, this, vfs, path, props), $completion);
  }
  h5i(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme.bind(VOID, this, data, props), $completion);
  }
  r5k(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0.bind(VOID, this, file, props), $completion);
  }
  i5i(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1.bind(VOID, this, file, props), $completion);
  }
  x4h(width, height, premultiplied) {
    return BitmapNativeImage.w5k(Bitmap32.k43(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  w4h(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.x4h(bmp.r43_1, bmp.s43_1, bmp.x43_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.v43_1;
    if (true) {
      this_0.e44();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.n4b(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.x5k(bmp, Companion_getInstance_6().j2d_1);
      }finally {
        ctx.d1b();
      }
    }finally {
      result = true ? this_0.g44(rect) : 0;
    }
    return this_0;
  }
  s5k(bmp) {
    return BitmapNativeImage.m5k(bmp);
  }
  p5k(_this__u8e3s4, props) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof NativeImage) {
      tmp_0 = !props.f5h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = props.e5h_1 == null || props.e5h_1 === _this__u8e3s4.x43_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      return _this__u8e3s4;
    }
    var out = _this__u8e3s4.o4b();
    if (props.f5h_1) {
      asumePremultiplied(out);
    } else if (!_this__u8e3s4.x43_1 && props.e5h_1 === false) {
      out.x4e();
    } else if (_this__u8e3s4.x43_1 && props.e5h_1 === true) {
      out.w4e();
    }
    return this.s5k(out);
  }
  s5j(_this__u8e3s4, props) {
    return new NativeImageResult(this.p5k(_this__u8e3s4, props));
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  u5j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt.bind(VOID, this, data, props), $completion);
  }
  v5j(bmp) {
    return BitmapNativeImage.m5k(bmp);
  }
  t5j(bmp, props) {
    var bmp32 = bmp.o4b();
    return new NativeImageResult(this.v5j(props.f5h_1 ? asumePremultiplied(bmp32) : props.o5h() ? bmp32.t4e() : bmp32.u4e()));
  }
  x4h(width, height, premultiplied) {
    return this.v5j(Bitmap32.k43(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  w4h(bmp) {
    return this.v5j(bmp);
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.r43_1 : originalWidth;
    originalHeight = originalHeight === VOID ? image.s43_1 : originalHeight;
    this.t5k_1 = image;
    this.u5k_1 = originalWidth;
    this.v5k_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.t5k_1.toString() + ', originalWidth=' + this.u5k_1 + ', originalHeight=' + this.v5k_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t5k_1);
    result = imul(result, 31) + this.u5k_1 | 0;
    result = imul(result, 31) + this.v5k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.t5k_1, tmp0_other_with_cast.t5k_1))
      return false;
    if (!(this.u5k_1 === tmp0_other_with_cast.u5k_1))
      return false;
    if (!(this.v5k_1 === tmp0_other_with_cast.v5k_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static w5k(bitmap) {
    var $this = this.v4h(bitmap.r43_1, bitmap.s43_1, bitmap, bitmap.x43_1);
    $this.k5k_1 = bitmap;
    $this.l5k_1 = $this.k5k_1.h43_1;
    return $this;
  }
  u3() {
    return 'BitmapNativeImage';
  }
  static m5k(bitmap) {
    return this.w5k(bitmap.o4b());
  }
  n4b(antialiasing) {
    return this.k5k_1.n4b(antialiasing);
  }
  d44() {
    return this.k5k_1;
  }
  o44(x, y, width, height, out, offset) {
    return this.k5k_1.o44(x, y, width, height, out, offset);
  }
  q44(x, y, width, height, out, offset) {
    return this.k5k_1.q44(x, y, width, height, out, offset);
  }
  r44(x, y, v) {
    return this.k5k_1.r44(x, y, v);
  }
  p44(x, y) {
    return this.k5k_1.p44(x, y);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_32 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.sc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.a5l_1;
      destination.j3(tmp$ret$0, element);
    }
    tmp.c5l_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.d5l_1 = startingRow;
    this.e5l_1 = startingCol;
    this.f5l_1 = rowIncrement;
    this.g5l_1 = colIncrement;
    this.h5l_1 = blockHeight;
    this.i5l_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.g5l_1;
    var tmp$ret$0 = log2(x);
    tmp.j5l_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.d5l_1 + ', startingCol=' + this.e5l_1 + ', rowIncrement=' + this.f5l_1 + ', colIncrement=' + this.g5l_1 + ', blockHeight=' + this.h5l_1 + ', blockWidth=' + this.i5l_1 + ')';
  }
  hashCode() {
    var result = this.d5l_1;
    result = imul(result, 31) + this.e5l_1 | 0;
    result = imul(result, 31) + this.f5l_1 | 0;
    result = imul(result, 31) + this.g5l_1 | 0;
    result = imul(result, 31) + this.h5l_1 | 0;
    result = imul(result, 31) + this.i5l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.d5l_1 === tmp0_other_with_cast.d5l_1))
      return false;
    if (!(this.e5l_1 === tmp0_other_with_cast.e5l_1))
      return false;
    if (!(this.f5l_1 === tmp0_other_with_cast.f5l_1))
      return false;
    if (!(this.g5l_1 === tmp0_other_with_cast.g5l_1))
      return false;
    if (!(this.h5l_1 === tmp0_other_with_cast.h5l_1))
      return false;
    if (!(this.i5l_1 === tmp0_other_with_cast.i5l_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.a5l_1 = id;
    this.b5l_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.k5l_1 = width;
    this.l5l_1 = height;
    this.m5l_1 = bitsPerChannel;
    this.n5l_1 = colorspace;
    this.o5l_1 = compressionmethod;
    this.p5l_1 = filtermethod;
    this.q5l_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.n5l_1.t3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.r5l_1 = tmp_0;
    this.s5l_1 = imul(imul(this.k5l_1, this.r5l_1), this.m5l_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.t5l_1 = header;
    this.u5l_1 = _UByteArrayInt___init__impl__xif7bu_0(this.t5l_1.s5l_1);
    this.v5l_1 = _UByteArrayInt___init__impl__xif7bu_0(this.t5l_1.s5l_1);
    this.w5l_1 = Companion_instance_11.a4f(this.t5l_1.k5l_1);
  }
  g5m() {
    var temp = this.v5l_1;
    this.v5l_1 = this.u5l_1;
    this.u5l_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.h5m_1 = $data;
    this.i5m_1 = $info;
  }
  fe($completion) {
    return EXIF_getInstance().b5f(openAsync(readAll_0(this.h5m_1)), this.i5m_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static j5m() {
    PNG_instance = null;
    var $this = this.u5h(['png']);
    PNG_instance = $this;
    $this.a5m_1 = -1991225785;
    $this.b5m_1 = 218765834;
    $this.c5m_1 = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.d5m_1 = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  z5h(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  w5h(image, s, props) {
    var bitmap = image.s5g();
    var width = bitmap.r43_1;
    var height = bitmap.s43_1;
    write32BE(s, -1991225785);
    write32BE(s, 218765834);
    var level = numberToInt(convertRangeClamped(props.m5i_1, 0.0, 1.0, 0.0, 9.0));
    var tmp;
    if (bitmap instanceof BitmapIndexed) {
      var ncolors = bitmap.i4f();
      writeImageContainer$writeHeader(width, height, s, Colorspace_INDEXED_getInstance());
      var tmp_0 = imul(ncolors, 3);
      writeImageContainer$writeChunk_0(s, 'PLTE', tmp_0, PNG$writeImageContainer$lambda(ncolors, bitmap));
      var tmp_1 = imul(_RgbaArray___get_size__impl__imxef8(bitmap.x4c_1), 1);
      writeImageContainer$writeChunk_0(s, 'tRNS', tmp_1, PNG$writeImageContainer$lambda_0(ncolors, bitmap));
      var tmp0_elvis_lhs = tryToExactBitmap8(bitmap);
      tmp = tmp0_elvis_lhs == null ? bitmap : tmp0_elvis_lhs;
    } else {
      writeImageContainer$writeHeader(width, height, s, Colorspace_RGBA_getInstance());
      tmp = props.o5i_1 ? bitmap.d44().u4e() : bitmap.d44();
    }
    var bmp = tmp;
    var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
    var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
    var Bpp = divCeil(bitmap.t43_1, 8);
    var scanline = imul(width, Bpp);
    var prev = _UByteArrayInt___init__impl__xif7bu_0(scanline);
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(3), null);
    while (tmp_2 < 3) {
      var tmp_4 = tmp_2;
      var tmp$ret$1 = _UByteArrayInt___init__impl__xif7bu_0(scanline);
      tmp_3[tmp_4] = new UByteArrayInt(tmp$ret$1);
      tmp_2 = tmp_2 + 1 | 0;
    }
    var currs = tmp_3;
    var curr = currs[0].v14_1;
    var currF1 = currs[1].v14_1;
    var currF2 = currs[2].v14_1;
    var tempScore = _UByteArrayInt___init__impl__xif7bu_0(256);
    var oscanline = scanline + 1 | 0;
    var out = new Int8Array(imul(height, oscanline));
    var tryFilters = props.m5i_1 >= 0.5;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var index = bmp.m44(0, y);
        var pos = 0;
        if (!(bmp32 == null)) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var c = bmp32.x4b(index + x | 0);
              var tmp_5 = _UByteArrayInt___get_data__impl__l2b913(curr);
              var _unary__edvuaz = pos;
              pos = _unary__edvuaz + 1 | 0;
              set8(tmp_5, _unary__edvuaz, _RGBA___get_r__impl__duz7mo(c));
              var tmp_6 = _UByteArrayInt___get_data__impl__l2b913(curr);
              var _unary__edvuaz_0 = pos;
              pos = _unary__edvuaz_0 + 1 | 0;
              set8(tmp_6, _unary__edvuaz_0, _RGBA___get_g__impl__o8pukr(c));
              var tmp_7 = _UByteArrayInt___get_data__impl__l2b913(curr);
              var _unary__edvuaz_1 = pos;
              pos = _unary__edvuaz_1 + 1 | 0;
              set8(tmp_7, _unary__edvuaz_1, _RGBA___get_b__impl__m6tl80(c));
              var tmp_8 = _UByteArrayInt___get_data__impl__l2b913(curr);
              var _unary__edvuaz_2 = pos;
              pos = _unary__edvuaz_2 + 1 | 0;
              set8(tmp_8, _unary__edvuaz_2, _RGBA___get_a__impl__6msvu7(c));
            }
             while (inductionVariable_0 < width);
        } else if (!(bmp8 == null)) {
          var inductionVariable_1 = 0;
          if (inductionVariable_1 < width)
            do {
              var x_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var tmp_9 = _UByteArrayInt___get_data__impl__l2b913(curr);
              var _unary__edvuaz_3 = pos;
              pos = _unary__edvuaz_3 + 1 | 0;
              set8(tmp_9, _unary__edvuaz_3, bmp8.d4f(index + x_0 | 0));
            }
             while (inductionVariable_1 < width);
        }
        if (tryFilters) {
          // Inline function 'kotlin.run' call
          // Inline function 'kotlin.contracts.contract' call
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < Bpp)
            do {
              var n = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              UByteArrayInt__set_impl_gn4532(currF1, n, UByteArrayInt__get_impl_px6q8a(curr, n));
            }
             while (inductionVariable_2 < Bpp);
          var inductionVariable_3 = Bpp;
          if (inductionVariable_3 < scanline)
            do {
              var n_0 = inductionVariable_3;
              inductionVariable_3 = inductionVariable_3 + 1 | 0;
              UByteArrayInt__set_impl_gn4532(currF1, n_0, (UByteArrayInt__get_impl_px6q8a(curr, n_0) - UByteArrayInt__get_impl_px6q8a(curr, n_0 - Bpp | 0) | 0) & 255);
            }
             while (inductionVariable_3 < scanline);
          if (y > 0) {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.contracts.contract' call
            var inductionVariable_4 = 0;
            if (inductionVariable_4 < scanline)
              do {
                var n_1 = inductionVariable_4;
                inductionVariable_4 = inductionVariable_4 + 1 | 0;
                UByteArrayInt__set_impl_gn4532(currF2, n_1, (UByteArrayInt__get_impl_px6q8a(curr, n_1) - UByteArrayInt__get_impl_px6q8a(prev, n_1) | 0) & 255);
              }
               while (inductionVariable_4 < scanline);
          }
        }
        var tmp_10;
        if (!tryFilters) {
          tmp_10 = 0;
        } else if (props.m5i_1 < 0.9) {
          tmp_10 = y === 0 ? 1 : 2;
        } else {
          // Inline function 'kotlin.collections.mapIndexed' call
          // Inline function 'kotlin.collections.mapIndexedTo' call
          var destination = ArrayList.w(currs.length);
          var index_0 = 0;
          var inductionVariable_5 = 0;
          var last = currs.length;
          while (inductionVariable_5 < last) {
            var item = currs[inductionVariable_5];
            inductionVariable_5 = inductionVariable_5 + 1 | 0;
            // Inline function 'korlibs.image.format.PNG.writeImageContainer.<anonymous>' call
            var tmp1 = index_0;
            index_0 = tmp1 + 1 | 0;
            var bytes = item.v14_1;
            UByteArrayInt__fill$default_impl_mdydxi(tempScore, 0);
            var tmp$ret$4 = to(tmp1, y > 0 || tmp1 <= 1 ? compressionScore(PNG_getInstance(), bytes, tempScore) : Infinity);
            destination.h(tmp$ret$4);
          }
          var scores = destination;
          // Inline function 'kotlin.also' call
          var tmp$ret$7;
          $l$block: {
            // Inline function 'kotlin.collections.minBy' call
            var iterator = scores.a1();
            if (!iterator.b1())
              throw NoSuchElementException.b7();
            var minElem = iterator.c1();
            if (!iterator.b1()) {
              tmp$ret$7 = minElem;
              break $l$block;
            }
            // Inline function 'korlibs.image.format.PNG.writeImageContainer.<anonymous>' call
            var minValue = minElem.tl_1;
            do {
              var e = iterator.c1();
              // Inline function 'korlibs.image.format.PNG.writeImageContainer.<anonymous>' call
              var v = e.tl_1;
              if (compareTo(minValue, v) > 0) {
                minElem = e;
                minValue = v;
              }
            }
             while (iterator.b1());
            tmp$ret$7 = minElem;
          }
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.format.PNG.writeImageContainer.<anonymous>' call
          tmp_10 = tmp$ret$7.sl_1;
        }
        var filter = tmp_10;
        var outpos = imul(y, oscanline);
        var currFiltered = currs[filter].v14_1;
        out[outpos] = toByte(filter);
        arraycopy_0(_UByteArrayInt___get_data__impl__l2b913(currFiltered), 0, out, outpos + 1 | 0, scanline);
        arraycopy_1(curr, 0, prev, 0, scanline);
      }
       while (inductionVariable < height);
    writeImageContainer$writeChunk(s, 'IDAT', writeImageContainer$compress(level, out));
    writeImageContainer$writeChunk_0(s, 'IEND', 0, PNG$writeImageContainer$lambda_1);
  }
  v5h(s, props) {
    var tmp = Companion_instance_28;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.b5g([tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE()]);
  }
  k5m(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  e5m(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.k5m(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.ee('An operation is not implemented: ' + reason);
    }
  }
  f5m(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.e5m(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.e5m.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  o5m(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.n5m(n, yFloat));
      }
       while (!(n === x1));
  }
  p5m(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.h43_1);
    var inductionVariable = rect.a2e();
    var last = rect.b2e();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.r43_1);
        this.o5m(cols, offset, rect.y2d(), rect.z2d() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  q5m(bmp, rect, $super) {
    rect = rect === VOID ? bmp.j43_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.p5m(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.p5m.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.l5m_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().a45_1);
  }
  m5m(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.l5m_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  n5m(x, y) {
    return this.l5m_1;
  }
  o5m(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.l5m_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_27 {
  constructor() {
    this.r5m_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.s5m_1 = Companion_instance_14.q4l(256);
  }
  u5m(fill, state) {
    fill.v5m(this.s5m_1);
    this.t5m_1 = fill.w5m(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_5().s2g_1.k2i(fill.c5a_1).k2i(state.f4o_1));
    return this;
  }
  x5m(x, y) {
    return _get_fill__d6ivc8(this).y5m(Vector2D.b2i(x, y));
  }
  n5m(x, y) {
    return color(this, this.x5m(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.z5m_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.a5n_1 = 0.0;
    this.b5n_1 = 0.0;
    this.c5n_1 = 0.0;
    this.d5n_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.e5n_1 = get_bmp(tmp$ret$0);
    this.f5n_1 = Companion_getInstance_5().s2g_1;
    this.g5n_1 = true;
    this.h5n_1 = Companion_getInstance_5().s2g_1;
  }
  i5n(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.z5m_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.l5n_1, fill.m5n_1);
    _set_texture__qu271y(this, fill.p5n_1);
    this.f5n_1 = fill.k5n_1;
    this.g5n_1 = fill.n5n_1;
    this.h5n_1 = Companion_getInstance_5().s2g_1.d2i(state.f4o_1).d2i(fill.k5n_1).e2i();
    return this;
  }
  q5n(x, y) {
    return this.e5n_1.x44(x, y);
  }
  r5n(x, y) {
    return this.e5n_1.i4d(numberToInt(x), numberToInt(y));
  }
  n5m(x, y) {
    var mat = this.h5n_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D.b2i(x, y);
      if (mat.w2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.q2f(mat.k2h(p.h2d_1, p.i2d_1), mat.n2h(p.h2d_1, p.i2d_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D.b2i(this.c5n_1, this.d5n_1);
    var p_0 = Vector2D.q2f(this_0.h2d_1 * that.h2d_1, this_0.i2d_1 * that.i2d_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.z5m_1, p_0);
    var that_0 = Vector2D.b2i(this.a5n_1, this.b5n_1);
    var t = Vector2D.q2f(this_1.h2d_1 * that_0.h2d_1, this_1.i2d_1 * that_0.i2d_1);
    return this.g5n_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.q5n(t.h2d_1, t.i2d_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.r5n(t.h2d_1, t.i2d_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  n5m(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  o5m(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class Companion_28 {}
class TransformedPaint {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.a2t() : stops;
    colors = colors === VOID ? IntArrayList.g2s() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_5().s2g_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_8().y2c_1 : startAngle;
    this.s59_1 = kind;
    this.t59_1 = x0;
    this.u59_1 = y0;
    this.v59_1 = r0;
    this.w59_1 = x1;
    this.x59_1 = y1;
    this.y59_1 = r1;
    this.z59_1 = stops;
    this.a5a_1 = colors;
    this.b5a_1 = cycle;
    this.c5a_1 = transform;
    this.d5a_1 = interpolationMethod;
    this.e5a_1 = units;
    this.f5a_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_5().s2g_1.y2h(-this.t59_1, -this.u59_1).t2h(1.0 / clamp_1(Companion_getInstance_6().t2m(this.t59_1, this.u59_1, this.w59_1, this.x59_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_8();
    var x0_0 = this.t59_1;
    var y0_0 = this.u59_1;
    var x1_0 = this.w59_1;
    var y1_0 = this.x59_1;
    var up = Companion_getInstance_6().n2d_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.g5a_1 = tmp_0.q2h(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.h5a_1 = this.c5a_1.e2i();
    this.i5a_1 = Companion_getInstance_5().s2g_1.d2i(this.g5a_1).d2i(this.h5a_1);
    this.j5a_1 = 2 * this.v59_1 * this.y59_1;
    this.k5a_1 = this.s5n(this.v59_1);
    this.l5a_1 = this.s5n(this.y59_1);
    this.m5a_1 = this.u59_1 - this.x59_1;
    this.n5a_1 = this.v59_1 - this.y59_1;
    this.o5a_1 = this.t59_1 - this.w59_1;
    this.p5a_1 = 1.0 / (this.s5n(this.v59_1 - this.y59_1) - this.s5n(this.t59_1 - this.w59_1) - this.s5n(this.u59_1 - this.x59_1));
  }
  y4x() {
    return this.c5a_1;
  }
  v5m(out) {
    return _fillColors(Companion_instance_34, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.z59_1, this.a5a_1, true);
  }
  q5a(stop, color) {
    return this.t5n(stop, color);
  }
  t5n(stop, color) {
    this.z59_1.i2t(stop);
    this.a5a_1.n2s(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  y5m(p) {
    var tmp;
    switch (this.s59_1.t3_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.h5a_1;
          if (this_0.w2d()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.q2f(this_0.k2h(p.h2d_1, p.i2d_1), this_0.n2h(p.h2d_1, p.i2d_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_6().g2o(Vector2D.q2f(this.t59_1, this.u59_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.h5a_1;
          if (this_1.w2d()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.q2f(this_1.k2h(p.h2d_1, p.i2d_1), this_1.n2h(p.h2d_1, p.i2d_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.ul();
        var y = _destruct__k2r9zo.vl();
        var tmp_0 = -this.y59_1 * this.n5a_1 + this.o5a_1 * (this.w59_1 - x) + this.m5a_1 * (this.x59_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.l5a_1 * (this.s5n(this.t59_1 - x) + this.s5n(this.u59_1 - y)) - this.j5a_1 * ((this.t59_1 - x) * (this.w59_1 - x) + (this.u59_1 - y) * (this.x59_1 - y)) + this.k5a_1 * (this.s5n(this.w59_1 - x) + this.s5n(this.x59_1 - y)) - this.s5n(this.w59_1 * this.u59_1 - x * this.u59_1 - this.t59_1 * this.x59_1 + x * this.x59_1 + this.t59_1 * y - this.w59_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.p5a_1;
        break;
      default:
        tmp = this.i5a_1.j2h(p);
        break;
    }
    return this.b5a_1.w5n(tmp);
  }
  s5n(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  o10() {
    return this.w5m(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.c5a_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.s59_1.t3_1) {
      case 0:
        tmp = 'LinearGradient([' + this.t59_1 + ', ' + this.u59_1 + '], [' + this.w59_1 + ', ' + this.x59_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.t59_1 + ', ' + this.u59_1 + ', ' + this.v59_1 + '], [' + this.w59_1 + ', ' + this.x59_1 + ', ' + this.y59_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.t59_1 + ', ' + this.u59_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.ec(tmp);
    this_0.ec(', stops=' + this.z59_1.toString() + ', colors=' + colorsToString_0(this, this.a5a_1) + ', cycle=' + this.b5a_1.toString() + ', transform=' + this.c5a_1.toString() + ', interpolationMethod=' + this.d5a_1.toString() + ', units=' + this.e5a_1.toString() + ')');
    return this_0.toString();
  }
  x5n(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  w5m(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.s59_1 : kind;
    x0 = x0 === VOID ? this.t59_1 : x0;
    y0 = y0 === VOID ? this.u59_1 : y0;
    r0 = r0 === VOID ? this.v59_1 : r0;
    x1 = x1 === VOID ? this.w59_1 : x1;
    y1 = y1 === VOID ? this.x59_1 : y1;
    r1 = r1 === VOID ? this.y59_1 : r1;
    stops = stops === VOID ? this.z59_1 : stops;
    colors = colors === VOID ? this.a5a_1 : colors;
    cycle = cycle === VOID ? this.b5a_1 : cycle;
    transform = transform === VOID ? this.c5a_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.d5a_1 : interpolationMethod;
    units = units === VOID ? this.e5a_1 : units;
    startAngle = startAngle === VOID ? this.f5a_1 : startAngle;
    return $super === VOID ? this.x5n(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.x5n.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.s59_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.t59_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u59_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v59_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w59_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x59_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y59_1) | 0;
    result = imul(result, 31) + this.z59_1.hashCode() | 0;
    result = imul(result, 31) + this.a5a_1.hashCode() | 0;
    result = imul(result, 31) + this.b5a_1.hashCode() | 0;
    result = imul(result, 31) + this.c5a_1.hashCode() | 0;
    result = imul(result, 31) + this.d5a_1.hashCode() | 0;
    result = imul(result, 31) + this.e5a_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.f5a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.s59_1.equals(tmp0_other_with_cast.s59_1))
      return false;
    if (!equals(this.t59_1, tmp0_other_with_cast.t59_1))
      return false;
    if (!equals(this.u59_1, tmp0_other_with_cast.u59_1))
      return false;
    if (!equals(this.v59_1, tmp0_other_with_cast.v59_1))
      return false;
    if (!equals(this.w59_1, tmp0_other_with_cast.w59_1))
      return false;
    if (!equals(this.x59_1, tmp0_other_with_cast.x59_1))
      return false;
    if (!equals(this.y59_1, tmp0_other_with_cast.y59_1))
      return false;
    if (!this.z59_1.equals(tmp0_other_with_cast.z59_1))
      return false;
    if (!this.a5a_1.equals(tmp0_other_with_cast.a5a_1))
      return false;
    if (!this.b5a_1.equals(tmp0_other_with_cast.b5a_1))
      return false;
    if (!this.c5a_1.equals(tmp0_other_with_cast.c5a_1))
      return false;
    if (!this.d5a_1.equals(tmp0_other_with_cast.d5a_1))
      return false;
    if (!this.e5a_1.equals(tmp0_other_with_cast.e5a_1))
      return false;
    if (!equals(this.f5a_1, tmp0_other_with_cast.f5a_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientInterpolationMethod extends Enum {}
class GradientUnits extends Enum {}
class NonePaint {
  o10() {
    return this;
  }
}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_5().s2g_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.j5n_1 = bitmap;
    this.k5n_1 = transform;
    this.l5n_1 = cycleX;
    this.m5n_1 = cycleY;
    this.n5n_1 = smooth;
    this.o5n_1 = units;
    this.p5n_1 = this.j5n_1.d44();
  }
  y4x() {
    return this.k5n_1;
  }
  y5n() {
    return this.l5n_1.z5n();
  }
  a5o() {
    return this.m5n_1.z5n();
  }
  o10() {
    return this.b5o(VOID, this.k5n_1);
  }
  toString() {
    return 'BitmapPaint(' + toString_0(this.j5n_1) + ', cycle=(' + this.l5n_1.toString() + ', ' + this.m5n_1.toString() + '), smooth=' + this.n5n_1 + ', transform=' + this.k5n_1.toString() + ')';
  }
  c5o(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  b5o(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.j5n_1 : bitmap;
    transform = transform === VOID ? this.k5n_1 : transform;
    cycleX = cycleX === VOID ? this.l5n_1 : cycleX;
    cycleY = cycleY === VOID ? this.m5n_1 : cycleY;
    smooth = smooth === VOID ? this.n5n_1 : smooth;
    units = units === VOID ? this.o5n_1 : units;
    return $super === VOID ? this.c5o(bitmap, transform, cycleX, cycleY, smooth, units) : $super.c5o.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.j5n_1);
    result = imul(result, 31) + this.k5n_1.hashCode() | 0;
    result = imul(result, 31) + this.l5n_1.hashCode() | 0;
    result = imul(result, 31) + this.m5n_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n5n_1) | 0;
    result = imul(result, 31) + this.o5n_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.j5n_1, tmp0_other_with_cast.j5n_1))
      return false;
    if (!this.k5n_1.equals(tmp0_other_with_cast.k5n_1))
      return false;
    if (!this.l5n_1.equals(tmp0_other_with_cast.l5n_1))
      return false;
    if (!this.m5n_1.equals(tmp0_other_with_cast.m5n_1))
      return false;
    if (!(this.n5n_1 === tmp0_other_with_cast.n5n_1))
      return false;
    if (!this.o5n_1.equals(tmp0_other_with_cast.o5n_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_35 = this;
    this.d5o_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.e5o_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.f5o_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.g5o_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h5o_1 = [new VerticalAlign(this.d5o_1), new VerticalAlign(this.e5o_1), new VerticalAlign(this.g5o_1), new VerticalAlign(this.f5o_1)];
    this.i5o_1 = toList_1(this.h5o_1);
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_45();
    this.j5o_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.j5o_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.j5o_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.j5o_1, other);
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_36 = this;
    this.k5o_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.l5o_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.m5o_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.n5o_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o5o_1 = [new HorizontalAlign(this.l5o_1), new HorizontalAlign(this.m5o_1), new HorizontalAlign(this.n5o_1), new HorizontalAlign(this.k5o_1)];
    this.p5o_1 = toList_1(this.o5o_1);
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_46();
    this.q5o_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.q5o_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.q5o_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.q5o_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_37 = this;
    this.m4t_1 = listOf([new HorizontalAlign(Companion_getInstance_46().l5o_1), new HorizontalAlign(Companion_getInstance_46().m5o_1), new HorizontalAlign(Companion_getInstance_46().n5o_1), new HorizontalAlign(Companion_getInstance_46().k5o_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.m4t_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var it = item.q5o_1;
      var tmp$ret$0 = new TextAlignment(it, Companion_getInstance_45().d5o_1);
      destination.h(tmp$ret$0);
    }
    tmp.n4t_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.m4t_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var it_0 = item_0.q5o_1;
      var tmp$ret$3 = new TextAlignment(it_0, Companion_getInstance_45().g5o_1);
      destination_0.h(tmp$ret$3);
    }
    tmp_0.o4t_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.m4t_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.a1();
    while (tmp0_iterator_1.b1()) {
      var item_1 = tmp0_iterator_1.c1();
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var it_1 = item_1.q5o_1;
      var tmp$ret$6 = new TextAlignment(it_1, Companion_getInstance_45().e5o_1);
      destination_1.h(tmp$ret$6);
    }
    tmp_1.p4t_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.m4t_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.a1();
    while (tmp0_iterator_2.b1()) {
      var item_2 = tmp0_iterator_2.c1();
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var it_2 = item_2.q5o_1;
      var tmp$ret$9 = new TextAlignment(it_2, Companion_getInstance_45().f5o_1);
      destination_2.h(tmp$ret$9);
    }
    tmp_2.q4t_1 = destination_2;
    this.r4t_1 = plus(plus(plus(this.n4t_1, this.o4t_1), this.p4t_1), this.q4t_1);
    this.s4t_1 = this.n4t_1.d1(0);
    this.t4t_1 = this.n4t_1.d1(1);
    this.u4t_1 = this.n4t_1.d1(2);
    this.v4t_1 = this.n4t_1.d1(3);
    this.w4t_1 = this.o4t_1.d1(0);
    this.x4t_1 = this.o4t_1.d1(1);
    this.y4t_1 = this.o4t_1.d1(2);
    this.z4t_1 = this.o4t_1.d1(3);
    this.a4u_1 = this.n4t_1.d1(0);
    this.b4u_1 = this.n4t_1.d1(1);
    this.c4u_1 = this.n4t_1.d1(2);
    this.d4u_1 = this.n4t_1.d1(3);
    this.e4u_1 = this.p4t_1.d1(0);
    this.f4u_1 = this.p4t_1.d1(1);
    this.g4u_1 = this.p4t_1.d1(2);
    this.h4u_1 = this.p4t_1.d1(3);
    this.i4u_1 = this.q4t_1.d1(0);
    this.j4u_1 = this.q4t_1.d1(1);
    this.k4u_1 = this.q4t_1.d1(2);
    this.l4u_1 = this.q4t_1.d1(3);
  }
  r5o(horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_46().l5o_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_46().m5o_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_46().n5o_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_46().k5o_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_45().d5o_1) ? this.n4t_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_45().g5o_1) ? this.o4t_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_45().e5o_1) ? this.p4t_1.d1(horizontalIndex) : equals(vertical, Companion_getInstance_45().f5o_1) ? this.q4t_1.d1(horizontalIndex) : new TextAlignment(horizontal, vertical);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_47();
    this.k4v_1 = horizontal;
    this.l4v_1 = vertical;
    this.m4v_1 = Anchor2D.v2c(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.k4v_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.l4v_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.l4v_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.k4v_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.k4v_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.l4v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.k4v_1, tmp0_other_with_cast.k4v_1))
      return false;
    if (!equals(this.l4v_1, tmp0_other_with_cast.l4v_1))
      return false;
    return true;
  }
}
class TextRenderer {}
function get_version() {
  return 0;
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_7().h2e() : bounds;
    this.o4v_1 = maxLineHeight;
    this.p4v_1 = maxX;
    this.q4v_1 = bounds;
  }
  r4v(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.p4v_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.q4v_1, 0.0);
  }
  g4y(dx) {
    this.p4v_1 = this.p4v_1 + dx;
  }
  u5o(fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.o4v_1;
    var b = fontMetrics.t4m();
    tmp.o4v_1 = Math.max(a, b);
  }
  v5o() {
  }
  j2y() {
    this.p4v_1 = 0.0;
    this.q4v_1 = Companion_getInstance_7().c2e_1;
    this.o4v_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.o4v_1 + ', maxX=' + this.p4v_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.q4v_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.o4v_1);
    result = imul(result, 31) + getNumberHashCode(this.p4v_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.q4v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.o4v_1, tmp0_other_with_cast.o4v_1))
      return false;
    if (!equals(this.p4v_1, tmp0_other_with_cast.p4v_1))
      return false;
    if (!equals(this.q4v_1, tmp0_other_with_cast.q4v_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.e4v_1 = Companion_getInstance_7().h2e();
    this.f4v_1 = Companion_getInstance_7().h2e();
    this.g4v_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.h4v_1 = ArrayList.i1();
    this.i4v_1 = new LineStats();
  }
  j4v() {
    return this.g4v_1;
  }
  w5o() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.h4v_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.o4v_1;
    }
    return sum;
  }
  w4x(align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.h4v_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.p4v_1);
  }
  n4v(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.w5o());
  }
  j2y() {
    super.j2y();
    this.g4v_1 = 0;
    this.f4v_1 = Companion_getInstance_7().c2e_1;
    this.e4v_1 = Companion_getInstance_7().c2e_1;
    this.i4v_1.j2y();
    this.h4v_1.m3();
  }
  k4x(reader, codePoint) {
    var g = this.e4y(reader, codePoint);
    add_0(this, g.i4m_1);
    this.i4v_1.u5o(this.n4x_1);
    return g;
  }
  g4y(x) {
    super.g4y(x);
    this.i4v_1.g4y(x);
  }
  h4y(y, end) {
    super.h4y(y, end);
    this.g4v_1 = this.g4v_1 + 1 | 0;
    this.i4v_1.u5o(this.n4x_1);
    this.i4v_1.v5o();
    this.h4v_1.h(this.i4v_1);
    this.i4v_1 = new LineStats();
  }
}
class LineInfo {
  constructor(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.x5o_1 = maxTop;
    this.y5o_1 = minBottom;
    this.z5o_1 = maxLineHeight;
  }
  toString() {
    return 'LineInfo(maxTop=' + this.x5o_1 + ', minBottom=' + this.y5o_1 + ', maxLineHeight=' + this.z5o_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.x5o_1);
    result = imul(result, 31) + getNumberHashCode(this.y5o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z5o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.x5o_1, tmp0_other_with_cast.x5o_1))
      return false;
    if (!equals(this.y5o_1, tmp0_other_with_cast.y5o_1))
      return false;
    if (!equals(this.z5o_1, tmp0_other_with_cast.z5o_1))
      return false;
    return true;
  }
}
class Entry_0 {
  constructor(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians(0) : rot;
    this.a5p_1 = tex;
    this.b5p_1 = x;
    this.c5p_1 = y;
    this.d5p_1 = sx;
    this.e5p_1 = sy;
    this.f5p_1 = rot;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    this_0.ec('Entry(');
    this_0.ec("'" + this.a5p_1.e3o_1 + "', " + numberToInt(this.b5p_1) + ', ' + numberToInt(this.c5p_1) + ', ' + this.a5p_1.j3o_1 + ', ' + this.a5p_1.k3o_1);
    if (!(this.d5p_1 === 1.0)) {
      this_0.ec(', sx=' + get_niceStr_0(this.d5p_1));
    }
    if (!(this.e5p_1 === 1.0)) {
      this_0.ec(', sy=' + get_niceStr_0(this.e5p_1));
    }
    if (!equals(this.f5p_1, get_radians(0))) {
      this_0.ec(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.f5p_1)));
    }
    this_0.ec(')');
    return this_0.toString();
  }
  hashCode() {
    var result = this.a5p_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.b5p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c5p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d5p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e5p_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.f5p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.a5p_1.equals(tmp0_other_with_cast.a5p_1))
      return false;
    if (!equals(this.b5p_1, tmp0_other_with_cast.b5p_1))
      return false;
    if (!equals(this.c5p_1, tmp0_other_with_cast.c5p_1))
      return false;
    if (!equals(this.d5p_1, tmp0_other_with_cast.d5p_1))
      return false;
    if (!equals(this.e5p_1, tmp0_other_with_cast.e5p_1))
      return false;
    if (!equals(this.f5p_1, tmp0_other_with_cast.f5p_1))
      return false;
    return true;
  }
}
class Text2TextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.q5p_1 = Companion_getInstance_47().s4t_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r5p_1 = ArrayList.i1();
    this.s5p_1 = doubleArrayListOf(new Float64Array([]));
    this.t5p_1 = doubleArrayListOf(new Float64Array([]));
    this.u5p_1 = doubleArrayListOf(new Float64Array([]));
    this.v5p_1 = doubleArrayListOf(new Float64Array([]));
    this.w5p_1 = doubleArrayListOf(new Float64Array([]));
    this.x5p_1 = new DoubleVectorArrayList(4);
    this.y5p_1 = MatrixTransform.b2j();
  }
  z5p() {
    return this.q5p_1.l4v_1;
  }
  e1() {
    return this.s5p_1.e1();
  }
  a5q() {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.x5p_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(this_0.s2f(n, 0));
        while (out.e1() <= line) {
          out.h(new LineInfo());
        }
        var lineInfo = out.d1(line);
        var top = this_0.s2f(n, 1);
        var bottom = this_0.s2f(n, 2);
        var lineHeight = this_0.s2f(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.x5o_1;
        tmp.x5o_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.y5o_1;
        tmp_0.y5o_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.z5o_1;
        tmp_1.z5o_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  }
  b5q(n) {
    return n >= this.e1() ? Companion_getInstance_4().d2e_1 : Companion_getInstance_4().r2l(this.s5p_1.d1(n), this.t5p_1.d1(n), this.s5p_1.d1(n) + this.r5p_1.d1(n).j3o_1 * this.u5p_1.d1(n), this.t5p_1.d1(n) + this.r5p_1.d1(n).k3o_1 * this.v5p_1.d1(n));
  }
  k3i() {
    if (this.e1() === 0) {
      return Companion_getInstance_4().d2e_1;
    }
    var bb = Companion_getInstance_7().h2e();
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.b5q(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  c5q(n, out) {
    out.a5p_1 = this.r5p_1.d1(n);
    out.b5p_1 = this.s5p_1.d1(n);
    out.c5p_1 = this.t5p_1.d1(n);
    out.d5p_1 = this.u5p_1.d1(n);
    out.e5p_1 = this.v5p_1.d1(n);
    var tmp = out;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_8();
    var ratio = this.w5p_1.d1(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp.f5p_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    return out;
  }
  d5q() {
    this.d4y(Companion_getInstance_6().j2d_1);
    this.r5p_1.m3();
    this.s5p_1.m3();
    this.t5p_1.m3();
    this.u5p_1.m3();
    this.v5p_1.m3();
    this.w5p_1.m3();
    this.x5p_1.m3();
    this.b4y(0);
  }
  k4x(reader, codePoint) {
    var tmp = this.a4y();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_elvis_lhs = reader == null ? null : reader.ry_1;
      var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      try {
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$1 = this.e4y(reader, codePoint);
        break $l$block;
      }finally {
        if (reader == null)
          null;
        else {
          reader.ry_1 = old;
        }
      }
    }
    var m = tmp$ret$1;
    var g = bf.d1(codePoint);
    var x = g.w4l_1;
    var tmp_0 = g.x4l_1;
    var tmp295_subject = this.z5p();
    var y = tmp_0 - (equals(tmp295_subject, Companion_getInstance_45().g5o_1) ? bf.j3p() : bf.t4m() * _VerticalAlign___get_ratio__impl__b3ilr8(this.z5p()));
    var fontScale = this.q4x_1 / bf.p4n();
    this.y5p_1 = get_immutable(this.y4x()).f2i();
    this.r5p_1.h(g.v4l_1);
    this.s5p_1.j12(this.pz().h2d_1 + this.y4x().k2h(x, y) * fontScale);
    this.t5p_1.j12(this.pz().i2d_1 + this.y4x().n2h(x, y) * fontScale);
    this.u5p_1.j12(this.y5p_1.t2i_1 * fontScale);
    this.v5p_1.j12(this.y5p_1.u2i_1 * fontScale);
    this.w5p_1.j12(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.y5p_1.x2i_1)));
    this.x5p_1.g2t(this.v4x(), this.n4x_1.l4m_1, this.n4x_1.p4m_1, this.n4x_1.t4m());
    return m;
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.e5q_1 = $getVersion;
    this.f5q_1 = $handler;
  }
  s5o() {
    return this.e5q_1();
  }
  g5q(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.j2y();
    _this__u8e3s4.c4y(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.yy()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.bz());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.zy(1));
      var startPos = reader.ry_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.h4y(_this__u8e3s4.t4m(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.ry_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.e4y(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.ry_1 = old;
            }
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.f4y(Companion_getInstance_5().s2g_1);
        this.f5q_1(_this__u8e3s4, reader, c, g, g.j4m_1 + _this__u8e3s4.c4o(c, c1));
      }
      if (reader.ry_1 <= startPos) {
        reader.dz(1);
      }
    }
    _this__u8e3s4.h4y(_this__u8e3s4.t4m(), true);
  }
  t5o(_this__u8e3s4, text, size, defaultFont) {
    return this.g5q(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.h5q_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  s5o() {
    return this.h5q_1.s5o();
  }
  i5q(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.h5q_1.t5o(_this__u8e3s4, Companion_getInstance_11().iz(text), size, defaultFont);
  }
  t5o(_this__u8e3s4, text, size, defaultFont) {
    return this.i5q(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class SegmentHandler {
  constructor() {
    this.j5q_1 = intArrayListOf(new Int32Array([]));
    this.k5q_1 = intArrayListOf(new Int32Array([]));
    this.j2y();
  }
  e1() {
    return this.j5q_1.e1();
  }
  j2y() {
    this.j5q_1.m3();
    this.k5q_1.m3();
  }
  p3s(x0, x1) {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.j5q_1.m10(n);
        var xmax = this.k5q_1.m10(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.j5q_1.r2s(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.k5q_1.r2s(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.j5q_1.m2s(x0);
    this.k5q_1.m2s(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.w5q_1 = $outer;
    this.l5q_1 = get_DEFAULT(Companion_getInstance_48());
    this.m5q_1 = NoneFiller_getInstance();
    this.n5q_1 = -1;
    this.o5q_1 = -1;
    this.p5q_1 = new Float32Array(this.e1());
    this.q5q_1 = new Int32Array(this.e1());
    this.r5q_1 = Companion_instance_14.q4l(this.e1());
    this.s5q_1 = Companion_instance_14.q4l(this.e1());
    this.t5q_1 = new SegmentHandler();
    this.u5q_1 = 0;
    this.v5q_1 = 1.0;
  }
  e1() {
    return this.w5q_1.z5q_1.r43_1;
  }
  j5r() {
    return this.w5q_1.z5q_1.r43_1 - 1 | 0;
  }
  j2y() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.t5q_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.j5q_1.m10(n);
        var xmax = this_0.k5q_1.m10(n);
        fill_0(this.p5q_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.q5q_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.u5q_1 = 0;
    this.t5q_1.j2y();
  }
  k5r(x0, x1, y0) {
    if (this.j5r() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.j5r(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.j5r(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.j5r());
    var i1 = coerceIn(b, 0, this.j5r());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.o5q_1 === y)) {
      if (y >= 0) {
        this.bd();
      }
      this.o5q_1 = y;
      this.j2y();
    }
    if (!(this.n5q_1 === y0)) {
      this.n5q_1 = y0;
      this.u5q_1 = this.u5q_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.t5q_1.p3s(i0, i1);
      this.l5r(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.l5r(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.l5r(i1, i1m / 20);
      }
    }
  }
  l5r(x, ratio) {
    var mask = 1 << this.u5q_1;
    if ((this.q5q_1[x] & mask) === 0) {
      this.q5q_1[x] = this.q5q_1[x] | mask;
      var _array__4zh2yp = this.p5q_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  bd() {
    var containsUpper = this.w5q_1.z5q_1.s43_1;
    var containsArg = this.o5q_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.v5q_1);
    var scale_0 = 1.0 / this.u5q_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.t5q_1;
    var inductionVariable = 0;
    var last = this_0.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.j5q_1.m10(n);
        var xmax = this_0.k5q_1.m10(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.m5q_1.o5m(this.s5q_1, 0, xmin, xmax, this.o5q_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.p5q_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.s5q_1, xmin, this.p5q_1, xmin, count);
        var index = this.w5q_1.z5q_1.m44(0, this.o5q_1) + x | 0;
        if (this.w5q_1.z5q_1.x43_1) {
          arraycopy(this.w5q_1.z5q_1.h43_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.r5q_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.w5q_1.z5q_1.h43_1), index, this.r5q_1, x, count);
        }
        this.l5q_1.m5r(this.r5q_1, x, this.s5q_1, x, count);
        if (this.w5q_1.z5q_1.x43_1) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.r5q_1), x, this.w5q_1.z5q_1.h43_1, index, count);
        } else {
          depremultiply(this.r5q_1, x, _RgbaArray___init__impl__oib4y4(this.w5q_1.z5q_1.h43_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.y5r_1 = false;
    this.z5r_1 = 0;
  }
  bd() {
    return Unit_instance;
  }
  b5s() {
    var _unary__edvuaz = this.z5r_1;
    this.z5r_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  c5s() {
    this.z5r_1 = this.z5r_1 - 1 | 0;
    if (this.z5r_1 === 0) {
      this.bd();
    }
  }
  d5s(state, fill, winding) {
    var rstate = state;
    if (fill && !this.f5s(state.p4o_1)) {
      rstate = state.o10();
      rstate.p4o_1 = toBitmapPaint(rstate.p4o_1, state);
    }
    this.x5r(rstate, fill, winding);
  }
  e5s(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.d5s(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.d5s.call(this, state, fill, winding);
    }
    return tmp;
  }
  x5r(state, fill, winding) {
    return Unit_instance;
  }
  f5s(_this__u8e3s4) {
    return true;
  }
  g5s(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.i2h().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.h3v(pos, size);
    } else {
      this_0.u3v(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.e5s(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().s2g_1, size.m2n(toFloat(image.e1()))).w2h(pos))), true);
  }
  d1b() {
    this.bd();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.z5q_1 = bmp;
    this.a5r_1 = antialiasing;
    this.b5r_1 = this.z5q_1.j43_1.d2n();
    this.c5r_1 = new Rasterizer();
    this.d5r_1 = new ColorFiller();
    this.e5r_1 = new GradientFiller();
    this.f5r_1 = new BitmapFiller();
    this.g5r_1 = new ScanlineWriter(this);
    this.h5r_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.i5r_1 = new StrokeToFill();
  }
  x2p() {
    return this.z5q_1.r43_1;
  }
  y2p() {
    return this.z5q_1.s43_1;
  }
  x5r(state, fill, winding) {
    var style = fill ? state.p4o_1 : state.o4o_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.d5r_1.m5m(style.u4k_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.e5r_1.u5m(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.f5r_1.i5n(style, state);
          } else {
            throw NotImplementedError.ee();
          }
        }
      }
    }
    var filler = tmp;
    this.g5r_1.l5q_1 = state.w4o_1;
    this.c5r_1.j2y();
    this.c5r_1.n5r_1 = this.y5r_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.h4o_1;
    } else {
      this.h5r_1.m3();
      var tmp306_$receiver = state.h4o_1;
      var tmp307_lineWidth = state.a5s();
      var tmp308_joins = state.m4o_1;
      var tmp309_startCap = state.k4o_1;
      var tmp310_endCap = state.l4o_1;
      var tmp311_miterLimit = state.n4o_1;
      var tmp312_temp = this.i5r_1;
      var tmp313_outFill = this.h5r_1;
      var tmp314_lineDash = state.x4o_1;
      var tmp315_lineDashOffset = state.y4o_1;
      tmp_0 = strokeToFill(tmp306_$receiver, tmp307_lineWidth, tmp308_joins, tmp309_startCap, tmp310_endCap, tmp311_miterLimit, tmp314_lineDash, tmp315_lineDashOffset, tmp312_temp, tmp313_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.g4o_1 == null)) {
      this.c5r_1.r5r_1.u3r_1 = ensureNotNull(state.g4o_1).c3m_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.g4o_1);
      var i = Vector2D.b2g();
      var l = Vector2D.b2g();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.c5r_1.r5r_1.t6();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.a3m_1;
      var n_0 = 0;
      while (n_0 < this_1.e1()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.m10(_unary__edvuaz)) {
          case 0:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.b3m_1.d1(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.q2f(tmp_1, this_0.b3m_1.d1(_unary__edvuaz_1));
            i = it;
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x = it.ul();
            var y = it.vl();
            this.c5r_1.r5r_1.x3s(x, y, true);
            l = it;
            break;
          case 1:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.b3m_1.d1(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.q2f(tmp_2, this_0.b3m_1.d1(_unary__edvuaz_3));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x_0 = it_0.ul();
            var y_0 = it_0.vl();
            this.c5r_1.r5r_1.x3s(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 2:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.b3m_1.d1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var c = Vector2D.q2f(tmp_3, this_0.b3m_1.d1(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.b3m_1.d1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.q2f(tmp_4, this_0.b3m_1.d1(_unary__edvuaz_7));
            var sum = Companion_getInstance_6().m2o(l, c) + Companion_getInstance_6().m2o(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.b2g()};
            var prevPos = {_v: Vector2D.b2g()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio = Companion_getInstance_9().g10_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos._v = Companion_getInstance_1().t3j(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_1().t3j(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_1 = it_1.ul();
                var y_1 = it_1.vl();
                this.c5r_1.r5r_1.x3s(x_1, y_1, false);
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 3:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.b3m_1.d1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var c0 = Vector2D.q2f(tmp_5, this_0.b3m_1.d1(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.b3m_1.d1(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var c1 = Vector2D.q2f(tmp_6, this_0.b3m_1.d1(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.b3m_1.d1(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.q2f(tmp_7, this_0.b3m_1.d1(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_6().m2o(l, c0) + Companion_getInstance_6().m2o(c0, c1) + Companion_getInstance_6().m2o(c1, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.b2g()};
            var prevPos_0 = {_v: Vector2D.b2g()};
            var emittedCount_0 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio_1 = Companion_getInstance_9().g10_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos_0._v = Companion_getInstance_1().s3j(l, c0, c1, a_1, ratio_1);
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_2 = Companion_getInstance_1().s3j(l, c0, c1, a_1, ratio_2);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_2 = it_2.ul();
                var y_2 = it_2.vl();
                this.c5r_1.r5r_1.x3s(x_2, y_2, false);
                emittedCount_0._v = emittedCount_0._v + 1 | 0;
                lastPos_0._v = prevPos_0._v;
                prevPos_0._v = it_2;
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 4:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var destruct = i;
            var x_3 = destruct.ul();
            var y_3 = destruct.vl();
            this.c5r_1.r5r_1.x3s(x_3, y_3, false);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            if (true) {
              this.c5r_1.r5r_1.t6();
            }

            break;
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.c5r_1.r5r_1.t6();
      }
    }
    var tmp_8 = this.c5r_1.q5r_1;
    tmp_8.u3r_1 = winding == null ? ensureNotNull(state.h4o_1).c3m_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.b2g();
    var l_0 = Vector2D.b2g();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.c5r_1.q5r_1.t6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.a3m_1;
    var n_4 = 0;
    while (n_4 < this_2.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.m10(_unary__edvuaz_14)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.b3m_1.d1(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_3 = Vector2D.q2f(tmp_9, fillPath.b3m_1.d1(_unary__edvuaz_16));
          i_0 = it_3;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_4 = it_3.ul();
          var y_4 = it_3.vl();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.c5r_1.q5r_1.x3s(x_4, y_4, true);
          l_0 = it_3;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.b3m_1.d1(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_4 = Vector2D.q2f(tmp_10, fillPath.b3m_1.d1(_unary__edvuaz_18));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_5 = it_4.ul();
          var y_5 = it_4.vl();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.c5r_1.q5r_1.x3s(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.b3m_1.d1(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var c_0 = Vector2D.q2f(tmp_11, fillPath.b3m_1.d1(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.b3m_1.d1(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.q2f(tmp_12, fillPath.b3m_1.d1(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_6().m2o(l_0, c_0) + Companion_getInstance_6().m2o(c_0, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.b2g()};
          var prevPos_1 = {_v: Vector2D.b2g()};
          var emittedCount_1 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_3 = Companion_getInstance_9().g10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_1().t3j(l_0, c_0, a_3, ratio_3);
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_4 = _Ratio___init__impl__9mwvn2_0(n_5 * dt_1);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_5 = Companion_getInstance_1().t3j(l_0, c_0, a_3, ratio_4);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_6 = it_5.ul();
              var y_6 = it_5.vl();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.c5r_1.q5r_1.x3s(x_6, y_6, false);
              emittedCount_1._v = emittedCount_1._v + 1 | 0;
              lastPos_1._v = prevPos_1._v;
              prevPos_1._v = it_5;
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.b3m_1.d1(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var c0_0 = Vector2D.q2f(tmp_13, fillPath.b3m_1.d1(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.b3m_1.d1(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var c1_0 = Vector2D.q2f(tmp_14, fillPath.b3m_1.d1(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.b3m_1.d1(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.q2f(tmp_15, fillPath.b3m_1.d1(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_6().m2o(l_0, c0_0) + Companion_getInstance_6().m2o(c0_0, c1_0) + Companion_getInstance_6().m2o(c1_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.b2g()};
          var prevPos_2 = {_v: Vector2D.b2g()};
          var emittedCount_2 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_5 = Companion_getInstance_9().g10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_2._v = Companion_getInstance_1().s3j(l_0, c0_0, c1_0, a_5, ratio_5);
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_6 = _Ratio___init__impl__9mwvn2_0(n_6 * dt_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_6 = Companion_getInstance_1().s3j(l_0, c0_0, c1_0, a_5, ratio_6);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_7 = it_6.ul();
              var y_7 = it_6.vl();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.c5r_1.q5r_1.x3s(x_7, y_7, false);
              emittedCount_2._v = emittedCount_2._v + 1 | 0;
              lastPos_2._v = prevPos_2._v;
              prevPos_2._v = it_6;
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var destruct_0 = i_0;
          var x_8 = destruct_0.ul();
          var y_8 = destruct_0.vl();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.c5r_1.q5r_1.x3s(x_8, y_8, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          if (true) {
            this.c5r_1.q5r_1.t6();
          }

          break;
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.c5r_1.q5r_1.t6();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.h5s_1 = $func;
  }
  m5r(dst, dstN, src, srcN, count) {
    return this.h5s_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_38 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_48();
    tmp.i5s_1 = tmp_0.j5s(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  j5s(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_33 {
  v3v() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.m5s_1 = op;
  }
  m5r(dst, dstN, src, srcN, count) {
    this.m5s_1.m5r(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_5().s2g_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_45().g5o_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_46().l5o_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.f4o_1 = transform;
    this.g4o_1 = clip;
    this.h4o_1 = path;
    this.i4o_1 = lineScaleMode;
    this.j4o_1 = lineWidth;
    this.k4o_1 = startLineCap;
    this.l4o_1 = endLineCap;
    this.m4o_1 = lineJoin;
    this.n4o_1 = miterLimit;
    this.o4o_1 = strokeStyle;
    this.p4o_1 = fillStyle;
    this.q4o_1 = fontRegistry;
    this.r4o_1 = font;
    this.s4o_1 = fontSize;
    this.t4o_1 = verticalAlign;
    this.u4o_1 = horizontalAlign;
    this.v4o_1 = globalAlpha;
    this.w4o_1 = globalCompositeOperation;
    this.x4o_1 = lineDash;
    this.y4o_1 = lineDashOffset;
    var tmp = this;
    tmp.z4o_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  n5s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z4o_1;
    transformTransform$factory();
    return this_0.u1();
  }
  a5s() {
    var tmp = this.j4o_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.n5s().d2j();
    return tmp * Math.abs(this_0);
  }
  h4w(value) {
    this.k4o_1 = value;
    this.l4o_1 = value;
  }
  a4w() {
    return this.k4o_1;
  }
  o10() {
    var tmp = this.f4o_1;
    var tmp319_safe_receiver = this.g4o_1;
    var tmp_0 = tmp319_safe_receiver == null ? null : tmp319_safe_receiver.o10();
    var tmp_1 = this.h4o_1.o10();
    var tmp320_safe_receiver = this.x4o_1;
    return this.o5s(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp320_safe_receiver == null ? null : tmp320_safe_receiver.o10());
  }
  p5s(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  o5s(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.f4o_1 : transform;
    clip = clip === VOID ? this.g4o_1 : clip;
    path = path === VOID ? this.h4o_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.i4o_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.j4o_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.k4o_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.l4o_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.m4o_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.n4o_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.o4o_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.p4o_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.q4o_1 : fontRegistry;
    font = font === VOID ? this.r4o_1 : font;
    fontSize = fontSize === VOID ? this.s4o_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.t4o_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.u4o_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.v4o_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.w4o_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.x4o_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.y4o_1 : lineDashOffset;
    return $super === VOID ? this.p5s(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.p5s.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.f4o_1.toString() + ', clip=' + toString(this.g4o_1) + ', path=' + this.h4o_1.toString() + ', lineScaleMode=' + this.i4o_1.toString() + ', lineWidth=' + this.j4o_1 + ', startLineCap=' + this.k4o_1.toString() + ', endLineCap=' + this.l4o_1.toString() + ', lineJoin=' + this.m4o_1.toString() + ', miterLimit=' + this.n4o_1 + ', strokeStyle=' + toString_0(this.o4o_1) + ', fillStyle=' + toString_0(this.p4o_1) + ', fontRegistry=' + toString(this.q4o_1) + ', font=' + toString(this.r4o_1) + ', fontSize=' + this.s4o_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.t4o_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.u4o_1) + ', globalAlpha=' + this.v4o_1 + ', globalCompositeOperation=' + toString_0(this.w4o_1) + ', lineDash=' + toString(this.x4o_1) + ', lineDashOffset=' + this.y4o_1 + ')';
  }
  hashCode() {
    var result = this.f4o_1.hashCode();
    result = imul(result, 31) + (this.g4o_1 == null ? 0 : this.g4o_1.hashCode()) | 0;
    result = imul(result, 31) + this.h4o_1.hashCode() | 0;
    result = imul(result, 31) + this.i4o_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.j4o_1) | 0;
    result = imul(result, 31) + this.k4o_1.hashCode() | 0;
    result = imul(result, 31) + this.l4o_1.hashCode() | 0;
    result = imul(result, 31) + this.m4o_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.n4o_1) | 0;
    result = imul(result, 31) + hashCode(this.o4o_1) | 0;
    result = imul(result, 31) + hashCode(this.p4o_1) | 0;
    result = imul(result, 31) + (this.q4o_1 == null ? 0 : hashCode(this.q4o_1)) | 0;
    result = imul(result, 31) + (this.r4o_1 == null ? 0 : hashCode(this.r4o_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s4o_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.t4o_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.u4o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v4o_1) | 0;
    result = imul(result, 31) + hashCode(this.w4o_1) | 0;
    result = imul(result, 31) + (this.x4o_1 == null ? 0 : hashCode(this.x4o_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y4o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.f4o_1.equals(tmp0_other_with_cast.f4o_1))
      return false;
    if (!equals(this.g4o_1, tmp0_other_with_cast.g4o_1))
      return false;
    if (!this.h4o_1.equals(tmp0_other_with_cast.h4o_1))
      return false;
    if (!this.i4o_1.equals(tmp0_other_with_cast.i4o_1))
      return false;
    if (!equals(this.j4o_1, tmp0_other_with_cast.j4o_1))
      return false;
    if (!this.k4o_1.equals(tmp0_other_with_cast.k4o_1))
      return false;
    if (!this.l4o_1.equals(tmp0_other_with_cast.l4o_1))
      return false;
    if (!this.m4o_1.equals(tmp0_other_with_cast.m4o_1))
      return false;
    if (!equals(this.n4o_1, tmp0_other_with_cast.n4o_1))
      return false;
    if (!equals(this.o4o_1, tmp0_other_with_cast.o4o_1))
      return false;
    if (!equals(this.p4o_1, tmp0_other_with_cast.p4o_1))
      return false;
    if (!equals(this.q4o_1, tmp0_other_with_cast.q4o_1))
      return false;
    if (!equals(this.r4o_1, tmp0_other_with_cast.r4o_1))
      return false;
    if (!equals(this.s4o_1, tmp0_other_with_cast.s4o_1))
      return false;
    if (!equals(this.t4o_1, tmp0_other_with_cast.t4o_1))
      return false;
    if (!equals(this.u4o_1, tmp0_other_with_cast.u4o_1))
      return false;
    if (!equals(this.v4o_1, tmp0_other_with_cast.v4o_1))
      return false;
    if (!equals(this.w4o_1, tmp0_other_with_cast.w4o_1))
      return false;
    if (!equals(this.x4o_1, tmp0_other_with_cast.x4o_1))
      return false;
    if (!equals(this.y4o_1, tmp0_other_with_cast.y4o_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.p4b_1 = renderer;
    this.q4b_1 = defaultFontRegistry;
    this.r4b_1 = defaultFont;
    this.s4b_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.q4b_1, this.r4b_1);
    this.t4b_1 = _TGenStack___init__impl__yynjgt();
    this.u4b_1 = Vector2D.b2g();
    this.v4b_1 = Vector2D.b2g();
  }
  q5s() {
    return this.p4b_1.x2p();
  }
  r5s() {
    return this.p4b_1.y2p();
  }
  s5s(state, fill, winding) {
    return this.p4b_1.d5s(state, fill, winding);
  }
  t5s(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.s5s(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.s5s.call(this, state, fill, winding);
    }
    return tmp;
  }
  u5s(image, pos, size, transform) {
    return this.p4b_1.g5s(image, pos, size, transform);
  }
  v5s() {
    return this.p4b_1.d1b();
  }
  w5s() {
    return this.p4b_1.b5s();
  }
  x5s() {
    return this.p4b_1.c5s();
  }
  x2p() {
    return this.q5s();
  }
  y2p() {
    return this.r5s();
  }
  d1b() {
    this.v5s();
  }
  y5s() {
    return this.w5s();
  }
  z5s() {
    return this.x5s();
  }
  a5t(value) {
    this.s4b_1.i4o_1 = value;
  }
  g4w(value) {
    this.s4b_1.j4o_1 = value;
  }
  z4v() {
    return this.s4b_1.j4o_1;
  }
  h4w(value) {
    this.s4b_1.h4w(value);
  }
  a4w() {
    return this.s4b_1.a4w();
  }
  j4w(value) {
    this.s4b_1.n4o_1 = value;
  }
  c4w() {
    return this.s4b_1.n4o_1;
  }
  b5t(value) {
    this.s4b_1.k4o_1 = value;
  }
  c5t(value) {
    this.s4b_1.l4o_1 = value;
  }
  i4w(value) {
    this.s4b_1.m4o_1 = value;
  }
  b4w() {
    return this.s4b_1.m4o_1;
  }
  d5t(value) {
    this.s4b_1.o4o_1 = value;
  }
  e5t() {
    return this.s4b_1.o4o_1;
  }
  c4p(value) {
    this.s4b_1.p4o_1 = value;
  }
  b4p() {
    return this.s4b_1.p4o_1;
  }
  a4y() {
    return this.s4b_1.r4o_1;
  }
  p4n() {
    return this.s4b_1.s4o_1;
  }
  z5p() {
    return this.s4b_1.t4o_1;
  }
  f5t() {
    return this.s4b_1.u4o_1;
  }
  g5t() {
    return Companion_getInstance_47().r5o(this.f5t(), this.z5p());
  }
  k4w(value) {
    this.s4b_1.x4o_1 = value;
  }
  d4w() {
    return this.s4b_1.x4o_1;
  }
  l4w(value) {
    this.s4b_1.y4o_1 = value;
  }
  e4w() {
    return this.s4b_1.y4o_1;
  }
  f4w() {
    TGenStack__push_impl_9yh33t(this.t4b_1, this.s4b_1.o10());
  }
  n4w() {
    this.s4b_1 = TGenStack__pop_impl_qisxa0(this.t4b_1);
  }
  t5e(sx, sy) {
    this.s4b_1.f4o_1 = this.s4b_1.f4o_1.u2h(sx, sy);
  }
  a4p(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.t5e(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.t5e.call(this, sx, sy);
    }
    return tmp;
  }
  x4x(tx, ty) {
    this.s4b_1.f4o_1 = this.s4b_1.f4o_1.c2i(tx, ty);
  }
  z4x(m) {
    this.s4b_1.f4o_1 = this.s4b_1.f4o_1.d2i(m);
  }
  h5t(_set____db54di) {
    this.u4b_1 = _set____db54di;
  }
  i5t() {
    return this.u4b_1;
  }
  j5t(_set____db54di) {
    this.v4b_1 = _set____db54di;
  }
  u3l() {
    return this.v4b_1;
  }
  d3v() {
    return this.s4b_1.h4o_1.d3v();
  }
  t6() {
    this.s4b_1.h4o_1.t6();
    this.j5t(this.i5t());
  }
  t3l(p) {
    this.s4b_1.h4o_1.t3l(trans(this, p));
    this.j5t(p);
    this.h5t(p);
  }
  v3l(p) {
    this.s4b_1.h4o_1.v3l(trans(this, p));
    this.j5t(p);
  }
  w3l(c, a) {
    this.s4b_1.h4o_1.w3l(trans(this, c), trans(this, a));
    this.j5t(a);
  }
  y3l(c1, c2, a) {
    this.s4b_1.h4o_1.y3l(trans(this, c1), trans(this, c2), trans(this, a));
    this.j5t(a);
  }
  s5e(path) {
    if (this.g1())
      this.s4b_1.h4o_1.c3m_1 = path.c3m_1;
    write_0(this, path);
  }
  r4y(d) {
    d.q4y(this);
  }
  d4p(x, y, width, height) {
    this.m4u();
    this.i3v(x, y, width, height);
    this.v4v();
  }
  m4u() {
    this.s4b_1.h4o_1 = new VectorPath();
  }
  u4v() {
    if (!equals(this.s4b_1.o4o_1, NonePaint_instance)) {
      this.t5s(this.s4b_1, false);
    }
  }
  k5t(winding) {
    if (!equals(this.s4b_1.p4o_1, NonePaint_instance)) {
      this.s5s(this.s4b_1, true, winding);
    }
  }
  v4v(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.k5t(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.k5t.call(this, winding);
    }
    return tmp;
  }
  l5t(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.b4p();
    this.c4p(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.k5t(winding);
    }finally {
      this.c4p(oldStyle);
    }
  }
  y4v(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.l5t(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.l5t.call(this, paint, winding);
    }
    return tmp;
  }
  m4w(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.e5t();
    this.d5t(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.u4v();
    }finally {
      this.d5t(oldStyle);
    }
  }
  m5t(path, winding) {
    if (!(path == null)) {
      if (this.s4b_1.g4o_1 == null) {
        this.s4b_1.g4o_1 = new VectorPath();
      }
      ensureNotNull(this.s4b_1.g4o_1).m3();
      ensureNotNull(this.s4b_1.g4o_1).c3m_1 = winding;
      ensureNotNull(this.s4b_1.g4o_1).a3w(path);
      if (path === this.s4b_1.h4o_1) {
        path.m3();
      }
    } else {
      this.s4b_1.g4o_1 = null;
    }
  }
  n5t(path, winding, $super) {
    path = path === VOID ? this.s4b_1.h4o_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.m5t(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.m5t.call(this, path, winding);
    }
    return tmp;
  }
  o5t(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.b4p() : this.e5t() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  p5t(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_6().j2d_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.a4y() : font;
    size = size === VOID ? this.p4n() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.g5t() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    return $super === VOID ? this.o5t(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.o5t.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  e4p(image, pos, size) {
    return this.u5s(image, pos, size, this.s4b_1.f4o_1);
  }
  x5k(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.e1()) : size;
    var tmp;
    if ($super === VOID) {
      this.e4p(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.e4p.call(this, image, pos, size);
    }
    return tmp;
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_40 = this;
    this.q5t_1 = values_6();
  }
}
class CycleMethod extends Enum {
  z5n() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  w5n(ratio) {
    var tmp;
    switch (this.t3_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  r5t(ratio) {
    return this.w5n(ratio);
  }
}
class ColorizedBeziers {
  constructor(beziers) {
    this.s5t_1 = beziers;
    var tmp = this;
    tmp.t5t_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.u5t_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.v5t_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.w5t_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.x5t_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.y5t_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.z5t_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  k5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5t_1;
    red$factory();
    return this_0.u1();
  }
  l5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5t_1;
    green$factory();
    return this_0.u1();
  }
  m5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5t_1;
    blue$factory();
    return this_0.u1();
  }
  a5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w5t_1;
    allProjected$factory();
    return this_0.u1();
  }
  f5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5t_1;
    redProjected$factory();
    return this_0.u1();
  }
  g5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y5t_1;
    greenProjected$factory();
    return this_0.u1();
  }
  h5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5t_1;
    blueProjected$factory();
    return this_0.u1();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.i5u_1 = bezier;
    this.j5u_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.i5u_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.j5u_1) + ')';
  }
  hashCode() {
    var result = this.i5u_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.j5u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.i5u_1.equals(tmp0_other_with_cast.i5u_1))
      return false;
    if (!(this.j5u_1 === tmp0_other_with_cast.j5u_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.b5u_1 = beziers;
    this.c5u_1 = new ProjectedPoint();
    this.d5u_1 = Companion_getInstance_2().v2g();
  }
  e5u(point) {
    return Companion_getInstance_6().m2o(point, this.z3k(point));
  }
  z3k(point) {
    if (this.b5u_1.g1())
      return Vector2D.d2g(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.b5u_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.d1(_unary__edvuaz).k3k().b2f(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.b2g();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.b5u_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_1.d1(_unary__edvuaz_0);
        if (it.k3k().a2f(point) > minDistSq) {
          break $l$block;
        }
        it.x3k(point, this.c5u_1);
        if (this.c5u_1.n3j_1 < bminDistSq) {
          bminDistSq = this.c5u_1.n3j_1;
          out = this.c5u_1.l3j_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.n5u(path) : getPath(path);
}
function get_bounds() {
  return this.o5u(true);
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp345_safe_receiver = this.c29();
  var tmp;
  if (tmp345_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_1(Companion_getInstance_7().h2e(), tmp345_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_4().g2e() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
  var tmp347_safe_receiver = this.c29();
  if (tmp347_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    path.a3w(tmp347_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.s4b_1.f4o_1;
  try {
    // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
    c.m4u();
    var tmp348_safe_receiver = this.c29();
    if (tmp348_safe_receiver == null)
      null;
    else {
      draw_0(tmp348_safe_receiver, c);
    }
    if (!(this.w5u() == null)) {
      draw_0(ensureNotNull(this.w5u()), c);
      c.n5t();
    }
    c.z4x(get_immutable(this.y4x()));
    this.a5v(c);
  }finally {
    c.s4b_1.f4o_1 = t;
  }
}
function drawInternal(c) {
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_5().s2g_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.p5u_1 = path;
    this.q5u_1 = clip;
    this.r5u_1 = paint;
    this.s5u_1 = transform;
    this.t5u_1 = globalAlpha;
    var tmp = this;
    tmp.u5u_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.v5u_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  c29() {
    return this.p5u_1;
  }
  w5u() {
    return this.q5u_1;
  }
  y4x() {
    return this.s5u_1;
  }
  x5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5u_1;
    pathCurvesList$factory();
    return this_0.u1();
  }
  y5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5u_1;
    clipCurvesList$factory();
    return this_0.u1();
  }
  z5u() {
    return this.x5u().e1() === 1 && get_isConvex(first(this.x5u())) && this.y5u() == null;
  }
  a5v(c) {
    c.l5t(this.r5u_1, this.p5u_1.c3m_1);
  }
  toString() {
    return 'FillShape(path=' + this.p5u_1.toString() + ', clip=' + toString(this.q5u_1) + ', paint=' + toString_0(this.r5u_1) + ', transform=' + this.s5u_1.toString() + ', globalAlpha=' + this.t5u_1 + ')';
  }
  hashCode() {
    var result = this.p5u_1.hashCode();
    result = imul(result, 31) + (this.q5u_1 == null ? 0 : this.q5u_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.r5u_1) | 0;
    result = imul(result, 31) + this.s5u_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.t5u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.p5u_1.equals(tmp0_other_with_cast.p5u_1))
      return false;
    if (!equals(this.q5u_1, tmp0_other_with_cast.q5u_1))
      return false;
    if (!equals(this.r5u_1, tmp0_other_with_cast.r5u_1))
      return false;
    if (!this.s5u_1.equals(tmp0_other_with_cast.s5u_1))
      return false;
    if (!equals(this.t5u_1, tmp0_other_with_cast.t5u_1))
      return false;
    return true;
  }
}
class CompoundShape {
  constructor(components) {
    this.b5v_1 = components;
  }
  o5u(includeStrokes) {
    var bb = Companion_getInstance_7().h2e();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.b5v_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it.o5u(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  q4y(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.y5s();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.b5v_1;
        var n = 0;
        while (n < this_0.e1()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.d1(_unary__edvuaz).q4y(c);
        }
        break $l$block;
      }finally {
        c.z5s();
      }
    }
    return Unit_instance;
  }
  n5u(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.b5v_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).n5u(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.b5v_1, ',\n  ') + '\n)';
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.d5v_1 = path;
    this.e5v_1 = clip;
    this.f5v_1 = paint;
    this.g5v_1 = transform;
    this.h5v_1 = strokeInfo;
    this.i5v_1 = globalAlpha;
    this.j5v_1 = thickness$factory(this.h5v_1);
    this.k5v_1 = scaleMode$factory(this.h5v_1);
    this.l5v_1 = startCap$factory(this.h5v_1);
    this.m5v_1 = endCap$factory(this.h5v_1);
    this.n5v_1 = join$factory(this.h5v_1);
    this.o5v_1 = miterLimit$factory(this.h5v_1);
    this.p5v_1 = dash$factory(this.h5v_1);
    this.q5v_1 = dashOffset$factory(this.h5v_1);
    var tmp = this;
    tmp.r5v_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  c29() {
    return this.d5v_1;
  }
  w5u() {
    return this.e5v_1;
  }
  y4x() {
    return this.g5v_1;
  }
  o5u(includeStrokes) {
    var tmp352_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_1(Companion_getInstance_7().h2e(), this.d5v_1));
    var bounds = tmp352_safe_receiver == null ? null : get_mutable(tmp352_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.h5v_1.c3g_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.x3x(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.c3x();
    return tmp0_elvis_lhs == null ? Companion_getInstance_4().d2e_1 : tmp0_elvis_lhs;
  }
  s5v(c) {
    c.a5t(this.h5v_1.e3g_1);
    c.g4w(this.h5v_1.c3g_1);
    c.b5t(this.h5v_1.f3g_1);
    c.c5t(this.h5v_1.g3g_1);
    c.i4w(this.h5v_1.h3g_1);
    c.j4w(this.h5v_1.i3g_1);
    c.k4w(this.h5v_1.j3g_1);
    c.l4w(this.h5v_1.k3g_1);
  }
  a5v(c) {
    this.s5v(c);
    c.m4w(this.f5v_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.d5v_1.toString() + ', clip=' + toString(this.e5v_1) + ', paint=' + toString_0(this.f5v_1) + ', transform=' + this.g5v_1.toString() + ', strokeInfo=' + this.h5v_1.toString() + ', globalAlpha=' + this.i5v_1 + ')';
  }
  hashCode() {
    var result = this.d5v_1.hashCode();
    result = imul(result, 31) + (this.e5v_1 == null ? 0 : this.e5v_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.f5v_1) | 0;
    result = imul(result, 31) + this.g5v_1.hashCode() | 0;
    result = imul(result, 31) + this.h5v_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.i5v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.d5v_1.equals(tmp0_other_with_cast.d5v_1))
      return false;
    if (!equals(this.e5v_1, tmp0_other_with_cast.e5v_1))
      return false;
    if (!equals(this.f5v_1, tmp0_other_with_cast.f5v_1))
      return false;
    if (!this.g5v_1.equals(tmp0_other_with_cast.g5v_1))
      return false;
    if (!this.h5v_1.equals(tmp0_other_with_cast.h5v_1))
      return false;
    if (!equals(this.i5v_1, tmp0_other_with_cast.i5v_1))
      return false;
    return true;
  }
}
class TextShape {
  u5v() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5v_1;
    primitiveShapes$factory();
    return this_0.u1();
  }
}
class EmptyShape {
  o5u(includeStrokes) {
    return Companion_getInstance_4().g2e();
  }
  q4y(c) {
    return Unit_instance;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_51());
    var tmp = this;
    tmp.c4t_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.d4t_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.e4t_1 = ArrayList.i1();
  }
  q5s() {
    return this.c4t_1;
  }
  r5s() {
    return this.d4t_1;
  }
  s5s(state, fill, winding) {
    if (state.h4o_1.g1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.h4o_1.o10();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.c3m_1 = winding == null ? this_0.c3m_1 : winding;
    var path = this_0;
    var tmp367_safe_receiver = state.g4o_1;
    var tmp368_safe_receiver = tmp367_safe_receiver == null ? null : tmp367_safe_receiver.o10();
    var tmp_0;
    if (tmp368_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp368_safe_receiver;
      tmp_1.c3m_1 = winding == null ? tmp368_safe_receiver.c3m_1 : winding;
      tmp_0 = tmp368_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.f4o_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.e4t_1;
      var element = new FillShape(path, clip, state.p4o_1.o10(), transform, state.v4o_1);
      this_1.h(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.e4t_1;
      var tmp_2 = state.o4o_1.o10();
      var tmp369_thickness = state.j4o_1;
      var tmp370_scaleMode = state.i4o_1;
      var tmp371_startCap = state.k4o_1;
      var tmp372_endCap = state.l4o_1;
      var tmp373_join = state.m4o_1;
      var tmp374_dash = state.x4o_1;
      var tmp375_dashOffset = state.y4o_1;
      var tmp376_miterLimit = state.n4o_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp369_thickness, true, tmp370_scaleMode, tmp371_startCap, tmp372_endCap, tmp373_join, tmp376_miterLimit, tmp374_dash, tmp375_dashOffset), state.v4o_1);
      this_2.h(element_0);
    }
  }
  u5s(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.h3v(pos, size);
    this.t5s(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_5().s2g_1, size.m2n(toFloat(image.e1()))).w2h(pos))), true);
  }
  v5s() {
  }
  w5s() {
    return 0;
  }
  x5s() {
  }
  f4t() {
    return this.e4t_1.e1() === 1 ? first(this.e4t_1) : new CompoundShape(toList(this.e4t_1));
  }
  q4y(c) {
    c.r4y(this.f4t());
  }
}
class SvgPath {
  c5v(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.i1();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.a3m_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.m10(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.b3m_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.q2f(tmp, path.b3m_1.d1(_unary__edvuaz_1));
          var x = destruct.ul();
          var y = destruct.vl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.h(element);
          break;
        case 1:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.b3m_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.q2f(tmp_0, path.b3m_1.d1(_unary__edvuaz_3));
          var x_0 = destruct_0.ul();
          var y_0 = destruct_0.vl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.h(element_0);
          break;
        case 2:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.b3m_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.q2f(tmp_1, path.b3m_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.b3m_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.q2f(tmp_2, path.b3m_1.d1(_unary__edvuaz_7));
          var x1 = destruct_1.ul();
          var y1 = destruct_1.vl();
          var x2 = destruct_2.ul();
          var y2 = destruct_2.vl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.h(element_1);
          break;
        case 3:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.b3m_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.q2f(tmp_3, path.b3m_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.b3m_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.q2f(tmp_4, path.b3m_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.b3m_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.q2f(tmp_5, path.b3m_1.d1(_unary__edvuaz_13));
          var x1_0 = destruct_3.ul();
          var y1_0 = destruct_3.vl();
          var x2_0 = destruct_4.ul();
          var y2_0 = destruct_4.vl();
          var x3 = destruct_5.ul();
          var y3 = destruct_5.vl();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.h(element_2);
          break;
        case 4:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          // Inline function 'kotlin.collections.plusAssign' call

          parts.h('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.n5r_1 = false;
    this.o5r_1 = 2;
    this.p5r_1 = 1;
    this.q5r_1 = new PolygonScanline();
    this.r5r_1 = new PolygonScanline();
    this.s5r_1 = new IntSegmentSet();
    this.t5r_1 = new IntSegmentSet();
    this.u5r_1 = new IntSegmentSet();
    this.v5r_1 = IntArrayList.g2s(1024);
  }
  j2y() {
    this.q5r_1.j2y();
    this.r5r_1.j2y();
  }
  v5v(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.j2y();
    }
    var xmin = this.l3s(bounds.y2d());
    var xmax = this.l3s(bounds.z2d());
    var tempRect = this.q5r_1.k3i();
    // Inline function 'kotlin.math.max' call
    var a = bounds.a2e();
    var b = tempRect.a2e();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.l3s(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.b2e();
    var b_0 = tempRect.b2e();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.l3s(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.v5r_1.m3();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.d3t() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.d3t()) / this.p5r_1 | 0) / q | 0) | 0;
        this.v5r_1.m2s(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.v5r_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.m10(_unary__edvuaz);
      this.q5r_1.y3s(y_0, winding, this.s5r_1);
      edgesChecked = edgesChecked + this.q5r_1.j3s_1 | 0;
      if (this.r5r_1.r2f()) {
        this.r5r_1.y3s(y_0, this.r5r_1.u3r_1, this.t5r_1);
        edgesChecked = edgesChecked + this.r5r_1.j3s_1 | 0;
        this.u5r_1.a3g(this.s5r_1, this.t5r_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.r5r_1.r2f() ? this.u5r_1 : this.s5r_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.s3f_1.m10(n_1), this_1.t3f_1.m10(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.z5v(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  w5r(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.o5r_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.v5v(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.v5v.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_51();
    super();
    this.c5w_1 = width;
    this.d5w_1 = height;
  }
  x2p() {
    return this.c5w_1;
  }
  y2p() {
    return this.d5w_1;
  }
}
class Companion_35 extends DummyRenderer {
  constructor() {
    Companion_instance_41 = null;
    super(128, 128);
    Companion_instance_41 = this;
  }
}
class HtmlCanvas {
  z41(width, height) {
    if (Companion_getInstance_10().cx()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.l5(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  z5w(width, height) {
    return HtmlCanvas_instance.z41(width, height);
  }
  a5x(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  b5x(bmp, canvas) {
    return this.a5x(_RgbaArray___init__impl__oib4y4(bmp.u4e().h43_1), bmp.r43_1, bmp.s43_1, canvas);
  }
  e5w(bmp) {
    return this.b5x(bmp, this.z5w(bmp.r43_1, bmp.s43_1));
  }
}
class NonBrowserNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NonBrowserNativeImageFormatProvider_instance = null;
    super();
    NonBrowserNativeImageFormatProvider_instance = this;
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  u5j(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_2.bind(VOID, this, data, props), $completion);
  }
  n5k(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_3.bind(VOID, this, vfs, path, props), $completion);
  }
  x4h(width, height, premultiplied) {
    return HtmlNativeImage.y5w(HtmlCanvas_instance.z41(width, height));
  }
  w4h(bmp) {
    return HtmlNativeImage.y5w(HtmlImage_instance.e5w(bmp.d44()));
  }
}
class HtmlNativeImage extends NativeImage {
  static h5x(texSourceBase, width, height) {
    var $this = this.v4h(width, height, texSourceBase, true);
    $this.t5w_1 = texSourceBase;
    $this.u5w_1 = $this.t5w_1;
    var tmp = $this;
    tmp.v5w_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.w5w_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.x5w_1 = Monotonic_instance.rj();
    return $this;
  }
  u3() {
    return 'HtmlNativeImage';
  }
  static e5x(img) {
    return this.h5x(img, img.width, img.height);
  }
  static y5w(canvas) {
    return this.h5x(canvas, canvas.width, canvas.height);
  }
  g5x() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5w_1;
    lazyCanvasElement$factory();
    return this_0.u1();
  }
  i5x() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w5w_1;
    ctx$factory();
    return this_0.u1();
  }
  o44(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.t5w_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.rj();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.x5w_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.x5w_1 = now;
        this.i5x().clearRect(0.0, 0.0, width, height);
        this.i5x().drawImage(this.t5w_1, 0.0, 0.0);
      }
    }
    var idata = this.i5x().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.y43_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  q44(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.i5x().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.y43_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.i5x().putImageData(idata, x, y);
  }
  n4b(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.g5x()));
  }
  j5x(type, quality) {
    return this.g5x().toDataURL(type, quality);
  }
  k5x(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.j5x(type, quality) : $super.j5x.call(this, type, quality);
  }
}
class BrowserImage {
  c5x(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd.bind(VOID, this, bytes, props), $completion);
  }
  m5x(img) {
    return this.f5x(img, img.width, img.height);
  }
  f5x(img, width, height) {
    var canvas = HtmlCanvas_instance.z41(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  d5x(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.j1c();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_10().cx()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.l5(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.v19();
  }
  l5x(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
    return $super === VOID ? this.d5x(jsUrl, props, $completion) : $super.d5x.call(this, jsUrl, props, $completion);
  }
  v41(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi.bind(VOID, this, jsUrl), $completion);
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.p5x_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q5x_1 = this.p5x_1.getContext('2d');
    this.r5x_1 = NaN;
    this.s5x_1 = null;
  }
  x2p() {
    return this.p5x_1.width;
  }
  y2p() {
    return this.p5x_1.height;
  }
  w5x(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.z59_1.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.z59_1.m10(n);
        var color = paint.a5a_1.m10(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  u5x(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.u4k_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.s59_1.t3_1) {
            case 0:
              tmp_0 = this.w5x(this.q5x_1.createLinearGradient(_this__u8e3s4.t59_1, _this__u8e3s4.u59_1, _this__u8e3s4.w59_1, _this__u8e3s4.x59_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.w5x(this.q5x_1.createRadialGradient(_this__u8e3s4.t59_1, _this__u8e3s4.u59_1, _this__u8e3s4.v59_1, _this__u8e3s4.w59_1, _this__u8e3s4.x59_1, _this__u8e3s4.y59_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.q5x_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.q5x_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.f5a_1), _this__u8e3s4.t59_1, _this__u8e3s4.u59_1);
                tmp_1 = this.w5x(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.j5n_1).u5w_1;
            tmp = this.q5x_1.createPattern(tmp$ret$3, _this__u8e3s4.y5n() && _this__u8e3s4.a5o() ? 'repeat' : _this__u8e3s4.y5n() ? 'repeat-x' : _this__u8e3s4.a5o() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  x5x(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.t3_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  y5x(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.t3_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.s3_1.toLowerCase();
        break;
    }
    return tmp;
  }
  t5x(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.x5x(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.y5x(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  v5x(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.x2g_1, m.y2g_1, m.z2g_1, m.a2h_1, m.b2h_1, m.c2h_1);
  }
  g5s(image, pos, size, transform) {
    this.q5x_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.q5x_1.setTransform(transform.x2g_1, transform.y2g_1, transform.z2g_1, transform.a2h_1, transform.b2h_1, transform.c2h_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).u5w_1;
      this.q5x_1.drawImage(tmp$ret$2, pos.h2d_1, pos.i2d_1, size.m2e_1, size.n2e_1);
    }finally {
      this.q5x_1.restore();
    }
  }
  z5x(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.a3m_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.m10(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.b3m_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.q2f(tmp, path.b3m_1.d1(_unary__edvuaz_1));
          var x = destruct.ul();
          var y = destruct.vl();
          this.q5x_1.moveTo(x, y);
          break;
        case 1:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.b3m_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.q2f(tmp_0, path.b3m_1.d1(_unary__edvuaz_3));
          var x_0 = destruct_0.ul();
          var y_0 = destruct_0.vl();
          this.q5x_1.lineTo(x_0, y_0);
          break;
        case 2:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.b3m_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.q2f(tmp_1, path.b3m_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.b3m_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.q2f(tmp_2, path.b3m_1.d1(_unary__edvuaz_7));
          var cx = destruct_1.ul();
          var cy = destruct_1.vl();
          var ax = destruct_2.ul();
          var ay = destruct_2.vl();
          this.q5x_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.b3m_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.q2f(tmp_3, path.b3m_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.b3m_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.q2f(tmp_4, path.b3m_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.b3m_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.q2f(tmp_5, path.b3m_1.d1(_unary__edvuaz_13));
          var cx1 = destruct_3.ul();
          var cy1 = destruct_3.vl();
          var cx2 = destruct_4.ul();
          var cy2 = destruct_4.vl();
          var ax_0 = destruct_5.ul();
          var ay_0 = destruct_5.vl();
          this.q5x_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          this.q5x_1.closePath();
          break;
      }
    }
  }
  x5r(state, fill, winding) {
    if (state.h4o_1.g1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.q5x_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.g4o_1;
        if (!(clip == null)) {
          this.q5x_1.beginPath();
          this.z5x(clip);
          this.q5x_1.clip(this.a5y(winding == null ? clip.c3m_1 : winding));
        }
        this.q5x_1.beginPath();
        this.z5x(state.h4o_1);
        this.v5x(this.q5x_1, state.f4o_1);
        if (fill) {
          transformPaint(this, state.p4o_1);
          this.q5x_1.fill(this.a5y(winding == null ? state.h4o_1.c3m_1 : winding));
        } else {
          transformPaint(this, state.o4o_1);
          var lineDash = state.x4o_1;
          if (!(lineDash == null)) {
            this.q5x_1.lineDashOffset = state.y4o_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.a2t();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var _iterator__ex2g4s = lineDash.a1();
            while (_iterator__ex2g4s.b1()) {
              var v = _iterator__ex2g4s.c1();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.j12(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.q5x_1.setLineDash(tmp$ret$3);
          }
          this.q5x_1.stroke();
        }
        break $l$block;
      }finally {
        this.q5x_1.restore();
      }
    }
  }
  a5y(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.t3_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.j26() <= 0.25;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.r42_1);
  $this.j42_1 = Companion_instance_0.n3m(width, height);
  $this.p42_1 = Bitmap32.k43(width, height, VOID, $this.l42_1);
  $this.q42_1.m3();
  $this.q42_1.h($this.p42_1);
  $this.s42_1.m3();
  $this.r42_1.m3();
  var _iterator__ex2g4s = slices.a1();
  while (_iterator__ex2g4s.b1()) {
    var entry = _iterator__ex2g4s.c1();
    $this.l43(entry.h42_1, entry.i42_1, entry.h42_1.e3o_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.n42_1.t3_1) {
    case 0:
      reconstructWithSize($this, imul($this.x2p(), 2), imul($this.y2p(), 2));
      break;
    case 1:
      if (bmp.j3o_1 > $this.x2p() || bmp.k3o_1 > $this.y2p()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.x2p() + 'x' + $this.y2p() + ') to hold a slice of (' + bmp.j3o_1 + 'x' + bmp.k3o_1 + ')';
        throw IllegalStateException.l5(toString_0(message));
      }

      $this.j42_1 = Companion_instance_0.n3m($this.x2p(), $this.y2p());
      $this.p42_1 = Bitmap32.k43($this.x2p(), $this.y2p(), VOID, $this.l42_1);
      $this.q42_1.h($this.p42_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.r43_1, 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.o44(x, y, width, height, out, 0);
  return out;
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
  _this__u8e3s4.c44_1 = enable;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.v43_1;
  if (false) {
    this_0.e44();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.n4b(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.d1b();
    }
  }finally {
    result = false ? this_0.g44(rect) : 0;
  }
  return this_0;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.x43_1 = true;
  _this__u8e3s4.y43_1 = true;
  return _this__u8e3s4;
}
function Bitmap32Context2d_0(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = Bitmap32.k43(width, height, VOID, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.v43_1;
  if (false) {
    this_0.e44();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.n4b(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.Bitmap32Context2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.d1b();
    }
  }finally {
    result = false ? this_0.g44(rect) : 0;
  }
  return this_0;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.j44();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.w4b_1.b2n();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.cm(new RGBA($this.w4b_1.x4b(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_5;
function Companion_getInstance_15() {
  if (Companion_instance_5 === VOID)
    new Companion();
  return Companion_instance_5;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.f4d($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).h43_1);
  var width = _this__u8e3s4.z2d() - _this__u8e3s4.y2d() | 0;
  var inductionVariable = _this__u8e3s4.a2e();
  var last = _this__u8e3s4.b2e();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.m44(_this__u8e3s4.y2d(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.y2d() + ', top=' + _this__u8e3s4.a2e() + ', right=' + _this__u8e3s4.z2d() + ', bottom=' + _this__u8e3s4.b2e();
        throw IllegalStateException.l5(toString_0(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.a2e(), area.y2d(), area.b2e(), area.z2d(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.h43_1;
  var x0Index = _this__u8e3s4.m44(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.m44(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.r43_1 | 0;
      x1Index = x1Index + _this__u8e3s4.r43_1 | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.m44(x, areaTop), data, _this__u8e3s4.m44(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.m44(x, areaBottom - 1 | 0), data, _this__u8e3s4.m44(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_6;
function Companion_getInstance_16() {
  return Companion_instance_6;
}
function tryToExactBitmap8(_this__u8e3s4) {
  if (_this__u8e3s4 instanceof BitmapIndexed) {
    var tmp = 0;
    var tmp_0 = imul(_this__u8e3s4.r43_1, _this__u8e3s4.s43_1);
    var tmp_1 = new Int8Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = toByte(_this__u8e3s4.d4f(tmp_2));
      tmp = tmp + 1 | 0;
    }
    return Bitmap8.s4e(_this__u8e3s4.r43_1, _this__u8e3s4.s43_1, tmp_1, _RgbaArray___init__impl__oib4y4(copyOf(_RgbaArray___get_ints__impl__u2kps1(_this__u8e3s4.x4c_1), 256)));
  }
  var bmp = _this__u8e3s4.o4b().u4e();
  var bmpInts = bmp.h43_1;
  var palette = new Palette(Companion_instance_11.a4f(256));
  var colors = IntIntMap.h2x();
  var ncolor = 0;
  var inductionVariable = 0;
  var last = bmpInts.length;
  while (inductionVariable < last) {
    var color = bmpInts[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (!colors.rp(color)) {
      var tmp_3 = ncolor;
      var tmp_4;
      if (bmp.x43_1) {
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(color);
        tmp_4 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      } else {
        tmp_4 = _RGBA___init__impl__lqpay5(color);
      }
      RgbaArray__set_impl_epw2wg(palette.j4f_1, tmp_3, tmp_4);
      var _unary__edvuaz = ncolor;
      ncolor = _unary__edvuaz + 1 | 0;
      colors.g2x(color, _unary__edvuaz);
    }
    if (colors.e2x_1 >= 256)
      return null;
  }
  var tmp_5 = 0;
  var tmp_6 = imul(bmp.r43_1, bmp.s43_1);
  var tmp_7 = new Int8Array(tmp_6);
  while (tmp_5 < tmp_6) {
    var tmp_8 = tmp_5;
    tmp_7[tmp_8] = toByte(colors.d1(bmpInts[tmp_8]));
    tmp_5 = tmp_5 + 1 | 0;
  }
  return Bitmap8.s4e(bmp.r43_1, bmp.s43_1, tmp_7, palette.j4f_1);
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_7;
function Companion_getInstance_17() {
  BitmapChannel_initEntries();
  if (Companion_instance_7 === VOID)
    new Companion_1();
  return Companion_instance_7;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_17();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.b3o_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.j3p();
}
function slice(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.n2m(0, 0, _this__u8e3s4.r43_1, _this__u8e3s4.s43_1) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().q3n_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().i2g_1 : padding;
  var left = clamp(bounds.y2d(), 0, _this__u8e3s4.r43_1);
  var top = clamp(bounds.a2e(), 0, _this__u8e3s4.s43_1);
  return new RectSlice(_this__u8e3s4, Companion_instance_1.s2l(left, top, clamp(bounds.z2d(), left, _this__u8e3s4.r43_1), clamp(bounds.b2e(), top, _this__u8e3s4.s43_1)), orientation, padding, name);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.c3o_1) ? _this__u8e3s4.b3o_1.l2m_1 : _this__u8e3s4.b3o_1.m2m_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.c3o_1) ? _this__u8e3s4.b3o_1.m2m_1 : _this__u8e3s4.b3o_1.l2m_1;
  var tmp = get_container(_this__u8e3s4).m4b(w + _this__u8e3s4.d3o_1.q2g() | 0, h + _this__u8e3s4.d3o_1.r2g() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).l4b(_this__u8e3s4.c3o_1);
  raw.z4a(0, 0, out, _this__u8e3s4.d3o_1.m2g_1, _this__u8e3s4.d3o_1.j2g_1, raw.r43_1, raw.s43_1);
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_0().q3n_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_3().i2g_1 : padding;
  return slice(_this__u8e3s4, RectangleInt.n2m(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).m4b(_this__u8e3s4.b3o_1.l2m_1, _this__u8e3s4.b3o_1.m2m_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).w4a(_this__u8e3s4.b3o_1.j2m_1, _this__u8e3s4.b3o_1.k2m_1, out, 0, 0, _this__u8e3s4.b3o_1.l2m_1, _this__u8e3s4.b3o_1.m2m_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice(Companion_getInstance_15().z4b(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().d45_1)), VOID, 'transparent');
    Bitmaps_white = slice(Companion_getInstance_15().z4b(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().y44_1)), VOID, 'white');
  }
}
var Companion_instance_8;
function Companion_getInstance_18() {
  return Companion_instance_8;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.c4b(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.p44(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.a4g(x + dx | 0, y + dy | 0) + d < this$0.a4g(x, y)) {
    this$0.w4f(x, y, x + dx | 0, y + dy | 0);
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this$0.x4f(x, y) | 0;
    var y_0 = y - this$0.y4f(x, y) | 0;
    var tmp$ret$0 = hypot(x_0, y_0);
    this$0.z4f(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.r43_1, _this__u8e3s4.s43_1) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
  out.c4g(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.m44(x, y), 4);
}
function NativeImageOrBitmap32(width, height, native, premultiplied) {
  native = native === VOID ? true : native;
  premultiplied = premultiplied === VOID ? null : premultiplied;
  var tmp;
  if (native) {
    tmp = NativeImage_0(width, height, premultiplied);
  } else {
    tmp = Bitmap32.k43(width, height, VOID, premultiplied == null ? true : premultiplied);
  }
  return tmp;
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().w4h(_this__u8e3s4);
  }
  return tmp;
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().x4h(width, height, premultiplied);
}
var Companion_instance_9;
function Companion_getInstance_19() {
  if (Companion_instance_9 === VOID)
    Companion_3.m4i();
  return Companion_instance_9;
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_15().a4c(_this__u8e3s4.r43_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.s43_1 + imul(safeBorder, 2) | 0, _this__u8e3s4.x43_1);
  out.s4d(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.i4j();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.b4j_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.b4j_1);
  }
  if (!(effect.e4j_1 === 0) || !(effect.c4j_1 === 0) || !(effect.d4j_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.c4j_1, effect.d4j_1, effect.e4j_1, effect.f4j_1);
  }
  if (!(effect.g4j_1 === 0)) {
    borderInline(_this__u8e3s4, effect.g4j_1, effect.h4j_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.r43_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.s43_1 / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.s4e(_this__u8e3s4.r43_1, _this__u8e3s4.s43_1);
  var t2 = Bitmap8.s4e(_this__u8e3s4.r43_1, _this__u8e3s4.s43_1);
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_17().d1(n);
      _this__u8e3s4.w4d(channel, t1);
      arraycopy_0(t1.d4d(), 0, t2.d4d(), 0, t2.b2n());
      gaussBlur(t1.d4d(), t2.d4d(), _this__u8e3s4.r43_1, _this__u8e3s4.s43_1, r_0);
      _this__u8e3s4.v4d(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
  a = 0 < m ? wl : wu;
  b = 1 < m ? wl : wu;
  c = 2 < m ? wl : wu;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.s4e(_this__u8e3s4.r43_1 + imul(r, 2) | 0, _this__u8e3s4.s43_1 + imul(r, 2) | 0);
  Companion_instance_6.z4e(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.r43_1, _this__u8e3s4.s43_1);
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.r43_1 / 2 | 0) - 1 | 0), (_this__u8e3s4.s43_1 / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.s4e(_this__u8e3s4.r43_1, _this__u8e3s4.s43_1);
  arraycopy_0(_this__u8e3s4.d4d(), 0, t2.d4d(), 0, _this__u8e3s4.b2n());
  gaussBlur(t2.d4d(), _this__u8e3s4.d4d(), _this__u8e3s4.r43_1, _this__u8e3s4.s43_1, r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().z44_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.s43_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.r43_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.a4g(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.h4d(x, y, Companion_getInstance_22().j4j(rcolor, out.i4d(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().z44_1 : color;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
  var copy = _this__u8e3s4.o10();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.x4d(BitmapChannel_ALPHA_getInstance()), r);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
  this_0.x43_1 = true;
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.x4c_1, n, Companion_getInstance_22().k4j(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.d44();
  _this__u8e3s4.q4d(Colors_getInstance().d45_1);
  _this__u8e3s4.t4d(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.t4d(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.u4j()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.l('Unsupported bpp ' + _this__u8e3s4.u4j());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_22().k4j(_this__u8e3s4.v4j(c), _this__u8e3s4.w4j(c), _this__u8e3s4.x4j(c), _this__u8e3s4.y4j(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.u4j() / 8;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var Companion_instance_10;
function Companion_getInstance_20() {
  if (Companion_instance_10 === VOID)
    new Companion_4();
  return Companion_instance_10;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_11;
function Companion_getInstance_21() {
  return Companion_instance_11;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.g1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
      var it = element.u4k_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.a4l_1, elements);
}
function RgbaArray__indexOf_impl_d6b5pl($this, element) {
  return indexOf(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__indexOf_impl_d6b5pl_0($this, element) {
  if (!(element instanceof RGBA))
    return -1;
  return RgbaArray__indexOf_impl_d6b5pl($this.a4l_1, element instanceof RGBA ? element.u4k_1 : THROW_CCE());
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.a4l_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.a4l_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function blendComponent($this, c1, c2, factor) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor);
  return roundToInt(this_0) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withAd_impl_cralao($this, v) {
  return RGBA__withA_impl_vogscm($this, d2i(v));
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, roundToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.jc(9);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.fc(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.jc(7);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
  this_0.fc(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.u4k_1, other instanceof RGBA ? other.u4k_1 : THROW_CCE());
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
var Companion_instance_12;
function Companion_getInstance_22() {
  if (Companion_instance_12 === VOID)
    new Companion_6();
  return Companion_instance_12;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.u4k_1 : THROW_CCE())))
    return false;
  return true;
}
function asNonPremultiplied(_this__u8e3s4) {
  return _RGBA___init__impl__lqpay5(_RGBAPremultiplied___get_value__impl__bqfhud(_this__u8e3s4));
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
  return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
}
function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
  return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
}
function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
  return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().d45_1;
  } else {
    var ialpha = 255.0 / alpha;
    var tmp_0 = Companion_getInstance_22();
    // Inline function 'kotlin.math.roundToInt' call
    var this_0 = _RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha;
    var tmp_1 = roundToInt(this_0);
    // Inline function 'kotlin.math.roundToInt' call
    var this_1 = _RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha;
    var tmp_2 = roundToInt(this_1);
    // Inline function 'kotlin.math.roundToInt' call
    var this_2 = _RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha;
    var tmp$ret$2 = roundToInt(this_2);
    tmp = tmp_0.k4j(tmp_1, tmp_2, tmp$ret$2, alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = clamp01_0(alpha) * 256;
  var tmp$ret$0 = roundToInt(this_0);
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, tmp$ret$0);
}
var Companion_instance_13;
function Companion_getInstance_23() {
  return Companion_instance_13;
}
function asPremultiplied(_this__u8e3s4) {
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v(_this__u8e3s4));
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  // Inline function 'kotlin.math.roundToInt' call
  var this_0 = _RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf;
  var outA = roundToInt(this_0);
  // Inline function 'kotlin.math.roundToInt' call
  var this_1 = _RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf;
  var outR = roundToInt(this_1);
  // Inline function 'kotlin.math.roundToInt' call
  var this_2 = _RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf;
  var outG = roundToInt(this_2);
  // Inline function 'kotlin.math.roundToInt' call
  var this_3 = _RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf;
  var outB = roundToInt(this_3);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_14;
function Companion_getInstance_24() {
  return Companion_instance_14;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.r4l_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_13.p4l(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
var Companion_instance_15;
function Companion_getInstance_25() {
  return Companion_instance_15;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract_0(this$0.v4l_1).d44();
  };
}
var Companion_instance_16;
function Companion_getInstance_26() {
  return Companion_instance_16;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.k4p_1;
    var baseline = 0.0;
    var tmp = -this$0.p4p_1;
    var tmp_0 = -this$0.p4p_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.l4p_1.n3().a1();
    while (_iterator__ex2g4s.b1()) {
      var glyph = _iterator__ex2g4s.c1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.v4l_1.j3o_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.i4p_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.l4p_1.d1(this$0.l4p_1.i3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.u4p() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.i4p_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function *_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var tmp = fntFile.r2b(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var content = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.y8();
  var tmp_0;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    var tmp_1 = readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    var tmp_2 = readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } else if (startsWith(content, 'info')) {
    var tmp_3 = readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.ee('An operation is not implemented: ' + reason);
  }
  return tmp_0;
}
function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFont__n2ejpo.bind(VOID, _this__u8e3s4, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull(xml.oi('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.l14('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull(xml.oi('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.l14('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull(xml.oi('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.l14('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull(xml.oi('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.m14('fieldType');
  var _iterator__ex2g4s = get(xml.oi('pages'), 'page').a1();
  while (_iterator__ex2g4s.b1()) {
    var page = _iterator__ex2g4s.c1();
    var id = page.i14('id');
    var file = page.k14('file');
    var texFile = fntFile.l2b().oi(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.j3(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get(xml.oi('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var page_0 = item.i14('page');
    var tmp0_elvis_lhs_0 = textures.h3(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first_0(textures.n3()) : tmp0_elvis_lhs_0;
    var tmp_0 = item.i14('id');
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.r3p(item.i14('x'), item.i14('y'), item.i14('width'), item.i14('height'));
      tmp_1 = atlas.h44(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_1;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.h42_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs_0 == null ? texture.r3p(item.i14('x'), item.i14('y'), item.i14('width'), item.i14('height')) : tmp1_elvis_lhs_0, item.i14('xoffset'), item.i14('yoffset'), item.i14('xadvance'));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get(xml.oi('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$3 = new Kerning(item_0.i14('first'), item_0.i14('second'), item_0.i14('amount'));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.a1();
  while (tmp0_iterator_1.b1()) {
    var item_1 = tmp0_iterator_1.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$6 = to(item_1.u4l_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.a1();
  while (tmp0_iterator_2.b1()) {
    var item_2 = tmp0_iterator_2.c1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_15.s4l(item_2.l4n_1, item_2.m4n_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontXml__tgdamn.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_12().y11(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.e1()) {
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var id = n;
    var page = this_0.d1(n).f35_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.l2b().oi(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.j3(id, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it = item.f35_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.h3(page_0);
    var texture = tmp0_elvis_lhs == null ? first_0(textures.n3()) : tmp0_elvis_lhs;
    var tmp_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.r3p(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_1 = atlas.h44(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_1;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.h42_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs == null ? texture.r3p(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.h(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_0 = this_2.a1();
  while (tmp0_iterator_0.b1()) {
    var item_0 = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it_0 = item_0.f35_1;
    var tmp$ret$3 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.h(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.a1();
  while (tmp0_iterator_1.b1()) {
    var item_1 = tmp0_iterator_1.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$6 = to(item_1.u4l_1, item_1);
    destination_1.h(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.a1();
  while (tmp0_iterator_2.b1()) {
    var item_2 = tmp0_iterator_2.c1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_15.s4l(item_2.l4n_1, item_2.m4n_1), item_2);
    destination_2.h(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontJson__a3fd7w.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function *_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.i1();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.i1();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).a1();
  while (_iterator__ex2g4s.b1()) {
    var rline = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.text.trim' call
    var line = toString_0(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.rc();
    var _iterator__ex2g4s_0 = split_0(line, charArrayOf([_Char___init__impl__6a9atx(32)])).a1();
    while (_iterator__ex2g4s_0.b1()) {
      var part = _iterator__ex2g4s_0.c1();
      var _destruct__k2r9zo = plus(split_0(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.d1(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.d1(1);
      // Inline function 'kotlin.collections.set' call
      map.j3(key, value);
    }
    if (startsWith(line, 'info')) {
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp44_safe_receiver = map.h3('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.h3('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt_0(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.h3('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var message = 'page without file';
        throw IllegalStateException.l5(toString_0(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp_0 = readBitmap(fntFile.l2b().oi(file), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var value_0 = slice(mipmaps(tmp_0, mipmaps_0));
      textures.j3(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.h3('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.h3('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.h3('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.h3(page);
      var texture = tmp5_elvis_lhs == null ? first_0(textures.n3()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_1;
      if (atlas == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = texture.r3p(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_1 = atlas.h44(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_1;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.h42_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.r3p(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.h(element);
    } else if (startsWith(line, 'kerning ')) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp57_safe_receiver = map.h3('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_3 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.h3('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_4 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.h3('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      var element_0 = new Kerning(tmp_3, tmp_4, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.h(element_0);
    }
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var fontSize_0 = fontSize;
  var lineHeight_0 = lineHeight;
  var tmp10_elvis_lhs = base;
  var base_0 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.sc(capacity);
  var tmp0_iterator = glyphs.a1();
  while (tmp0_iterator.b1()) {
    var element_1 = tmp0_iterator.c1();
    // Inline function 'korlibs.image.font.readBitmapFontTxt.<anonymous>' call
    var tmp$ret$6 = element_1.u4l_1;
    destination.j3(tmp$ret$6, element_1);
  }
  var glyphs_0 = toIntMap(destination);
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize_0), numberToDouble(lineHeight_0), numberToDouble(base_0), glyphs_0, kernings_0, name, null);
}
function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontTxt__tgfm88.bind(VOID, content, fntFile, textures, props, mipmaps, atlas), $completion);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_15.s4l(it.l4n_1, it.m4n_1);
}
function bmp$factory() {
  return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
    return receiver.o4n();
  }, null);
}
function naturalFontMetrics$factory() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.v4n();
  }, null);
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.u4n();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.u4p();
  }, null);
}
var Companion_instance_17;
function Companion_getInstance_27() {
  if (Companion_instance_17 === VOID)
    new Companion_11();
  return Companion_instance_17;
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.rj();
    // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
    var result = TtfFont.u4s(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.ks_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_13());
}
function get_DefaultTtfFontAsBitmap() {
  return get_lazyBitmapSDF(get_DefaultTtfFont());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.c4m(size);
  var gmetrics = _this__u8e3s4.e4m(size, codePoint, VOID, reader);
  var gx = -gmetrics.y2d();
  var gy = gmetrics.y2p() + gmetrics.a2e();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.x2p()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.y2p()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.k43(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.v43_1;
  if (true) {
    image.e44();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = image.n4b(true);
    try {
      // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.d1b();
    }
  }finally {
    result = true ? image.g44(rect) : 0;
  }
  var imageOut = applyEffect(image.o4b(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.q2f(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_5().s2g_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf_0(glyph);
  var tmp_1 = listOf_0(listOf_0(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$3 = this_0.f4t();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
    this_0.d3m_1 = false;
    this_0.i3v(this$0.c4n_1.y2d(), -this$0.d4n_1.m4m_1, this$0.c4n_1.j4m_1, this$0.d4n_1.t4m());
    return applyTransform(this_0, Companion_getInstance_5().v2g().w2h(this$0.b4n_1).d2i(this$0.e4n_1));
  };
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return function () {
    var curves = getCurves(this$0.g4t());
    var tmp;
    if (!(curves.n3h_1.e1() === 4)) {
      println('curves=' + curves.n3h_1.e1());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.h4t().n3h_1.d1(3).j3l();
    var tmp$ret$0 = Line2D.z2f(this_0.y2f_1, this_0.x2f_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return function () {
    return this$0.h4t().n3h_1.d1(1);
  };
}
function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
  pos = pos === VOID ? Companion_getInstance_6().j2d_1 : pos;
  fill = fill === VOID ? true : fill;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_47().w4t_1 : align;
  outMetrics = outMetrics === VOID ? null : outMetrics;
  fillStyle = fillStyle === VOID ? null : fillStyle;
  stroke = stroke === VOID ? null : stroke;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  placed = placed === VOID ? null : placed;
  var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
  var fnt = _this__u8e3s4;
  var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
  var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
  if (ctx == null)
    null;
  else {
    ctx.m4u();
  }
  invoke(renderer, actions, text, size, _this__u8e3s4);
  doRender();
  if (!(outMetrics == null)) {
    ensureNotNull(glyphs);
    outMetrics.k4t_1 = glyphs.n4u_1;
    outMetrics.l4t_1 = glyphs.o4u_1;
    var fmetrics = _this__u8e3s4.c4m(size);
    outMetrics.i4t_1 = fmetrics;
    var metrics = outMetrics.j4t_1;
    metrics.r4u_1.t4u(fmetrics);
    metrics.s4u_1 = glyphs.o4u_1.e1();
    var tmp_1 = metrics;
    // Inline function 'kotlin.collections.map' call
    var this_0 = glyphs.o4u_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.font.drawText.<anonymous>' call
      var bb = Companion_getInstance_7().h2e();
      var _iterator__ex2g4s = item.a1();
      while (_iterator__ex2g4s.b1()) {
        var g = _iterator__ex2g4s.c1();
        bb = plus_1(bb, g.g4t());
      }
      var tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
      destination.h(tmp$ret$0);
    }
    tmp_1.q4u_1 = destination;
    metrics.p4u_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_7().h2e(), metrics.q4u_1));
  }
  return outMetrics;
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_47().s4t_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.x4n(size, out.r4u_1);
  out.s4u_1 = actions.j4v();
  var bb = Companion_getInstance_7().h2e();
  var dy = 0.0;
  var lineBounds = FastArrayList.j11();
  var offsetY = actions.n4v(align.l4v_1, out.r4u_1);
  var _iterator__ex2g4s = actions.h4v_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var line = _iterator__ex2g4s.c1();
    var offsetX = line.r4v(align.k4v_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.s4v(), line.p4v_1, line.o4v_1);
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
    lineBounds.h(rect);
    dy = dy + line.o4v_1;
  }
  out.q4u_1 = lineBounds;
  out.p4u_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.c4p($paint);
  font.f4p(_this__u8e3s4, $size, $codePoint, Vector2D.q2f(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.v4v();
  } else {
    _this__u8e3s4.u4v();
  }
}
function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
  return function () {
    if (!($fillStyle == null) || !($stroke == null)) {
      var tmp67_safe_receiver = $ctx;
      if (tmp67_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = $fillStyle;
        var stroke = $stroke;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var stroke_0 = stroke == null ? null : stroke.w4v_1;
        var strokeInfo = stroke == null ? null : stroke.x4v_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
        if (!(fill == null)) {
          tmp67_safe_receiver.y4v(fill);
        }
        if (!(stroke_0 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke_0 == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.c3g_1;
              var lineCap = strokeInfo.f3g_1;
              var lineJoin = strokeInfo.h3g_1;
              var miterLimit = strokeInfo.i3g_1;
              var lineDash = strokeInfo.j3g_1;
              var lineDashOffset = strokeInfo.k3g_1;
              if (false) {
                tmp67_safe_receiver.m4u();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp67_safe_receiver.f4w();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp67_safe_receiver.g4w(numberToDouble(lineWidth));
                tmp67_safe_receiver.h4w(lineCap);
                tmp67_safe_receiver.i4w(lineJoin);
                tmp67_safe_receiver.j4w(numberToDouble(miterLimit));
                tmp67_safe_receiver.k4w(lineDash);
                tmp67_safe_receiver.l4w(numberToDouble(lineDashOffset));
                tmp67_safe_receiver.m4w(stroke_0);
              }finally {
                tmp67_safe_receiver.n4w();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = tmp67_safe_receiver.z4v();
            var lineCap_0 = tmp67_safe_receiver.a4w();
            var lineJoin_0 = tmp67_safe_receiver.b4w();
            var miterLimit_0 = tmp67_safe_receiver.c4w();
            var lineDash_0 = tmp67_safe_receiver.d4w();
            var lineDashOffset_0 = tmp67_safe_receiver.e4w();
            if (false) {
              tmp67_safe_receiver.m4u();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            tmp67_safe_receiver.f4w();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              tmp67_safe_receiver.g4w(numberToDouble(lineWidth_0));
              tmp67_safe_receiver.h4w(lineCap_0);
              tmp67_safe_receiver.i4w(lineJoin_0);
              tmp67_safe_receiver.j4w(numberToDouble(miterLimit_0));
              tmp67_safe_receiver.k4w(lineDash_0);
              tmp67_safe_receiver.l4w(numberToDouble(lineDashOffset_0));
              tmp67_safe_receiver.m4w(stroke_0);
            }finally {
              tmp67_safe_receiver.n4w();
            }
          }
        }
      }
    } else {
      if ($fill) {
        var tmp68_safe_receiver = $ctx;
        if (tmp68_safe_receiver == null)
          null;
        else {
          tmp68_safe_receiver.v4v();
        }
      } else {
        var tmp69_safe_receiver = $ctx;
        if (tmp69_safe_receiver == null)
          null;
        else {
          tmp69_safe_receiver.u4v();
        }
      }
    }
    var tmp70_safe_receiver = $ctx;
    if (tmp70_safe_receiver == null)
      null;
    else {
      tmp70_safe_receiver.m4u();
    }
    return Unit_instance;
  };
}
function boundsPath$factory() {
  return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
    return receiver.g4t();
  }, null);
}
function boundsPathCurves$factory() {
  return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
    return receiver.h4t();
  }, null);
}
function *_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  var tmp = _this__u8e3s4.n2b(until(0, 16), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var header = tmp;
  var tmp_0;
  switch (getS32BE(header, 0)) {
    case 1953784678:
    case 1330926671:
    case 65536:
      var tmp_1 = readTtfFont(_this__u8e3s4, VOID, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
      break;
    default:
      var tmp_2 = readBitmapFont(_this__u8e3s4, props, mipmaps, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
      break;
  }
  return tmp_0;
}
function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readFont__gkiy77.bind(VOID, _this__u8e3s4, preload, props, mipmaps), $completion);
}
var SystemFontRegistryOrNull;
var lazyBitmap$delegate;
function get_lazyBitmapSDF(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmapSDF$delegate;
    var property = lazyBitmapSDF$factory();
    var tmp0_elvis_lhs = this_0.v10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.w10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.v10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmapSDF$delegate;
var Companion_instance_18;
function Companion_getInstance_28() {
  if (Companion_instance_18 === VOID)
    new Companion_12();
  return Companion_instance_18;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.b4z_1.d1(this$0.b4z_1.i3().a1().c1());
    return tmp0_elvis_lhs == null ? this$0.u4p() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.v4y_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var descent = this$0.y4y_1.o4m_1 - this$0.y4y_1.q4m_1;
    var tmp78_size = this$0.y4y_1.k4m_1;
    var tmp79_top = this$0.y4y_1.l4m_1;
    var tmp80_ascent = this$0.y4y_1.m4m_1;
    var tmp81_baseline = this$0.y4y_1.n4m_1;
    var tmp82_maxWidth = this$0.y4y_1.r4m_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function lazyBitmapSDF$factory() {
  return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
    return get_lazyBitmapSDF(receiver);
  }, null);
}
function anyGlyph$factory_0() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.u4n();
  }, null);
}
function invalidGlyph$factory_0() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.u4p();
  }, null);
}
function naturalFontMetrics$factory_0() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.v4n();
  }, null);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_19;
function Companion_getInstance_29() {
  Op_initEntries();
  if (Companion_instance_19 === VOID)
    new Companion_13();
  return Companion_instance_19;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_29();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_20;
function Companion_getInstance_30() {
  Op_initEntries_0();
  if (Companion_instance_20 === VOID)
    new Companion_14();
  return Companion_instance_20;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_30();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
var Companion_instance_21;
function Companion_getInstance_31() {
  if (Companion_instance_21 === VOID)
    new Companion_15();
  return Companion_instance_21;
}
function _get_ss__ndcawb($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.y56_1;
  ss$factory();
  return this_0.u1();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return function () {
    return ensureNotNull(this$0.x56_1)();
  };
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return function () {
    return $$this$run.b1t($table.v56_1, $table.w56_1);
  };
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_22;
function Companion_getInstance_32() {
  return Companion_instance_22;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_23;
function Companion_getInstance_33() {
  Colrv1Paint_initEntries();
  if (Companion_instance_23 === VOID)
    new Companion_17();
  return Companion_instance_23;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_33();
}
var Companion_instance_24;
function Companion_getInstance_34() {
  return Companion_instance_24;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_25;
function Companion_getInstance_35() {
  return Companion_instance_25;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
function *_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  var tmp = _this__u8e3s4.o2b($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return TtfFont.u4s(tmp, get_baseName(_this__u8e3s4), onlyReadMetadata, enableLigatures);
}
function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readTtfFont__nm5tmd.bind(VOID, _this__u8e3s4, onlyReadMetadata, enableLigatures), $completion);
}
function ss$factory() {
  return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
    return _get_ss__ndcawb(receiver);
  }, null);
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_26;
function Companion_getInstance_36() {
  DataFormat_initEntries();
  if (Companion_instance_26 === VOID)
    new Companion_20();
  return Companion_instance_26;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_36();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString(s, 2, Charsets_instance.py(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.l5(toString_0(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.z5e_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.r31(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.x1v_1.l2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_36();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.d1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.z5e_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.q31(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.x5e_1(nComponent);
          this_1.r31(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact(s, dataFormat.x5e_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.z5e_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.q31(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.r31(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().q3n_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_0().u3n_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_0().s3n_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_0().w3n_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_0().x3n_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_0().r3n_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_0().v3n_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_0().t3n_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_0().q3n_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.mw());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.mw());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.d5f_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.d5f_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
var Companion_instance_27;
function Companion_getInstance_37() {
  return Companion_instance_27;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.f5g()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.e5g().r43_1, b.e5g().s43_1), imul(b.e5g().t43_1, b.e5g().t43_1));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.f5g()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.e5g().r43_1, a.e5g().s43_1), imul(a.e5g().t43_1, a.e5g().t43_1));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
var Companion_instance_28;
function Companion_getInstance_38() {
  return Companion_instance_28;
}
function ImageDataContainer$imageDatasByName$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this$0.u5g_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.sc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = element.n5g_1;
      destination.j3(tmp$ret$0, element);
    }
    return destination;
  };
}
function ImageDataContainer$default$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.y5g().h3(null);
    return tmp0_elvis_lhs == null ? first(this$0.u5g_1) : tmp0_elvis_lhs;
  };
}
function imageDatasByName$factory() {
  return getPropertyCallableRef('imageDatasByName', 1, KProperty1, function (receiver) {
    return receiver.y5g();
  }, null);
}
function default$factory() {
  return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
    return receiver.a5h();
  }, null);
}
var tilesetBorder$delegate;
var Companion_instance_29;
function Companion_getInstance_39() {
  if (Companion_instance_29 === VOID)
    new Companion_23();
  return Companion_instance_29;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.t5h(tmp, props.r5h(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  _init_properties_ImageFormat_kt__44biio();
  return props.q5h(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function tilesetBorder$delegate$lambda() {
  _init_properties_ImageFormat_kt__44biio();
  return 1;
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.n5h();
  }, null);
}
var properties_initialized_ImageFormat_kt_anr6ua;
function _init_properties_ImageFormat_kt__44biio() {
  if (!properties_initialized_ImageFormat_kt_anr6ua) {
    properties_initialized_ImageFormat_kt_anr6ua = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = tilesetBorder$delegate$lambda;
    tilesetBorder$delegate = new Property(null, default_0);
  }
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.i1();
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.a5j();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.z5i();
  }, function (receiver, value) {
    return receiver.y5i(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.z5i();
  }, function (receiver, value) {
    return receiver.y5i(value);
  });
}
var Companion_instance_30;
function Companion_getInstance_40() {
  return Companion_instance_30;
}
function get_area(_this__u8e3s4) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    var tmp = sum;
    // Inline function 'korlibs.image.format.<get-area>.<anonymous>' call
    sum = tmp + element.b2n() | 0;
  }
  return sum;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_31;
function Companion_getInstance_41() {
  Type_initEntries();
  if (Companion_instance_31 === VOID)
    new Companion_25();
  return Companion_instance_31;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_41();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.t10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.s10();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.t10_1;
      tmp_0 = tmp0_safe_receiver.h3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.u10_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.t10_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.t10_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.z3n_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.z3n_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.z3n_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.z3n_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.n5h(), $completion);
}
function *_generator_writeBitmap__wmo0sa(_this__u8e3s4, bitmap, format, props, $completion) {
  props = props === VOID ? new ImageEncodingProps() : props;
  var tmp = _this__u8e3s4.k2b(format.k5i(bitmap, props.r5h(_this__u8e3s4)), [], $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function writeBitmap(_this__u8e3s4, bitmap, format, props, $completion) {
  props = props === VOID ? new ImageEncodingProps() : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_writeBitmap__wmo0sa.bind(VOID, _this__u8e3s4, bitmap, format, props), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.o43(result.o4b(), Unit_instance, name).h42_1 : slice(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr.bind(VOID, _this__u8e3s4, bprops, name, atlas), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  var prop = !(file == null) ? props.r5h(file) : props;
  var rformats = !prop.j5h_1 ? listOf_0(prop.k5h_1) : prop.k5h_1 == null ? listOf_0(null) : prop.i5h_1 ? listOf([prop.k5h_1, null]) : listOf([null, prop.k5h_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.a1();
  while (_iterator__ex2g4s.b1()) {
    var format = _iterator__ex2g4s.c1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.h5i(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.i5i(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.ee();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.f5h_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.q31(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.r31(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_39().v4p_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g.bind(VOID, file, bytes, props), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.n5h(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr.bind(VOID, _this__u8e3s4, props), $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_14().iz('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, data, props, $completion) {
  if (props.f5h_1 || props.e5h_1 === false) {
    return $this.s5j(get_RegisteredImageFormats().g5i(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_4, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.t5j(toBitmap(tmp), props);
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  if (props.f5h_1 || props.e5h_1 === false) {
    return $this.s5j(get_RegisteredImageFormats().g5i(data, props), props);
  }
  var tmp = decodeBytes(Companion_instance_4, data, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var image = tmp;
  return $this.s5j($this.o5k(image, props), props);
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp = vfs.u2a(path).p2b($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.u5j(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp = $this.u5j(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.t5k_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.n5k(file.w28(), file.c29(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.t5k_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.r5k(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function toBitmap(_this__u8e3s4) {
  return toBitmap_0(_this__u8e3s4.s41());
}
function toBitmap_0(_this__u8e3s4) {
  return Bitmap32.k43(_this__u8e3s4.n41_1, _this__u8e3s4.o41_1, _this__u8e3s4.p41_1, _this__u8e3s4.q41_1);
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_32;
function Companion_getInstance_42() {
  Colorspace_initEntries();
  if (Companion_instance_32 === VOID)
    new Companion_26();
  return Companion_instance_32;
}
function values_5() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_42();
}
function compressionScore($this, data, temp) {
  var score = 0.0;
  UByteArrayInt__fill$default_impl_mdydxi(temp, 0);
  var inductionVariable = 0;
  var last = _UByteArrayInt___get_size__impl__bcjnte(data);
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.UByte.toInt' call
      // Inline function 'kotlin.toUByte' call
      var this_0 = UByteArrayInt__get_impl_px6q8a(data, n);
      var this_1 = _UByte___init__impl__g9hnc4(toByte(this_0));
      var _index_0__fvwizt = _UByte___get_data__impl__jof9qr(this_1) & 255;
      var _unary__edvuaz = UByteArrayInt__get_impl_px6q8a(temp, _index_0__fvwizt);
      UByteArrayInt__set_impl_gn4532(temp, _index_0__fvwizt, _unary__edvuaz + 1 | 0);
    }
     while (inductionVariable < last);
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < 256)
    $l$loop: do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var count = UByteArrayInt__get_impl_px6q8a(temp, n_0);
      if (count === 0)
        continue $l$loop;
      var tmp = score;
      var tmp_0 = 1.0 / count;
      // Inline function 'kotlin.math.sqrt' call
      var x = 1.0 + n_0;
      score = tmp + tmp_0 * Math.sqrt(x);
    }
     while (inductionVariable_0 < 256);
  return score;
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.l('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.sv();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.k5l_1;
  var height = header.l5l_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.r5l_1);
  var databb = uncompress(pngdata.xv(), Companion_getInstance_13());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.t5l_1.r5l_1;
  var row32 = context.w5l_1;
  var tmp_2;
  if (header.r5l_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
        var it = item;
        var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_22().k4j(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(it, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, it)));
        destination.h(tmp$ret$1);
      }
       while (!(item === last));
    tmp_2 = Bitmap8.s4e(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray(destination)));
  } else {
    tmp_2 = Bitmap32.k43(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.q5l_1 === 1 ? $this.c5m_1 : $this.d5m_1;
  var _iterator__ex2g4s = passes.a1();
  while (_iterator__ex2g4s.b1()) {
    var pass = _iterator__ex2g4s.c1();
    var progression = step(until(pass.d5l_1, height), pass.f5l_1);
    var inductionVariable_0 = progression.d2_1;
    var last_0 = progression.e2_1;
    var step_0 = progression.f2_1;
    if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
      do {
        var row = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_0 | 0;
        var col = pass.e5l_1;
        var colIncrement = pass.g5l_1;
        var pixelsInThisRow = width >>> pass.j5l_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.r5l_1), header.m5l_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.v5l_1;
        var lastRow = context.u5l_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.f5m(filter, lastRow, currentRow, header.r5l_1);
          switch (header.m5l_1) {
            case 1:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n / 8 | 0, 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.v44(x, y, color);
                }
                 while (inductionVariable_1 < width);
              break;
            case 2:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_0 / 4 | 0, 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.v44(x_0, y_0, color_0);
                }
                 while (inductionVariable_2 < width);
              break;
            case 4:
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < width)
                do {
                  var n_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract(UByteArrayInt__getOrElse_impl_f0pf72(currentRow, n_1 / 2 | 0, 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.v44(x_1, y_1, color_1);
                }
                 while (inductionVariable_3 < width);
              break;
            case 8:
              bmp8.h4f(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.m5l_1;
              throw IllegalStateException.l5(toString_0(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.m5l_1 === 8) {
            $this.e5m(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_20(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_22(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.ee('An operation is not implemented: ' + reason);
            }
            bmp32.y4e(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.m5l_1;
            throw IllegalStateException.l5(toString_0(message_0));
          }
        }
        context.g5m();
      }
       while (!(row === last_0));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function writeImageContainer$writeChunk($s, name, data) {
  var nameBytes = copyOf_0(toByteArray(name), 4);
  var crc = CRC32_getInstance().r23_1;
  crc = CRC32_getInstance().q23(crc, nameBytes);
  crc = CRC32_getInstance().q23(crc, data);
  write32BE($s, data.length);
  writeBytes($s, nameBytes);
  writeBytes($s, data);
  write32BE($s, crc);
}
function writeImageContainer$compress(level, data) {
  return compress(data, Companion_getInstance_13(), new CompressionContext(level));
}
function writeImageContainer$writeChunk_0($s, name, initialCapacity, callback) {
  // Inline function 'korlibs.io.stream.MemorySyncStreamToByteArray' call
  var buffer = ByteArrayBuilder.sv(initialCapacity);
  var s = MemorySyncStream(buffer);
  // Inline function 'korlibs.image.format.PNG.writeImageContainer.writeChunk.<anonymous>' call
  callback(s);
  var tmp$ret$0 = buffer.xv();
  return writeImageContainer$writeChunk($s, name, tmp$ret$0);
}
function writeImageContainer$writeHeader(width, height, $s, colorspace) {
  writeImageContainer$writeChunk_0($s, 'IHDR', 13, PNG$writeImageContainer$writeHeader$lambda(width, height, colorspace));
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream(_this__u8e3s4, toLong(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_42().c5l_1.h3(readU8(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.b5i_1 = this_0.k5l_1;
      $info.c5i_1 = this_0.l5l_1;
      $info.d5i_1 = imul(this_0.m5l_1, this_0.n5l_1.b5l_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().l2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.o16(asByteArray(rgbPalette), 0, data.a().l2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().l2();
      paletteCount._v = Math.max(a_0, b_0);
      data.o16(asByteArray(aPalette), 0, data.a().l2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.vv(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$writeImageContainer$lambda($ncolors, $bitmap) {
  return function ($this$writeChunk) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < $ncolors) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o($bitmap.x4c_1, n);
        write8($this$writeChunk, _RGBA___get_r__impl__duz7mo(c));
        write8($this$writeChunk, _RGBA___get_g__impl__o8pukr(c));
        write8($this$writeChunk, _RGBA___get_b__impl__m6tl80(c));
      }
       while (inductionVariable < $ncolors);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function PNG$writeImageContainer$lambda_0($ncolors, $bitmap) {
  return function ($this$writeChunk) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < $ncolors) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o($bitmap.x4c_1, n);
        write8($this$writeChunk, _RGBA___get_a__impl__6msvu7(c));
      }
       while (inductionVariable < $ncolors);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function PNG$writeImageContainer$lambda_1($this$writeChunk) {
  return Unit_instance;
}
function PNG$writeImageContainer$writeHeader$lambda($width, $height, $colorspace) {
  return function ($this$writeChunk) {
    write32BE($this$writeChunk, $width);
    write32BE($this$writeChunk, $height);
    write8($this$writeChunk, 8);
    write8($this$writeChunk, $colorspace.a5l_1);
    write8($this$writeChunk, 0);
    write8($this$writeChunk, 0);
    write8($this$writeChunk, 0);
    return Unit_instance;
  };
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.j5m();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.j5j([PNG_getInstance()]);
  }
}
var WEBP_WASM_BASE64_ZLIB;
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function d2i(v) {
  return toIntRound(clamp01(v) * 255);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_33;
function Companion_getInstance_43() {
  return Companion_instance_33;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.t5m_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.s5m_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.e5n_1 = value;
  $this.a5n_1 = $this.e5n_1.r43_1;
  $this.b5n_1 = $this.e5n_1.s43_1;
  $this.c5n_1 = 1.0 / $this.a5n_1;
  $this.d5n_1 = 1.0 / $this.b5n_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
      this_0.m5m(_this__u8e3s4.u4k_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_1.u5m(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_2.i5n(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          throw NotImplementedError.ee();
        }
      }
    }
  }
  return tmp;
}
function colorInt(_this__u8e3s4, $this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.e1();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().a47_1 : _RGBA___init__impl__lqpay5(colors.xk());
      var pcolor = colorInt(color, $this, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.xk()), $this, premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.m10(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.m10(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt(Companion_getInstance_22().l4l(color0, color1, ratio), $this, premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.t2s()), $this, premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.d1(n) * NCOLORS);
}
var Companion_instance_34;
function Companion_getInstance_44() {
  return Companion_instance_34;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.x2s()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.u4k_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function get_DefaultPaint() {
  return Colors_getInstance().z44_1;
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_45().g5o_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_35;
function Companion_getInstance_45() {
  if (Companion_instance_35 === VOID)
    new Companion_29();
  return Companion_instance_35;
}
function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
  return equals($this, Companion_getInstance_45().g5o_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_45().g5o_1) ? 0.0 : interpolate_0(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.l4m_1, font.l4m_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_45().d5o_1) ? 'TOP' : equals($this, Companion_getInstance_45().e5o_1) ? 'MIDDLE' : equals($this, Companion_getInstance_45().f5o_1) ? 'BOTTOM' : equals($this, Companion_getInstance_45().g5o_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.j5o_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_46().k5o_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_36;
function Companion_getInstance_46() {
  if (Companion_instance_36 === VOID)
    new Companion_30();
  return Companion_instance_36;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_46().k5o_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_46().l5o_1) ? 'LEFT' : equals($this, Companion_getInstance_46().m5o_1) ? 'CENTER' : equals($this, Companion_getInstance_46().n5o_1) ? 'RIGHT' : equals($this, Companion_getInstance_46().k5o_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.q5o_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_37;
function Companion_getInstance_47() {
  if (Companion_instance_37 === VOID)
    new Companion_31();
  return Companion_instance_37;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function add($this, x, y) {
  var rx = $this.pz().h2d_1 + $this.y4x().k2h(x, y);
  var ry = $this.pz().i2d_1 + $this.y4x().n2h(x, y);
  $this.f4v_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.f4v_1, Vector2D.q2f(rx, ry));
  if ($this.g4v_1 === 0) {
    $this.e4v_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.e4v_1, Vector2D.q2f(rx, ry));
  }
  var _receiver__tnumb7 = $this.i4v_1;
  _receiver__tnumb7.q4v_1 = BoundsBuilder__plus_impl_cz7f7x_1(_receiver__tnumb7.q4v_1, Vector2D.q2f(rx, ry));
}
function add_0($this, rect) {
  var fx = rect.y2d();
  var fy = rect.a2e();
  var w = rect.t2d_1;
  var h = rect.u2d_1;
  add($this, fx, fy);
  add($this, fx + w, fy);
  add($this, fx + w, fy + h);
  add($this, fx, fy + h);
}
function measure(_this__u8e3s4, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  var actions = new BoundBuilderTextRendererActions();
  invoke(_this__u8e3s4, actions, text, size, defaultFont);
  return actions;
}
function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.text.invoke.<anonymous>' call
  _this__u8e3s4.t5o(actions, text, size, defaultFont);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.k4x(text, c);
  $this$CreateWStringTextRenderer.g4y(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.k4x(text, c);
  $this$CreateStringTextRenderer.g4y(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.c5r_1.q5r_1.r2f()) {
    this$0.c5r_1.o5r_1 = this$0.a5r_1 ? 4 : 1;
    this$0.g5r_1.m5q_1 = filler;
    this$0.g5r_1.v5q_1 = $state.v4o_1;
    this$0.g5r_1.j2y();
    var tmp = $winding == null ? fillPath.c3m_1 : $winding;
    this$0.c5r_1.w5r(this$0.b5r_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.g5r_1.bd();
    this$0.c5r_1.q5r_1.j2y();
  }
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return function (x0, x1, y) {
    this$0.g5r_1.k5r(x0, x1, y);
    return Unit_instance;
  };
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.r4l_1, dstN, src.r4l_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_38;
function Companion_getInstance_48() {
  if (Companion_instance_38 === VOID)
    new Companion_32();
  return Companion_instance_38;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_39;
function Companion_getInstance_49() {
  return Companion_instance_39;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.r4l_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.r4l_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.r4l_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.r4l_1, dstN, dst.r4l_1, dstN, src.r4l_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.r4l_1, dstN, src.r4l_1, srcN, dst.r4l_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_48();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.j5s(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_48().i5s_1);
  var tmp_0 = Companion_getInstance_48();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.j5s(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_48();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.j5s(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_48().i5s_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_48().i5s_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_48().i5s_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_48().i5s_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_48().i5s_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_48().i5s_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_48().i5s_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_48().i5s_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_39.v3v();
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.f4o_1.f2i();
  };
}
function trans($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.s4b_1.f4o_1;
    if (this_0.w2d()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.q2f(this_0.k2h(p.h2d_1, p.i2d_1), this_0.n2h(p.h2d_1, p.i2d_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.a3m_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.m10(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.b3m_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.q2f(tmp, path.b3m_1.d1(_unary__edvuaz_1));
        _this__u8e3s4.t3l(it);
        break;
      case 1:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.b3m_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.q2f(tmp_0, path.b3m_1.d1(_unary__edvuaz_3));
        _this__u8e3s4.v3l(it_0);
        break;
      case 2:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.b3m_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.q2f(tmp_1, path.b3m_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.b3m_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.q2f(tmp_2, path.b3m_1.d1(_unary__edvuaz_7));
        _this__u8e3s4.w3l(c, a);
        break;
      case 3:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.b3m_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c1 = Vector2D.q2f(tmp_3, path.b3m_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.b3m_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c2 = Vector2D.q2f(tmp_4, path.b3m_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.b3m_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.q2f(tmp_5, path.b3m_1.d1(_unary__edvuaz_13));
        _this__u8e3s4.y3l(c1, c2, a_0);
        break;
      case 4:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        _this__u8e3s4.t6();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_7().h2e();
  bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.h4o_1.k3i());
  var tmp = bb;
  var tmp333_safe_receiver = state.g4o_1;
  bb = BoundsBuilder__plus_impl_cz7f7x_0(tmp, tmp333_safe_receiver == null ? null : tmp333_safe_receiver.k3i());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).q2m(state.f4o_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.k43(toIntCeil_0(bounds.t2d_1), toIntCeil_0(bounds.u2d_1), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
  filler.q5m(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_5().v2g().y2h(-bounds.y2d(), -bounds.a2e()));
}
function transformTransform$factory() {
  return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
    return receiver.n5s();
  }, null);
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_40;
function Companion_getInstance_50() {
  CycleMethod_initEntries();
  if (Companion_instance_40 === VOID)
    new Companion_34();
  return Companion_instance_40;
}
function values_6() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_50();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.t3_1, 0), y.t3_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_50().q5t_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_50().q5t_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.q2f(_CycleMethodPair___get_x__impl__dgz5uj($this).r5t(ratio.h2d_1), _CycleMethodPair___get_y__impl__fcnb7o($this).r5t(ratio.i2d_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.s5e(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.s5e(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.r43_1 - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.s43_1 - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.m44(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
          n = n + 1 | 0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value = msdf_0.t4g(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_0 = msdf_0.u4g(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_1 = msdf_0.v4g(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_2 = msdf_0.w4g(x, y);
          var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
          msdf_0.x4g(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.e4h(-1.0);
  msdf_0.g4h(-1.0, +1.0);
  msdf_0.d4h();
  var msdfBitmap = msdf_0.d44();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.s4j(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).d44(), VOID, 0);
  return newImage.l4j_1.o4b();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.r4g(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.b2g();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator = curvesList.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var tmp$ret$0 = colorize(item.n3h_1, item.o3h_1);
    destination.h(tmp$ret$0);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.i1();
  var tmp0_iterator_0 = colorizedCurves.a1();
  while (tmp0_iterator_0.b1()) {
    var element = tmp0_iterator_0.c1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var list = element.s5t_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.s43_1;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.r43_1;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.q2f(x + 0.5, y + 0.5);
          var inside = path.y3v(p);
          var allDist = allColorizedCurves.a5u().e5u(p);
          var redDist = allColorizedCurves.f5u().e5u(p);
          var greenDist = allColorizedCurves.g5u().e5u(p);
          var blueDist = allColorizedCurves.h5u().e5u(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.x4g(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.s5t_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_r__impl__duz7mo(element.j5u_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.s5t_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_g__impl__o8pukr(element.j5u_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.s5t_1;
    var destination = ArrayList.i1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_b__impl__m6tl80(element.j5u_1) === 0)) {
        destination.h(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.s5t_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.i5u_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.k5u();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.i5u_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.l5u();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.i5u_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.m5u();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.i5u_1;
      destination.h(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var tmp0_iterator = _this__u8e3s4.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var index_0 = checkIndexOverflow(tmp1);
    var color = msdfColor(index_0, _this__u8e3s4.e1(), closed);
    var tmp$ret$0 = new ColoredBezier(item, color);
    destination.h(tmp$ret$0);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().y44_1;
  if (index === 0)
    return Colors_getInstance().a47_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().o4a_1 : Colors_getInstance().y45_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return function ($this$NativeImageContext2d) {
    var paint = new RGBA(Colors_getInstance().y44_1);
    if (true) {
      $this$NativeImageContext2d.m4u();
    }
    // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.l5t(paint, null);
    return Unit_instance;
  };
}
function red$factory() {
  return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
    return receiver.k5u();
  }, null);
}
function green$factory() {
  return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
    return receiver.l5u();
  }, null);
}
function blue$factory() {
  return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
    return receiver.m5u();
  }, null);
}
function allProjected$factory() {
  return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
    return receiver.a5u();
  }, null);
}
function redProjected$factory() {
  return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
    return receiver.f5u();
  }, null);
}
function greenProjected$factory() {
  return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
    return receiver.g5u();
  }, null);
}
function blueProjected$factory() {
  return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
    return receiver.h5u();
  }, null);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.i1();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.a3m_1;
  var n_0 = 0;
  while (n_0 < this_1.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.m10(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.b3m_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.q2f(tmp, _this__u8e3s4.b3m_1.d1(_unary__edvuaz_1));
        var x = destruct.ul();
        var y = destruct.vl();
        this_0.h('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
        break;
      case 1:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.b3m_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.q2f(tmp_0, _this__u8e3s4.b3m_1.d1(_unary__edvuaz_3));
        var x_0 = destruct_0.ul();
        var y_0 = destruct_0.vl();
        this_0.h('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        break;
      case 2:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.b3m_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var destruct_1 = Vector2D.q2f(tmp_1, _this__u8e3s4.b3m_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.b3m_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_2 = Vector2D.q2f(tmp_2, _this__u8e3s4.b3m_1.d1(_unary__edvuaz_7));
        var cx = destruct_1.ul();
        var cy = destruct_1.vl();
        var ax = destruct_2.ul();
        var ay = destruct_2.vl();
        this_0.h('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
        break;
      case 3:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.b3m_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var destruct_3 = Vector2D.q2f(tmp_3, _this__u8e3s4.b3m_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.b3m_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var destruct_4 = Vector2D.q2f(tmp_4, _this__u8e3s4.b3m_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.b3m_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_5 = Vector2D.q2f(tmp_5, _this__u8e3s4.b3m_1.d1(_unary__edvuaz_13));
        var cx1 = destruct_3.ul();
        var cy1 = destruct_3.vl();
        var cx2 = destruct_4.ul();
        var cy2 = destruct_4.vl();
        var ax_0 = destruct_5.ul();
        var ay_0 = destruct_5.vl();
        this_0.h('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        this_0.h('close()');
        break;
    }
  }
  var this_2 = this_0.k8();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator = this_2.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    var tmp$ret$3 = prefix + item + suffix;
    destination.h(tmp$ret$3);
  }
  return destination;
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return function () {
    return toCurvesList(this$0.p5u_1);
  };
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return function () {
    var tmp351_safe_receiver = this$0.q5u_1;
    return tmp351_safe_receiver == null ? null : toCurvesList(tmp351_safe_receiver);
  };
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.c5v(_this__u8e3s4, separator, decimalPlaces);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return function () {
    return new FillShape(strokeToFill_0(this$0.d5v_1, this$0.h5v_1), this$0.e5v_1, this$0.f5v_1, this$0.g5v_1, this$0.i5v_1);
  };
}
var EmptyShape_instance;
function EmptyShape_getInstance() {
  return EmptyShape_instance;
}
function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function pathCurvesList$factory() {
  return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
    return receiver.x5u();
  }, null);
}
function clipCurvesList$factory() {
  return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
    return receiver.y5u();
  }, null);
}
function thickness$factory($b0) {
  return getPropertyCallableRef('thickness', 0, KProperty0, function () {
    return $b0.c3g_1;
  }, null);
}
function scaleMode$factory($b0) {
  return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
    return $b0.e3g_1;
  }, null);
}
function startCap$factory($b0) {
  return getPropertyCallableRef('startCap', 0, KProperty0, function () {
    return $b0.f3g_1;
  }, null);
}
function endCap$factory($b0) {
  return getPropertyCallableRef('endCap', 0, KProperty0, function () {
    return $b0.g3g_1;
  }, null);
}
function join$factory($b0) {
  return getPropertyCallableRef('join', 0, KProperty0, function () {
    return $b0.h3g_1;
  }, null);
}
function miterLimit$factory($b0) {
  return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
    return $b0.i3g_1;
  }, null);
}
function dash$factory($b0) {
  return getPropertyCallableRef('dash', 0, KProperty0, function () {
    return $b0.j3g_1;
  }, null);
}
function dashOffset$factory($b0) {
  return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
    return $b0.k3g_1;
  }, null);
}
function primitiveShapes$factory() {
  return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
    return receiver.u5v();
  }, null);
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return function (a, b, y) {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.n5r_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return function ($this$transformed) {
    $this$transformed.h3v($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_41;
function Companion_getInstance_51() {
  if (Companion_instance_41 === VOID)
    new Companion_35();
  return Companion_instance_41;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.y5w(HtmlImage_instance.e5w(_this__u8e3s4.d44()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return isLittleEndian;
}
var isLittleEndian;
var NonBrowserNativeImageFormatProvider_instance;
function NonBrowserNativeImageFormatProvider_getInstance() {
  if (NonBrowserNativeImageFormatProvider_instance === VOID)
    new NonBrowserNativeImageFormatProvider();
  return NonBrowserNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_2($this, data, props, $completion) {
  var tmp = BrowserImage_instance.c5x(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.y5w(tmp));
}
function *_generator_decodeInternal__jnwsgt_3($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.d5x(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.e5x(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.h2c(path);
      var tmp_1 = BrowserImage_instance.d5x(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.e5x(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.oi(path).o2b($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.c5x(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.y5w(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.u5w_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.u5w_1;
      tmp = tmp_0.f5x(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.u5w_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.u5w_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.g5x().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_10().cx()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.l5(toString_0(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.v41(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.l5x(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.m5x(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.ed(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.za('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.ed(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.u3()) == $this.s5x_1) {
    tmp = fontSize === $this.r5x_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.s5x_1 = font == null ? null : font.u3();
  $this.r5x_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.u3();
  $this.q5x_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.q5x_1.globalAlpha = state.v4o_1;
  $this.q5x_1.globalCompositeOperation = $this.t5x(state.w4o_1);
  if (doSetFont) {
    setFont($this, state.r4o_1, state.s4o_1);
  }
  if (fill) {
    $this.q5x_1.fillStyle = $this.u5x(state.p4o_1);
  } else {
    $this.q5x_1.lineWidth = state.j4o_1;
    var tmp;
    switch (state.m4o_1.t3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.q5x_1.lineJoin = tmp;
    var tmp_0;
    switch (state.a4w().t3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.q5x_1.lineCap = tmp_0;
    $this.q5x_1.strokeStyle = $this.u5x(state.o4o_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.v5x($this.q5x_1, paint.y4x());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.g5x();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.i5x();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_10().dx() ? NonBrowserNativeImageFormatProvider_getInstance() : Companion_getInstance_10().cx() ? NonBrowserNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    // Inline function 'org.khronos.webgl.get' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [1];
    // Inline function 'kotlin.js.asDynamic' call
    isLittleEndian = (new Uint8Array((new Int32Array(tmp$ret$2)).buffer))[0] === 1;
  }
}
//region block: post-declaration
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.n43);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_1);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_2);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage', VOID, VOID, [Bitmap, NativeImageRef]);
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForCompanion(Companion_3);
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(Result, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForObject(Colors, 'Colors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).t4n = get_baseBmp;
protoOf(BitmapFontImpl).x4n = getFontMetrics;
protoOf(BitmapFontImpl).c4m = getFontMetrics$default;
protoOf(BitmapFontImpl).z4n = getGlyphMetrics;
protoOf(BitmapFontImpl).e4m = getGlyphMetrics$default;
protoOf(BitmapFontImpl).g4p = getKerning;
protoOf(BitmapFontImpl).d4o = getTextScale;
protoOf(BitmapFontImpl).d1 = get_0;
protoOf(BitmapFontImpl).e4o = renderGlyph;
protoOf(BitmapFontImpl).f4p = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(CharacterSet, 'CharacterSet');
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(TextMetricsResult, 'TextMetricsResult', TextMetricsResult);
initMetadataForClass(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', MultiplePlacedGlyphMetrics);
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).j2y = reset;
protoOf(TextRendererActions).g4y = advance;
protoOf(TextRendererActions).h4y = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(drawText$actions$1);
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_12);
protoOf(LazyBitmapFont).t4n = get_baseBmp;
protoOf(LazyBitmapFont).x4n = getFontMetrics;
protoOf(LazyBitmapFont).c4m = getFontMetrics$default;
protoOf(LazyBitmapFont).z4n = getGlyphMetrics;
protoOf(LazyBitmapFont).e4m = getGlyphMetrics$default;
protoOf(LazyBitmapFont).g4p = getKerning;
protoOf(LazyBitmapFont).d4o = getTextScale;
protoOf(LazyBitmapFont).v11 = getOrNull_2;
protoOf(LazyBitmapFont).d1 = get_0;
protoOf(LazyBitmapFont).e4o = renderGlyph;
protoOf(LazyBitmapFont).f4p = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_13);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.z50, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_14);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_15, VOID, VOID, [1]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(BaseTtfFont).c4m = getFontMetrics$default;
protoOf(BaseTtfFont).e4m = getGlyphMetrics$default;
protoOf(BaseTtfFont).v54 = getGlyphPath$default;
protoOf(BaseTtfFont).e4o = renderGlyph_0;
protoOf(BaseTtfFont).f4p = renderGlyph$default;
protoOf(BaseTtfFont).v11 = getOrNull_2;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_16);
initMetadataForCompanion(Companion_17);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_18);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).b5c = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).b5c = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).l3v = arc$default;
protoOf(GlyphGraphicsPath).p3v = polyline$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_19);
initMetadataForCompanion(Companion_20);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_21);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForCompanion(Companion_22);
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForCompanion(Companion_23);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageEncodingProps, 'ImageEncodingProps', ImageEncodingProps);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.i5j, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_24);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_25);
initMetadataForClass(Type, 'Type');
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', NativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [1, 2, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_26);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_27);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForCompanion(Companion_28);
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_29);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForCompanion(Companion_30);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_31);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(LineInfo, 'LineInfo', LineInfo);
initMetadataForClass(Entry_0, 'Entry', Entry_0);
initMetadataForClass(Text2TextRendererActions, 'Text2TextRendererActions', Text2TextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_32);
initMetadataForCompanion(Companion_33);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).t3s = moveTo;
protoOf(Context2d).s3v = cubicTo;
protoOf(Context2d).e3v = line;
protoOf(Context2d).f3v = arcTo;
protoOf(Context2d).g1 = isEmpty;
protoOf(Context2d).g3v = rect;
protoOf(Context2d).h3v = rect_0;
protoOf(Context2d).i3v = rect_1;
protoOf(Context2d).j3v = roundRect;
protoOf(Context2d).k3v = arc;
protoOf(Context2d).l3v = arc$default;
protoOf(Context2d).b3g = circle;
protoOf(Context2d).m3v = polygon;
protoOf(Context2d).n3v = polyline;
protoOf(Context2d).o3v = polyline_0;
protoOf(Context2d).p3v = polyline$default;
protoOf(Context2d).q3v = rMoveTo;
protoOf(Context2d).r3v = rLineTo;
protoOf(Context2d).q2m = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_34);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape');
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
protoOf(FillShape).o5u = getBounds;
protoOf(FillShape).n5u = getPath_0;
protoOf(FillShape).j4z = getPath$default;
protoOf(FillShape).q4y = draw;
protoOf(FillShape).k5c = get_bounds;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(CompoundShape).j4z = getPath$default;
protoOf(CompoundShape).k5c = get_bounds;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
protoOf(PolylineShape).n5u = getPath_0;
protoOf(PolylineShape).j4z = getPath$default;
protoOf(PolylineShape).q4y = draw;
protoOf(PolylineShape).k5c = get_bounds;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
initMetadataForClass(TextShape, 'TextShape', VOID, VOID, [StyledShape]);
protoOf(EmptyShape).n5u = getPath;
protoOf(EmptyShape).j4z = getPath$default;
protoOf(EmptyShape).k5c = get_bounds;
initMetadataForObject(EmptyShape, 'EmptyShape', VOID, VOID, [Shape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_35);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NonBrowserNativeImageFormatProvider, 'NonBrowserNativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_6 = new Companion_0();
Bitmaps_instance = new Bitmaps();
Companion_instance_8 = new Companion_2();
NewSDF_instance = new NewSDF();
Companion_instance_11 = new Companion_5();
Companion_instance_13 = new Companion_7();
Companion_instance_14 = new Companion_8();
Companion_instance_15 = new Companion_9();
Companion_instance_16 = new Companion_10();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_22 = new Companion_16();
Companion_instance_24 = new Companion_18();
Companion_instance_25 = new Companion_19();
Companion_instance_27 = new Companion_21();
Companion_instance_28 = new Companion_22();
Companion_instance_30 = new Companion_24();
WEBP_WASM_BASE64_ZLIB = 'eJy0vQ2YZNVVKLr3Pvv8VJ1zuk719Mw0UwOss+mEis4EIqSGDFzTa6Sn54+Bd8318Xx5D2KYCKeKn+4pOngfTjXJhEwSjBAxohLvxJCA3hlFxStXuWaiaMifYoIR70WDSgxqNKgkDk7P9PvWWruqu4fE7777fa9h6uyzzz77Z+21115r7bXWUW87eLNWSulH9cbr9UBdbwYDPbjeDgaDgbo+4N9wIHdmmKUH12v6iQb+CRdfydCD62uD4Z+6XunB9Updbw7Rg3iUHQ7L2sEhvibDV9a8rwfXB4NDA33oenPnQN95fTS4U7LN+7Td8M63HbzpuoO3vO22gzfe2r/utvkDCzcdeOcbarfN3/r26w7ccVNfqe9QJHnHDde9vXfrwQMq/jdKvHP+pv4BVfsOJeJ33HDdwQMHuqoZ/IJ52OSZVjWdZUrFtVAHgQlVHGutoyjSEf1GpqZVva4izX+qlimliljXonqkdKh1HBobmvFaPQqMaeQmsfWkHmgdxEFIf9baJAmCILBJor7DXxA2GhEVrkXGGGOtNXrNX8DZVEtgOO3/kkSHoVIqT+XPGkP/60hba/g//xdFhl5WWtM/FapaYfS6mq6pOFZKjY2NJXkUmSyOJuJ4fS2IgzG7IYx1HKtMxTUb69v0x/THdBhpvWgWTZTogcajd4dp/C7TjG4+cPOt8z9iVOOGA2+/9YYD89ctHJg/eNOtt6gwf/v8gbf1D1z3Q7e/4x0H5lUU3fy2Xu/Wt6uPm7EbDhzsz9/6I8NHsX3H/IED6hMmkkpUkvzwgf51N93yjltVLaVn180fOHh7r6/icXogN9fddutNt/QPzKt6Y1XmwZv+4wGVnnPddTfdcsNN8wfe3r/uHbff8vb+Tbfecl3/bT/UO6BVet1Nt9zUv+ltPSr546a47roD8/O33Hpd79a3v43KqZ8wtYP9t729+/1vWzigHjYZ3/z7Awf7t84fUI+YOt8jj+UXTO19RivU6c/r5oaNk+dsam0+97zzoXQXTH3Xd8/u+d+u+Q8/8L9f+3/84P/51v/r/77u+rf90NtvOPCOH77xpqrbu/mWW2+bmz/Yv33hnXf8yH/8f+780UODRX2Xfpd+tz6s36Pv1u/VR/T79Pv1T+oP65/SD+if1j+jf1Z/RP+i/gX9iH5Yf0J/XD+kP6Z/Xn9UH9X/Sf+cPq4f1/9V/6b+Lf2E/m/6t/Un9Qn9Kf07+pf1L+n/rI/pX9W/on9d/5p+TP+uflJ/Rj+lf19/Wn9ef0H/gf5D/bT+I/1F/WX9Jf28/nP9l/rP9J/qF/RX9V/rr+kX9d/ov9V/p7+hX9L/qP9Bv8fcbd5rjpj3mfcbe7/5SfNhc9R81NQ/97R92GxQeM+7NN5/l+4YhU/epfG7OkalkcK77rZprkCB7qHpFx83aaxAFZ8w6b++wWwamEMXKLxXd10xpaBAWzlrp8GiwmdUcZ/ZlEKBz6kKFV5Kt1Cg7hgLBdiOudZMU71QYFJBgVlVXDWTKzB2GgwUbZNQFyCw0xDQbca3BT6rqrKJqgx8y7UpBTWqNoEacO01UB2jzLQZXKCw6Do1pUCh4hKW2qy1Df9QPxXSw6RCBbViX8dkZpr61TaZlQvGs7mhVJLrzKScmsl1Cgptx2SckYHCoppSmU7xJ6bw0y38+QB/aaz4kFGp07ky09C001DDqcqZ4nVQo9YzJz2pOuYGybGguh1zPTTBFOvNNGXBjJ020zs0PjVe/JhxiiCk8LfaNBgeE90uqQo//4pqG9VUfqiPG7lafIQfOI1HObEzV3jklDID0HYam2hAN2OV600pjqc0+0dfUf4dBriayQMBWdExx8YlOdExj47z9JniIssdnaKfNjTbZoJ+VNFwOtf8ZBM/2kRAaJsJp2egNjOfK9Bt06bx8DBzhe8Zww9vxo+E+MWNDDkZwf2aXysDVKWmNgkhZnJKBm2zxVlUu3KFy7oMweIL6ipGwGXdw+XlYA5fULfwA7qhaUNV2mAaNNpZOy0YiGG/cnHbHI1chNl+Ow1x2zwUlXGmU4ghhAgV/dvTwg9uq7Yq1cNgwcUd81CUgkZdlRosxPOlzXSagpU5esRW+Pw/K3xOF/eaTaB2LC4uLr4UbDNHLShcNB1zOAJFiPugTUHRYC51umOeHOc+vaD22QFoVPtzgyrEF1RKzwjD3vNagtNnDX56PcOJATOgJYGqjFGVIY2L19KMILHKNSg8fCljzQ6zzShUmUkJ1eU/KmS5MM3oTB5JRq5TM+Dnpm0udjwyA5YQhoYY4Z9OFls3cQvlWKapQio+oOJXUm00gYfHkReGKS2VPDzuIvwZhmMZQIRmZ64hSukhvbYPgq6L0N7eMY8YyXoLZSWcdczQROwaVv2ISSFhEIHCY6bKdDp8IBkpeiyGABuVC6i6ayu0t7uoYx6j+jnrGs4KqHtHjUsggGRXq2Me5XX/kHEBRNwmBPRWiopI3L5c89CvLHO63Fg2gmkI0e7MtRlAg8uH1RZ1h1R8my9+BQTSz7a5Ii3rNG3BNARoZuUNDPoV3fYrl+CR8apMzTS+2QygDvlMrriOXVCvnKVlIPfXgq1SZ8Him/e3aEXsESpM//a0XCSQn3aZPInQoIYM7d7WgrNYg6zrMrCQ7WqVliD6vvEKCact6n0tZ7crBSlYiFD3K7pJ8APjFdJcjO2FCC/c29quaI4hRbVdKari/eMVBFQ2oAUS8MoIKRlmKlUpjKV5wEhrZcYe0KjL+hAX79fSU6FtTwtti9UM4TEofExXHXMPpzvmiJZldFhjgEZQjIZd1mne6x3zoCb0o/c0fuaSYuuMn4kHNRfhOQ+kVUfLvI+mT8UZVxOuKoUAw74bgzravpuExGOwyyoMemhu7pXjPGllTgPuo6nKBgh69/Fo1CvXDYd2bNweAnWJ/h76ufhQuEOl7nwYPw7pcVh3HBrHYew45Mfv5D933o6jrywvN34g5/681KS1babhvB1fie5051Hey01nj/+AnYaw+IRZgefLTVBwHuriA8aFHfNSE0KB3nkPOyuP/fj8WswEAmVEUAs75smmVHRUDyeI8iGv3ETHfL7JSyrou/Ud83W5sX23oWNepJsxmKjcGJqqY56W+0blJlBB2nIbO+YZytsIwYisEkbR1fSrjjlGDaUwUeH5FV4/55KOeZZeSPBEVNHdIlHIxL9udrYIvlXHPKo5ex0t8ww29Cpa48/xKCCAcco+/5pWxzxBr2eoF2B9zyUQwQaY7FVc+nlqJ4I6rO/xMkyqjnmhCQGc/3AFFsJqbx7AGCpoMDej2ubpJpouqsuH++5JD7WnGL5PNlFBTmWFMml85Q2MfykYYUgYX59rdsyEJJ9vdsykJF9odsxmSb7Y7BigxNebZSCv3giGqNGU36vxGF9m7TQeW1LoaCd/4pTCCyjx+JLCKUo8uqTwNZR4bEnha7nMksILKXFiSWGbEk8vKXwds4FLitlAfGpJ4XdT4tklhVso8fySwq2UeGFJ4esp8eKSwoso8fUlhRdT4pklhW+gxOeXFH4PJZ5bUngJJU6eUngpJV46pfCN/PophR2u8JTCbdzEKYWXUeLwksI3UWJxSeF2SiydUng5JV4+pfAKbvSUwn/HPTyl8Hu59VMK38zDOaXwhOJ+nFL4KU49dUrh73DqyVMKf5dTJ04pfJJTjywp/D1OPbSk8Pc5dXRJ4ac59eCSwqc49cCSws9w6v4lhZ/l1L1LCj/HqZeWFH6eU8fWMFSoicQSp4BHz6d9/HCEiwnv47w+MavKeiCcSdwxS02IaeIfM/uFBDxuyjHaYlGVxAE+1axo3xHSctRAskd2/CcZ/xbHIeHV4VJ6g7J6vGfUQW1VR+KiTXs+37wvLtqEpHzz/rhoo5lPt6ufY07gCeJe/bMTzaK9XX0kIiJv+lWZ0QO8TxdtF8xsV4sRs+wpbVj4oC7adho1BlDHRV20W9wEfkwXbVSzqPupC7aruyLIIMC73nU46bmgoxQ0gC7Ebqd4V1SV0WibtDtzAwHRk3GiWpbYHdl3Z3koIWSVW7dVKfzvqgcWa70Kj35OVW79VqWKNjN/Fh/9oqq2KFXm+Le/Z8AuoJ7jt3NYX3E5yFH3hxzdOlrFXdkH/R5G2RFkbaWou+NgV7Y6iNBWZSTbnGqbqRkeB09AHT+oC2J6N6GBOv6T8jcCod8gCKXb1X0RJFRVwnUwWxDD2Bxu7lX4hKnKdVTtySYzqMTyCYsXgsJT3yMsXrzNqCxMzXQwLfhz1OzPtWcRCWbrL1AIXZdNKaFiLkTTLTdAKFU7Gn5VTgoSleOesZseIcM45IJY8Vb1kYjFoZW8dKv6ucidQ3x1GRNPgItRcZ9x0Va1GBHGZTvUtmBSLoVcErkwgLvOwjpQ+FKjArtV8bZD/XF2q9IVxHhvRPJaRoIMMQZ15UJUe1xCk2Ah2a40hGiIk88gIjpIpUKVBSlkr9cKgwqD2xkVAlzWRNQj3rYrsJdrmseCWBaZQDxZVDSBk8zawAa5xMOh+K5Rrua+ew5oBAy7Q20z90fEim1XD0aZYRJA7GmjSssxiPFIVJUTsIFwtjFXhjDpUzRXUUDsGuN2iHqubECIy3qu3Eh4T3O/gvvraJulYcxVMAEW0lXgScDucQ2M+xDgGT2HemG+DCAmRod4pvQirVDN0ore34IEgz2t+TL2uA4pQlWmjPJcxUZ+ncQiXZURxLAek/58uR4CfEnPoV3w7J7Cx4qqbDGM58oJCIePx0ABYwc+EFXlZo+SCa/MgOQ3ggVYtJULFsqIAQLBAgNkox/0RmGYIwbKiAhwXoB6AZfVHKyD1ggim4n7WAWRTYQwDQz63xYQmxgQm74zIKJhGw0M+/NlRECpSuJpzAK+ec5DIKIRg+3D2DzNNFg0/T4k82XC/BK+dD4/nZgvJ+hZ5enNJEwwqsHYdrVqWQWQdMwDEQSwvkMYFUCCv/jHZs4OUIVDkJLkmhKiQQLr51HNlkE64ollb3imKYucZQy7euGGtHCZ8wkJv6kAiSC0dfHKsluVgWB+uzIprGubScgQqiklgqPUqSuSjE82aSBradOza2nTv8098QYXC8Ghru+T3W+pKZz6MbMrJ66Od8Z9ZUzIdpSJLzOx0qG4Yx7R4N/rmIcoHRQFy7hNYciWVOUsPjOUL0omf4sa9U6/4OxAxA0w+HUlgvzqeh/QwiCvtDGSX8xOgfbiOPWKUo9qz7sGxKxyB6g/KcTDeRmWPKY9kxwQO5yCxWdX1DvSLgE6QA+DB/VsS0SoEBUhKH6oTbzFeyz+cY15C2lhieanjDMTrp2ap/zURDI1KiUaFQ8FsX0sXpMg9swqQYwI2R+di3+wGX85xFc2DDURMb0avFqGW4FxkJLIfSlrCg3YJlHLAOI53kSKLayZGCqvNE1tnOYiL6uSrlRlsUWUkJlOi45TM7lh5VqpReNnptRQBaKHKhCnMZxFBbrFbJbpGDVSF7CCU1Rqk7TOdNtM088VxbdYzwQGM0KBhH5sVbzxO1QajCo1HWNB00AzEreUpBOnZVQBWNDIklWxXQa+jXZnmRKFL1+Ip1p4KsO7m6IKM6xfpL78W+o2VKUGZQcrip3VCp5jWnr9iGZOs20eGk4u9czM5KwLabtwJmd9gRWFBA0z6JgMgpk8otsJMBgUV8/YaTS+y87MgMFw53xey1jsNtSnK2by2lB79FbLlxvKmC5FGTFsyoSBYdrmelc/5s7fEd7tzoPzd5i779zxjLpTxFc7graZyTNqZzbPM9G8HjF5HRTYjrnHyPWIIRYAaMN9RtFknvdwBXWIUaGFoLhL6mibt3qkynh8mHbxzt25Tou3DDPLICV4Y7o7HzLwLsCnRnLWC4saP8QK8+cXNf4Ep55Z1Hg/p55d1PiTnHpuUeOHOfXUK7yi1bDdzTO5Kt6SyuxcNiMk7g5P7PAIrXBGB1nkh3Xxis7VcHm9Cua8YlKhDwX93MBqKVZ54UTx5pk8Efau3zEF1ZLVUvzSawnR3pPjn/sV/GuccfdKxq9fTBnvXck48RrKeP9KxsemKOOelYyf4zruW8l40VHGxyyebHjN7hAO3w7tf3f0IgREz9as/uJNKRAeE9I7NdTRq32SuoaIgoDimjQLWDUqWmemEaptLqYrr5ixkmnYx1hf/4UA/0iWGmpqp4b36mpKgc4VFG0zUZ6bQuHzzk2v1MOzBTOlMCs+zgokWuNDOlFcRYueMTsjUsCphCV+XskQpDWFi8yOUOqwpN6kgHZTfM9r8Vc3489p/PHEA6xtHh8vPmFAETv5+Div4/Ei9+rO8XSTAg+NieJNkjshNDJ9XptwoA9JzabBlRUlU4CkNEPqoLB+lZUTGYUTlRN8B4O626s6pvDEkoqCC7qskJDbKWe7HTM1vG27sNsxba4pAHNsh/5RFz3sDNci6EnsabRDH3nYacqdkNxJ0BDSPYsdm52QKe7PlpX+UIHN0hXqBW066ftiEw/sIZmSeEqhYR14MANE4ajsvvl5PoYxrMJum8QPleYHD80xTfLXCcclJp0u9s/khncrWqnAlAuIEnJqijcM0BDTpMc06e8y1OWY4MqXrOS9jbeWAGh9cl+4V/M56/yVizDby30LGJP3SP41RAOOO+Ih7xJVoz1+aMfy8vJy/AO5Bn3cZUTves4eO1TmqMvQHIII0912eocqCfHVDlHJQnZoh4IIs50uaZUCuaTF2gNdoV5w6jifYqBeOH4oddkOfbcbgxTyOz395XngURRyuQbyh5n/T6/m07mwYy6GgIgvQAAZKxgvlQFP0RsQVrTxTUiZy+RJm59Ynm7qHNekYexhmV9mdrdAAOn3mitoHNzMpFQxkaIpIwEZ7cEEQEonZUgXWyrGau07SDhpweL5tzt7EGzX+bGbm53dT4+nXA1q9Lh2EGpdVwPJBleHOmXXD0K96+qg9kPwRnMxqGOOtdndYy6H+vFDd/4g5V8K9pjLWFhAczM/HYMaPZ2jx5dBchzGDkF25w/Ozc3NUQMFqllOTAwTk5QoQ9CYzTL28xmXBk3d0AdBd53eR7VdAfo45Icg5drbZjPXEM7lhqRcqnLtkC2fKgkq9ZwMZBLUMRkGWN9N3yc56gz9gVmUQuRCMHxqZ4iG2mkSuXhairEyTCEWqhamf1LT4wNav882ncWnbFUmYLFdlTViqIjWa5qgLJgmSriTzymetRUfhBjOTHbSfk+EMuyj7rq4wrs0y9xQHyYN8bGGZAwzDdnwvIOePWx94jeGCT7GszuWz5w+9S/f+Monl9U2FZ91P3HWfQMsLqvt6pftWQ+4dnryybOf/IZNMcQIshYfAQT9ssEyXllANoOmX44xy01bVdkMRjzZUQMxdV7Tnh2zFFZGOCgNDsrATEM8kytWUxQMlRqfQ1QuRNuFsK2yzpoTFg+/XHvwuQBt14UVa8vtvAsqr7AKoV5BAPXhvYfnUGX1+SbErL0JIWqb+yPqipmGJnXBQvg6pbapRFLJNlVIqtimHrGSnNymHrfA6p5cZzaVJDGYtm0meeJk8Ki7EO+TWreqhjOiBBQduMGkP+/oWvTn5SVLgwZnOmaSbkzHPGD8NfBXPUKkIcgM6j4e3VZdpFXlUjAQVVvVXSTd4vOnVOXlqgAihlkFaeHPcoJVeAZjkEPcKtPMpI0UajSkuyJnfD7V26IaT4xqpH7wEZ3vDBPRYRtre/WqBnkiorZ5ICoNMbNb1X2RCyCFgBu5l+TWwHe8DsOUgQgXbQVJsY6At0C3YQX1Yp2cYxK0sz2stLKvU0fsNsYE+zp1r6X55OQjEU0oJx+PtqnJVA4oIEbbr6CQ04hexUqToO/8SUVVRnJ6AaYSIfrrTd6EzMo6jyCFRs8ZetdAKErd1Us+kvdoix/ib1gxrnkO2D8j5PXZq+YnHoq2UvZFLuvGGdK0ZNb5V8ZhHWNtsvIyQVuFXA5qFeru2VSGCvzthfrCgdQsgz2qy/O8esIfodUEVnIeTAAQ4JQNgU25QfQV5ZgIX+XmNaoCUWEURbpaZiNZjZmjR0xZ968R7eT0o2Z/roeyHdTlzJhYBcI6wqir8sBPH/fXhdJ/Z3o8m3X6HZ7Ki86j7mkpGKIYFb6wxGJ7oFJItiozevT1lfzsrFeeX/sKMQ/y7MXhA1rJyValyxjqhETj4FHGbezRfeiRyiugn29CWMF4VY7TW0EZnt1Ldw7EEOKTUr+lOZ6EjSC5n5fc5KwR8LNnznpDcp9beSP7tg2d+LYNPbW2IZqClZae/rYtPbvySp1wre4XPpxHE1TGkEMEtZ67oAsp5QVEIhpQQ70Aac+d2y0T2ADndstxwYIHve3JUVuVZog1a7BF9FBQF33fxq3qwchNor1aRIcXCLWNTErqp8QK7vDEZDIdVQUWJosJIjiQVZDSPddVTKwdScw6UUhoJgOZwjHU3XLKDFDTpreFj6M2o+27OhZVGZoBbLbTsLEMYLw0MFlaqEOt63eMF5oQeIx9npNmSJ6qMkCVlnXiKTtmM7H2HZYogg5xV8R3yLEpH8HPQAg1VLAZpna1us5QV651NF12V8udD/V980SRtBnA+VDvsn66hoqP3s7Sq7AVUR3VLrYJmedZr1culiqTPWLopMpzZIoeG/fredyFrNfYofFeXfyYcQHJcRBwJmp86JJi6yZUWe6Fv5w5uEvNtfSjDglrbjrmcZp7M7SIOTEOikb+xPjwxPkhtnjgmXtivBQDtmPjLp5hfi6UvogI/uh4GQ41HRE+OtJ0PHha4RfkzPO0wj+QM8/TCv9QzjxPK3yaU/ecVvhHnDpyWuEXOXX4tMIvcerRVxREfJB7WnmznIC6eoSFC1ZoiMxMDKKLSFgyJCxFDNaIoR2i2c36kHirUhjM0SvJ8NYsYDDHiiq5t3RPFRVEyfdChHovzQ8/fDOJDMT7ksiAk2yXhwpMsR4CnO6yfsL3S8QO6hUhFqd2dcz1ktrXMTdI6hrCLk69pWN6krq2Y24zXh3HAsqYUUanIGIKb9y9qzOT4j2OBP6/UniyzgK/GaAqOs7w8uCtLfLKPyNCT8rtEisdM3GarMScIJZexNLVlPs+Go8RZafByQoiCItvaa6M60FNj4vtbFonOrtHNepZYfkf0xhwEk+qqrhc9hc2upFKiRaYS82N9HODR86YIB/nLGQrF4imNGjlzOV0DB/HBWwhpv2oiitY4Ga0mEBWzyyyLumjGf7UUBNavAlVKkohQV6SdQI74BpC1KksnSzzijVaaSTW6NnhImEzOkh4Yae8XFnNDMkeUXDeVq4jXGubxGsej427QBShCdR7LqpQV86AXzTV3rxGTzNmzU4z/zeT11cMsIQReGIcIk+7TozzaXYNUj6vAlFZnlVF07BhK0lOhigoMYLWBcNDIlahneCRhG0zMZPXCdE47RI7TcNpmxud3WenUVO6B/H+PNhEJQ7rGTtdvIVLlNbn5EEKCU1vSQx90jY3uEavbFLqNpKPoXGzC6DR65YR5d2vywm6FmULYmLs1kON9soCIgiK6XKMmOSm8PbxfnpQXE5yHU5WZU4vXlzaYDUltTNQg/W75lzIvODE3Mza2sbsNOQFwhhhbF7scAaX9VXM4bcqMMSweXBFND0RNHblMUmvLCA5g405Whj75/OI2Mvi+7IoBYM/ZfbmJGMsmi7kxZVlSg0U1EBpuL0aNIBSVxYzzu6CJtS6kO6azw037AzYbplBismuPBitdYu6O2aVjk2cQkYEhwUbkqqzi+hu0fZo6rK2Umm5AYw3TAjmGGD0hpw2T76z3EC1EeZkdMkyHZLwDSmRqy4Gc11n0NzuNqGCTYxumwJi8TfNilxFbCFsoHW/ynZhExriswxx4rtawoZDuDOP2cyJrSh8F1YZ7dF/+HXW9r47wV8/VxYk01/6t6tVfB/d5sVO2swuhnAGAprU5v75OVYZ0LQrZ4QSmFaebYIEQwwgaHXYJjWj92sdcxvqLKWlme5iVYPl0aY8ujDgYe2kWQNLrMeorwInYT0MZJAW95pNxE+llZykQ2M/I1eDkJiQQXAjwMbcPEvNQfF93rZjYo66nlauBuv308MRKtK8mTIYDtV2zMXcJP7CpXxqEw9Bgw9nlPGvKxnHJinjlZWMPzuXMv4gwx9fJxnvYXr3hVEGJLzIeD3SSsJ1xZvTmZwVHzGs2y/cQsc8Nu5ZpMfGZ7zCfLV+mO6fHHeBHC7QviWi2xPjvGE5C+f0qqpkruUaMN0y5e2LcHuM1hAqNrrfcIGiheI2TRH9P+fm0rBZSzwDAb6g9s7TFO2DMa9v3YSa2T33GmZYKbWOUkaEXz0P6Z6WC8RiUs/D2J6Wy7iHm1Dt0PRG3xVQEOL3XYCm6rn1FZ45v6LtJWHLGQVZt2ywgkPPk4jcY0uRHIquC1FBwZZ6m5D6XdxnygkIIOiVgMu6bNFPjX4MxLwAx6A5ywjHxkZCnlltyRpYU6HIhbCBWN89LVq40AIDtV0tNnQQ+x9eVtGuVhmR9EmP97ScKWuMWXwE2wQL5wwpeUTw5vP6qmzigM0caiPZeJFtGgxMUBfYiYBpXIBqv3ADXcfmK9Kgx8xVcnFEKz2ACLMeUQlLTRXQrPBMoyonUA+bSWSsNDNufWUG3HErc0HN7CdOJADTBduD6OYUzYIrL9cKJmB9FxWUXbpZ1fAEqsu1wsXFAuCWkv0ZMNiVszUo/dvTKmHVsh6DAk23LCHDwcGygJQm9rU09d3yQshhHVsktXEAGYllu1oCh7gMIJExMJdumOI3AHbmmonaGI0rl3Gtq4hDIkBCxB4BtE2EsE5UQw4srKvcuou04rGsA3fWkCyjJL2U7yzXsYIng8Y+Ox0QuGo77QBqnpa+dpedhiY3W8F66gBkFd1cpBXfFcO7Lvekh8XC2ta4mnRtNe2LtELdhxxKrrD7bWusvlOVQ6QSoBDyBpVzhNrhPgihJVKPw2UNE8NWqXbaQ7ip19NNxQsrZNPykO2R9rfY5mkVpAI4pwrXjD+jzWpVby8c9fY7dFYobATrWqWBc1BBA16zq0VXVPtbJPHF0KDSDbBDq/Kk+IRBTdvboqmmiAsbsl51InBlLYVaVkvxV15D7PYva3wqF7L7oQso4z6Nv+6PLBe5xJuG/DjedzHdv3l0/5sZ3T+9UsPnz6eMf1H4D76GRy+kjJMrGfdzxl16mAGqyFCltFfeCMFMblOoCzU2u3hp17vOop7LA2BZecLrtaycmWmvErOob+85fnOyEplXt81mqFcds5lPwYSi0f4wFLWoDm6X6EU9RQ11OJ9XuJbNwXKDvh1qQQTaNQ3EFQsZJCczieTqqCbTJVlEs+hMMoCWXcV2STgTsb8Zi6b5QQ3noa5mSRLfP+/Z7eeacEEXNspwWVN1AW3kqODcrtj/PN+sYFzGz+ZK54ppjlcQwOTZj9JGip95PX54M35Z4zfkEBp/sUMZTwf4V7Whv1GAX7uk2JruUSvyPZ63QLxcYLQKUj7iVXhsqMlqSM6jS97C0N8/PrxPU/Y9W2bzUnry2BLbXIPCX9RzrWGhx7S2gwsUTlcumlJsyXZC7RRNQFI5sdTx5lqWpo9zLOW0jeq6GPlgcE4sWbiwrpzIH9tmW6Nse1a2hRCiiuTLPk7eDkEPkwVc1AdfZehKXX9pOGiIcLo7pdLzFGg0HXMpaGR+T6PtmC2EmB3TTjf402D64ZNr5OwXU9MYmENmIE8JG4kpJIbZBZjtZnvhjxQQLBDq600pWIy7aHenZQB6h9pm2nK5WGx0JkBhihkEreJqFktnwIo1B6FT8Tl9lpvTW+W0RbH+3MW0vRiwcvhtMLs6t2yP+JECDPVgJrdZmMoTfdYTzT5U/uWh4sTgkyPFyVOLGj8gPpWLGu/h1IlFjT/GqScWNX6QU48vavxxTj02euPR0RvHRm88sqjxXk49NHr36KLG+6SNV1j1o1LQGNJEiFWJBr2DaUXmDJvn8Tl35dVHbTAzeSzqMpZNs5KmNfITCaZySlazIjy5veqYrPgcW69pjDtmS4q6DIl8hQSIWbAYzrLopjEhzjikgjUkcbi+16kWIYrKw8ymEMs8kRCu2uZ6moy+qx8vC9Z4uAQPzTnmAceOl01zCNgQqLnD3A3FjuDuO8sC7/vRsrbjG3w0VEDzzh3m7rLAr1Lmz5q0bHKmK/jYvPEDogwvxNMlEy39DWXE4Ckedo3VECGSa6BRQW3ohhIK5QvxEV11DHDyGcUkUPN2uKQrsK2OmSIpHMQrlDj3gI/2iEVrG0ANhm2QlNDQnA/eb3c1Fu4olfHhLSSUTliUpVTOx9T0ttfz+1oY+LptAGrAb06SVMJH3lw4pcLDBjGlWbWM4fzW1Npubh52cwu/OzZ614LGjCYzSJFo3MrE4ZLGpw3Ylovw/Or4jmCHpZtCJjQ4duhO5u5d7TgUh1yxw9x9p2sO50PLfNRlPhKZj5jno/mwS1fPh+b5SCuIujQZkUxGtDIZ0erJiFYmQ06V/BgNFA8z9Fj4QzWaDb+jJR7aCSuxKVUnxrpaKQ21EVC0wD2BOkRQW10moD1rWAbzjtkyJA4hPjEiDl9fVniYF+4Lywrfw6kjixrv5tThRY3v5dTiovbllkblTi4rPMKpl5eVf+OlZeXfeHFZ4fvEMm1Z4fuF2LzCXl1KlqtlWvYqHIggwKC3diiTvZWhjAmVb2ADCxhSboX1nS1QGO5sdcylafEWaiGFMO3rYABqq0qIWNqhW/XIlrfwKb8PCFugiafWbXOxC4YWOhA0I7UpFcahAFOJ+RoRoEaKP9PBv2zhv1j8H8KY/bbWKW8tE6LTBrFjnRTF22Y5nJwqE69x5hrZK5nNoXr+IDMra6y1RNMnAku7rKBp4QyyHnVPa+V8c6jG4+0UalBvWup5VImSgWRCy2/puS4kcy6rSssqljJczTNT9ekpo7OBrAsjRDsWe5Iyly4PtQETjo8bE1fvUT3JsLfLrDwUleNmgYEf/EQZmQHU+aiVeADucUCMPMSQNlMFTEh121ja8tuGgZRJIah1IRyVQ12lrJesV3IciaZydcj2j85xwRkvKpkuRL4xNhYzFR+0BJWjankkUjSkosM2PONBNflTnmvp5y2QVd5egiqJme/jrlrIhzcZBP6mhrrbSIm28pZkVg+bm65Gg0+hlh7XOh4ImInZLRkKbdGKTAhiTglImRcHwUgiA3JMlriwV8k4M8kpXFJ8kLvPPOkUHwiGRFmoJC8/602RjJAfc7ML/Cub5RUSUWMp3ab3/dMi/S9Gj3k7RDulpN0b2VZXzhv80XHmaqig5jXRPLqIUIQNyDCrwGJSFa8pNfGWiauznxIVziHi8dFlwgW9yo3xITs2pGzGPhsh5DtnVitNmHGNxaHGNfj4T45jXAENSr2k5+ZX+UtpKOZKvcpDmLYhbpFEPN4WVFUmXMBAfZZJUWMnZJ7NY5VCjYnVA+LfQTyQZYsk2q7wSE404gWNv/F6phFHtQ4H4lnJlgkMkpBNDiFsmy3CcCc970+Q8dkLw9byOFkI8ESACIAGszM3w1AAhF5Rca/hqnjt+xF4xSSf6IuWKC5eyxsqPjZBPbxb4/L53MM/1DryMxtMeeuHG50dzqz1/AOjqSo93xazG25WQSDzyYdMTNkJxwOaWyUYy4R/wrHLByok8mR3gsXaznmXtCqI8MGhowyxgLO5XmGqc0VLB2Lg5TCB95/yJ9sp+02tAflva3x26xDkAa8sT4sKtm4abiEGs6tkw+njb8JcawaMtDYnGHwjH4StWndGRsU7V4Cq+P501cMAbHHhqiUX+L2cRd/NxYWbVq0tzoPiwk3pkwTykWSw2VkxvWNQFQSqMl4RIm7kIxZi6EorDF4y6hEThKniQoKb4SNMtoCIaF+l7vFUbOFCbXMp0dLi+9m2yQ/xBrZQ2pUbkfKuBwPhEE9+rU5g/bDBe0Bk2KMpZXxklPHJYLh9OM/ClF7+4ZVa3yXoPgl1CLsrMHMGiB6Z4rARorcZUrBdZ4p3G3nDeyILSF0AloZTHDYCVT8jmz2F56dU2WwesGqAWHwSNYXlYPpTCComlct4tfNqi/wu9rzfxXLZYgVVJl3cNhyc47L9uaLrpJjLUvdcrS0RU/hZjUrXRk9pNbO+bF8eAhsiQttMzuYRxMVnhffzV/BXbutKfuKvQNeAWr0UctrgZecG7vTEMMQBn9QJqUoaKT7XpOn5UIBPyTLAZ3m+/tngb/uMV7jEy6OM23U48DjmFzmxPKX1ew/rahmjRJjxuw6h1BUu6lb8IqOiI14+7PYqiIvDZhMtV7C0w/K6vbQZqa43NEOV/rTxXNOU4zgkKxtGXSrjiYm7ZSpbApPnEHSvctlwS0gIx+SYm394IgzYfd6udc+84DdPhgZb7ctpM/usHu0c9TU7h3BqDPXh/pFD+G32jwTyOQ9zf1Dm94+wEuZvyk9OQrtGisFeVjRlUOPjsdV7RmM4Q58O8GOyWZzUuj4QIIRMO/mAlYdeZ9opDjJEQAMmoGmL+T6CViYgtW1zKWv0Aw8i25YfD6JgH9tFvgpEAYPIEkp6UPC0kLCjVlHoeL6MV84epH+ej53yRwzxDGTDcdchhRo7D64m3aORPxLg78nh1J1alDQJG+wxTbEcWMkrFpQZiLmK4eNOOcHTnlGXcXTZigJ1Ny1X8PUtntmuKuGRrp0VROERd8UwJL1U68FZ26wBywjiJ1nhsgZd3EesZMn8YnpAm4GskD1yNkL9Bk1kynZLThNpKpVEATobWYMRRSG0HJ4miuI/HCrDwvQbWlsGjPXROMR/CtX+Ib8VeAerCQj28j6heJMm6arq0JYsOrrJPrFeC7h4JpgDK7eUxqQ/P4/JwvzQWMNbzBb/PHTaYBcr49EyALPgLDtPYLLg9F6RnHBwEEwfqEXasnVXdDa6Sl3wwzh50Imalr1U+jx/VIfd3Ujxm6/FkxN4OX5ENKXj3rcEFX5dwnqlX5D9HIY6SNqwe3LIarGxx05j0UjBigsnRFuVKi62tAfxjS4uFrVy5YyvoExygwXxe2UExlksZnNFmNtIaZz0linY8FyXEXrvyah4QxmhSZn1iYrvKYlVtvj0FxVTDN2v+GTMotrjm+ldrhVxL9JbMJ4p+18YziWrh3PJ/9JwLvn/azhXDydsSVX4/IrraMEE6aXmyJEok8tLTblOyGWz6Gqnhj5lqROE9QGivN+LxB7jAqjSi7QesMtFsJtWAfX3I2w8pLYqb0aktiqD37WTsNekZ5rMqLDg0EjPimkm3hui//6vHckfOmxq3unET1zh194gT+OVp9Mu2Ko08WVblSF5nxLEY3KYBxdvV98FvHsvYDznku3qdXI752oz21UbmBZh0ocQC1qH4YIzHbMFEm8miU/5NgOmeLI2Y+nsr4gjLdpVjyIMutQbDIj9qQkFi6T7ny5Wus/lDfFJtni9VPfkxrNa4oUfbFUR/cSY9HHxjJqbd+ZyfbE8iTFa2K4ulZuEfmorxezl+ns4i8FisVGhXeiYhzjQ1vDuqOEwVFTNG8Vo8i1iVGlFS6zk7ga5u16KvFUyr5XMa0RDv0syC8nMiGIvB5frIzHT7u3q/bHM9x2gduht5jbBvhshwrpArO6NybcwzoDdy+KXMP/slPzJdWunX2FWkRAHpvgnLW8mhHdtTxJ18bLerjqr0tvS0Q1N841i+7aqeMf0fMq7o/nc2/xh8zAsCZMDg3YnG2qayhfkIG5R8U32zN6u7lhl4c+ouaZcPCrXX/Hq8GEoVMf0vIlHT6x8j4jRqz/AD3bmrCxbU2FSvKxDXNbp9lc7eUydDcx7ixVsE4I0HOtlnI44fQUonO7SQudbtQZ8Vw5d7IYQU6P+EYRW3eTBsJ9MU9hISQDVMdema/r6HcvtWluOidQVdoBawoBd1iJYdszh8W873GNnDxcJYqZ4WfdxcNDFHfO4wZhlfwtJ1xmIMei54Goxq6qIu+NwLKx6IPYiJGkmYgvlEU8bz3q3nc2sGYouUkL8ibYMDbD2tlxI+Gog5MMoqtyuRJMJqjJi1qMGsa+G0BvDMgIL2W5x0lo1si+NCYmOZGQ+7EvoowMm3rwkk9ViMC5eJnJphmA2aItvsuf92Vnhq7Nqr85KXp0lzto3lvnQ4o+WDBtmSFi9aovqo9dg3daqhNJZ8Z9hLzh24TCgXmeORtvM0Qg4/UC0zTzg0/dG28y9Pn0k2maORJlJPcHktyOWAF29Q69H+E3FwppLIcVvqv0tNzJFwRPszsGxNiJcVmyvtLy2iO7jicuqi7TqmHtGpWKpbfnb13bEl6tDXYqMFG2ra3twVFtYuW9TVGpD3e/QaCNMpHCtcqNejrjmlXrxCz8d9ZzBYgEMLi7C7lbH3B+lq4PzEZWcOXuNHF21nxEm6dL45bhJ/LaZCMXBtLezpDnliDXJTjttpn2wTYtNIk4kpDypCH85sMhDScVZRwxnLX5OuJyyV6HwrKus+UKIsOw55lbpBVerKvxAXJWZhH5hE8EQA2neYjprp82Az+jSnqtDArWqAlu5HE9slwhPckJZvMy8V47P/w43n5Y51CGjspCvMilcFb7Qh38ZLsrVIBxSQtsxTzTB+l0k4Y3mRJNLGHbSN+l7V4SIYCRAcJDJ4tIRk6/lSF7kJUXkYoHPx1mYCJmZdxpMv+uN1bulJ9tn1FVUO8n6+NJLPDKxycCX/pHvQtAp7eg2/R1mfRXorSpgjlTSVrhTdhen+7C4BINqeBetKhn7NP4nXVyCIZfBj1Na90Hhfbq4pMLYvyqvJMUlTldbVY0YZ9T9eRew1ueLovXRwTSVUk4gaItL2I5ovhzqWEXVggkEfUKW9EYdDr4jEHnj86IOwdtZ1AuiXVBEFBa6eP7tLgBboZ7nQ3Dmsmm254aw1RAchKCbHvqfmLRVkpklySxcmca1kpmthtP2PyWZhbvTu7RmI2810uzrkV6UK9ckabKcu1rSTLx3wIrYaUZip5Hbs8XOhoibr5YFrxE+X2FSnNR4EfH1GhSO0Z3mAZm1t0QkdHHSiwtBcVJLjydn2Pg+/abVZrBD472GAxyzS8zi4uIibAvUSvDix0bHpk+cUfgMO5Q8Pko9dkbhH4uTyRmFX5awe2cU/okE9Duj8FkJ6HdG4Z9KQL8zCv+7BPQ7o/B/iHPLGYXPiXPLGYV/Js4tZxT+uTi3nFH4FXFuOaPweXFuOaPwLzi1OOrL0mmFf8mpk6PUy6cV/pWEBTyt8AVOff20wq9y6sXTCv+aUy+cVvg1Tj1/WuGLnHrutMK/4dSzpxX+LaeeOa3w7zj19GmSyTm84WmFfy/hDU8r/AcJb3ha4TckvOGoL0tnRv0bpV4+M+rfmVH/zoz6d2bUvzOj/p0Z9e/MqH9nRv07M+rfmVH/zoz6d2bUvzOj/o368tBphS8JTJcV/qPM5WmF/yRzeVrhP8tMn1b4ssz+aYXfFIw4rfBbMjPLCv9FZvq0wpNS7hWRWokOpz/Cyi2mWydVVVzG2qmRmVIRsFbnUQ16j1+zE73KmbZ5UlMh9nl5Uq8mRxLr2L//KFPsI2ZUYSaXIyZN9/gYH3/MhvRP1fGnzh3F+BBDqba51F8vLpZoddmq+FfNMcblqvAyVsMUXs4vtvlQH381rjcOJLRfyibaJ1XFgdkmqzIxr4oLxLx6MA0Jr1AO80CDLmNI0BQntRwhHTaujhrCvovmOPhiBPV5HmsAMcMlxic1q0M7fNSkO+YEbfeqY56ga9gxj2kIpHIXMWF4VLyMIrS7eEfLzDSEY9aYQCUSKzEREqMrF2KxR6zJQ7ScMkgE2uxppSUfBDzhm3ucY/BxWKx6sX0mp5uECjyuF9xY/zhadkyayRPUoPoV6i6ohZJjCxChqUmUTrRlhOI6wRaudp+4HYQQkRRjYazPhsMhRLtbrCUKIeIYfRBXqM4yn6OaaT7rwGKqDSEiVrGAAm2XbZGhRnsyh1YecRasmf/5knDkZ+r4W+OCIzQzREPRVC6k8eIAQpZXIoFDBeECpU5oiCg9hAWx4FkuwcE0CzXDSSdI2+Kkdg3UXYl2FJSxeJmpmTxiQxGF4c48ymIO8dwxk6ih0S8LaLAX+5cUMZllbRVe8aTWpbX6SluoWQ4Zo01h1VDivqvzZMQLLgMNo5s69z/FyYqmMxDPtgfEeKUOWc/FqCBmFXEGadtMsr9rCJmPBsrWPjHEFylNEh3BOkZd0WVPq4zWWjkq0L09EOGL8R7WlEc8AMJSjzjjwiCPg7cdDGd5mCHEufF2cOLZplMYx2XNxvfFfYZ9KOrSv2QYrBCynbmBMUh8L/Ohjec6qXywk4M61qnXdbYCKesp5IxEq71yBMa8Ui/2ATvYRaXAB0yFDxhotKj7P2bKpiFRtN47JqMZm4H6MXzILwmo412LdhcNHE8D3rMJz8e/94axsdswA82Z+fmh7QiHbS43whgz4BxhYwQSmpAWkZIhKFjRHsNGmpKYA/OME9aNy7jFLGowy6oCCXcZ7swDVFBA1OIAYRxqsu+XBt4j2AYJKmi0Kgigiar4d4TbNoUNEOJDtlfxizkqNtOfIJE3mIYazxhJA6xHyGipU/U1wmJfLzdca0nlbCjWhKz4d25yJg/NAHI+OtqqWJ5mDy5Ja6jhKTbCZZdNjtI5Q9KExOs8B2qssmT810CSm76qVW7iUFSegrDDVnMFKi0qBq1dr8LTiaqcSGESTR+yqsxgHZxTleu8Z4g/6VIdsxkSyNmRkoGe81KHpG2Si7Shq71Isx6C0hmlJ/vzYlq3LhdfrYu0cTUOkUrw1lJnDZM+RPNEBVQZpoTAMIHRLraRBI4aMwrIeUIRkqdcmR+ZVq4mFXGse5fjlHi31nBxcTG5mi2IqNE5XDR8BJJDDYuFjmmLOpV3mZytiSGlRbW5YyYgxYkKE4iK7y1r0qCFEGoLruZb7ZgCUiwqLLhQLoUSqEG+ulAGKWYV4fhKoYwLjYokkGJS4SQV2bQ2rD0v8RgCGONA5gFs4GCRAS3jh7SQr6MMnsyMYlbwm6yU5xBfHKidKqKbMfrZUCz5FVZGGYela8gRVwBFx9wBAS6pChrFKzrXHLlxSLzDFeIdZlEK60eO11r8hBW7ESM7zz6gXUxbCQ4gbvGHN5h3h7jvqXHHPKhXEXhQx0AfOyTEJBSKv9J0stJ0ktU4fhMLgBqVxKLz9CpLUiEVFizHipD5Zcfg21gNJPq2lUxYX1yWmRTfcwFtjl9M8bTfHOVxijoLU/z9N9DTx0db50rnohmmMfNEK2mni0RNSVQmnM051JTXx4cpR9WnBpEml6OdpjfoYDCMmcanhapttqyyCwzYJCggTkFLtLWLQTNRIgbSblVKfKITSXmzIdM2REpmcpWmqNL7tNEDfUi8PG5wHMxYgWIX62OHXACa3WacOQ762A579513yjzojinMYHh4ojj4Aai1bpd6k/gMKjl6oc6yWayoV5lipI0Un1lHEPxaii9uZgh+xuqEmMunrXCXGieJN6OdvYz4rFb57W5oKRNJFNXiJHOBmDAHR7ct3vcJr5gEz+a+wOps/z0J/LyiKolaEJeCtnIRrtvnNVUrm1HEJ8TRKHjUiS+JPonGFTKjIaepqwJHJfi0qpBYqnXFaZGkhdQWJzUzc/KefM/BcyoRqD2EOMnIRS+aIZF/33weEFHvUg0FejcXZ6UR0K8LJsHim+eOH3kYl9WcOHMQ08cm2URnLTauYvMHUXJz1FALNbCtsrbSb7D4+zIyPhv8XUkXJ4n/BlNx7zi0hcViZ4vVb3UxGFlTsTdeqVOH6965V0xzlKCJarFFGyvHTYp/w4zonxh8t/82j26bizkIQEKcd3FaOzPUQ59VjfLV0Gw+baspBSad0exgqDhYDVvaVhIm1dCNBdp4QPdZHWOxtt9O46eAevCixp/wPQjSx3OzkQMbts0dJSv5L2OtNgk9HPLoNmL9wNxMoOl1xeL/fs1em7bnahJ6ax3kUC+mSz7mV23T87YDPRdAbf/wGNVtRAXjqPa4c1plA+q8V0HWKic4aGyZwDjxW+Um0MJdlC1aV5xaL9E8y0k+OikLjhlICDBWxsGrQrWOmOgYWlfnCuowsd8ObS4sFJC8LuBI6Zya3BZMSqrYFhSSSrYFCceM1100t3fM9SBxRWlgG2GyOMVB+BPmInLYwKaxq6CQUjO0rdpp2c+ijFiKAg3fA38LQBFCM+ELPFa/eY6381rbTLkMgqoMOEYtb+0ZLut9wy/obIFYAoEoFnRYp7touvQgwmV9VZ5Qa8Q3RLnOct5UFSTFjjKSB+y9yfWlbTPhewkRRyGPsoxfsPQCdZpuEn67RsmMkxnXo7Hoy2tQm4eM2B8Za4Q/Za5iVnfRdCEprpR3C3434FpJ+E2KK4sZvhf1NoMbgl2wHmJO1jhMQMxo0GX2O8ZgDmpod81TJosZfBjCwZc4pml03J27A+6Gcw+X5xJ0mq8zyp37cBmlZgAxWp6tWpmB/zwVQZLtnMsMzt0B7yvPhSbaquSQXVXqAozncnYvWeBQ6+IHv5npJJ8u9Ss4d1ugVuu0M3FvggA4IMUdcy6rIINmJeKxhGOsiWt+BCvGYnLkFe3kQbPj8Zr3hk1IaCBo8kIRF/0a5JWcDkGdzY1y2lhzMF35ok7l6tiY44gCYPfPz/OpUB3CZiiW4rEsOhfD+r15wljtkToQpOYY4jl/DmHsKjudNUJoEFqNifXWf/vDL/+j7lGWZT5P4qWMESDHhmewEWzan2s4h5iXCB8wXR4v1UewXKmt9uraamtqI+g12iZZyGvyWjC0GokkenJS7HSGHaVo0YOZmYcY1l8t/pHIrFAChV/8nOLFzyle/JxiIsGb//UcUUFs+e6QmM+TsLE4pZlBMbmCkBdnHSxYqO9pMWBXBccekZLb6A1UQ7PAlfDXyp+kplBvpPiP5xGx/mSCH/G+rxI14uUEP+4DH3yGN5SvaPyA98b8hzdSxudjfLcv8RGOlfBbtdErz3Pg4SdXMn6yjh9dj9+NTzSHypGIe0CIX8bsW+Vy4FDx9WGYB0IhC/V9IssqYktpqKgIz8q64IlawRPz/xlPVIrv467/9cpo/z6hjK+OMv6D1gMxvA3kQKE98g64vUf7xu2VR4kQVSrnP1toF3ycAfu3IX5ybKQ0HHKX6VY5CkDw+8UEnk980l8Cfu0c/F2N7x36uRb/otN0zhjePIk3Ud7hd0TMSfqi9aTEdKZ2tbCfJCQyD8E25qPSAzCYdEl2WHlLzq8M259N8JvpI4FuyGdExI7N2ba5dp/1t7TfcsxuUPh1VYFtm7ZLOCbO7pYYtAYQ72m52H/HQMITGQnQ79hdJ5j1Tn4Qi6PwDWwXlbTNEfZYUK4OQa9yaWklDDm7+SQsHxPj4Yz3ZtYQsEpp5Ole5jjABMyCG6Nxlg0aNKcKPn40LEEErNQRpwjRBxZMryMGiKd/KbN1Bhpzfo4xWVhRGYKBsQV2SR0dPPojRk+Eauy+Qpz00dMrEedoiUIK9WJ3KsZZPbn0Gyl+ZpyQ5vkIv+J91X/9IualVjJ+iwN0/80o47tpOdv9dsCHO6aLesExG6+QEGMedL8KgYSqKt1GDN4rHI1C40nVbaQodjJfEd7UKbQLPVDYmOsS0vCH2Pa10llvXlq4oXfqVXaa48KptpmUuBMazKz/xt0EnlB7SCx57jz80gQe0/h3Ith9TetkMMKptRhFNBq86x9jA/NjEZvsqH3e3XxihIxt4l48psgHCbGAAAIs9rdcCFGxizlH2mYshD185NTQJVrifISVo53PFruJrnTFHnd1wzydPCj9HWbp3Rn+hp+UP2Wi8eFRxm8meiNNiKnEu2ui5LiON0hcyUd1uS6YhnX+owuwTsKtTPQqWh5lAkFpoVmG4lWSTYmRXQra1fawsx3rOdJdOQeLSspoFSeatI0as9qogONlRZBCrduDEB86PQzpGBB7UpMvsnTLGMIyh5qEbA1I7CuOa/6iC4iU5Ejcs1XxS5q/r2n6LqiIArOvAOq0HOOwNxK5yrqg7wqIKwgW3ASMEZFkeDYghTH6t6dVridJsFuOo4KiW26EgvoxyTFd1ouaNgALOYxTY+dUqCEvfllDg78m4z/waHkndvUK6pBXbhOcQ/3dOAcFSVcRRLQ3EgnpwiaIaeVGC3jFHJ5Yidjl9566NwnIXzU4aKCCCRijDWkMJudaMhJR2/EUEPsUcj8rcSjEwUFIKx6yaJTvNZsyk66BUNx3OcF1jB36F1wBNYg9mLzFd6scZ8Wjgrw75ya6/MHKGoxTexmq7WqMLpfrDCxMeMGlXsZgPV+3fjdbzcfshbhdZZBBgsUCvwcJE7EcMnZAghxCXFxWa4ESQk7ASCqmlMnQbMLyoCoIrrIDCMJhE1aasKMm7NomGmuaCKFBdVup21ZE4euiyyVI12DMQ1qkXTbqCmdFzWmHcZESqPGXy+wIyV04BLtmYwPdhWABONMFXRfulWi6EBT3snQunytmxwOe7jpxEoLvJGu7uo9UFXC4AzYJDlOwhXwPhtunjhWPauLC+ZvCJsVvbsQfPwc/EOAnvC7r3edTxj2jDGh6WAYcwAiabPq+oTfkr9P3an9uT4Q2ZLXM6mB1mt1DNJhdLbG4vEd7z7Zwp1j4B47jAXEFZwWpGyqwaLxDQxjTMfewEulR/qTDFyL8c+HzvhXrsVefQ3p+wKyl3mHXBdjcz2cJal+eCLE27FwA4dADZhWBLXYNGQm9P2dVwjWOPzSyz9l98nmTa9keQ0PIwWtM27yF+YoA4l0ua7kaNWPY3dWFHDkSIrBdF3VMBobWVLdjEpr9Gsl13R4qyFrepEm8TTLHnxTJJaRERl3MiLVimt3v0XLkz49EEHrjUf56RVgGWY1dH1kS/y8a6pBS4RhqlTh4dFfZg7YlXHTbvHWGbZ5CglBNHPi5F8XeoQWhr0CCXXqPH++5mXio3sPGi11ni3ebkrawmuS2zRYwxb/3RSw9KA4b2r9C7+rEjoC1nh/7PcZFbXNpWYeoba5kD2kLgXfhitryw74W0cjXIio+y5wLarxntJ+mUJctm8bhHT7WhBeyQ44I/4D3zQ9G+J/9vvlR1hTdt5Lx1Y2U8dkQf1YYYLwrpYzPrWR8skEZx0L86tbhh4z462vebS7yX8lhMEXiFucsqn0cMHZevJYiAoNLVoPOjkBnaG0T6CxxrHUIIO1VbOsZeVedewwxu5fKxnclf9NMXFSStvww2JIR2BICW4P2kVVga3A4ckPYMwQaIdEaoOk0xS9xYLpnLX7w9asB8GejDEYwVuL4SJN94m3bJtmXK3wXv/1LIwAPWRletjfus9ONFL/Fge0eG5U5rFnkEWdJ9oM0vQo0Pr+ofd+VBL4wqG8X58sp8Zic5GgW7FKoweDgILGgL8hrll/aLIZiGFTI1AjEd5NaQIUPDR2lNqXpR+u66f1q8ykFsR3w1zpIyBI/SVAzoDFjN1dd1olDdbW2UvjFD/30r9pZV8zYaQzKJtTaKsE/ef/73hWSyFFrK+vGsVbh+t15ACmqWRiHOibdvXNQx6zr6pjs5piRmEkYKqr0y0f/4lPhrJtgjU4in8n2lVusM6bg+O5cQ+0ilUFtqxrDoj9P+9mG45TXoLzmMG/j8UM74MjD8la3rEMNx2mFUlfTskY184Y40cq1P1WpiVMES801NHPletYEhLAe9QLnRnLiy+mJmXId5MBOCTls8N7I/JUCVgXVYB2sl89H0AqqcWBku5s/blLMuBDWzcknE9dxsEWCwKce+NTv2Fkqv4FPDAlMuaFn1o3hwt48hmIGxgiyh+Zcg4OPwfjeuTyW97989C/u4i+ID+/+wtJdHRpcDSYV1Fa1tNNlrbIGYzAJWaucpHIEqAQaw69tQjLDAEx2s38bveoyaWYWMmlB4ttwH4lPy7p76fdq6lTKhrpJ19Uh3N3yXSiT4Zs7+funbAKRMXTC3bSUtyolpnTJVmURdrOxRloWEBIIQohmYL0/ezeooWjRdDBQOWR7fbeLcgM5oVYDcmoxlWDVEEHCX+1IMKigjkG3eP2Mb9FFeM4c+yVxMHZM+hy3nA+Eo3kMFyC8Wp5F9LPK2yTzVST0s8q9JKL8hp2GBh+tp6jLMUgpM/WambFcZ3HK43aNXEuXx6TLGRHcCxRezKdLhmrxfV8LnvP3coUJ1Itv0caR4pYKUmzTz1RVvJHaG7PE96dts4WbzZhxTdum7bsVibc1q7mn/NnExdWUgmgmjwjROTxe3jbZbB7BRkols/Qk5g/87FDbTCKGTlYMjxTEUHTYu3u8w4F0OF5QDJMdM0HbJsdChgRU1w3NwXbl8tGoendnrvG59fjpFrF0v+gjgcZlE2JYNzOf2+EhKMf+qqGanec+G+bMcv7EFO9ZTQjESCbnj02RVIb3vZbqfVHjcf99q79vU8YH1jSUQi4fcGmmCzoYyCxY/xU9jg/hwpl5O0Ajh7ghKmwX9xkW5m3FYcrYnYCN1FAV+9Jc+f5Z6YuAXb5MwMEjOhKlQcCeTkusZOI051Htn2Otyxxxkvxr93O6ywkNwR76DSXdpUT6iUBOJ4uui6aUfGVGorwM7ZLYVs5zmnVUsx2zC2ocPjKGuqi7E++/iYfm+Kt/9b3OtIaRPIa5LTEenhAN06SLi/3yvRz2hBrVSYJ+OHKe2gcaYvGFCiQMXsgB9K4dBc+7ZqV/m53h/r0VNUnDZciglGgo9LL49vrQ5xAR3KPh96eMxOvI2DWLUgn7ahGjWIap1K9QzbK7jtzamY65DMLcoCoZctdDDYMe2pt9uIAbiH7wfan8MC+T6GDzHXPlaOhXel8wNlDXqDvmMnE/sSlEgl82/T0trkm0U68K5zsrpt4SnUl0rcvLy++8ygfciCDw1iEDCHByoeQDRDtNmXeAvkUsqO96l+2ljsSFYgGX9VyPHtuKjZ0Xl2LGFrpZ9ajwdtBc/R1SYtXjyYX5+XlxI1LpKp1cushm8yuH/uEoGBBLTCzTGPluFy7rnURsvPukGAjKwZepXGQGJDXKQOwtcsTLA2Gt4UpHzgqxmb6ZGCr+BCh3YMXlyM56Xym1ijP0soACPXSW3k3vr+g345FdWrzT95Ql83tPjUTsoX5SvruwUtOPEW83tNVW+NDIVvveUwrXs/H0KYUb2Mb6lMKNbNJ7SuEk21qfUngOG2KfUriJLXZPKeR40A+dUriZrX5PKTyXjX5PKTyPbXlPKTyfTX5PKQQu/IpiQszRFMPVGBb7oAkSAUh3WVfLPgajoWr5vDRq/uC0diE25lyC97mei+S7xRCiXZjvEb7QXTIv35qO+APVzsqHftcUicBigzP7/y973x4mV1ElXlX33u7bfbtnOsmETGbA1L15MCGZJJCQhJCEqUkmk8nbhADiuuMk0yHTPZlHT8+QaMg0IcTIRkHEXUXdRVSiQBQVhVWEKIgvUFCyIoKAoPJDdkUReeTRv++cU/f27ZlJeOh+n3/s8JG+Vbdu1alTp845VXXqnByRVNUAfhU2Gi7dXW8Dii4NZ1QPZ0TDaOlNEkHeEPBLkIupPF6bh0c03wcyypXO2kJKv3Mf59FBdFnAa107RLsxQFQz7lX426K02pQM1ngAZjwTwlqsGY+AOZrHZkiVKHJyU2xlPOBIl18uAHVRpOBxA+Q12VI8h6+H5Ysc6HURdO+g851yPJk+nga5WYanUD9sdOVcQlowIyi+EO3uZXzUebGQDwkhY72Bw2REnL6FVyJzKaCTTv+QcQo7KcBdFX0fyfChQKZgjASBsvPaP0ImCBiNbVOjGgTs9RX8bXcbKEDqM8a32+1e4GHOuSP5ZKCeAQ3K0kGmPtEo9cyp53wQiAc3O9DuiAOJcbQBwXB8LiNG6SjuzEYTK12ebKSwrBQUgdcVgD6/OCxSDUfBwJRmPZGqQbzQIHsbgKxYLEZXU0wfMoUrwWgyxZxavNGa+heug6pIWKWamdS/cMf5muAJ8tOqPbHoa78RZfpYgOc8RatURsbTPtzMLOkMpnYt5bGsZ2eVMXAuf6+krTMoKqMZj1E27r1JO4MJqV1xYiKY2lwV/AliobZCpCVAWzO1t2ZoFjGGzjUxx854McxMZLy4n6mvSVEikfGS+u4OCmSZlDF9xQztVqQtraxngkqd9SxdMq73q81suZ2V04t3pmZwUBRLYfcJYYay8ig6mQG49rHIpJXJYHwHGKZ6xjIl8zq650gupzXdDLmH5zxnoSsn9A9SzyQ0LjxTHfkU71SpfsC1BXm2Z6j9HxOQB8NCEHqRjAeI7s94GM8UmyQfvtCkDKp10U2A/z2jT4KQHxh8kT5xg088KSQM7wkKekHBiXgVGAuO1O+JQUGGp1O6YxnPlAC9tAiYgFugi30fZf6nPkWdoCAPCooS1CMVFEFB4+RQG0FBlGYymvVO0n5DUFqdHFAVFGw8OaCNQcElJwd0SVDwvXrz18foSKXfG5Ruk0xGTlywLSi4CRT47AlpbFNQcDO6cDphwc3OVH39vuSR2r+dX+CZcLbTjaf3TGs7JQfVkCvDjG7IuwZ8F1RZ/vK9+PIpBl/uKXvrjPEhS6GplJnaz525xKFF3o0og5RNhCeS8crLfoj7u9UwncfgPJdlVU1ixLCUTX43U/vx+KIswzmTthyBMXqRTNnbD3F00Dkkz1mMywoKRxHyrZDSGnUG3ewYqQ9zFCA8dTUvU8nVST/nGJHQVKUa1LAa6gMUmcogMU4LI0SRFKls6SDAcaaA3h0qpoJineFiM6lYgHAsVobRcoRPIoSLMuQOyXDOoKV/WTZgdXie81mB93MlU6dlyZ5EIAtWEzAJmoN6Bz6iHq7EgGcCq0X/4hmPA3HC6wx5BlMClQuo71SqgIY+n8FPOTAPJs0FyOI4MGAoWotFTWlRJVhUwPTFMugBZQHxGuDE+GPghzUEMwpD+hC/NRbghGdqPEEuzQAGvwebQPMAdo0/jUQCGak7Sf3YTKAucW7ykVTPWuGfCR523oDn87ygewSxgAGiDhEuebj7bdQniinpDgMfy2yiMop+JB6oaTTDgAh/IDiByDX8hE1OshdHE438cfRIQQuG1QyGy8f1kjLsUmxvI0NwlUpNpNcYzl9aQ9BlOHegn0Y99CHCEahBaQoLhhhPgwNCUzSDg5foLkJ3mpeoi3x2EuaC9gdwhY1apdZTgDzJLYW1AIVfZAEKSwP6JmBUw2s9J4YTJnUNd/q4GFQmHbD6Oo+y8pJlaFDJa1lGE32m7Nq7dj9q4CYGBZUqq0gDJcXc8tZ/SWhD8goNqiYDTTHvpQITcCUckB4GCbeISIyA8CKQTfMQqFrHEjeI7CwaP4MGm8MKRIRG2SAyikjkBCIggQGfKkqzBElCUV0GUcZEAnaJJkvnNsFjgz7kGmjTB0hQH03qeFRn61nkzxHdI3KnEEwZv9+eJlQ0gqJ5YOmOE1ICEoI1OvoxDmaaTeBqMkVrKqLFWIhXUM9i6K0hnItMSRrEAyNhrgV9twlZOEd8ygXMbqaeuRSbPozbNkKjcu4RPEoMmYCx/J6/I9RzPZQB9w2PeGmmcR/RZjBMftB+zZz9AlFCnUn9ilKnLWLxZojjRGlwSsRhBR0gChQhbmdRr6LYX2LFsH4mpo27VD7n52SJpL/T3FmPbiQkQEpsGXhm+YAsIfgnwkLQHgyNvNDzRZNOOUZKaMbsSIAHprnuO8oRZVJDEcKkEaA6EhCvUcJjmRyIIvFnaCbYAdpIYkRDaIsS2mwtYMNE0kCjUi5QNxGOffxbYUEnAmZCc7okYKlCzc8952oeSLjzSAcwNDsqzXYd/5vEss+LyueUX6ShjB2F+uAX8IXaED7uv2ZOnKkClyz1Ee7MA5Zsa06a0jYvISY81PWIOUDfLRjpuzJmfsJPl+AFL5UimWL6nOhMxhov371n3zU3HCrwXZ6YRxNuHrODXRAl/c2whei7RclsGQS+YDKkCMJnCx30eqhASoFAWga9SA2tQ/d9WIeG9cjSPfLxeS13zg2LOPuN8UnyjL5dPNK3J8dp+PP5/k6TrTsyHKvzAtkYRuZZdOMO0DmVsbL2A6k6bwSZbgMKV4QJwX5rMh2JotSBfm4M6i1Ei6rCHRM72GjDIwXceA52El9lWWWeYF+hbIdRb+IzZWdckrS6K3cbPK5jEBHuLX93KxboKP6mg1knUh4LNlTIWHuWJ/ztEJivuNlmAhGadUJ6dsbTa+Pgxr4XldGRtiX8WtDvlr+3kfWAiu2T7hmMuGcx0sI5vGdx0hW24Yfb40AmZMFKO7IWtDCDp7wI7hx50YwX9zeVfLzAwmYGr/bsEl6cLBmSRWUk60VksAElbWmH+mpkKZqvISMZDISMxmCli/+SKQHjJ1TKXzn+RPDRg4pJnnXjkqvLOl2HrGHyXiLrJpE7wrK0Qj30AkP7ZvX4s/gQK+37C5L4FdJKfZQuRMIyOXUdsSdYrdK5VSLjVYKATUkmnYxno0V7TDKZzHijgB2PRmr3xsBzVTYznZFPUG8sniV4p8DzuKwyOjPwzouqWKc6L6Oi/V41nvdn/JCeo6QpR8uoGu2/t4NXp0hTjpNRVeu/igavQC0aK6NZPz1GmrJK2kG6UpoyJav9tFM67xA+N9gjeFLjM6YRCZj10eiU0Hjf7/DBHoZG543QyDMeug9ISpvQUwF6IOHWSwF6vKgykOCnM+aOIuSNxmjBUdpO1egjD/dj5Ogw7qiXo8qwUhHCSgINosecDAuLgcaeepEuEAPEtOqqZyyrb9cSYwPsED/iGf9lZo1zJYh8jSBPaIIbsXxAIXhGmfXI/xdSiGeVuorb3oR5Dx0mltAjzVBHcSc+6Njl5Ns/OBswSWZauiZfR8jSzQDtZjri6xYZPIzzAz34p7ho+IinX36rYftEfdpaEi5NWrgcbCzyK0KiSB8kpDRzFyi4mTRAVuNP2V76/KCWYTXY4RqGffhfnEcHRcMIg0lKI/PsYQPqxUhr9QfJI4Rmlie1NFMiGER1WScWiWMRaazAMnFplaUtTXx+Gq8Gd+rzzBhdFhlSIFKWjug5LI1V5D2sBcQud41Sx8wh5JX1yXGNOShNvy8lEpZihaW44+zh+lo/RSrGq0upf8OJWjp2ixCurNBpe6Tkd1XLYpDNKM2tbHDWaI0kmjOeGZLOzGFO4F4Nz0b8VvWxfhDxmFM8WtwW9P0GhZwlhqB3ULUjJ1G4VxPuDJ65aGIvq9fKeFa570Oniu7ikCqG1u41jvMNgcEKQtY1JsWJwhuGGKeAblIlTVqAM//MRlLlqNGmPsWloQb73JjidFavjzE5OW/OkNtHaeLeaepTPGSXroNVg3KhMc9oTuIlE1T7bWnJGHKGrBd4C/DQyyZfU5sd4quJPHJIm2ZtpaN+f7q6ebzay9X3z9C3coZm/HXmkIyfDs3445jyjIfIjd/fjjdAUcnmhJAVCZAlAVm+whAZ0qNfMvXHsh6FMqhHoYyfDs2gHpUyfv136ZEXOUGfeDkBoOqsPa7LSKiTfEgn56jHyvpYSlMXS+mfDklTB4P04nJbGyMkJgQdr9PM0TMoO2T2RBnaZThRcsUBv7z0azpxYFlmFrIWQUscryLSFVvWp/iAKh4/diSKJnC9Gc+P/VP+hvdmyCsHVuT7DGXDC7n+9ycsMUmXCNV2omrMk0BzMR5mUF8osE64jJBGbwbevBHAI6DAOUo2PprhE6wYZ7VUHaQ8kcX1wYR+Dx14SqaqByRX1QN4e0da8MbqAzEFS6IBXQM9eFYW+cSEfi/SB4JImvC1MaRK4vUii0d9E/o90ScFltXVWcPfpPyG6MHjWZQJE/o9s0+a2QzA6ZfJYs8m9HusT7JsRrFVtc73uMYs8wwASRteVQ9kQt2vHqCGB/ugiFAF0VKrqvNk30bIyuA6qHd4uVxgQhdAkgnAHaHaVD4XWNYFiMwEmKQ+0BeMvrDzOecJromdnYzYYbCEFOU9U2LbdzIjdo/RuEuh+zZyyVzQL11Ud+0E9UL//G55pPDY4Q9G7N5mjClRUjrLmAZeNET2h9EFPajQszRZFC8/Gu3NYACCDCUkV4XjV2zvzZUbDGk3wiEzRLKm9A1/oBGB9yYypIGn8qq6H2TEdMY6ldUPqucArMlTeW0iKXRDEgvxTmUNoF+Z6UzI6CFIZgDKXMhDMwCylPPBE4RGI1g4Xc9DVlmHYS0LNvnWLW2nrAVtrrwSUxo07ro6M1ydlUF5jwE7Ut9DD/Rl9b0bp4kO/HcyBDFCkI+o1Pd4efcqHfX9Serq8er7XB2ZXgrRhobBdH+HLpGjjQ/TahLdp4uGjCwtvETOBjw7TxrPoGT4FA8ukeOuPV0iZ4EMjOONA4xrgeFF8V6OiTHkYv4tcnKwi4ZjQtp0hdzfrfCRgjccDIzHSKunPUX/Crmzgk7L0QETSjgmjbV64w4plE63ONp2cT1paN1DBqEqsNE7/81WVT1AJ2cjVWoOqfTCN6oUrS65OnUgV6pK5yUGVCXFjBJKDKn3PW9YrzWgnsJqjAE1oTdc+6uYnRxQ0RPV/iawyoJul+F3GFbvEOyEvoJEheMwYVjRGDcjdlx79VK3HisFKh+Sg+oMV1yxUhyooNRtoe8MDT7o/OXJE1eQuoOHHvEG+Imaun0YiLeXQNRfBSG6gjJ3lr5S958JM/MOU71eH1xHk4b6gl8EKYe2ZMpGAddteoir88hhyQk2cXc0C+doAT53GEHiYm0TMvg3Zi+okxODiSgzi1wmdTM/MZf5GVfPE5f5m5r44kmaeJirf6n/25v4wkmaeIirT/0dmjhwkiZ+ytVBauLSN9lEGatHf3x0Q5h5olw5jfRmTtzuT7h6fRq2+7632y76ntcqzVtp+kGurpp+oqYxYJV2glfCqjVUvnnA+qlpq7xp62RNP8DV9dT05Xx426ShaT98ZhgEntGbSARChBSekUHgJwfhx1zd/HeYGTeehKZ+xNU3/SaGqQ+6k9ZInQx10Tq5FvFDrn508iYyf2sTP+DqMWqiGySQiXfcTe1LNlBHdOQMg0gmhD7hXxSKDCjQRbV+EdzEHiKcwypp19tuT7trLNmPl138PoGx75nM141B94bfjE5qPRpWBKhP00/O+YngzqAfuG8helBaTp5gmI7bZ9N6ZE6nGw8NjIMW6YZ0/B0/N+rv+Xk2hbWdrtBRJ5dRyHVNvEe9zk1Iw8Vr4ZM8CyeILc0sBcyUCe2M2JRWp4xIuxOPeVidqMO7NrGMF5PxNUmOB1VeRDHt3GmS3rHCsDNoVT5dis41yYhuhy6W4x04H5rw1rTVJCNNuSRz1J9mqatr1QL1ODG0Skf9Zg7keH6O+n41pCcG6c+Og/TZfvrrgsdOgE8fnYZGZyy0iRLH7tueiQbgEXQdacr4siTHW0gxXcckKejuSbQU2ZFwLY3ONeitAZCVdQWaceD+ixcNrr6Yfmj1deR+GPDVSfiqk5FObbxu4Zna2SKhmIxmD+7CCBT2zka574B22mMrdKIjmgBle84EBDzO1A1DcHZvkKXuR6TdV8ogrP00yNhriOig2FUKKkw+HnW3qz3oa1LfzyP3A9KLNJF/K1vj0yD6QnwsJS9WTcO2jrk0MDy1tDKw3jhbpED9B2ScLVi4q9pYeUVtyHLN9zaxCl1QBNXCpMgebJR7ZeTWgmc3FovFYuUVbqyRSfsyP2X7jfOyxm3dvCcQADR8iuLjzhIwbwauSkd9D9H+/5i6W2P5ahya50sZd+I4/CGUgSVeCDJ+K4Q9yHedYBR4aRRoEHzUC8KKRaiP+E5MUp3oTImGZeiCGPCXPYgHrn7McBnReKkiW6i8Z2S8aB1dvgCkyBje6veMcrL0bGkHOImSG7rwkJW1qi/DCBqJoS1mPGMoIdAJxQptPMCGVB7g/QNc7S7D+75Sxh2I9w8GGTeJYIsYMUteTwDXxGwbViW5uqbIXO4XMZNMXVdEs9I6UUV+lmdJ0ZxEcp+kuH6aDk84DnM8ocQK9Hqte4wj1rmGhm6pxI1moDwcPJA0uA9dJ1bhvcxSP7G2UmA5ThE0dYw5dHx6amYuPFC9rE4sz8yFB+wKRrhoKOHpVq6+qD2NFGdAxtdKGY9gxu1BxtXllykPBZcpDxWZOobRKe4qMnWcAqMEeZ8L8n5QZKpI4VWKTBXQw/KdRaYux6fbg7e3BW+/UGRqNz7dUGTqCnw6FFynvNfkSTpCstHBlOL9bpKubaEJikXXEHOeg1d1MNompmPK6Myo3QU74yWUoL3BhBpND5HULzgqPmhQEpPOyQpHU7/AIF3o9n1FLYzQGMXxwmJcjiHr+rjieW8UQDgat+JNGddekuMZH6KkFDrXCOUmoPlMJqP2FWTGq5SOTGTQVgy9jcUyXgr1U94rU2qUhp7ciI3NQC+YHIV1VqIXU//LSpnIeDH/y1jpy7gy8l4qE/RfEryOrBypfFRSI1w3kpRVIxfDGtGNTsaNy6TryAQFA6BQHxhJX1bopkJDw3xss2BoZAVxZ2wXoznqD8uGafiHwMYBCFiTT1Q316rfMPXbqUjV/1tE9MhbIaJH/lGJ6JG3TUSPvHkieuTNEdEjf28ieuRtENEjISJ6mqmjRESf/XsTkYyknn5TBCSjqaf/YYgHCYcj4Tz95gkHiUYg0Tz9RkRDBPP0yQiGiOXpv5lYkFA4EsrTb5pQiEieDhHJ75m69Yz/VU7z5FvhNE/+wxDLEE7z5NvmNE++eU7z5JvjNE/+vTnNk2+D0zwZIqJnmbrzf4/TPPNmOc0z/zDEE+I0z7wtTvPMm+M0z7wxp3nm78lpnnmLnOaZEJE8x9RHz/hfI5JH3yyRPPqPRSRGJxDJo2+RSCKdQCSPvjkiefSNieTRvw+RGJ1AJI++RSJ5NEQkv2Pqxv89TnL4zRLJ4X9EIjn8tojk8JsjksNvTCSH/55EcvgtEsnhEJH8lqmfEpEsxy1z3z6UYmYHZ/+WtiyjX21zjAGKRR6165L5ojNWX8eUBkBmqCJfwAynDi9KSZF6DE+byeucSP2KL2CcUqnH+QIm/hY4fnEiOB4dBge1NhIcBOHbhsPoxAEJwTGKbHWu/yNTn3+Ap24WTiOTTF35Md6p7AHJ1UfPwgeh9j3H4CmT9Zjacx/LeFxFYPDwUsjRbw2uqZVcFQq8pdav9GNXcXX9bgGV/g3wPloG798wAE+WVVTNNNaDgVAcqe9ttsDzqJ+HWpivnSukHqNw5DSSrgiGWFXmaFzJOZZQJrq/+lsgeKYMggUlskZDDB8GTyiLPG0ZUigjj8YbGiYDjUOc3Wh5Rlfi1c5eOm0zfCgQBGwfG8dVVj3j4TxF6xUyxfEPqIIrZf71Cai/d3iNFixdQjBgiJ03gOHJEWAwcdQNZb8tGJ58yzD8YmQYfvH2YfjFW4bhkZFheOTtw/BIGQxvhh6eGZkennn79PBMGQy7eoE1nByGR0eAwcgQt428LRgefcswHB4ZhsNvH4bD3HF+L3hkEPhVv2djGGj0cUbuyn0ugZHGIuhPS1UOqONGr0SnkRGdyngxGVVR/UY/ZLy4jMIAUyY9ZLxI6gXuRmVMxmUk9d8UG9lEVcPKyKj2UJeREe20EbLR+XusnrHgRjYLXN+hb7tSvhO+XWDobksbOkAb/BV4wI6Xx+msHT2jiDw+RgE25H8yCrAZGjI7I+nKETwZCxj6U5M2WcrzoYBh0BW8ax0GzFkEUuyV53d1SqY+ePtgZ0YKVXiad4LiUijsS4EMHN3vy8BC4dVuLQQLsqXWWQhfP3Avfo1fSaFuf/eb/Pg95d7swvb06CyCzSTXZTO58CLwYyIqqDsmhcUAhNAtArzKGrJF7SA3PIEJaVntZX7qPHJud91ZnWgIi4nvX0GdIQNf9dndojOjCoXvsow2TQwZH/zTG3nEA20ZKsSJQnXBo4Amy2tlyoBuvLXKxUiVszdT+X4KCOF7xcUQEIotT+p49dWSqe1zhS0ZHgs+NWEe3dtD18Vkw2TMFSlEpYFGNcpYWYuRnlJzKh319CT1+/Fqsno5pe9TTIT0lCC9by6kT/fTV/vhKZromC/hcf2Uknyl76IzQ62zOmErO4PQEfdASxU7n5tLFoJ1opoipfHgiM73tRj+ulIHOLMrHfXyFIDnl0wdpDAV/855xPdXqMMEmXTabnuAJ4y6P4fsfgU6z6NgRmjVNeBhuIYB9DXY65krtW/bwT4p8nijF093s+TrlWccz7hEVfd5Ikt9MqTIK57F4Jcy2kJ3Y3heWjnNRyynGm8rS576C/d4Ft1twHOt8yXOjV1Dx3X7WhjXRjYPxqdRx4UTc0VC2XjJ2l5b64mDPrN/p6awA5kzgdobjb17pbnHNaXRyHeGI3zA8JtUGSc00rB/hKtnysb92lJGIQ4ZHw0ydgoxKDCEZ5XLMd4BV/ZyPfbafeJaXJWxqQZrtPd5BrZYJ2wpAEBSPpWd9TiSHwodDVvj/L3S2DPPIKHDUstgIJCgU/NEleP06hi7aFSDTVevpKark5pWqjwhOYUwm2owIIHUKxwPkdWLf8YQKKhlYhy0XqCooHrFKh11eBZ092dcvUphEFrxEJzGhlxboiOu/K0Yod3DY3wMCYcYlUxJiYSguKXw4P2pyepLNWq8+m2c8PncTEjX+OlTGF32qxMsdZOey8xx2odNdm3lxNGxOV3PoXliSt/UV/0F25quvmhTW89MhHR9kP7YOyA9w08ndNupm4TjfJhzMTiRqYKNjsSloT4xejndjA5dsFQsdZwjSUlDFcxVvp80dEoWvDmoRBBimlGeX8rCUhilGeZSwc5AW5WO+m6d2l+jfsnVDygC4Ys2Hw3wXMPJP3gEY/8ydYilPiJqcFAMs0H7/GTSrMUgZmaulkZqhdmA41RmwRQld8na8a0vUmxVuSIZoQakjfYVGHWdIV2Gbxsq5tmgt6yTxrKkVaNvvlloBIIOszPSpi8ql2HXQ/6ZRVmbOn6RiSECUhnt79SgeNeGblj7v5HWuZxRJPUhJalcWGOhgC2rKDwpheeeyZlK5V0hYwgO9ifrcbKtmssxvUJy10oyh7xy84zrUITS0XjHgbuWEq6huJtQnIJ+CuiXA52sxBDhlatq3TESRpa5jhJuSg26FTLmRtGfuEwqnvcqNIoRCV4lRgjMekkQYk6N1EGNohkZVRP6ZbQ3izqkkDZ0xXZFwkCHwwtYAq9DoHuZmZydyytkREbqeIJ4Mbk1NWSMPKwXuYxLK1UQblxW6shOZf5OmcMcZGMGbrH5wFZpYA2KQwkQY7RXS0OcJIhVJTr0hO5XKoxDmPXG5t1T/AA/QlbIuBzd69nkghndsbqONFxLnkLBhKUlgVpkJY4guocPsFQnWNaLEq2AJkxRgXztlGlqjZJ7q6h0JMsqMSDt7LlcSNutUFxakmfzHoYUijkyIseeDIEmxvHhFCkzhbCYGocG4XAUBr0FNFohNKLVTUwxTXwgDGViWW0i4ciErMq4CZkC6FNUMCErIAuIG12mlKLxxxJRx0e8nidcWvkVScu/MYphyCjyh3psJrCMp5h6QActPT4HMp4sZXx1EmQ8Ucr4zJmQ8Xgpg0F71/DMJIauEyTvRnu8Os70tQMBQyp06FBOul0SOfvTs6Cu+erDVNV0zgfp2kQ2T7qfxxUfIM/rvUnyj52VrFfyjPOKEGIXH5TmrbA0uXVXo7HXi5MZ3kUoTSJzxXIK5LOUFIGFMHPnivnA5OaKOSTQZ5HcmS6ZjBL5C2kt9yIwkni5dbnnzPUdOGSlKZ3auaKOrvCCEuLUggSbJJ2mkqCVscJikXDQF1MEhbTEeiNZT8wVpwKH0S4VUFnTH1loWyhulcatuwpeTMYo/+LaxaJK838obrj4bM8Vq4JP+a2FxSj+bdCeOimk/TpYR8r4AWD2JeOqOwPjquuKTL2GZlHXFJl6HZ/2F5k6gk/7ikwdxac7fbMoEsjO3RyjqAqSHAZGkaDgkWjib6GUx9At/KAXkeatkt26a2cjv0xGCgdcCzXQVdKkYLRQwrpV8lAJkxz+WbBwKphZdXmhUNjZIk2oVZqgYBaNFTlzUDELxkprlhhUH2jqx5PVfePVo0z9gcLFqmMTIeOXQYYbBKJFVasaI9yJbehFlEm+vNbZI4bFa9DB8yhyLdnwrSGVopqsJU1LWg5p4ia5YJoqVjXKD84Tq5ySkfAas0Gbzd7I1T1o/UbeqgHx+4qkj9SSQ9mSRaBv2sfqxBzfuo8UMi9CVn1eFAMIktEvXjbIDLWOxJcLUd4tDNn0ySwQVRA5yyix9HGMpo3+SdGPrS+lgZZVVbJtND1eITiFZOGSpT4ggLVzsio0FV+W5OqnZ6tHatSdQu3WQcrwNaxYTEdyZyKjsmKt2aC+UAdlrxHqqvFBcK6qJrxNnvqgQNfqpM9xUv0SeuE0ipNPTgybx5tyc0HndRnBS9emzQZ120So/RdCHa7G2p05tLLYL5p8T+0HJdvlsXVIpAdSnxeVjirMUi/XqPu5eoG+mqU9k6wDRQm/8YzGQuFoMSpZgXiQQSamqfNx5nwA7zCP0NA61G7EICxwDniiKclqpDgo+cFdHjtAvl5zqlAwW5KsRg1KQ7JGue9AreOJ1OcFrRu5MrOwDjZ6KcWkgInvSB5A/hBXR6r9uyx67SlFE01VyYNL39JcjpFhjPIcLZB9v2Zm6pqysBghb7qVjnpkIrT4AlcHtJQojoGM/w4yTJYyndm43AcU6/0QXooVmXGNIMwiCEuBkSOZM3XYN2Hn/uGS+w3Sx1OkjqP3+wSohMDnTYpkZCJro0JiEm61wBqRuXwiUw/xrMfQ7bI5VzwAtHoDqjIUCKiGyOwBPlf8gIsG3PT5Ac9IRsI3dT1uLjB1++sUfmaNeu41Bv/jDX7V2jtXMDIPVh/HIkASH38dPgdmtud1WsmoV1+j9au6Dku5HB6kDkoPb/HSgaMGoe7Uv4kkr3HgsQwcBD11vXBcS3ITiyr4bz/WOSrCarBpbBCq52UgHMVGakqgMOB2NaEOSVNJvCDdlMQg6g+BPoC+uibBMp0xJ8LUcwWO7uPqxMIUdx4RPArDI7OeMYlRCMdTPRPXsbA0Rgf/c8WpMMQo+NDTPi150YmbJQ2VyrhcCTcatrNeCKxRGiqRSYnUjRjeGnfJcCVh1ImEh+H6I7SnAe+A/8gI+W2wV3ox3Gs1ZQQlaKw269no203z1IQyZaw243FaQtKVbpD0ZBm/UJoel1EZy+KeiIaiiQKfqsHmJNfMeDr05VSS61Xk/LFOzMKFPAZWReSfSrsXKX9PRwKS0Z2cWIZsAiAzs7CYlKCCnas540KiaSBfTvEscNcwZaRuFDBnpxo2cl8YoEYMsVzrvIvOt1idWO6htsNzqEPpy/q9elOKQBjElT+bh3rSSXujmBMHapyVVfEWZ1BzzW97RuOcfQdUsbLXE6pY2WzupJscXLKlTP+1kZj3M15ccqPkqU8I7c5DNWRIN8OtYKGORylkA2qBxWLxA4XBK5D/FgqFF8/bc48lmeN8u0pUDfJd6tdz3RjMcZb1rEnAvX49F1QqS83LuGOlpeZn3BTRFN3gMhpkzHWkKStRBYn2rUgKSGXcSk16MQ8D40TMBr2+i6DvhBh67cEjdxlTk5tBWcAbUZF6xtVkWNVE3FhC+LGWIF+QW92YG1GTlyHlmNLJeqXGvVNWJG3ae5CONFOfhM+TEWnJGPQCXfiZatBNAlzTGU99HChQxuqZUJOa4UkZ0Ba8U7OyblJxd5QDM2yuWKWYGweFZzp6CJZZL6YmrMRORHH/zo0qLmN5L6Y++LAJ8gZnFjpQjmLrMp5z4/A997+Xa5NcRl0z/CH0C7F0Bize0A1RBHcloiWAowHAkekMSMg1ZRRAjwDAIE1LlwUzKo5zA2AU0tTnDbgiH5WMUEkLlgXQwVGKuRUJAwiHXKooM4Nfu6NwrjtuhS4sKxRbkwSJWpF1K2RcFQ6xnBuHai31AMukPiW8CmD1MWnViVVuBMN/qUHXFoMYz0rN0GNMoOGwY5dhjClSG/RO6C5H6pmhx0h3OVbqZ2xYP2N+P10b15pEaH6HFXNtOsLBXkapl6gsurbjk4utBvvUhAHsEoZaoZlAnXNt6ldMcccdbQAZjFGnugkZ88ZNRze8R1hWLWtJxn3PkaYcoxZ0ZlTxLxQNH5ZKGF3SbxCIS9U20wYL2uvgDT/qYpLuBoJ8A44phUxCF6cabJ7RANOENSVhEd+QxXgEn0ZeCVUk43jTEl47atBN0MGA7E3GZVwVi+/v9SIyTuPXW+tC4aS6y3arZMqNaq8CpTDNQwI2S93V1l5pYpArZSyrhY7WeqZ6lGUrXLNK/1VUVUYqKiqqIpAQllFVFaviVVUmReBW32HZimhFlVNVUVGB8dV+zpYlY4kxjrSmGg1utbrLTlhIQkMgGAPcpMJmXBhmjRWpcWBYGmQlIGp8OFHtJ26dZ7DEOD91LmeJU/zEAsYSY8MfVZV9NMZRNvrntFfXuraMKzvnxtWreL0z5RKoXjVqxyD4kZ05oHs5svoAYOea1xj5JEOjhOrGygtkdaO5z61GZhZXdm8TVrIulzQwiJi6y864VUq4SZiUKdcMtWFg3Ahgf9UHVLRXzdKVRqFSw6/UdHXFSSFtmQJdgaKbSXt5rWsD5VCVjWwDcIJGJqsv86rnGQ2KIyVgoFJVSPWalPNtyFF32+ouwADv9ZK1jlslq2Uq9e/CdRw5ms5ql9cmKzWFybgcXevGg4bWSxvV6xRGJ7UTCUfasnqdTEknCxqGD5vjiEHi7Ih1fFpb6yW8KEYp0xQAA+SZ6u450qz1HM8EZV9Gm3LIgEH2QNdpgw4/I5aMxYD7EupxRxPKyqgyW3IavcAc4mqwT8bRV3S2VxUu371ne2/Sd6kCpaFeYyVWE21KokJl+u3W+NKL2odCijkeiC2ZAHhN6aCbOZrrEYAOO+4/4iFysiIRd6RtUl8TgqJpMyWBCct46j8EDqPCeKIWonmxsOEJI0DNFQ3Ad6Xp4OVaE6/b4im5A922lJmRTuqzwnMUW+5FMaSqmV2p48yaFAzMgYGxWzC+pSOjyQpHLXIT0gQWnyBYpImwYHxDRbeMFXOjCDSJ9rI2PVu3SveWzZVJjns1TuqTotRulDAbNAB8qg9aqcDg/BXLa10zYYepLoaAMWlNMxpkhbRlXJqpGzBM95pkFDBJKFrI5inu2nKsi9gGddesZxgStuRCUVZCXcmoHNWUFIr7R8j+djs5+EGhiivYT0OZhE9h8eYkT8QcR+fF1yajZZ8neagkcxJRByRIwoIBiIJmEwFle3mtZ8tkoF4Z2D3oVxI3OAAFnilPWZEkkjBllIaBySqZBFwyNYtyYbGMuIMckIuMyjkyQuWkX45wTKFsmJsAklvkJhxYq2BEXxAkQHEPMVjQJJxD6AZCSxYd9dI18GiCeRydRMPK35Icl2IgdlMO/FvlWdmVOmAaHj5NglVXQoBU4HViHS4WpSAXlZ5JwVmR7SEnJcRR5FT/a2m2UCmKa2dmXay4yrVg5A0pUteIGhL9VVJkcC/EcbZx2sVi0xkDlYM2Igw6QXMNNYgr7gc+8bXfsdVmgxqUBqkhnimFinei23nJ/VGqpe1I/8AFreFIfUNwnW+eyIOP5CqWrRjN7FjcjoFMi8ficTtmRaKg1Qhac5C2Qto+nXQPf3UWhyXpiK9mn/jVLHbCV2eWv1LRjNreCwsgv8A0g52jnfeI1GeEM2Itc8QJGzhbvEEDqOsw5/3CoI1Wvc97Pu56WLSUpRNyWHs1xgue1RjfddkBLRkZLoD+g18gLZfRuvOAJ8yG0lcChrLLM1S8M6s/Eiq2UhoubZ5wp4dzPMsUtDwyVeGQiQ4MaWvXIldzkJH1DFWA9XZBtHi8FndGOIkVWFYVBMw4A2syVJFrLgcEiqsWKAEL1wPVxuhBvlPsmsjUbWbWS8B0A0Y/HWjl2954FNuKuyl1v+2Okfx6j3/bHU8GBb7QTqkf2u4YYMcP2Or7Nhpdealad4xMNbljYaqN9xeErxbZFaHnd1JAMClkShnowh0FOrGNMTJFbOPlUeoOT1pK9npWrXp0rLq7Tlq1MMU21SrDZy0Uechn3zA1hTSW15JmnlCpjDuKNEzJZUJNz6Q+ITwu+Q0eDxa+mzB8dwKW1RG0i5gOrea8CvU0A15rOKX0sqTAkm5cRXDbji2vxZZkRJ2W9eLwsV/zbepGl5eKOS4ANCujbhAYxZ2tqc14STzljYrB4KsX1WZZgm1LL7CxW1DoOXR+D+sKcg1y52ewXPrBB9WN4f4kUf2N0xX4uGvIqBuRSVqcJEHFdA2jQZ2GgJ22phZZKqocEZDFTBoH3ZpG5o7HmJ/jtbsFGTlbMFmzd6c3Hgb2uj88bhQ8/bDrssXa/w1UsRa40fgDFK/dhkyb4rOjZ5KoF2khFSCLjghAuXE0/pHAAYURcgexAunXoM0jR43PqFgXSNFKWaF+x5bBCknF0OsB+syMramFJR6It9UYQV8wOtJFIGVswK1SgzKGHvFOwQAINqFfGrhK88bJ2ADyhVPkuF5Z1Qmow+CWMoIrKqqRooxHyCkCqRRBB2IZ6kASetqkT+dH13pRWYlLrQhGJlSiX1aiv2cDRRHKQ0NDnmTwNZRRsU7XUHHQ5AC6mIq3oPqpN2BjMgoyIroWsUSulwEvzbVZWaF+z5ZJR7Hm3iyaDSZ1hSqWXW42KFN9TgCFLK+ViYyMqsIPWMaLqdg2D+FUD03IunFsOiYrVawz68VUdBUyGmgU8kHHiCm7WW8txAHE0XK0jHZ5lTIKXzTJOGCvSkaW9SYx5L7iIMc1pTYscTk0DYPTDBrV2lySwye4uc5BkXaW8qCooz976jx/pvgPr54nI7JqWW0pCajhA17VsloZk1UttW61aJBjk0yOgarrYcFffb1bLfn1IFLjcrSMZb0YClVZfYPkbUkm4zKqhxNELkK5FhEQJ08ONoLqxVfi5RugcrKGgXUvWTv43xY/+ofHtS7/dkY2rkkQSGdlrRuBeRTxotJeTftdNO/8qSQacPBxwa/sXto8MdRgnxqEZaN0ar2INFZIQ71/Ra8Xr5WRjOuoQbVLxmvJUQ185sWTTF2KxqoxPM0nX1oVTUmm4m5MMTciK1S8B6GOeHEKGVshYwB3rAd3pmGNA1MjGhCfG5OWau1V9zMyOImDkihjGRUb4jxbOitqXYdUfShkyFhGRk5UzlGDbkw66hioSeo4Lu3i0sl5o2tXJLlENb45AyBWwMpOtfZ6YwkGaciKkg4c9sSOGztlBzMH5ajUvwsvklV8lQ7LywGcWRRHIpJVAqeyjCiR9SrJygHKqHo1jUQAlawELllqVgAOKkAMpoI8Hsi2FAY7GSIaZ6Gze9PXvLWS5/cJpJ4XUXbONWRExXJuHNmRLZMra70Y2qnYwMvjsLSGEbYp5HYEv1yNp0/hvlH+Sm1wE5GgHYMkW8CqpQEDDEXiMpIF4GxagyVXAwWMRkF/YI7iqH44iq2SQLc5bCMAwtMtDMNqqWVsRMUkVBJbUwstOSqWdSN+g9G1SQOyVsiI6wCoqOw7pOlHsRT8rKx1Y8MRlNSCICmjAFMSYSJUBr0EGSntN48nHHtadOLcAIJEo9MSPuCTJEVqAbw6y6lfMpJ1HV/wxNYCBcMikxass6SjRmfUaH+VVYkElfokLtYdHA01C3qVAcmY+g/haFKyQmqShWqS5atJY6SlavJqQr+K9WZcWwAfclYmmUpII+tGNFud1eBWGw2yOkje6Fbr/qNsRM4KSAO2Kqs/c8P16CaXOGr1Z1ycUKRlhbxe+7MqwHalTKhKFKkpJXIu6l69bpK0rihNrri0VGWmbH5F/fmFTI+GgoS7Z4F29QlfeqjNoFHdjGoBek33osEOWjJH4wg8INckuYze8ZlSd0MqVlsvWvh4UWwnq3gzaepqxgLGpaVExo06slwlAyZFLEoCJuJZL5LxkllpoDkqjlESb3pIqtWLkgtxAUVqQYev9WKoLdPI6z0N4gZGiRtIoHfLfxWTVlYxn1ripTX5CRVn0FJvM2EFHnP2WiKyiw/qLe1g8ZQKLZ5cA35s16LjRTYJBL3lHwsVi+wKz9S6/6HCwstkkCjeyy47HzcHzb3SaFy4j2yA/e8qr/CMxsv1osG+GMRZkDzEdrpI8H5lhULDZbAaDpL2erTPMxv5FTvRykIa60JNF9n5Zal31jaVQeJDYQTLlqNFtgcrCq1jXGiACt5TvJddkGSNlDdr3wGPq4+8wlCbdkWAj/P8+g6xPZ5Jbr3U5a8wUB4OsV4USLZqyBzc60agLgDcJm3TPuhF90qhDjFpZw/u24PRRaN7tXk4nVpG5hnVokFd/irFuNFVmpJDlftco5H2z+hOqQlV8ezBvdKQ/KAn9u3BwKRiH/oVlGQHLc15ho0nmIAbNtVgHg0VHmum4J/qPY1s/cGykdszdOhEI/eHITxEDF5cIcVOl9gUnmNLKyhSGLxizz3nGGR3rDdPcLcIT8oHnU+IUr42fMbA7Gx1kosGtX83UC2d9kuuCoO9qnCPsSxpkOFosXK1PmU9r1cVeE6HllSRAXUIUkwJPK1WhYZeVThkNMPjbcba3qYhn1GkmcSAeorn9JVIqCSoVRm6noKZVcXieUObJZ/HowfUiyN+H1RfqtBMmA5iQo1HTFiKa6HDAW7uUMC4V1/XkYz8qSsyLhPkDZRJvro2yc5jKpWXQKhQWpKPMsKymkVY/k4dd7RtR3zSCX1Ek0WA+gtfbTao2xDzXkSlJFMONA2/LbWepYwBjw14XBm92iZ+sE/xXokx+I28x9WjuzkF7H5qt/ZdXydsz1xG1cqI2iXFpb1kkkE2JQmyGrEBx37cOahLKCM3V5h0nwRZmKk45CQqQazcSUBGVyfx8rdoUEKyPAVXz+YklyzfuxUgzXuMoALO6UPFhkHFL+31IgFcgiKxEVx4pyxHdo4WqCtYK5cWnpvoF5xO4mQUT2i392KbLlf3IZyuEIMg7mRUGQN5zwAqxKYNGUFv+SRs64TtuGjFNFfYZNUBYHD6MQgaxBLUiwbggAg6A6x01O2EFNxPd7YqkVdP7aEOC0Df9l5pZV1DCv82Be7C4vyqE1UeLkHItAxLemhkLI0Wj9dS5C/Ja4F3+JEJ60S1G6O9uYRnoh86BKAGcmwPxzVBo2wnKhwpVFXGo+AhaBxFzScNClVHm3WuLZlnlgoir0thfD0sjtoKrtUSSZDKlmTqnkG8maGcjMfU9l7X8hEB3Fcx7LR/Wqloqw0NxCZIC6/hrEyyGmmpKRjG4RKPZQeQqBXPZ9XiDOgYIUxyOspgtL6B2sbjejWLtiYTmmvRIpew6yMyIo21SSa5a8qIZ6ChooEBaQztQLAK10NA+acNKLM3A13ly2pBKtRiKD+ed4XkWpdGk1A8OxcymqfghNmctHsJmyw88i7Dc2Cu9619iIQ0Wly6JqEH14QHk67WoFUn2uhUOR5tjJogdQw97aSVhf6YQABRacJDwhNhAjCJADQBIwEkHGmWE4AZEIAZIoCIZJ4oIwAiD00vSTSjZv6pt88ITOBcerIxMkIFIZpaq6+OYzAZf7KaGbTbKs1sYr9mMM3Ncpajwy9wB2cbmnzB/BMUVgHmYyIJsNxFsIgWswGeQRyiHRZTP9jN4X8KRgPQoEV7CKSAxfjVaeKamfEMMaj27eVkkXkNPgDxXbeXNw7OE0zt38sbCzegETAk9+3lMq4SGdXTqx69+fDNVh8A8Km9nEzUXrhSPxSk4/EMLsl51rN7gaOtTibUc1cSQs0G9RQ9RiXHa62rpSljLblk0hENUA8sGkw626H//C7Cty9eyfGIRofgicJAoGtdMyPNlUnDIbNURhtoqc8JT6jBZUmYFxHoEllh42G26KXodVm84InU3ouLDEtG1iYNH2JWgtiUEYw8uRpU7ZZc0nRkBJpgUjQnecKCFZvIwozBbHL1T8ChA2ecNQAOrAdmZWQEpb4LKoUeAYyaH8lmUN70eiL1OUHlBTlXhsIGsLzB5qRwEOsvIGzKzOFGE/e7TJ2H1nLAY1fnkmjpDFzDUnWZ1UnLgW7prkHHcPiepSQDWnv2StKqnNIQGKEh8CMZkP0xdFGUkA9dOqQpEzULsRr0achDAkdCVH+5kuM2MNSJ2eqh3VwNwsMju7kmT7SA1OQF7IZUApC5UmsGJhkGPrvbF5e408aUbIY11l0oi+uywMWlyKooRT/S80drArTPVxK8IqPqYIo+sJurj/tggMompLEaxNfKHHU3oezeJBrkUuBUrNNQ26WBLTGqG4DQ8xhQLSTLeqRXAaw5CrhqjNimgYfwiTj8iITto1WKlWF0EoFwGhzfbk57VG8mG20YGDpUZ/UsgZYa3AlG09CjudbUn2E8NyOYUjoCBd2a0DcVTT9WrI9YvMnja1hqu+SUGZGWjGY8K4sXy2Fdj1iyhiCGEQ1iBG3SyWxHM1/66D7/ozt3c19mDPsI+TLZ59qOxBv7hjJ6FW9Owip+ey9eqCuCTgpvEx6HH9sTWm/TiqraJQ1lDJBWiWeiqC+REpWIYM3Vro0Xj7SYonp4SL+ykScEUsdookIpz2hKmngbzhdPpjRC4skYIp6MJJoqaRo8AUXbI1G0fXKKxgX/6dLEcVIzMWoWmvW21Hpc1dI4vnolnyrwCgLSFz7bkCv1mekI89ifsJKr6gwdqquoL4m0G39ptugz9WXozwgl465eKIUaYtYTGnotFIUeNhFowkwM+gsLrlDFH8h7ItCDuRSoB6P+zVAP5nQnyYYGYJwMWi0YNFzcURNQMwIFjpqaghfzh+lvLoY1QgthQ9/P8PUj8ifta4umglWDF0Ggbge12lfO8bQIrQjVeKgXlT1Gyh6duZOrGs/X+dB/N1OnDaBRDsdS0gTNzkOqMlGLgWpTTslsW3fToP7hcsBjlMsJFQbdvzeIxLFXtuOrHQzkN85TmFlvU/GwQ6tH0HKjyM1oI4NufJ6KFzoRf57pz3haMzEpkhxQp1FK6yrAHdSgUqpK2nUiJSPLajO6PK45BCxlqmnCcYr4MBeIGO994QSuossbQvpW7fiCyRhQZ0TGyOOHayBWNWmOwGgwAhzK8tISrUSYAggACZMFhMk0YYYWaOiDiK7AWWRexemHBYRpQEOaMFmwsOBEmNwnTAOtT4AwLSJMY2TCBLiMvGcGhCmkqQnT0oTJ1Hh0K5DFQxAkTIMIU18P1ISJZ+AGEKbwL0XCZATCRG0cjVFMqDblUMeqpeV30yonTIsIE1FhEWGWocKRUaIp3M2PEgGZQEDBBEQmKmEhHnAOIiBpq12SXdqLvBKoJ4rUEwXqMYdRTxSvZpFNUQOtN1L61qAD+bi2ZfSiyn+BO+W4i2RilAePhdV/fceK+6sDM5goJq0mjJA2IP2zQqQt40RMzxiy+OfSGInpCWJ6pbVTIKM00zMC2jLUFIytOCLTE8T0xIhMD+RNObeLSFsTldBEZZyQ2+Fl84CojIDbRUrcLlLidhZxO4FEJYiohN8/UU5UoiS7pSCiCjZAiKhMIioOAxgjohIjEJUgokIt09RE5RBRaZKKIUnFgKQEkBQVRZIyZQxb9knK9EnKRJISAUmZPkmZ5SQlhpKUGE5SIiAp9A9kBiRlwALVGL6bxPwFLga21ntJlowEBGVpgRUiqIjvLiLiq0WMfiIoOu7Tu0e4sDVIP0X8OjKOV14kc152KD44OWBRdha30vyAm9tBdcbwIpx8JHJtRuubc4FyQJpwC5pz4rwA7qYVRlTIuJ47XBkDdEEW1D3cRjKGqXsmDaHl+IKQpCMq/aDrRfw9Kd5M20y2V17Q0HtRZqDrCa3rCdLmTDTZdaPS8HipIHYO3tLOGep6UdL1BFqFm7g1qozmpECEan2Xa4EkAoGEDJJV4iVQR0ZCVGyUy1ZBspV0xKGy1QhIOYKkHAlImcojKeNIa1I2yKwSSJmUDk3KBrmpNICUgxfSWptkfq94L8IYWCSS5vYDvRvkrxPECdYJpY4LPerNyQiuDZjeS1EaH/eFavS3WEZaRIiQbBcZjU1YyfRKhpvI5fRkET1Zb5meLKInS9cQ3uKyRqQrq5yurICurLdNVyPQT9BpWnSWaMgagYast0xD1sg0ZJ2AhqwT09AwgEMUwII5gt6WTqKYGSMqZsZIipnQvgnKds61I6e3oJcJ0svEiHpZ+ZLByHvR0JIhGhKiWtidXEHDK+swUkMUNO4raLCyA1kaVSnagUb6ICdLwpdIQ8VpeAPWHCJOzZA4xX2ch4gaOKxTByWrRb9AJpvInAiTbBJzUmwikyyrenrpnq9zFo41+kcNXKaChBPZsHNUKdaWXKM6L3XVMlWwnWuWqM7O7s1t+fTq9Lbu3A52YXrTuqXpNp2pOnu2tuk3F6ybv2pJd2d3bknb5q3pJd09O1j9NCnlrItmbWf1sy6aNusiOeui+lnbp83aLmdtZ5v7c6257kvlokWys60vD8+sPb25frGfapULS2+g9qXdyzo6Oxs78hd2dLV3X8o2pPNLct09OgWQrU/3bW7rTOeatvd05/Lrh+S2bPNzL1g3f12ue3O6rw9Syzq6Ovq26vxVy/O5dLo5193f07cmfSnrTHddkt8qF8pZ27fQ3/x+VpdN75CLF8vNm+sXb23r29q6qSPf1zoV+jKrn6W396Q359PtrV3921o7O7rSfa3d/Xl4WZbBlvT35bu3revPD8FdS1dHnqlV65bjQ0d3/eLNue6e1s70lrxcKIN0ruOSrXnWoxG2Q06TJ2h44SL8CJHQ3ro1jd/taO3p7pPT5JCisqd+cXd/vqc/X79YlywNSne/PzCL5JBC/kDBK50FKao/131pX+hFVzrdnm6nVuViOUtOmSLL8hYukgQSdJmtT/el82+AVGiBlYa0jzVtz+faNueRQDHjgnXzl6Y3d2/ryaX7+krZuty6ts50Pp9uLyu/an26rb2xI9/Htqbb2tO5PmhtzcZVq+TOndLVefWLO/paO7v7+jrTfX1Ibuvacn3p5fSWNafzJYJa1p1b193HNrd1dXXnZQ+Ug3/zHfmO7q6+MlptTuc34Hgt7diW7urD9wDOurbN2XT7hh3bNnV3EpDdbe1r0pc27sing/Syjq62TsohTHUg5afbEV0hTDPsr+rp6dyxrKMzn84xnGPw4M971dUOZOjDVQ58X/qSbemuvCRclL/bgvWM+KqnY3O+P5f23wHU0EYjNOPnDMtYBcPXrhEbysAu6FxE/QXr5ocKlabVqu7ubH8Po69auvLdrF8TUkcXIGYgSLGuti6YWNTl1v76xTta2zZv7t8GxUr5A0G+7sJAOteXPj/X1tW3pTu3DcerlArPEJxSHd2teiZv6s7nu3UlfU1d7Wu3bMjn0m3bfFi3tV2S1jlD+h1+Faa7lq58OtfV1sk2tbWXSEwSM6MZfWlHe34rTuUtQC6tmGZ9+VxHe1ouXiQp3bapr64vt7mV8qcGL2DOwrv2vvywdyeZq9s2tW5lnR2bLk1v6pnZl9s8sz/f0dk3c1NHvjWHkLdixow3KNTR1XmSgpthyFs3w5gHpTRFLe3Ib03nOrouYR1dW1gwhbu3bOlLI4BBVntbvq21r+N9aVkvg2e2Pt3T2QHT4oK2zv4029A2kN6Qb8unce6CzFvX2daVLk0eGCPKgoFr7O/obF/ev2XLtrau89s2daZDw4kjiVyf0j7Dak8jHemvlkBaAcn1d7bl08sxvR0IeKG8NJetXwxjRQN0htyuR4Y1trVLqEle2p1rh4qb0/nztwIuV6fzW7vb2Y7WvnxbDtj/jtZ0Vzuw7iAHniEPagYaBoqBZ50XToJEWbhIwqOL0OxoTW/vaQuS2/1kU1c7W5Zr2wYcJN/fI7e0dXSm2xGJG9q2pFejfhEkl1Byw46uzWWj3d7XM9PnvDOGvyIGNPQNkUgu7c9tpI+RigyjyZEKbaVhOUmJ4cQ4Uqk8jsZJCoz0Bjrpd2SEV/09fW3bejo7ui4Z+jK9eSYkWtvTm0d41dF9ghcDPfM7T/BqCwzmCd61wSQ4cZX6jT9lfM7V2L9lSzrXN/usTQzm1YZtbZ2d69ry8BLzOtNtudXpfBvMzTCfXFpK4+zDNOmDmCbmB9je0TqcJ5OG0jpMER3yui9XpvgB42jvy4ez2LZ0vq21o6s9vV0ulFvbc/WLgRluBV2g9RLULlvZplz94p7uPqwfnjvTXbrpjq7NuTSI1rbOVqZnIJTK++KkfvEOYEjQzjZ4Udff0ZWf35o/Yyp+vy29rVVOk8EzlW1Pd+bbcIpOwTd6ZIC7vXtoBn7xHta0rYPw9q6NF2BCKwLtQWZYwVuzcXWrWt/c2LpELVne1Lp+7YUbGEyR+sWAFCixfOOyZavVmtbzVeOqptbGlvM3IBZgsiEmFi+SwBNbL8RXQ1EGNaxWF7UuP399U1Nr8/q1G9dtIIR1pbfnWwPstPrAnL9erdmwbO361RsYUMSMAWDb0Ai8XNVyftN6tap1ydqlTdQWlAk6Atmtq5rWNJ+/XBfR6ASWiWMO3Fq1rlq7YcOqpg0bWpesXb1ufdOGDS1r17A1ag0LDVZ+R08aP1mydtXa9a0ta5Y2XdSyprkEn0+Wmi1twzWVr28yGJFSojRSPSBaWnGw/beXduey6Vz94o5tPZ2l3Hx3T+sO6eoUsG39DHK8vS9feoVcP0iFlwxBrq8N++metlzbtlISkNhKmkYps7+nJ50r1dBeet4Uyi4NdZCHXQ8BS+uOcA5In47u0gfpss6F3ujekHgsQRvw55HwwwDRraE6ywCisSCQWsszt7bnWmeUTfeR3mvxkQdlIFSihBPoAk6Q/i2tw2CqX+yz5NI7EJobu7Tse3epJOW0vicoWNfdn59aSnV0TS0HsC/flu8nmC5YN791w/nq/I0bWteuDCjML7BokRwhdyHmtqxZVkYPpFHpWRyaYBtaN7Rc3MSQi82d05qfWodori/Xx6bKhfTh8o1rVrauU+9atVYtZRtJzqUbL8mt6uhKr2vryLUuCXJV7pJNI2SvHzG38ZJc28iFT5B99tyzT1B+zpw5c0KvlnY359raO9JdeVpfYdby7lzH+7qByYcyL0jn8h2bQ1kjbmxs2Jrr6MoOeRtscIz4Nvi2CZWwE30bvF2XS7d3bM5351R7+zlD0vOHpOcNSc8dkj57SHrOkPTsIekzh2acNbTAsIwzh2bMal2iBf/65sYy2eWnabU/9GX3pX3v2niB0qtHWNTll+W6tzU2r1fDCq5vblRh7QLSMPJl1VNOZ8e2jjyIntlsiKa+aJE8E+Y5ZsOCirIXLpJnlYpqHrxoUamYzvK/3N7a1o4r/DNHFon4Rn+zWM5iue7uPCormApUF0wRBPDUtS29bZM8Q+LEhYzw4lFv3oR1o1IZ5HDDlB6qVLe0SM5ioNlMln35dA9unzHdl77+TZiWO3fKYO2t3/qr8YWQM5y9uKGCUA2mW7o2d+dy6c15mU3vQHVVotxK4xqBnZ/r7wL1s11znBmsq1tqKdzeDytGSR91dHXkO9o6O97XBivqGWxNd162QZ30foZe13R152V7R19PZ9sO4O0z2FqSW22bcCNmBpDqtjbcBUl3tdd3b6nf0tEJz5u7+0EDHrFIsJCfVV4QCQ1Gobs9nRsCoV5bzWC0xDjR2yXd/Z3tBDVWI9uozrZ82wyGgghW0N0lnMmOLhksUeumzmAtffM3re3Jd2zreB/0uG5re24qq+vq7+ycytwwpyFMLO3uStddmssOednSVfauDokUxWOZyKfdLJ0zFWgkXHLRsJI6Zypzu7NYekQhNpXNgoc6FEM9+VxrfiroRlPkvKmMBJesO7NfLlwoZ585lbl1Hd31i7dtat0hp0hMo37tJ6HnAdL6+tLtMt8tae2tN2nqpjLV1wfsPhiIBXJyn6yb3Ae/C+Tk9qlxZpiGaQphmqbg3I5GICE455wJG++8mcxmCVZge9g+tp8xbnKbJ3iB7+H7+H5uWpGoHYvHnUSyojI1atToMVVVY8eecsq4cdXjx9fUnnraOyZI15s4afLkKafXTT1j2vT6GTNmzjrzrNlzzp47b/45C85duGjxeQ2qccnSpmXNy1tWrFy1avWateveuX7D+RsvuPCid737Pa3v3dSe3rI109nVk8sPvG/nrsLuPXv3XbX/6o9c92/Xf9pkFouwKLNZjMWZwxIsySpYJUuxUWw0G8Oq2Fh2ChvHqtl4VsNq2ansNPYONoFJ5jKPTWST2GQ2hZ3O6thUdgabxqazejaDzWSz2JnsLDabzWFns7lsHpvPzmEL2EK2mDWwRraULWPL2Qq2iq1h69h6dj67gF3ELmb/xP6ZvZdtYu1sC9vKMqyTdbEelmN5dil7H7uMFdgVbC/7INvPrmbXso+xj7NPsn9nn2GfYwfYzewg+wr7OvtP9m32HfY99kP2IHuYHWa/ZE+wp9lv2fPsj+xl9ho7zgxu8yQfzcfxU3nxjf5u+2vw+OSfjvqPrx07FmT/Jch9/vhx//FYqIq/Brl/PBY8Hi8Gj8VXg8cjodzQX+mzI8dHrOH4MT/xeil/xKpO8PfL0uPTR/90TH/8/Ot/ev2Ybr1U25MlGP7nWOm51IvXRm65hJNXTlAgyD46MpQj4zdcIMh/PZQ5ctkR/755JPjw+SN/8b88cuSlYz5aS0C+EBqWYyVEhEbo+IhNh4bt+BsA+VZA/7v+vVp6fP34UR+MV4+/FiC4NAP+Wno8erxEoMeDQXy1NCzHQn0+Ejy9XHo8VkJq8Uip3mMjYqpEJq+Fs0OPI9HDyH8jo7rwRn/H9h0vPvsrfPz25X8uPnO4CInMrmeO/tfD+Dnf9Grxhd/g49ev/J/jTzxfvL5QKKzZ+6NX7r8dy/L/fK34EjV057++UnzhKXxc3fVo8YXf4SNPHyn+iQrc/C9/OvoC1Ts5f99LzxKE/IHjxZepwE9veL34PwTZlkt+X/z5LVTDx48WX6QCX/nAS8Xnn8bHdZf/vPhdao3zoKd/LT2Gen//xP9+8jvfuvGGj3xy8RX19z9x622Pf/roE3zpzGsf+tiBJ24sPlngH/tT8YmnEJw7P/T8sV8/Xvx+oVB45+av//m2u1/7UbFY4Jc/d+y/vvfn+4rFwuYdP3v9h/cXf1QoFMa9+7N/vvlbr/wMCvzgr8XnqcltX/1T8fcvY2XTd//w2IOHqJt7/njkVw8XP18oFP5539NHHrsbc09p/9LL3/wMtsa/8VrxuT9gDTuv/lPxmefxceLqrx/5zs+LD0KBT79SfOH3+NmOD/2h+PQz+Fi/+a4j9/6y+BTi4UjxMMHwY/6qP/wf5F8pPkXPx2KvHvnpQ8VDhULhy8mnXvrOf752f7FYaBl1yxOf+doLB4rPF3jrK8ceuQO//OPFf3n95zRYn1x976t33Uu9qP7jkcd+heD8cPavivd9E+ttmnH3H3/4WPFZKHDPEb/hJz//mg/Oh3YG4PBU8Hj3pN8VX6Dnj5XGjf8meHzlUPD4Ymk8+d6jfg2HF7/uP857zxuTu//3o+rDf/jmPY/f8OKXi7umfOO5L9757JeK3yosmnHVr/7tqy/eXHy0wHt+9/r373nlP4rFwk3bnj36818Uv1QoFE5ffeNzt97+8ldhuOc8/tf7v//a48ViYeeKe1664zuvP1EsFqqbd//q+ptf+gYU+MbTr/3qRRyWj/3rb44++mARiPnUzpv/fMd3jz8JBd75u6MP/BjH4v1bHn7lrvuK/69QKFS1fuKlzx0s/hi6+etXi48eRni/8OW/Hv3Dg9jTmflfFH/+CI3FjheOPfJf+Pih8w8f/eGPcEKese6GF2/8TyKYElL/Unr8n9Ij48KImFZE/0WZuuHHzNkT/f32We/q693+8Z6Pf61h180DM5a1frnp6nUb1y//5CXzF8Rveezbo5Ifz9WM+uz0e8fGD+6oXndvzeLpDRuvaY5PueXwNV7NzTPmjdl3g/uT5vOq7FzuoUTsN++sc977jfNPS03ae8e7Prgpnfn8dcu/1b77091y5brGLQc2r1hc93xh6tmxr/7pQzV2dsW0mmtbbjpz3KfVlI4bZs+Z0FfYujZR+8vihaOiFy5tnp6bXfnNcTOnVnR9446xo77bWD9+y/e+PW70KRdd9NF/PWNG/X0PTmu7o3/jlIlfW3T62T+4sGbstOdume/N3prbctp7Vp9+6sZbFnz+4k0N3in5n4zzpt3Ukp0ra2bzd06bsHR85pSGWyY9nfPGjN2y567Uqp2LR69p3XjOWbNmfyc98T9+0f2uGd0Lr5tw66+eHTu6u6d39cavFadsz9Wdwe97+eH4+G0XTTtt/02HJ0+7ftF57/jkkvql/OH2dfa06/nsmuYPr1mTKha8790ytc7a8vM7TP7E7LNGfeHhQ+PGr79qwqRbam+aMv23Sy5c8MX1fTXnfu28cy++/dyb3tNyfV3d2PzVD3unf3lmZeoO78kz6++YMcq9I7KpUt5xzoxTqgt87qjJSrb0nVoYV3iwzoj1zT40OvLkhZNjfeeubhg7c+u86Y/F5p69+zcNFy97sG7quJpz5p7Tc6c1dcpNh9/h1Vz58Xxc7j19zNlP1ORkS3FCTD0vKvlAy0qZmH2oeMO02RdNmLhky8Z539w4f+y47nMfrJ98aN6UZTtbtnBv02Wbzrho68b+L69vPf/sdxXae9P1K9e+f+bswjtv4eeMspq3nHP21DOnuMkd57TU8I1T40uuWt118cxc31gR31K8aVwkfVoqvrGQvq/mnNHxLVsOe1XT+qsqJ322sJTXbFnUPNk7e8JLh5oWNk9pufTUX09eWl/w+Ezn5VsWjxqz7NqN8xYvmzxt8vXtn914Az8v9k/7Tm2QP9y4sjIWayjeeWnqgsipVkNx/Kt8vj1qzweL8/KFBZVV6z9wTs2Ous+dNeGD1185fuJjsy+ZfsUV758Q+fcL6ho+cN1T9XcUTqkZdcWL11fwh+tTY9/d8Oso/978sad/cuFV47Yc3pBIzj1UXDrz1I01GzcWCvLaW0Y70fOuucU0/zqxNn7tl25J1BTuXjdx8+3rds2t37hr5oW3zZ5aJdMrC/8ycG2+sHH+1MrbXtg4Oba4+R2jLh0ojhp9VXrKwqvmLZtW8+FrJ415xy3Fttqqq+oXLf4Vf+ddDXJqVf+/fbhq7Gd7xiQW3VuYZVYz9ZWfMWcUL4rjhhk5Zh098nr0NfvVV5h6+GfMWcpN2xJGJJZIxqNORWXPVMbyUxnbMZWxwamMHbxuP7vtk/s/wG7/9If27mbHj7/0u/u+8on9V+6+nLFqzvC/OqZu+DlzbhpzlbPf+bBzrXO9c7PzIyee2J/Yn9xfuX+M7/hk1Gj0oWylcLWHiz1hRA3D0e+ro+PG10VOn3pKzZQz5lvzzhlbO3fB5GnLzeaWqlPPPnfZiknTL2paOWehceG7xpx2wcUT65eu2vju2Yu2iks6Rr9jS8abcf4/LVmdzp61eDu/dMeG94ya0N7ZuGbgfe7M/vefed7mbev/meV3qrUpualrVt9l72xtyO1q617XO/jeHh++N833/+/v//7+7+/v+3f57iv2XLn3A/s+eNW/7P/Qh6++5iPXfvS6j/3rv338E9d/8lOf/vf/uOEzN372c5+/6cAXvnjzLbce/NKXb/vKV792+9e/cced//nNb9317bvvOfSd79573/fu//4PfvijHz/w4E9++tDDP/v5I4f/6xeP/vKxXz3+xK+ffOrp3zzz7G9/9/vn/t/zf3jhv//njy/+6c8v/eXlv77y6muvH4F1FXGmEmNKjRo9pmrsKeOqy/afgu2nk+8+lW0+Xfzuf3rPP7e+t23T5vb0lku2dmSyndu6unt6c335/oFLt+943/v/P3vXGxVF9Yaf2WV33b27C/LbRXd/Cmr+19RQw3QKRy1DU9RQ0yjyX6KWlohYiZtuiKZG+KcVURdSQ0VFWhUUbCFUlEXB0FYgWpAIDRcwhF1YdTozYp7TFz90PHyI57zznpl7n3fOuXfmfd5z75e7OnKNrh3taEfbgKv9wYOA+meNp2jOswY3zkJfMIW3QNa5tbHgtbXg/8cBBA4DU36H+xPYhw/uu1qanY6mxnsNf96tr6u136n54/at6t+rfqu8WVFu+7Xsl9KS4hvWn69fK/rpamHBlcv5lrxLF3MvnD+X82N2lvmHs5kZZ06np506ecL0ferxlGNHjyQfPnQw6bsD+/d9m5hg3Ltnd/yuuJ2Gb3Zs37Y19uuYr7Zs3vTlxg3R66O+0K9b+7luTeTqzz79ZFXEyvAVYcs//mjZ0g8/WLJ4UejC9xfMnzd3znsh774T/PbsWW/NnDE96M1pU6cETp70xsQJAa+Pf+3VcWPHMKP9X3mZHjXypRF+Lw4fNtT3hSGDBz0/cED/fn379O7V87ke3bv5eHft8n+tpnMnL7Xqf54dPdyVCjmRSTtIxCI3oYBq69Lf1pmAED8w9fUglQKJWCwSiURurRD+A4KngPqXgE5n1hnNNl2MMcVcYKvTRccYjEkpaebcAqutus6h00dvitlmiDfuS0pOMaVlmHNyLQVF1lJbZXVNXYPDpVurj4reuGlLTOy2HYa4+D3GxH0Hkg4lH01JNZ1MO51x1pydcz73kuVywdWi69bi0jJbRWVV9e0ae93dhkZHs+sBXwkoAEIAEgCcZPoA8AfAdbLcRQGsEGAlAOsOsD4A6w+wOoDLK5alwLJCsKwELOsOlvUBy/qDZXXgEo8pbwBJFAyZVqFY39kktBwJiVg8d0OX6cEjQvumm1TOh1ETJqaXBRga7s/fKJgeDPSbUJK9RpGcNnpW5MytQcvzNJMXbS4asaCWkoeEJ/pOa/IL8h2YMTt15mH36qGNYSW1IaE38+eF65VxS+1JQ8ZfKM4KpNVLAlqEqkC5SxvkS+LCulisvcV++ctuRGQM7D94ZXhZfq/5c4JMPdXRkbKDKrceC83eKr36xIxKQVXYstS8cWMm9e7rOnYmzF4zReY6tbgruTZSETqqdLjeu8OAHUuuRNRXrZ2aOSpq1fbtRtD2qj7cNGogg0aj4W5Fj5bXUs49XutDg44yjUYjlElAQUo6A1Ix4frFXAwXycQ2gXRXPgmQKbhmBSCAVMm/UAkowViaQCg5GGsTiJrfbeCdVM7HyTljohwglAeYWAeImvusbnw5lHrwHA/OGDPH8QRjcYB4d+R3LHiOJ8/x5E0LQKvVglnnBFE+fmodH2NyglAqMGYniLoT18g7qYonqDhj7BzHC0yzE6SPmmvnndSL53jx9kRiHmkLmIRmkIAEGthPA90BHKGB4zRwggbSaSCTBrJo4BwNXKQBA4CdAOIA7AIQD2B361SKwNxrBqH28udQEpkRQAKAFaPB7G8BoQT86Zmkw9/VgnG2gAi7jaX+CgAA///kDTcP';
Companion_instance_33 = new Companion_27();
Companion_instance_34 = new Companion_28();
NonePaint_instance = new NonePaint();
Companion_instance_39 = new Companion_33();
EmptyShape_instance = new EmptyShape();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  GradientKind_RADIAL_getInstance as GradientKind_RADIAL_getInstance32x9dxhe31xgu,
  CycleMethod_NO_CYCLE_getInstance as CycleMethod_NO_CYCLE_getInstancea5nq2e90b21x,
  readFont as readFont34z4s2654u5hd,
  readBitmapSlice as readBitmapSlice2r7knpwifec2u,
  readBitmap_0 as readBitmap1yhww5yoq3a9l,
  readBitmap as readBitmapdk80pcjw6p8f,
  writeBitmap as writeBitmap1pzywoab73ikp,
  _RGBA___get_a__impl__6msvu7 as _RGBA___get_a__impl__6msvu7bgji1ly0wy68,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3fdqajvftucv7,
  _RGBA___get_b__impl__m6tl80 as _RGBA___get_b__impl__m6tl80qg881mr99i7e,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0,
  _RGBA___get_g__impl__o8pukr as _RGBA___get_g__impl__o8pukr1q8mr1galt839,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf629uhw1oxrapg6,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmis57bfwjkwav,
  _RGBA___get_premultiplied__impl__3bulqc as _RGBA___get_premultiplied__impl__3bulqc3rk78ta2124j5,
  _RGBA___get_r__impl__duz7mo as _RGBA___get_r__impl__duz7mojwqekabyzvum,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqtysv8goadjy9q,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2tumn1mea41fm,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8vehpblbe3f2y8,
  RGBA__withAd_impl_cralao as RGBA__withAd_impl_cralao1ojb8pkalp2nb,
  _RGBAPremultiplied___get_af__impl__euwcjn as _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx,
  _RGBAPremultiplied___get_bf__impl__qa3on2 as _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni,
  _RGBAPremultiplied___get_gf__impl__ivron7 as _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq,
  _RGBAPremultiplied___get_rf__impl__pt0c4y as _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v,
  _RgbaArray___init__impl__oib4y4 as _RgbaArray___init__impl__oib4y4249bb2a5xbrxx,
  _RgbaPremultipliedArray___init__impl__lx83hy as _RgbaPremultipliedArray___init__impl__lx83hy2e5m664sv80uc,
  HorizontalAlign__getOffsetX_impl_urzzxf as HorizontalAlign__getOffsetX_impl_urzzxfa8fekmmr9non,
  _HorizontalAlign___get_ratio__impl__x9wlea as _HorizontalAlign___get_ratio__impl__x9wlea2fkrj6kbsj2fk,
  VerticalAlign__getOffsetY_impl_iso0y6 as VerticalAlign__getOffsetY_impl_iso0y6m9d6k6n5h47j,
  _VerticalAlign___get_ratioFake__impl__1h2fwv as _VerticalAlign___get_ratioFake__impl__1h2fwv1dj21d0zq5uhq,
  Companion_getInstance_15 as Companion_getInstance3488ghvvugrnp,
  Bitmaps_instance as Bitmaps_instance27726euemn90u,
  Colors_getInstance as Colors_getInstance2cnv7p5d6jz4u,
  Companion_getInstance_22 as Companion_getInstance2ou2xyvohty1g,
  Companion_instance_16 as Companion_instance1zw3l6m7tnvps,
  Companion_instance_15 as Companion_instance1sgltfeqg9bxt,
  Companion_getInstance_27 as Companion_getInstance1qaz5nihq39ec,
  PNG_getInstance as PNG_getInstance30449hvvlhbbs,
  Companion_getInstance_47 as Companion_getInstancezw1wxvwtmh0g,
  Companion_getInstance_45 as Companion_getInstance2w9pdpq8h2ue0,
  EmptyShape_instance as EmptyShape_instance1905h5dvjxi3r,
  Bitmap32Context2d_0 as Bitmap32Context2d1xx7pfswf9phl,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImageOrBitmap32 as NativeImageOrBitmap3211fg7set8uiki,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  slice as slice2pfxfvku0ybgy,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  BitmapFont as BitmapFont35unsvaxq1brd,
  CharacterSet as CharacterSetvf7yl3wrjq2o,
  get_DefaultTtfFontAsBitmap as get_DefaultTtfFontAsBitmap1hzwi8e4truhb,
  FontMetrics as FontMetrics1b1o1zbrk6cew,
  Font as Font2bg7nte760csr,
  TextMetricsResult as TextMetricsResult1qr6b0fc6i56z,
  TextMetrics as TextMetrics1vfyzci74zdhy,
  getTextBounds as getTextBoundsio1pfpt2q8ze,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  BitmapPaint as BitmapPaintgyia0tdij0bl,
  GradientPaint as GradientPaint1uc4xuo0s2w8w,
  NonePaint as NonePaint2h93brzruznft,
  get_DefaultStringTextRenderer as get_DefaultStringTextRendererdyzggul2pyry,
  Entry_0 as Entry3jfmfe0iy8gwc,
  LineInfo as LineInfo27uw564y6w2d2,
  Text2TextRendererActions as Text2TextRendererActions1307nbc4pqqhs,
  invoke as invoke2ot88cm6qcfmr,
  CompoundShape as CompoundShape2jsp34o6wp7wp,
  FillShape as FillShape13c5zk3dmjgcf,
  PolylineShape as PolylineShape2w5p5crr94b97,
  ShapeBuilder as ShapeBuilderk05da5wk16e9,
  TextShape as TextShape3u9vrw15swk1x,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
